var _toConsumableArray = require("/safe/uwave/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/safe/uwave/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/safe/uwave/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/safe/uwave/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/safe/uwave/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/safe/uwave/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
module.exports = function (e) {
  var t = {};
  function n(r) {
    if (t[r]) return t[r].exports;
    var l = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(l.exports, l, l.exports, n), l.l = !0, l.exports;
  }
  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var l in e) n.d(r, l, function (t) {
      return e[t];
    }.bind(null, l));
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 6);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  e.exports = n(9)();
}, function (e, t, n) {
  (function (e, r) {
    var l;
    /**
     * @license
     * Lodash <https://lodash.com/>
     * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
     * Released under MIT license <https://lodash.com/license>
     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     */
    (function () {
      var c = "Expected a function",
        a = "__lodash_placeholder__",
        i = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]],
        s = "[object Arguments]",
        o = "[object Array]",
        h = "[object Boolean]",
        f = "[object Date]",
        d = "[object Error]",
        u = "[object Function]",
        p = "[object GeneratorFunction]",
        m = "[object Map]",
        v = "[object Number]",
        E = "[object Object]",
        M = "[object RegExp]",
        z = "[object Set]",
        k = "[object String]",
        g = "[object Symbol]",
        b = "[object WeakMap]",
        y = "[object ArrayBuffer]",
        _ = "[object DataView]",
        W = "[object Float32Array]",
        w = "[object Float64Array]",
        x = "[object Int8Array]",
        S = "[object Int16Array]",
        C = "[object Int32Array]",
        O = "[object Uint8Array]",
        j = "[object Uint16Array]",
        L = "[object Uint32Array]",
        N = /\b__p \+= '';/g,
        I = /\b(__p \+=) '' \+/g,
        A = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
        F = /&(?:amp|lt|gt|quot|#39);/g,
        R = /[&<>"']/g,
        T = RegExp(F.source),
        P = RegExp(R.source),
        D = /<%-([\s\S]+?)%>/g,
        B = /<%([\s\S]+?)%>/g,
        U = /<%=([\s\S]+?)%>/g,
        V = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        H = /^\w*$/,
        q = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        $ = /[\\^$.*+?()[\]{}|]/g,
        G = RegExp($.source),
        Y = /^\s+|\s+$/g,
        Z = /^\s+/,
        K = /\s+$/,
        X = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
        J = /\{\n\/\* \[wrapped with (.+)\] \*/,
        Q = /,? & /,
        ee = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
        te = /\\(\\)?/g,
        ne = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
        re = /\w*$/,
        le = /^[-+]0x[0-9a-f]+$/i,
        ce = /^0b[01]+$/i,
        ae = /^\[object .+?Constructor\]$/,
        ie = /^0o[0-7]+$/i,
        se = /^(?:0|[1-9]\d*)$/,
        oe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
        he = /($^)/,
        fe = /['\n\r\u2028\u2029\\]/g,
        de = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
        ue = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
        pe = "[\\ud800-\\udfff]",
        me = "[" + ue + "]",
        ve = "[" + de + "]",
        Ee = "\\d+",
        Me = "[\\u2700-\\u27bf]",
        ze = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
        ke = "[^\\ud800-\\udfff" + ue + Ee + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
        ge = "\\ud83c[\\udffb-\\udfff]",
        be = "[^\\ud800-\\udfff]",
        ye = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        _e = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        We = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
        we = "(?:" + ze + "|" + ke + ")",
        xe = "(?:" + We + "|" + ke + ")",
        Se = "(?:" + ve + "|" + ge + ")" + "?",
        Ce = "[\\ufe0e\\ufe0f]?" + Se + ("(?:\\u200d(?:" + [be, ye, _e].join("|") + ")[\\ufe0e\\ufe0f]?" + Se + ")*"),
        Oe = "(?:" + [Me, ye, _e].join("|") + ")" + Ce,
        je = "(?:" + [be + ve + "?", ve, ye, _e, pe].join("|") + ")",
        Le = RegExp("['’]", "g"),
        Ne = RegExp(ve, "g"),
        Ie = RegExp(ge + "(?=" + ge + ")|" + je + Ce, "g"),
        Ae = RegExp([We + "?" + ze + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [me, We, "$"].join("|") + ")", xe + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [me, We + we, "$"].join("|") + ")", We + "?" + we + "+(?:['’](?:d|ll|m|re|s|t|ve))?", We + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ee, Oe].join("|"), "g"),
        Fe = RegExp("[\\u200d\\ud800-\\udfff" + de + "\\ufe0e\\ufe0f]"),
        Re = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
        Te = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
        Pe = -1,
        De = {};
      De[W] = De[w] = De[x] = De[S] = De[C] = De[O] = De["[object Uint8ClampedArray]"] = De[j] = De[L] = !0, De[s] = De[o] = De[y] = De[h] = De[_] = De[f] = De[d] = De[u] = De[m] = De[v] = De[E] = De[M] = De[z] = De[k] = De[b] = !1;
      var Be = {};
      Be[s] = Be[o] = Be[y] = Be[_] = Be[h] = Be[f] = Be[W] = Be[w] = Be[x] = Be[S] = Be[C] = Be[m] = Be[v] = Be[E] = Be[M] = Be[z] = Be[k] = Be[g] = Be[O] = Be["[object Uint8ClampedArray]"] = Be[j] = Be[L] = !0, Be[d] = Be[u] = Be[b] = !1;
      var Ue = {
          "\\": "\\",
          "'": "'",
          "\n": "n",
          "\r": "r",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
        Ve = parseFloat,
        He = parseInt,
        qe = "object" == typeof e && e && e.Object === Object && e,
        $e = "object" == typeof self && self && self.Object === Object && self,
        Ge = qe || $e || Function("return this")(),
        Ye = t && !t.nodeType && t,
        Ze = Ye && "object" == typeof r && r && !r.nodeType && r,
        Ke = Ze && Ze.exports === Ye,
        Xe = Ke && qe.process,
        Je = function () {
          try {
            var e = Ze && Ze.require && Ze.require("util").types;
            return e || Xe && Xe.binding && Xe.binding("util");
          } catch (e) {}
        }(),
        Qe = Je && Je.isArrayBuffer,
        et = Je && Je.isDate,
        tt = Je && Je.isMap,
        nt = Je && Je.isRegExp,
        rt = Je && Je.isSet,
        lt = Je && Je.isTypedArray;
      function ct(e, t, n) {
        switch (n.length) {
          case 0:
            return e.call(t);
          case 1:
            return e.call(t, n[0]);
          case 2:
            return e.call(t, n[0], n[1]);
          case 3:
            return e.call(t, n[0], n[1], n[2]);
        }
        return e.apply(t, n);
      }
      function at(e, t, n, r) {
        for (var l = -1, c = null == e ? 0 : e.length; ++l < c;) {
          var a = e[l];
          t(r, a, n(a), e);
        }
        return r;
      }
      function it(e, t) {
        for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e););
        return e;
      }
      function st(e, t) {
        for (var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e););
        return e;
      }
      function ot(e, t) {
        for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) if (!t(e[n], n, e)) return !1;
        return !0;
      }
      function ht(e, t) {
        for (var n = -1, r = null == e ? 0 : e.length, l = 0, c = []; ++n < r;) {
          var a = e[n];
          t(a, n, e) && (c[l++] = a);
        }
        return c;
      }
      function ft(e, t) {
        return !!(null == e ? 0 : e.length) && gt(e, t, 0) > -1;
      }
      function dt(e, t, n) {
        for (var r = -1, l = null == e ? 0 : e.length; ++r < l;) if (n(t, e[r])) return !0;
        return !1;
      }
      function ut(e, t) {
        for (var n = -1, r = null == e ? 0 : e.length, l = Array(r); ++n < r;) l[n] = t(e[n], n, e);
        return l;
      }
      function pt(e, t) {
        for (var n = -1, r = t.length, l = e.length; ++n < r;) e[l + n] = t[n];
        return e;
      }
      function mt(e, t, n, r) {
        var l = -1,
          c = null == e ? 0 : e.length;
        for (r && c && (n = e[++l]); ++l < c;) n = t(n, e[l], l, e);
        return n;
      }
      function vt(e, t, n, r) {
        var l = null == e ? 0 : e.length;
        for (r && l && (n = e[--l]); l--;) n = t(n, e[l], l, e);
        return n;
      }
      function Et(e, t) {
        for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
        return !1;
      }
      var Mt = Wt("length");
      function zt(e, t, n) {
        var r;
        return n(e, function (e, n, l) {
          if (t(e, n, l)) return r = n, !1;
        }), r;
      }
      function kt(e, t, n, r) {
        for (var l = e.length, c = n + (r ? 1 : -1); r ? c-- : ++c < l;) if (t(e[c], c, e)) return c;
        return -1;
      }
      function gt(e, t, n) {
        return t == t ? function (e, t, n) {
          var r = n - 1,
            l = e.length;
          for (; ++r < l;) if (e[r] === t) return r;
          return -1;
        }(e, t, n) : kt(e, yt, n);
      }
      function bt(e, t, n, r) {
        for (var l = n - 1, c = e.length; ++l < c;) if (r(e[l], t)) return l;
        return -1;
      }
      function yt(e) {
        return e != e;
      }
      function _t(e, t) {
        var n = null == e ? 0 : e.length;
        return n ? St(e, t) / n : NaN;
      }
      function Wt(e) {
        return function (t) {
          return null == t ? void 0 : t[e];
        };
      }
      function wt(e) {
        return function (t) {
          return null == e ? void 0 : e[t];
        };
      }
      function xt(e, t, n, r, l) {
        return l(e, function (e, l, c) {
          n = r ? (r = !1, e) : t(n, e, l, c);
        }), n;
      }
      function St(e, t) {
        for (var n, r = -1, l = e.length; ++r < l;) {
          var c = t(e[r]);
          void 0 !== c && (n = void 0 === n ? c : n + c);
        }
        return n;
      }
      function Ct(e, t) {
        for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
        return r;
      }
      function Ot(e) {
        return function (t) {
          return e(t);
        };
      }
      function jt(e, t) {
        return ut(t, function (t) {
          return e[t];
        });
      }
      function Lt(e, t) {
        return e.has(t);
      }
      function Nt(e, t) {
        for (var n = -1, r = e.length; ++n < r && gt(t, e[n], 0) > -1;);
        return n;
      }
      function It(e, t) {
        for (var n = e.length; n-- && gt(t, e[n], 0) > -1;);
        return n;
      }
      function At(e, t) {
        for (var n = e.length, r = 0; n--;) e[n] === t && ++r;
        return r;
      }
      var Ft = wt({
          "À": "A",
          "Á": "A",
          "Â": "A",
          "Ã": "A",
          "Ä": "A",
          "Å": "A",
          "à": "a",
          "á": "a",
          "â": "a",
          "ã": "a",
          "ä": "a",
          "å": "a",
          "Ç": "C",
          "ç": "c",
          "Ð": "D",
          "ð": "d",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "Ì": "I",
          "Í": "I",
          "Î": "I",
          "Ï": "I",
          "ì": "i",
          "í": "i",
          "î": "i",
          "ï": "i",
          "Ñ": "N",
          "ñ": "n",
          "Ò": "O",
          "Ó": "O",
          "Ô": "O",
          "Õ": "O",
          "Ö": "O",
          "Ø": "O",
          "ò": "o",
          "ó": "o",
          "ô": "o",
          "õ": "o",
          "ö": "o",
          "ø": "o",
          "Ù": "U",
          "Ú": "U",
          "Û": "U",
          "Ü": "U",
          "ù": "u",
          "ú": "u",
          "û": "u",
          "ü": "u",
          "Ý": "Y",
          "ý": "y",
          "ÿ": "y",
          "Æ": "Ae",
          "æ": "ae",
          "Þ": "Th",
          "þ": "th",
          "ß": "ss",
          "Ā": "A",
          "Ă": "A",
          "Ą": "A",
          "ā": "a",
          "ă": "a",
          "ą": "a",
          "Ć": "C",
          "Ĉ": "C",
          "Ċ": "C",
          "Č": "C",
          "ć": "c",
          "ĉ": "c",
          "ċ": "c",
          "č": "c",
          "Ď": "D",
          "Đ": "D",
          "ď": "d",
          "đ": "d",
          "Ē": "E",
          "Ĕ": "E",
          "Ė": "E",
          "Ę": "E",
          "Ě": "E",
          "ē": "e",
          "ĕ": "e",
          "ė": "e",
          "ę": "e",
          "ě": "e",
          "Ĝ": "G",
          "Ğ": "G",
          "Ġ": "G",
          "Ģ": "G",
          "ĝ": "g",
          "ğ": "g",
          "ġ": "g",
          "ģ": "g",
          "Ĥ": "H",
          "Ħ": "H",
          "ĥ": "h",
          "ħ": "h",
          "Ĩ": "I",
          "Ī": "I",
          "Ĭ": "I",
          "Į": "I",
          "İ": "I",
          "ĩ": "i",
          "ī": "i",
          "ĭ": "i",
          "į": "i",
          "ı": "i",
          "Ĵ": "J",
          "ĵ": "j",
          "Ķ": "K",
          "ķ": "k",
          "ĸ": "k",
          "Ĺ": "L",
          "Ļ": "L",
          "Ľ": "L",
          "Ŀ": "L",
          "Ł": "L",
          "ĺ": "l",
          "ļ": "l",
          "ľ": "l",
          "ŀ": "l",
          "ł": "l",
          "Ń": "N",
          "Ņ": "N",
          "Ň": "N",
          "Ŋ": "N",
          "ń": "n",
          "ņ": "n",
          "ň": "n",
          "ŋ": "n",
          "Ō": "O",
          "Ŏ": "O",
          "Ő": "O",
          "ō": "o",
          "ŏ": "o",
          "ő": "o",
          "Ŕ": "R",
          "Ŗ": "R",
          "Ř": "R",
          "ŕ": "r",
          "ŗ": "r",
          "ř": "r",
          "Ś": "S",
          "Ŝ": "S",
          "Ş": "S",
          "Š": "S",
          "ś": "s",
          "ŝ": "s",
          "ş": "s",
          "š": "s",
          "Ţ": "T",
          "Ť": "T",
          "Ŧ": "T",
          "ţ": "t",
          "ť": "t",
          "ŧ": "t",
          "Ũ": "U",
          "Ū": "U",
          "Ŭ": "U",
          "Ů": "U",
          "Ű": "U",
          "Ų": "U",
          "ũ": "u",
          "ū": "u",
          "ŭ": "u",
          "ů": "u",
          "ű": "u",
          "ų": "u",
          "Ŵ": "W",
          "ŵ": "w",
          "Ŷ": "Y",
          "ŷ": "y",
          "Ÿ": "Y",
          "Ź": "Z",
          "Ż": "Z",
          "Ž": "Z",
          "ź": "z",
          "ż": "z",
          "ž": "z",
          "Ĳ": "IJ",
          "ĳ": "ij",
          "Œ": "Oe",
          "œ": "oe",
          "ŉ": "'n",
          "ſ": "s"
        }),
        Rt = wt({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        });
      function Tt(e) {
        return "\\" + Ue[e];
      }
      function Pt(e) {
        return Fe.test(e);
      }
      function Dt(e) {
        var t = -1,
          n = Array(e.size);
        return e.forEach(function (e, r) {
          n[++t] = [r, e];
        }), n;
      }
      function Bt(e, t) {
        return function (n) {
          return e(t(n));
        };
      }
      function Ut(e, t) {
        for (var n = -1, r = e.length, l = 0, c = []; ++n < r;) {
          var i = e[n];
          i !== t && i !== a || (e[n] = a, c[l++] = n);
        }
        return c;
      }
      function Vt(e) {
        var t = -1,
          n = Array(e.size);
        return e.forEach(function (e) {
          n[++t] = e;
        }), n;
      }
      function Ht(e) {
        var t = -1,
          n = Array(e.size);
        return e.forEach(function (e) {
          n[++t] = [e, e];
        }), n;
      }
      function qt(e) {
        return Pt(e) ? function (e) {
          var t = Ie.lastIndex = 0;
          for (; Ie.test(e);) ++t;
          return t;
        }(e) : Mt(e);
      }
      function $t(e) {
        return Pt(e) ? function (e) {
          return e.match(Ie) || [];
        }(e) : function (e) {
          return e.split("");
        }(e);
      }
      var Gt = wt({
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      });
      var Yt = function e(t) {
        var n,
          r = (t = null == t ? Ge : Yt.defaults(Ge.Object(), t, Yt.pick(Ge, Te))).Array,
          l = t.Date,
          de = t.Error,
          ue = t.Function,
          pe = t.Math,
          me = t.Object,
          ve = t.RegExp,
          Ee = t.String,
          Me = t.TypeError,
          ze = r.prototype,
          ke = ue.prototype,
          ge = me.prototype,
          be = t["__core-js_shared__"],
          ye = ke.toString,
          _e = ge.hasOwnProperty,
          We = 0,
          we = (n = /[^.]+$/.exec(be && be.keys && be.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "",
          xe = ge.toString,
          Se = ye.call(me),
          Ce = Ge._,
          Oe = ve("^" + ye.call(_e).replace($, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          je = Ke ? t.Buffer : void 0,
          Ie = t.Symbol,
          Fe = t.Uint8Array,
          Ue = je ? je.allocUnsafe : void 0,
          qe = Bt(me.getPrototypeOf, me),
          $e = me.create,
          Ye = ge.propertyIsEnumerable,
          Ze = ze.splice,
          Xe = Ie ? Ie.isConcatSpreadable : void 0,
          Je = Ie ? Ie.iterator : void 0,
          Mt = Ie ? Ie.toStringTag : void 0,
          wt = function () {
            try {
              var e = Ql(me, "defineProperty");
              return e({}, "", {}), e;
            } catch (e) {}
          }(),
          Zt = t.clearTimeout !== Ge.clearTimeout && t.clearTimeout,
          Kt = l && l.now !== Ge.Date.now && l.now,
          Xt = t.setTimeout !== Ge.setTimeout && t.setTimeout,
          Jt = pe.ceil,
          Qt = pe.floor,
          en = me.getOwnPropertySymbols,
          tn = je ? je.isBuffer : void 0,
          nn = t.isFinite,
          rn = ze.join,
          ln = Bt(me.keys, me),
          cn = pe.max,
          an = pe.min,
          sn = l.now,
          on = t.parseInt,
          hn = pe.random,
          fn = ze.reverse,
          dn = Ql(t, "DataView"),
          un = Ql(t, "Map"),
          pn = Ql(t, "Promise"),
          mn = Ql(t, "Set"),
          vn = Ql(t, "WeakMap"),
          En = Ql(me, "create"),
          Mn = vn && new vn(),
          zn = {},
          kn = wc(dn),
          gn = wc(un),
          bn = wc(pn),
          yn = wc(mn),
          _n = wc(vn),
          Wn = Ie ? Ie.prototype : void 0,
          wn = Wn ? Wn.valueOf : void 0,
          xn = Wn ? Wn.toString : void 0;
        function Sn(e) {
          if (Va(e) && !La(e) && !(e instanceof Ln)) {
            if (e instanceof jn) return e;
            if (_e.call(e, "__wrapped__")) return xc(e);
          }
          return new jn(e);
        }
        var Cn = function () {
          function e() {}
          return function (t) {
            if (!Ua(t)) return {};
            if ($e) return $e(t);
            e.prototype = t;
            var n = new e();
            return e.prototype = void 0, n;
          };
        }();
        function On() {}
        function jn(e, t) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
        }
        function Ln(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
        }
        function Nn(e) {
          var t = -1,
            n = null == e ? 0 : e.length;
          for (this.clear(); ++t < n;) {
            var r = e[t];
            this.set(r[0], r[1]);
          }
        }
        function In(e) {
          var t = -1,
            n = null == e ? 0 : e.length;
          for (this.clear(); ++t < n;) {
            var r = e[t];
            this.set(r[0], r[1]);
          }
        }
        function An(e) {
          var t = -1,
            n = null == e ? 0 : e.length;
          for (this.clear(); ++t < n;) {
            var r = e[t];
            this.set(r[0], r[1]);
          }
        }
        function Fn(e) {
          var t = -1,
            n = null == e ? 0 : e.length;
          for (this.__data__ = new An(); ++t < n;) this.add(e[t]);
        }
        function Rn(e) {
          var t = this.__data__ = new In(e);
          this.size = t.size;
        }
        function Tn(e, t) {
          var n = La(e),
            r = !n && ja(e),
            l = !n && !r && Fa(e),
            c = !n && !r && !l && Xa(e),
            a = n || r || l || c,
            i = a ? Ct(e.length, Ee) : [],
            s = i.length;
          for (var o in e) !t && !_e.call(e, o) || a && ("length" == o || l && ("offset" == o || "parent" == o) || c && ("buffer" == o || "byteLength" == o || "byteOffset" == o) || ac(o, s)) || i.push(o);
          return i;
        }
        function Pn(e) {
          var t = e.length;
          return t ? e[Fr(0, t - 1)] : void 0;
        }
        function Dn(e, t) {
          return yc(El(e), Zn(t, 0, e.length));
        }
        function Bn(e) {
          return yc(El(e));
        }
        function Un(e, t, n) {
          (void 0 !== n && !Sa(e[t], n) || void 0 === n && !(t in e)) && Gn(e, t, n);
        }
        function Vn(e, t, n) {
          var r = e[t];
          _e.call(e, t) && Sa(r, n) && (void 0 !== n || t in e) || Gn(e, t, n);
        }
        function Hn(e, t) {
          for (var n = e.length; n--;) if (Sa(e[n][0], t)) return n;
          return -1;
        }
        function qn(e, t, n, r) {
          return er(e, function (e, l, c) {
            t(r, e, n(e), c);
          }), r;
        }
        function $n(e, t) {
          return e && Ml(t, zi(t), e);
        }
        function Gn(e, t, n) {
          "__proto__" == t && wt ? wt(e, t, {
            configurable: !0,
            enumerable: !0,
            value: n,
            writable: !0
          }) : e[t] = n;
        }
        function Yn(e, t) {
          for (var n = -1, l = t.length, c = r(l), a = null == e; ++n < l;) c[n] = a ? void 0 : pi(e, t[n]);
          return c;
        }
        function Zn(e, t, n) {
          return e == e && (void 0 !== n && (e = e <= n ? e : n), void 0 !== t && (e = e >= t ? e : t)), e;
        }
        function Kn(e, t, n, r, l, c) {
          var a,
            i = 1 & t,
            o = 2 & t,
            d = 4 & t;
          if (n && (a = l ? n(e, r, l, c) : n(e)), void 0 !== a) return a;
          if (!Ua(e)) return e;
          var b = La(e);
          if (b) {
            if (a = function (e) {
              var t = e.length,
                n = new e.constructor(t);
              t && "string" == typeof e[0] && _e.call(e, "index") && (n.index = e.index, n.input = e.input);
              return n;
            }(e), !i) return El(e, a);
          } else {
            var N = nc(e),
              I = N == u || N == p;
            if (Fa(e)) return fl(e, i);
            if (N == E || N == s || I && !l) {
              if (a = o || I ? {} : lc(e), !i) return o ? function (e, t) {
                return Ml(e, tc(e), t);
              }(e, function (e, t) {
                return e && Ml(t, ki(t), e);
              }(a, e)) : function (e, t) {
                return Ml(e, ec(e), t);
              }(e, $n(a, e));
            } else {
              if (!Be[N]) return l ? e : {};
              a = function (e, t, n) {
                var r = e.constructor;
                switch (t) {
                  case y:
                    return dl(e);
                  case h:
                  case f:
                    return new r(+e);
                  case _:
                    return function (e, t) {
                      var n = t ? dl(e.buffer) : e.buffer;
                      return new e.constructor(n, e.byteOffset, e.byteLength);
                    }(e, n);
                  case W:
                  case w:
                  case x:
                  case S:
                  case C:
                  case O:
                  case "[object Uint8ClampedArray]":
                  case j:
                  case L:
                    return ul(e, n);
                  case m:
                    return new r();
                  case v:
                  case k:
                    return new r(e);
                  case M:
                    return function (e) {
                      var t = new e.constructor(e.source, re.exec(e));
                      return t.lastIndex = e.lastIndex, t;
                    }(e);
                  case z:
                    return new r();
                  case g:
                    return l = e, wn ? me(wn.call(l)) : {};
                }
                var l;
              }(e, N, i);
            }
          }
          c || (c = new Rn());
          var A = c.get(e);
          if (A) return A;
          c.set(e, a), Ya(e) ? e.forEach(function (r) {
            a.add(Kn(r, t, n, r, e, c));
          }) : Ha(e) && e.forEach(function (r, l) {
            a.set(l, Kn(r, t, n, l, e, c));
          });
          var F = b ? void 0 : (d ? o ? $l : ql : o ? ki : zi)(e);
          return it(F || e, function (r, l) {
            F && (r = e[l = r]), Vn(a, l, Kn(r, t, n, l, e, c));
          }), a;
        }
        function Xn(e, t, n) {
          var r = n.length;
          if (null == e) return !r;
          for (e = me(e); r--;) {
            var l = n[r],
              c = t[l],
              a = e[l];
            if (void 0 === a && !(l in e) || !c(a)) return !1;
          }
          return !0;
        }
        function Jn(e, t, n) {
          if ("function" != typeof e) throw new Me(c);
          return zc(function () {
            e.apply(void 0, n);
          }, t);
        }
        function Qn(e, t, n, r) {
          var l = -1,
            c = ft,
            a = !0,
            i = e.length,
            s = [],
            o = t.length;
          if (!i) return s;
          n && (t = ut(t, Ot(n))), r ? (c = dt, a = !1) : t.length >= 200 && (c = Lt, a = !1, t = new Fn(t));
          e: for (; ++l < i;) {
            var h = e[l],
              f = null == n ? h : n(h);
            if (h = r || 0 !== h ? h : 0, a && f == f) {
              for (var d = o; d--;) if (t[d] === f) continue e;
              s.push(h);
            } else c(t, f, r) || s.push(h);
          }
          return s;
        }
        Sn.templateSettings = {
          escape: D,
          evaluate: B,
          interpolate: U,
          variable: "",
          imports: {
            _: Sn
          }
        }, Sn.prototype = On.prototype, Sn.prototype.constructor = Sn, jn.prototype = Cn(On.prototype), jn.prototype.constructor = jn, Ln.prototype = Cn(On.prototype), Ln.prototype.constructor = Ln, Nn.prototype.clear = function () {
          this.__data__ = En ? En(null) : {}, this.size = 0;
        }, Nn.prototype.delete = function (e) {
          var t = this.has(e) && delete this.__data__[e];
          return this.size -= t ? 1 : 0, t;
        }, Nn.prototype.get = function (e) {
          var t = this.__data__;
          if (En) {
            var n = t[e];
            return "__lodash_hash_undefined__" === n ? void 0 : n;
          }
          return _e.call(t, e) ? t[e] : void 0;
        }, Nn.prototype.has = function (e) {
          var t = this.__data__;
          return En ? void 0 !== t[e] : _e.call(t, e);
        }, Nn.prototype.set = function (e, t) {
          var n = this.__data__;
          return this.size += this.has(e) ? 0 : 1, n[e] = En && void 0 === t ? "__lodash_hash_undefined__" : t, this;
        }, In.prototype.clear = function () {
          this.__data__ = [], this.size = 0;
        }, In.prototype.delete = function (e) {
          var t = this.__data__,
            n = Hn(t, e);
          return !(n < 0) && (n == t.length - 1 ? t.pop() : Ze.call(t, n, 1), --this.size, !0);
        }, In.prototype.get = function (e) {
          var t = this.__data__,
            n = Hn(t, e);
          return n < 0 ? void 0 : t[n][1];
        }, In.prototype.has = function (e) {
          return Hn(this.__data__, e) > -1;
        }, In.prototype.set = function (e, t) {
          var n = this.__data__,
            r = Hn(n, e);
          return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
        }, An.prototype.clear = function () {
          this.size = 0, this.__data__ = {
            hash: new Nn(),
            map: new (un || In)(),
            string: new Nn()
          };
        }, An.prototype.delete = function (e) {
          var t = Xl(this, e).delete(e);
          return this.size -= t ? 1 : 0, t;
        }, An.prototype.get = function (e) {
          return Xl(this, e).get(e);
        }, An.prototype.has = function (e) {
          return Xl(this, e).has(e);
        }, An.prototype.set = function (e, t) {
          var n = Xl(this, e),
            r = n.size;
          return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
        }, Fn.prototype.add = Fn.prototype.push = function (e) {
          return this.__data__.set(e, "__lodash_hash_undefined__"), this;
        }, Fn.prototype.has = function (e) {
          return this.__data__.has(e);
        }, Rn.prototype.clear = function () {
          this.__data__ = new In(), this.size = 0;
        }, Rn.prototype.delete = function (e) {
          var t = this.__data__,
            n = t.delete(e);
          return this.size = t.size, n;
        }, Rn.prototype.get = function (e) {
          return this.__data__.get(e);
        }, Rn.prototype.has = function (e) {
          return this.__data__.has(e);
        }, Rn.prototype.set = function (e, t) {
          var n = this.__data__;
          if (n instanceof In) {
            var r = n.__data__;
            if (!un || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
            n = this.__data__ = new An(r);
          }
          return n.set(e, t), this.size = n.size, this;
        };
        var er = gl(sr),
          tr = gl(or, !0);
        function nr(e, t) {
          var n = !0;
          return er(e, function (e, r, l) {
            return n = !!t(e, r, l);
          }), n;
        }
        function rr(e, t, n) {
          for (var r = -1, l = e.length; ++r < l;) {
            var c = e[r],
              a = t(c);
            if (null != a && (void 0 === i ? a == a && !Ka(a) : n(a, i))) var i = a,
              s = c;
          }
          return s;
        }
        function lr(e, t) {
          var n = [];
          return er(e, function (e, r, l) {
            t(e, r, l) && n.push(e);
          }), n;
        }
        function cr(e, t, n, r, l) {
          var c = -1,
            a = e.length;
          for (n || (n = cc), l || (l = []); ++c < a;) {
            var i = e[c];
            t > 0 && n(i) ? t > 1 ? cr(i, t - 1, n, r, l) : pt(l, i) : r || (l[l.length] = i);
          }
          return l;
        }
        var ar = bl(),
          ir = bl(!0);
        function sr(e, t) {
          return e && ar(e, t, zi);
        }
        function or(e, t) {
          return e && ir(e, t, zi);
        }
        function hr(e, t) {
          return ht(t, function (t) {
            return Pa(e[t]);
          });
        }
        function fr(e, t) {
          for (var n = 0, r = (t = il(t, e)).length; null != e && n < r;) e = e[Wc(t[n++])];
          return n && n == r ? e : void 0;
        }
        function dr(e, t, n) {
          var r = t(e);
          return La(e) ? r : pt(r, n(e));
        }
        function ur(e) {
          return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Mt && Mt in me(e) ? function (e) {
            var t = _e.call(e, Mt),
              n = e[Mt];
            try {
              e[Mt] = void 0;
              var r = !0;
            } catch (e) {}
            var l = xe.call(e);
            r && (t ? e[Mt] = n : delete e[Mt]);
            return l;
          }(e) : function (e) {
            return xe.call(e);
          }(e);
        }
        function pr(e, t) {
          return e > t;
        }
        function mr(e, t) {
          return null != e && _e.call(e, t);
        }
        function vr(e, t) {
          return null != e && t in me(e);
        }
        function Er(e, t, n) {
          for (var l = n ? dt : ft, c = e[0].length, a = e.length, i = a, s = r(a), o = 1 / 0, h = []; i--;) {
            var f = e[i];
            i && t && (f = ut(f, Ot(t))), o = an(f.length, o), s[i] = !n && (t || c >= 120 && f.length >= 120) ? new Fn(i && f) : void 0;
          }
          f = e[0];
          var d = -1,
            u = s[0];
          e: for (; ++d < c && h.length < o;) {
            var p = f[d],
              m = t ? t(p) : p;
            if (p = n || 0 !== p ? p : 0, !(u ? Lt(u, m) : l(h, m, n))) {
              for (i = a; --i;) {
                var v = s[i];
                if (!(v ? Lt(v, m) : l(e[i], m, n))) continue e;
              }
              u && u.push(m), h.push(p);
            }
          }
          return h;
        }
        function Mr(e, t, n) {
          var r = null == (e = mc(e, t = il(t, e))) ? e : e[Wc(Tc(t))];
          return null == r ? void 0 : ct(r, e, n);
        }
        function zr(e) {
          return Va(e) && ur(e) == s;
        }
        function kr(e, t, n, r, l) {
          return e === t || (null == e || null == t || !Va(e) && !Va(t) ? e != e && t != t : function (e, t, n, r, l, c) {
            var a = La(e),
              i = La(t),
              u = a ? o : nc(e),
              p = i ? o : nc(t),
              b = (u = u == s ? E : u) == E,
              W = (p = p == s ? E : p) == E,
              w = u == p;
            if (w && Fa(e)) {
              if (!Fa(t)) return !1;
              a = !0, b = !1;
            }
            if (w && !b) return c || (c = new Rn()), a || Xa(e) ? Vl(e, t, n, r, l, c) : function (e, t, n, r, l, c, a) {
              switch (n) {
                case _:
                  if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                  e = e.buffer, t = t.buffer;
                case y:
                  return !(e.byteLength != t.byteLength || !c(new Fe(e), new Fe(t)));
                case h:
                case f:
                case v:
                  return Sa(+e, +t);
                case d:
                  return e.name == t.name && e.message == t.message;
                case M:
                case k:
                  return e == t + "";
                case m:
                  var i = Dt;
                case z:
                  var s = 1 & r;
                  if (i || (i = Vt), e.size != t.size && !s) return !1;
                  var o = a.get(e);
                  if (o) return o == t;
                  r |= 2, a.set(e, t);
                  var u = Vl(i(e), i(t), r, l, c, a);
                  return a.delete(e), u;
                case g:
                  if (wn) return wn.call(e) == wn.call(t);
              }
              return !1;
            }(e, t, u, n, r, l, c);
            if (!(1 & n)) {
              var x = b && _e.call(e, "__wrapped__"),
                S = W && _e.call(t, "__wrapped__");
              if (x || S) {
                var C = x ? e.value() : e,
                  O = S ? t.value() : t;
                return c || (c = new Rn()), l(C, O, n, r, c);
              }
            }
            if (!w) return !1;
            return c || (c = new Rn()), function (e, t, n, r, l, c) {
              var a = 1 & n,
                i = ql(e),
                s = i.length,
                o = ql(t).length;
              if (s != o && !a) return !1;
              var h = s;
              for (; h--;) {
                var f = i[h];
                if (!(a ? f in t : _e.call(t, f))) return !1;
              }
              var d = c.get(e);
              if (d && c.get(t)) return d == t;
              var u = !0;
              c.set(e, t), c.set(t, e);
              var p = a;
              for (; ++h < s;) {
                f = i[h];
                var m = e[f],
                  v = t[f];
                if (r) var E = a ? r(v, m, f, t, e, c) : r(m, v, f, e, t, c);
                if (!(void 0 === E ? m === v || l(m, v, n, r, c) : E)) {
                  u = !1;
                  break;
                }
                p || (p = "constructor" == f);
              }
              if (u && !p) {
                var M = e.constructor,
                  z = t.constructor;
                M == z || !("constructor" in e) || !("constructor" in t) || "function" == typeof M && M instanceof M && "function" == typeof z && z instanceof z || (u = !1);
              }
              return c.delete(e), c.delete(t), u;
            }(e, t, n, r, l, c);
          }(e, t, n, r, kr, l));
        }
        function gr(e, t, n, r) {
          var l = n.length,
            c = l,
            a = !r;
          if (null == e) return !c;
          for (e = me(e); l--;) {
            var i = n[l];
            if (a && i[2] ? i[1] !== e[i[0]] : !(i[0] in e)) return !1;
          }
          for (; ++l < c;) {
            var s = (i = n[l])[0],
              o = e[s],
              h = i[1];
            if (a && i[2]) {
              if (void 0 === o && !(s in e)) return !1;
            } else {
              var f = new Rn();
              if (r) var d = r(o, h, s, e, t, f);
              if (!(void 0 === d ? kr(h, o, 3, r, f) : d)) return !1;
            }
          }
          return !0;
        }
        function br(e) {
          return !(!Ua(e) || (t = e, we && we in t)) && (Pa(e) ? Oe : ae).test(wc(e));
          var t;
        }
        function yr(e) {
          return "function" == typeof e ? e : null == e ? qi : "object" == typeof e ? La(e) ? Cr(e[0], e[1]) : Sr(e) : es(e);
        }
        function _r(e) {
          if (!fc(e)) return ln(e);
          var t = [];
          for (var n in me(e)) _e.call(e, n) && "constructor" != n && t.push(n);
          return t;
        }
        function Wr(e) {
          if (!Ua(e)) return function (e) {
            var t = [];
            if (null != e) for (var n in me(e)) t.push(n);
            return t;
          }(e);
          var t = fc(e),
            n = [];
          for (var r in e) ("constructor" != r || !t && _e.call(e, r)) && n.push(r);
          return n;
        }
        function wr(e, t) {
          return e < t;
        }
        function xr(e, t) {
          var n = -1,
            l = Ia(e) ? r(e.length) : [];
          return er(e, function (e, r, c) {
            l[++n] = t(e, r, c);
          }), l;
        }
        function Sr(e) {
          var t = Jl(e);
          return 1 == t.length && t[0][2] ? uc(t[0][0], t[0][1]) : function (n) {
            return n === e || gr(n, e, t);
          };
        }
        function Cr(e, t) {
          return sc(e) && dc(t) ? uc(Wc(e), t) : function (n) {
            var r = pi(n, e);
            return void 0 === r && r === t ? mi(n, e) : kr(t, r, 3);
          };
        }
        function Or(e, t, n, r, l) {
          e !== t && ar(t, function (c, a) {
            if (l || (l = new Rn()), Ua(c)) !function (e, t, n, r, l, c, a) {
              var i = Ec(e, n),
                s = Ec(t, n),
                o = a.get(s);
              if (o) return void Un(e, n, o);
              var h = c ? c(i, s, n + "", e, t, a) : void 0,
                f = void 0 === h;
              if (f) {
                var d = La(s),
                  u = !d && Fa(s),
                  p = !d && !u && Xa(s);
                h = s, d || u || p ? La(i) ? h = i : Aa(i) ? h = El(i) : u ? (f = !1, h = fl(s, !0)) : p ? (f = !1, h = ul(s, !0)) : h = [] : $a(s) || ja(s) ? (h = i, ja(i) ? h = ci(i) : Ua(i) && !Pa(i) || (h = lc(s))) : f = !1;
              }
              f && (a.set(s, h), l(h, s, r, c, a), a.delete(s));
              Un(e, n, h);
            }(e, t, a, n, Or, r, l);else {
              var i = r ? r(Ec(e, a), c, a + "", e, t, l) : void 0;
              void 0 === i && (i = c), Un(e, a, i);
            }
          }, ki);
        }
        function jr(e, t) {
          var n = e.length;
          if (n) return ac(t += t < 0 ? n : 0, n) ? e[t] : void 0;
        }
        function Lr(e, t, n) {
          var r = -1;
          return t = ut(t.length ? t : [qi], Ot(Kl())), function (e, t) {
            var n = e.length;
            for (e.sort(t); n--;) e[n] = e[n].value;
            return e;
          }(xr(e, function (e, n, l) {
            return {
              criteria: ut(t, function (t) {
                return t(e);
              }),
              index: ++r,
              value: e
            };
          }), function (e, t) {
            return function (e, t, n) {
              var r = -1,
                l = e.criteria,
                c = t.criteria,
                a = l.length,
                i = n.length;
              for (; ++r < a;) {
                var s = pl(l[r], c[r]);
                if (s) {
                  if (r >= i) return s;
                  var o = n[r];
                  return s * ("desc" == o ? -1 : 1);
                }
              }
              return e.index - t.index;
            }(e, t, n);
          });
        }
        function Nr(e, t, n) {
          for (var r = -1, l = t.length, c = {}; ++r < l;) {
            var a = t[r],
              i = fr(e, a);
            n(i, a) && Br(c, il(a, e), i);
          }
          return c;
        }
        function Ir(e, t, n, r) {
          var l = r ? bt : gt,
            c = -1,
            a = t.length,
            i = e;
          for (e === t && (t = El(t)), n && (i = ut(e, Ot(n))); ++c < a;) for (var s = 0, o = t[c], h = n ? n(o) : o; (s = l(i, h, s, r)) > -1;) i !== e && Ze.call(i, s, 1), Ze.call(e, s, 1);
          return e;
        }
        function Ar(e, t) {
          for (var n = e ? t.length : 0, r = n - 1; n--;) {
            var l = t[n];
            if (n == r || l !== c) {
              var c = l;
              ac(l) ? Ze.call(e, l, 1) : Qr(e, l);
            }
          }
          return e;
        }
        function Fr(e, t) {
          return e + Qt(hn() * (t - e + 1));
        }
        function Rr(e, t) {
          var n = "";
          if (!e || t < 1 || t > 9007199254740991) return n;
          do {
            t % 2 && (n += e), (t = Qt(t / 2)) && (e += e);
          } while (t);
          return n;
        }
        function Tr(e, t) {
          return kc(pc(e, t, qi), e + "");
        }
        function Pr(e) {
          return Pn(Si(e));
        }
        function Dr(e, t) {
          var n = Si(e);
          return yc(n, Zn(t, 0, n.length));
        }
        function Br(e, t, n, r) {
          if (!Ua(e)) return e;
          for (var l = -1, c = (t = il(t, e)).length, a = c - 1, i = e; null != i && ++l < c;) {
            var s = Wc(t[l]),
              o = n;
            if (l != a) {
              var h = i[s];
              void 0 === (o = r ? r(h, s, i) : void 0) && (o = Ua(h) ? h : ac(t[l + 1]) ? [] : {});
            }
            Vn(i, s, o), i = i[s];
          }
          return e;
        }
        var Ur = Mn ? function (e, t) {
            return Mn.set(e, t), e;
          } : qi,
          Vr = wt ? function (e, t) {
            return wt(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: Ui(t),
              writable: !0
            });
          } : qi;
        function Hr(e) {
          return yc(Si(e));
        }
        function qr(e, t, n) {
          var l = -1,
            c = e.length;
          t < 0 && (t = -t > c ? 0 : c + t), (n = n > c ? c : n) < 0 && (n += c), c = t > n ? 0 : n - t >>> 0, t >>>= 0;
          for (var a = r(c); ++l < c;) a[l] = e[l + t];
          return a;
        }
        function $r(e, t) {
          var n;
          return er(e, function (e, r, l) {
            return !(n = t(e, r, l));
          }), !!n;
        }
        function Gr(e, t, n) {
          var r = 0,
            l = null == e ? r : e.length;
          if ("number" == typeof t && t == t && l <= 2147483647) {
            for (; r < l;) {
              var c = r + l >>> 1,
                a = e[c];
              null !== a && !Ka(a) && (n ? a <= t : a < t) ? r = c + 1 : l = c;
            }
            return l;
          }
          return Yr(e, t, qi, n);
        }
        function Yr(e, t, n, r) {
          t = n(t);
          for (var l = 0, c = null == e ? 0 : e.length, a = t != t, i = null === t, s = Ka(t), o = void 0 === t; l < c;) {
            var h = Qt((l + c) / 2),
              f = n(e[h]),
              d = void 0 !== f,
              u = null === f,
              p = f == f,
              m = Ka(f);
            if (a) var v = r || p;else v = o ? p && (r || d) : i ? p && d && (r || !u) : s ? p && d && !u && (r || !m) : !u && !m && (r ? f <= t : f < t);
            v ? l = h + 1 : c = h;
          }
          return an(c, 4294967294);
        }
        function Zr(e, t) {
          for (var n = -1, r = e.length, l = 0, c = []; ++n < r;) {
            var a = e[n],
              i = t ? t(a) : a;
            if (!n || !Sa(i, s)) {
              var s = i;
              c[l++] = 0 === a ? 0 : a;
            }
          }
          return c;
        }
        function Kr(e) {
          return "number" == typeof e ? e : Ka(e) ? NaN : +e;
        }
        function Xr(e) {
          if ("string" == typeof e) return e;
          if (La(e)) return ut(e, Xr) + "";
          if (Ka(e)) return xn ? xn.call(e) : "";
          var t = e + "";
          return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
        }
        function Jr(e, t, n) {
          var r = -1,
            l = ft,
            c = e.length,
            a = !0,
            i = [],
            s = i;
          if (n) a = !1, l = dt;else if (c >= 200) {
            var o = t ? null : Rl(e);
            if (o) return Vt(o);
            a = !1, l = Lt, s = new Fn();
          } else s = t ? [] : i;
          e: for (; ++r < c;) {
            var h = e[r],
              f = t ? t(h) : h;
            if (h = n || 0 !== h ? h : 0, a && f == f) {
              for (var d = s.length; d--;) if (s[d] === f) continue e;
              t && s.push(f), i.push(h);
            } else l(s, f, n) || (s !== i && s.push(f), i.push(h));
          }
          return i;
        }
        function Qr(e, t) {
          return null == (e = mc(e, t = il(t, e))) || delete e[Wc(Tc(t))];
        }
        function el(e, t, n, r) {
          return Br(e, t, n(fr(e, t)), r);
        }
        function tl(e, t, n, r) {
          for (var l = e.length, c = r ? l : -1; (r ? c-- : ++c < l) && t(e[c], c, e););
          return n ? qr(e, r ? 0 : c, r ? c + 1 : l) : qr(e, r ? c + 1 : 0, r ? l : c);
        }
        function nl(e, t) {
          var n = e;
          return n instanceof Ln && (n = n.value()), mt(t, function (e, t) {
            return t.func.apply(t.thisArg, pt([e], t.args));
          }, n);
        }
        function rl(e, t, n) {
          var l = e.length;
          if (l < 2) return l ? Jr(e[0]) : [];
          for (var c = -1, a = r(l); ++c < l;) for (var i = e[c], s = -1; ++s < l;) s != c && (a[c] = Qn(a[c] || i, e[s], t, n));
          return Jr(cr(a, 1), t, n);
        }
        function ll(e, t, n) {
          for (var r = -1, l = e.length, c = t.length, a = {}; ++r < l;) {
            var i = r < c ? t[r] : void 0;
            n(a, e[r], i);
          }
          return a;
        }
        function cl(e) {
          return Aa(e) ? e : [];
        }
        function al(e) {
          return "function" == typeof e ? e : qi;
        }
        function il(e, t) {
          return La(e) ? e : sc(e, t) ? [e] : _c(ai(e));
        }
        var sl = Tr;
        function ol(e, t, n) {
          var r = e.length;
          return n = void 0 === n ? r : n, !t && n >= r ? e : qr(e, t, n);
        }
        var hl = Zt || function (e) {
          return Ge.clearTimeout(e);
        };
        function fl(e, t) {
          if (t) return e.slice();
          var n = e.length,
            r = Ue ? Ue(n) : new e.constructor(n);
          return e.copy(r), r;
        }
        function dl(e) {
          var t = new e.constructor(e.byteLength);
          return new Fe(t).set(new Fe(e)), t;
        }
        function ul(e, t) {
          var n = t ? dl(e.buffer) : e.buffer;
          return new e.constructor(n, e.byteOffset, e.length);
        }
        function pl(e, t) {
          if (e !== t) {
            var n = void 0 !== e,
              r = null === e,
              l = e == e,
              c = Ka(e),
              a = void 0 !== t,
              i = null === t,
              s = t == t,
              o = Ka(t);
            if (!i && !o && !c && e > t || c && a && s && !i && !o || r && a && s || !n && s || !l) return 1;
            if (!r && !c && !o && e < t || o && n && l && !r && !c || i && n && l || !a && l || !s) return -1;
          }
          return 0;
        }
        function ml(e, t, n, l) {
          for (var c = -1, a = e.length, i = n.length, s = -1, o = t.length, h = cn(a - i, 0), f = r(o + h), d = !l; ++s < o;) f[s] = t[s];
          for (; ++c < i;) (d || c < a) && (f[n[c]] = e[c]);
          for (; h--;) f[s++] = e[c++];
          return f;
        }
        function vl(e, t, n, l) {
          for (var c = -1, a = e.length, i = -1, s = n.length, o = -1, h = t.length, f = cn(a - s, 0), d = r(f + h), u = !l; ++c < f;) d[c] = e[c];
          for (var p = c; ++o < h;) d[p + o] = t[o];
          for (; ++i < s;) (u || c < a) && (d[p + n[i]] = e[c++]);
          return d;
        }
        function El(e, t) {
          var n = -1,
            l = e.length;
          for (t || (t = r(l)); ++n < l;) t[n] = e[n];
          return t;
        }
        function Ml(e, t, n, r) {
          var l = !n;
          n || (n = {});
          for (var c = -1, a = t.length; ++c < a;) {
            var i = t[c],
              s = r ? r(n[i], e[i], i, n, e) : void 0;
            void 0 === s && (s = e[i]), l ? Gn(n, i, s) : Vn(n, i, s);
          }
          return n;
        }
        function zl(e, t) {
          return function (n, r) {
            var l = La(n) ? at : qn,
              c = t ? t() : {};
            return l(n, e, Kl(r, 2), c);
          };
        }
        function kl(e) {
          return Tr(function (t, n) {
            var r = -1,
              l = n.length,
              c = l > 1 ? n[l - 1] : void 0,
              a = l > 2 ? n[2] : void 0;
            for (c = e.length > 3 && "function" == typeof c ? (l--, c) : void 0, a && ic(n[0], n[1], a) && (c = l < 3 ? void 0 : c, l = 1), t = me(t); ++r < l;) {
              var i = n[r];
              i && e(t, i, r, c);
            }
            return t;
          });
        }
        function gl(e, t) {
          return function (n, r) {
            if (null == n) return n;
            if (!Ia(n)) return e(n, r);
            for (var l = n.length, c = t ? l : -1, a = me(n); (t ? c-- : ++c < l) && !1 !== r(a[c], c, a););
            return n;
          };
        }
        function bl(e) {
          return function (t, n, r) {
            for (var l = -1, c = me(t), a = r(t), i = a.length; i--;) {
              var s = a[e ? i : ++l];
              if (!1 === n(c[s], s, c)) break;
            }
            return t;
          };
        }
        function yl(e) {
          return function (t) {
            var n = Pt(t = ai(t)) ? $t(t) : void 0,
              r = n ? n[0] : t.charAt(0),
              l = n ? ol(n, 1).join("") : t.slice(1);
            return r[e]() + l;
          };
        }
        function _l(e) {
          return function (t) {
            return mt(Pi(ji(t).replace(Le, "")), e, "");
          };
        }
        function Wl(e) {
          return function () {
            var t = arguments;
            switch (t.length) {
              case 0:
                return new e();
              case 1:
                return new e(t[0]);
              case 2:
                return new e(t[0], t[1]);
              case 3:
                return new e(t[0], t[1], t[2]);
              case 4:
                return new e(t[0], t[1], t[2], t[3]);
              case 5:
                return new e(t[0], t[1], t[2], t[3], t[4]);
              case 6:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
              case 7:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
            }
            var n = Cn(e.prototype),
              r = e.apply(n, t);
            return Ua(r) ? r : n;
          };
        }
        function wl(e) {
          return function (t, n, r) {
            var l = me(t);
            if (!Ia(t)) {
              var c = Kl(n, 3);
              t = zi(t), n = function n(e) {
                return c(l[e], e, l);
              };
            }
            var a = e(t, n, r);
            return a > -1 ? l[c ? t[a] : a] : void 0;
          };
        }
        function xl(e) {
          return Hl(function (t) {
            var n = t.length,
              r = n,
              l = jn.prototype.thru;
            for (e && t.reverse(); r--;) {
              var a = t[r];
              if ("function" != typeof a) throw new Me(c);
              if (l && !i && "wrapper" == Yl(a)) var i = new jn([], !0);
            }
            for (r = i ? r : n; ++r < n;) {
              var s = Yl(a = t[r]),
                o = "wrapper" == s ? Gl(a) : void 0;
              i = o && oc(o[0]) && 424 == o[1] && !o[4].length && 1 == o[9] ? i[Yl(o[0])].apply(i, o[3]) : 1 == a.length && oc(a) ? i[s]() : i.thru(a);
            }
            return function () {
              var e = arguments,
                r = e[0];
              if (i && 1 == e.length && La(r)) return i.plant(r).value();
              for (var l = 0, c = n ? t[l].apply(this, e) : r; ++l < n;) c = t[l].call(this, c);
              return c;
            };
          });
        }
        function Sl(e, t, n, l, c, a, i, s, o, h) {
          var f = 128 & t,
            d = 1 & t,
            u = 2 & t,
            p = 24 & t,
            m = 512 & t,
            v = u ? void 0 : Wl(e);
          return function E() {
            for (var M = arguments.length, z = r(M), k = M; k--;) z[k] = arguments[k];
            if (p) var g = Zl(E),
              b = At(z, g);
            if (l && (z = ml(z, l, c, p)), a && (z = vl(z, a, i, p)), M -= b, p && M < h) {
              var y = Ut(z, g);
              return Al(e, t, Sl, E.placeholder, n, z, y, s, o, h - M);
            }
            var _ = d ? n : this,
              W = u ? _[e] : e;
            return M = z.length, s ? z = vc(z, s) : m && M > 1 && z.reverse(), f && o < M && (z.length = o), this && this !== Ge && this instanceof E && (W = v || Wl(W)), W.apply(_, z);
          };
        }
        function Cl(e, t) {
          return function (n, r) {
            return function (e, t, n, r) {
              return sr(e, function (e, l, c) {
                t(r, n(e), l, c);
              }), r;
            }(n, e, t(r), {});
          };
        }
        function Ol(e, t) {
          return function (n, r) {
            var l;
            if (void 0 === n && void 0 === r) return t;
            if (void 0 !== n && (l = n), void 0 !== r) {
              if (void 0 === l) return r;
              "string" == typeof n || "string" == typeof r ? (n = Xr(n), r = Xr(r)) : (n = Kr(n), r = Kr(r)), l = e(n, r);
            }
            return l;
          };
        }
        function jl(e) {
          return Hl(function (t) {
            return t = ut(t, Ot(Kl())), Tr(function (n) {
              var r = this;
              return e(t, function (e) {
                return ct(e, r, n);
              });
            });
          });
        }
        function Ll(e, t) {
          var n = (t = void 0 === t ? " " : Xr(t)).length;
          if (n < 2) return n ? Rr(t, e) : t;
          var r = Rr(t, Jt(e / qt(t)));
          return Pt(t) ? ol($t(r), 0, e).join("") : r.slice(0, e);
        }
        function Nl(e) {
          return function (t, n, l) {
            return l && "number" != typeof l && ic(t, n, l) && (n = l = void 0), t = ti(t), void 0 === n ? (n = t, t = 0) : n = ti(n), function (e, t, n, l) {
              for (var c = -1, a = cn(Jt((t - e) / (n || 1)), 0), i = r(a); a--;) i[l ? a : ++c] = e, e += n;
              return i;
            }(t, n, l = void 0 === l ? t < n ? 1 : -1 : ti(l), e);
          };
        }
        function Il(e) {
          return function (t, n) {
            return "string" == typeof t && "string" == typeof n || (t = li(t), n = li(n)), e(t, n);
          };
        }
        function Al(e, t, n, r, l, c, a, i, s, o) {
          var h = 8 & t;
          t |= h ? 32 : 64, 4 & (t &= ~(h ? 64 : 32)) || (t &= -4);
          var f = [e, t, l, h ? c : void 0, h ? a : void 0, h ? void 0 : c, h ? void 0 : a, i, s, o],
            d = n.apply(void 0, f);
          return oc(e) && Mc(d, f), d.placeholder = r, gc(d, e, t);
        }
        function Fl(e) {
          var t = pe[e];
          return function (e, n) {
            if (e = li(e), (n = null == n ? 0 : an(ni(n), 292)) && nn(e)) {
              var r = (ai(e) + "e").split("e");
              return +((r = (ai(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
            }
            return t(e);
          };
        }
        var Rl = mn && 1 / Vt(new mn([, -0]))[1] == 1 / 0 ? function (e) {
          return new mn(e);
        } : Ki;
        function Tl(e) {
          return function (t) {
            var n = nc(t);
            return n == m ? Dt(t) : n == z ? Ht(t) : function (e, t) {
              return ut(t, function (t) {
                return [t, e[t]];
              });
            }(t, e(t));
          };
        }
        function Pl(e, t, n, l, i, s, o, h) {
          var f = 2 & t;
          if (!f && "function" != typeof e) throw new Me(c);
          var d = l ? l.length : 0;
          if (d || (t &= -97, l = i = void 0), o = void 0 === o ? o : cn(ni(o), 0), h = void 0 === h ? h : ni(h), d -= i ? i.length : 0, 64 & t) {
            var u = l,
              p = i;
            l = i = void 0;
          }
          var m = f ? void 0 : Gl(e),
            v = [e, t, n, l, i, u, p, s, o, h];
          if (m && function (e, t) {
            var n = e[1],
              r = t[1],
              l = n | r,
              c = l < 131,
              i = 128 == r && 8 == n || 128 == r && 256 == n && e[7].length <= t[8] || 384 == r && t[7].length <= t[8] && 8 == n;
            if (!c && !i) return e;
            1 & r && (e[2] = t[2], l |= 1 & n ? 0 : 4);
            var s = t[3];
            if (s) {
              var o = e[3];
              e[3] = o ? ml(o, s, t[4]) : s, e[4] = o ? Ut(e[3], a) : t[4];
            }
            (s = t[5]) && (o = e[5], e[5] = o ? vl(o, s, t[6]) : s, e[6] = o ? Ut(e[5], a) : t[6]);
            (s = t[7]) && (e[7] = s);
            128 & r && (e[8] = null == e[8] ? t[8] : an(e[8], t[8]));
            null == e[9] && (e[9] = t[9]);
            e[0] = t[0], e[1] = l;
          }(v, m), e = v[0], t = v[1], n = v[2], l = v[3], i = v[4], !(h = v[9] = void 0 === v[9] ? f ? 0 : e.length : cn(v[9] - d, 0)) && 24 & t && (t &= -25), t && 1 != t) E = 8 == t || 16 == t ? function (e, t, n) {
            var l = Wl(e);
            return function c() {
              for (var a = arguments.length, i = r(a), s = a, o = Zl(c); s--;) i[s] = arguments[s];
              var h = a < 3 && i[0] !== o && i[a - 1] !== o ? [] : Ut(i, o);
              if ((a -= h.length) < n) return Al(e, t, Sl, c.placeholder, void 0, i, h, void 0, void 0, n - a);
              var f = this && this !== Ge && this instanceof c ? l : e;
              return ct(f, this, i);
            };
          }(e, t, h) : 32 != t && 33 != t || i.length ? Sl.apply(void 0, v) : function (e, t, n, l) {
            var c = 1 & t,
              a = Wl(e);
            return function t() {
              for (var i = -1, s = arguments.length, o = -1, h = l.length, f = r(h + s), d = this && this !== Ge && this instanceof t ? a : e; ++o < h;) f[o] = l[o];
              for (; s--;) f[o++] = arguments[++i];
              return ct(d, c ? n : this, f);
            };
          }(e, t, n, l);else var E = function (e, t, n) {
            var r = 1 & t,
              l = Wl(e);
            return function t() {
              var c = this && this !== Ge && this instanceof t ? l : e;
              return c.apply(r ? n : this, arguments);
            };
          }(e, t, n);
          return gc((m ? Ur : Mc)(E, v), e, t);
        }
        function Dl(e, t, n, r) {
          return void 0 === e || Sa(e, ge[n]) && !_e.call(r, n) ? t : e;
        }
        function Bl(e, t, n, r, l, c) {
          return Ua(e) && Ua(t) && (c.set(t, e), Or(e, t, void 0, Bl, c), c.delete(t)), e;
        }
        function Ul(e) {
          return $a(e) ? void 0 : e;
        }
        function Vl(e, t, n, r, l, c) {
          var a = 1 & n,
            i = e.length,
            s = t.length;
          if (i != s && !(a && s > i)) return !1;
          var o = c.get(e);
          if (o && c.get(t)) return o == t;
          var h = -1,
            f = !0,
            d = 2 & n ? new Fn() : void 0;
          for (c.set(e, t), c.set(t, e); ++h < i;) {
            var u = e[h],
              p = t[h];
            if (r) var m = a ? r(p, u, h, t, e, c) : r(u, p, h, e, t, c);
            if (void 0 !== m) {
              if (m) continue;
              f = !1;
              break;
            }
            if (d) {
              if (!Et(t, function (e, t) {
                if (!Lt(d, t) && (u === e || l(u, e, n, r, c))) return d.push(t);
              })) {
                f = !1;
                break;
              }
            } else if (u !== p && !l(u, p, n, r, c)) {
              f = !1;
              break;
            }
          }
          return c.delete(e), c.delete(t), f;
        }
        function Hl(e) {
          return kc(pc(e, void 0, Nc), e + "");
        }
        function ql(e) {
          return dr(e, zi, ec);
        }
        function $l(e) {
          return dr(e, ki, tc);
        }
        var Gl = Mn ? function (e) {
          return Mn.get(e);
        } : Ki;
        function Yl(e) {
          for (var t = e.name + "", n = zn[t], r = _e.call(zn, t) ? n.length : 0; r--;) {
            var l = n[r],
              c = l.func;
            if (null == c || c == e) return l.name;
          }
          return t;
        }
        function Zl(e) {
          return (_e.call(Sn, "placeholder") ? Sn : e).placeholder;
        }
        function Kl() {
          var e = Sn.iteratee || $i;
          return e = e === $i ? yr : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function Xl(e, t) {
          var n,
            r,
            l = e.__data__;
          return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? l["string" == typeof t ? "string" : "hash"] : l.map;
        }
        function Jl(e) {
          for (var t = zi(e), n = t.length; n--;) {
            var r = t[n],
              l = e[r];
            t[n] = [r, l, dc(l)];
          }
          return t;
        }
        function Ql(e, t) {
          var n = function (e, t) {
            return null == e ? void 0 : e[t];
          }(e, t);
          return br(n) ? n : void 0;
        }
        var ec = en ? function (e) {
            return null == e ? [] : (e = me(e), ht(en(e), function (t) {
              return Ye.call(e, t);
            }));
          } : rs,
          tc = en ? function (e) {
            for (var t = []; e;) pt(t, ec(e)), e = qe(e);
            return t;
          } : rs,
          nc = ur;
        function rc(e, t, n) {
          for (var r = -1, l = (t = il(t, e)).length, c = !1; ++r < l;) {
            var a = Wc(t[r]);
            if (!(c = null != e && n(e, a))) break;
            e = e[a];
          }
          return c || ++r != l ? c : !!(l = null == e ? 0 : e.length) && Ba(l) && ac(a, l) && (La(e) || ja(e));
        }
        function lc(e) {
          return "function" != typeof e.constructor || fc(e) ? {} : Cn(qe(e));
        }
        function cc(e) {
          return La(e) || ja(e) || !!(Xe && e && e[Xe]);
        }
        function ac(e, t) {
          var n = typeof e;
          return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && se.test(e)) && e > -1 && e % 1 == 0 && e < t;
        }
        function ic(e, t, n) {
          if (!Ua(n)) return !1;
          var r = typeof t;
          return !!("number" == r ? Ia(n) && ac(t, n.length) : "string" == r && t in n) && Sa(n[t], e);
        }
        function sc(e, t) {
          if (La(e)) return !1;
          var n = typeof e;
          return !("number" != n && "symbol" != n && "boolean" != n && null != e && !Ka(e)) || H.test(e) || !V.test(e) || null != t && e in me(t);
        }
        function oc(e) {
          var t = Yl(e),
            n = Sn[t];
          if ("function" != typeof n || !(t in Ln.prototype)) return !1;
          if (e === n) return !0;
          var r = Gl(n);
          return !!r && e === r[0];
        }
        (dn && nc(new dn(new ArrayBuffer(1))) != _ || un && nc(new un()) != m || pn && "[object Promise]" != nc(pn.resolve()) || mn && nc(new mn()) != z || vn && nc(new vn()) != b) && (nc = function nc(e) {
          var t = ur(e),
            n = t == E ? e.constructor : void 0,
            r = n ? wc(n) : "";
          if (r) switch (r) {
            case kn:
              return _;
            case gn:
              return m;
            case bn:
              return "[object Promise]";
            case yn:
              return z;
            case _n:
              return b;
          }
          return t;
        });
        var hc = be ? Pa : ls;
        function fc(e) {
          var t = e && e.constructor;
          return e === ("function" == typeof t && t.prototype || ge);
        }
        function dc(e) {
          return e == e && !Ua(e);
        }
        function uc(e, t) {
          return function (n) {
            return null != n && n[e] === t && (void 0 !== t || e in me(n));
          };
        }
        function pc(e, t, n) {
          return t = cn(void 0 === t ? e.length - 1 : t, 0), function () {
            for (var l = arguments, c = -1, a = cn(l.length - t, 0), i = r(a); ++c < a;) i[c] = l[t + c];
            c = -1;
            for (var s = r(t + 1); ++c < t;) s[c] = l[c];
            return s[t] = n(i), ct(e, this, s);
          };
        }
        function mc(e, t) {
          return t.length < 2 ? e : fr(e, qr(t, 0, -1));
        }
        function vc(e, t) {
          for (var n = e.length, r = an(t.length, n), l = El(e); r--;) {
            var c = t[r];
            e[r] = ac(c, n) ? l[c] : void 0;
          }
          return e;
        }
        function Ec(e, t) {
          if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
        }
        var Mc = bc(Ur),
          zc = Xt || function (e, t) {
            return Ge.setTimeout(e, t);
          },
          kc = bc(Vr);
        function gc(e, t, n) {
          var r = t + "";
          return kc(e, function (e, t) {
            var n = t.length;
            if (!n) return e;
            var r = n - 1;
            return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(X, "{\n/* [wrapped with " + t + "] */\n");
          }(r, function (e, t) {
            return it(i, function (n) {
              var r = "_." + n[0];
              t & n[1] && !ft(e, r) && e.push(r);
            }), e.sort();
          }(function (e) {
            var t = e.match(J);
            return t ? t[1].split(Q) : [];
          }(r), n)));
        }
        function bc(e) {
          var t = 0,
            n = 0;
          return function () {
            var r = sn(),
              l = 16 - (r - n);
            if (n = r, l > 0) {
              if (++t >= 800) return arguments[0];
            } else t = 0;
            return e.apply(void 0, arguments);
          };
        }
        function yc(e, t) {
          var n = -1,
            r = e.length,
            l = r - 1;
          for (t = void 0 === t ? r : t; ++n < t;) {
            var c = Fr(n, l),
              a = e[c];
            e[c] = e[n], e[n] = a;
          }
          return e.length = t, e;
        }
        var _c = function (e) {
          var t = ba(e, function (e) {
              return 500 === n.size && n.clear(), e;
            }),
            n = t.cache;
          return t;
        }(function (e) {
          var t = [];
          return 46 === e.charCodeAt(0) && t.push(""), e.replace(q, function (e, n, r, l) {
            t.push(r ? l.replace(te, "$1") : n || e);
          }), t;
        });
        function Wc(e) {
          if ("string" == typeof e || Ka(e)) return e;
          var t = e + "";
          return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
        }
        function wc(e) {
          if (null != e) {
            try {
              return ye.call(e);
            } catch (e) {}
            try {
              return e + "";
            } catch (e) {}
          }
          return "";
        }
        function xc(e) {
          if (e instanceof Ln) return e.clone();
          var t = new jn(e.__wrapped__, e.__chain__);
          return t.__actions__ = El(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
        }
        var Sc = Tr(function (e, t) {
            return Aa(e) ? Qn(e, cr(t, 1, Aa, !0)) : [];
          }),
          Cc = Tr(function (e, t) {
            var n = Tc(t);
            return Aa(n) && (n = void 0), Aa(e) ? Qn(e, cr(t, 1, Aa, !0), Kl(n, 2)) : [];
          }),
          Oc = Tr(function (e, t) {
            var n = Tc(t);
            return Aa(n) && (n = void 0), Aa(e) ? Qn(e, cr(t, 1, Aa, !0), void 0, n) : [];
          });
        function jc(e, t, n) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var l = null == n ? 0 : ni(n);
          return l < 0 && (l = cn(r + l, 0)), kt(e, Kl(t, 3), l);
        }
        function Lc(e, t, n) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var l = r - 1;
          return void 0 !== n && (l = ni(n), l = n < 0 ? cn(r + l, 0) : an(l, r - 1)), kt(e, Kl(t, 3), l, !0);
        }
        function Nc(e) {
          return (null == e ? 0 : e.length) ? cr(e, 1) : [];
        }
        function Ic(e) {
          return e && e.length ? e[0] : void 0;
        }
        var Ac = Tr(function (e) {
            var t = ut(e, cl);
            return t.length && t[0] === e[0] ? Er(t) : [];
          }),
          Fc = Tr(function (e) {
            var t = Tc(e),
              n = ut(e, cl);
            return t === Tc(n) ? t = void 0 : n.pop(), n.length && n[0] === e[0] ? Er(n, Kl(t, 2)) : [];
          }),
          Rc = Tr(function (e) {
            var t = Tc(e),
              n = ut(e, cl);
            return (t = "function" == typeof t ? t : void 0) && n.pop(), n.length && n[0] === e[0] ? Er(n, void 0, t) : [];
          });
        function Tc(e) {
          var t = null == e ? 0 : e.length;
          return t ? e[t - 1] : void 0;
        }
        var Pc = Tr(Dc);
        function Dc(e, t) {
          return e && e.length && t && t.length ? Ir(e, t) : e;
        }
        var Bc = Hl(function (e, t) {
          var n = null == e ? 0 : e.length,
            r = Yn(e, t);
          return Ar(e, ut(t, function (e) {
            return ac(e, n) ? +e : e;
          }).sort(pl)), r;
        });
        function Uc(e) {
          return null == e ? e : fn.call(e);
        }
        var Vc = Tr(function (e) {
            return Jr(cr(e, 1, Aa, !0));
          }),
          Hc = Tr(function (e) {
            var t = Tc(e);
            return Aa(t) && (t = void 0), Jr(cr(e, 1, Aa, !0), Kl(t, 2));
          }),
          qc = Tr(function (e) {
            var t = Tc(e);
            return t = "function" == typeof t ? t : void 0, Jr(cr(e, 1, Aa, !0), void 0, t);
          });
        function $c(e) {
          if (!e || !e.length) return [];
          var t = 0;
          return e = ht(e, function (e) {
            if (Aa(e)) return t = cn(e.length, t), !0;
          }), Ct(t, function (t) {
            return ut(e, Wt(t));
          });
        }
        function Gc(e, t) {
          if (!e || !e.length) return [];
          var n = $c(e);
          return null == t ? n : ut(n, function (e) {
            return ct(t, void 0, e);
          });
        }
        var Yc = Tr(function (e, t) {
            return Aa(e) ? Qn(e, t) : [];
          }),
          Zc = Tr(function (e) {
            return rl(ht(e, Aa));
          }),
          Kc = Tr(function (e) {
            var t = Tc(e);
            return Aa(t) && (t = void 0), rl(ht(e, Aa), Kl(t, 2));
          }),
          Xc = Tr(function (e) {
            var t = Tc(e);
            return t = "function" == typeof t ? t : void 0, rl(ht(e, Aa), void 0, t);
          }),
          Jc = Tr($c);
        var Qc = Tr(function (e) {
          var t = e.length,
            n = t > 1 ? e[t - 1] : void 0;
          return n = "function" == typeof n ? (e.pop(), n) : void 0, Gc(e, n);
        });
        function ea(e) {
          var t = Sn(e);
          return t.__chain__ = !0, t;
        }
        function ta(e, t) {
          return t(e);
        }
        var na = Hl(function (e) {
          var t = e.length,
            n = t ? e[0] : 0,
            r = this.__wrapped__,
            l = function l(t) {
              return Yn(t, e);
            };
          return !(t > 1 || this.__actions__.length) && r instanceof Ln && ac(n) ? ((r = r.slice(n, +n + (t ? 1 : 0))).__actions__.push({
            func: ta,
            args: [l],
            thisArg: void 0
          }), new jn(r, this.__chain__).thru(function (e) {
            return t && !e.length && e.push(void 0), e;
          })) : this.thru(l);
        });
        var ra = zl(function (e, t, n) {
          _e.call(e, n) ? ++e[n] : Gn(e, n, 1);
        });
        var la = wl(jc),
          ca = wl(Lc);
        function aa(e, t) {
          return (La(e) ? it : er)(e, Kl(t, 3));
        }
        function ia(e, t) {
          return (La(e) ? st : tr)(e, Kl(t, 3));
        }
        var sa = zl(function (e, t, n) {
          _e.call(e, n) ? e[n].push(t) : Gn(e, n, [t]);
        });
        var oa = Tr(function (e, t, n) {
            var l = -1,
              c = "function" == typeof t,
              a = Ia(e) ? r(e.length) : [];
            return er(e, function (e) {
              a[++l] = c ? ct(t, e, n) : Mr(e, t, n);
            }), a;
          }),
          ha = zl(function (e, t, n) {
            Gn(e, n, t);
          });
        function fa(e, t) {
          return (La(e) ? ut : xr)(e, Kl(t, 3));
        }
        var da = zl(function (e, t, n) {
          e[n ? 0 : 1].push(t);
        }, function () {
          return [[], []];
        });
        var ua = Tr(function (e, t) {
            if (null == e) return [];
            var n = t.length;
            return n > 1 && ic(e, t[0], t[1]) ? t = [] : n > 2 && ic(t[0], t[1], t[2]) && (t = [t[0]]), Lr(e, cr(t, 1), []);
          }),
          pa = Kt || function () {
            return Ge.Date.now();
          };
        function ma(e, t, n) {
          return t = n ? void 0 : t, Pl(e, 128, void 0, void 0, void 0, void 0, t = e && null == t ? e.length : t);
        }
        function va(e, t) {
          var n;
          if ("function" != typeof t) throw new Me(c);
          return e = ni(e), function () {
            return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = void 0), n;
          };
        }
        var Ea = Tr(function (e, t, n) {
            var r = 1;
            if (n.length) {
              var l = Ut(n, Zl(Ea));
              r |= 32;
            }
            return Pl(e, r, t, n, l);
          }),
          Ma = Tr(function (e, t, n) {
            var r = 3;
            if (n.length) {
              var l = Ut(n, Zl(Ma));
              r |= 32;
            }
            return Pl(t, r, e, n, l);
          });
        function za(e, t, n) {
          var r,
            l,
            a,
            i,
            s,
            o,
            h = 0,
            f = !1,
            d = !1,
            u = !0;
          if ("function" != typeof e) throw new Me(c);
          function p(t) {
            var n = r,
              c = l;
            return r = l = void 0, h = t, i = e.apply(c, n);
          }
          function m(e) {
            return h = e, s = zc(E, t), f ? p(e) : i;
          }
          function v(e) {
            var n = e - o;
            return void 0 === o || n >= t || n < 0 || d && e - h >= a;
          }
          function E() {
            var e = pa();
            if (v(e)) return M(e);
            s = zc(E, function (e) {
              var n = t - (e - o);
              return d ? an(n, a - (e - h)) : n;
            }(e));
          }
          function M(e) {
            return s = void 0, u && r ? p(e) : (r = l = void 0, i);
          }
          function z() {
            var e = pa(),
              n = v(e);
            if (r = arguments, l = this, o = e, n) {
              if (void 0 === s) return m(o);
              if (d) return hl(s), s = zc(E, t), p(o);
            }
            return void 0 === s && (s = zc(E, t)), i;
          }
          return t = li(t) || 0, Ua(n) && (f = !!n.leading, a = (d = "maxWait" in n) ? cn(li(n.maxWait) || 0, t) : a, u = "trailing" in n ? !!n.trailing : u), z.cancel = function () {
            void 0 !== s && hl(s), h = 0, r = o = l = s = void 0;
          }, z.flush = function () {
            return void 0 === s ? i : M(pa());
          }, z;
        }
        var ka = Tr(function (e, t) {
            return Jn(e, 1, t);
          }),
          ga = Tr(function (e, t, n) {
            return Jn(e, li(t) || 0, n);
          });
        function ba(e, t) {
          if ("function" != typeof e || null != t && "function" != typeof t) throw new Me(c);
          var n = function n() {
            var r = arguments,
              l = t ? t.apply(this, r) : r[0],
              c = n.cache;
            if (c.has(l)) return c.get(l);
            var a = e.apply(this, r);
            return n.cache = c.set(l, a) || c, a;
          };
          return n.cache = new (ba.Cache || An)(), n;
        }
        function ya(e) {
          if ("function" != typeof e) throw new Me(c);
          return function () {
            var t = arguments;
            switch (t.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, t[0]);
              case 2:
                return !e.call(this, t[0], t[1]);
              case 3:
                return !e.call(this, t[0], t[1], t[2]);
            }
            return !e.apply(this, t);
          };
        }
        ba.Cache = An;
        var _a = sl(function (e, t) {
            var n = (t = 1 == t.length && La(t[0]) ? ut(t[0], Ot(Kl())) : ut(cr(t, 1), Ot(Kl()))).length;
            return Tr(function (r) {
              for (var l = -1, c = an(r.length, n); ++l < c;) r[l] = t[l].call(this, r[l]);
              return ct(e, this, r);
            });
          }),
          Wa = Tr(function (e, t) {
            return Pl(e, 32, void 0, t, Ut(t, Zl(Wa)));
          }),
          wa = Tr(function (e, t) {
            return Pl(e, 64, void 0, t, Ut(t, Zl(wa)));
          }),
          xa = Hl(function (e, t) {
            return Pl(e, 256, void 0, void 0, void 0, t);
          });
        function Sa(e, t) {
          return e === t || e != e && t != t;
        }
        var Ca = Il(pr),
          Oa = Il(function (e, t) {
            return e >= t;
          }),
          ja = zr(function () {
            return arguments;
          }()) ? zr : function (e) {
            return Va(e) && _e.call(e, "callee") && !Ye.call(e, "callee");
          },
          La = r.isArray,
          Na = Qe ? Ot(Qe) : function (e) {
            return Va(e) && ur(e) == y;
          };
        function Ia(e) {
          return null != e && Ba(e.length) && !Pa(e);
        }
        function Aa(e) {
          return Va(e) && Ia(e);
        }
        var Fa = tn || ls,
          Ra = et ? Ot(et) : function (e) {
            return Va(e) && ur(e) == f;
          };
        function Ta(e) {
          if (!Va(e)) return !1;
          var t = ur(e);
          return t == d || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !$a(e);
        }
        function Pa(e) {
          if (!Ua(e)) return !1;
          var t = ur(e);
          return t == u || t == p || "[object AsyncFunction]" == t || "[object Proxy]" == t;
        }
        function Da(e) {
          return "number" == typeof e && e == ni(e);
        }
        function Ba(e) {
          return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
        }
        function Ua(e) {
          var t = typeof e;
          return null != e && ("object" == t || "function" == t);
        }
        function Va(e) {
          return null != e && "object" == typeof e;
        }
        var Ha = tt ? Ot(tt) : function (e) {
          return Va(e) && nc(e) == m;
        };
        function qa(e) {
          return "number" == typeof e || Va(e) && ur(e) == v;
        }
        function $a(e) {
          if (!Va(e) || ur(e) != E) return !1;
          var t = qe(e);
          if (null === t) return !0;
          var n = _e.call(t, "constructor") && t.constructor;
          return "function" == typeof n && n instanceof n && ye.call(n) == Se;
        }
        var Ga = nt ? Ot(nt) : function (e) {
          return Va(e) && ur(e) == M;
        };
        var Ya = rt ? Ot(rt) : function (e) {
          return Va(e) && nc(e) == z;
        };
        function Za(e) {
          return "string" == typeof e || !La(e) && Va(e) && ur(e) == k;
        }
        function Ka(e) {
          return "symbol" == typeof e || Va(e) && ur(e) == g;
        }
        var Xa = lt ? Ot(lt) : function (e) {
          return Va(e) && Ba(e.length) && !!De[ur(e)];
        };
        var Ja = Il(wr),
          Qa = Il(function (e, t) {
            return e <= t;
          });
        function ei(e) {
          if (!e) return [];
          if (Ia(e)) return Za(e) ? $t(e) : El(e);
          if (Je && e[Je]) return function (e) {
            for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
            return n;
          }(e[Je]());
          var t = nc(e);
          return (t == m ? Dt : t == z ? Vt : Si)(e);
        }
        function ti(e) {
          return e ? (e = li(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
        }
        function ni(e) {
          var t = ti(e),
            n = t % 1;
          return t == t ? n ? t - n : t : 0;
        }
        function ri(e) {
          return e ? Zn(ni(e), 0, 4294967295) : 0;
        }
        function li(e) {
          if ("number" == typeof e) return e;
          if (Ka(e)) return NaN;
          if (Ua(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = Ua(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(Y, "");
          var n = ce.test(e);
          return n || ie.test(e) ? He(e.slice(2), n ? 2 : 8) : le.test(e) ? NaN : +e;
        }
        function ci(e) {
          return Ml(e, ki(e));
        }
        function ai(e) {
          return null == e ? "" : Xr(e);
        }
        var ii = kl(function (e, t) {
            if (fc(t) || Ia(t)) Ml(t, zi(t), e);else for (var n in t) _e.call(t, n) && Vn(e, n, t[n]);
          }),
          si = kl(function (e, t) {
            Ml(t, ki(t), e);
          }),
          oi = kl(function (e, t, n, r) {
            Ml(t, ki(t), e, r);
          }),
          hi = kl(function (e, t, n, r) {
            Ml(t, zi(t), e, r);
          }),
          fi = Hl(Yn);
        var di = Tr(function (e, t) {
            e = me(e);
            var n = -1,
              r = t.length,
              l = r > 2 ? t[2] : void 0;
            for (l && ic(t[0], t[1], l) && (r = 1); ++n < r;) for (var c = t[n], a = ki(c), i = -1, s = a.length; ++i < s;) {
              var o = a[i],
                h = e[o];
              (void 0 === h || Sa(h, ge[o]) && !_e.call(e, o)) && (e[o] = c[o]);
            }
            return e;
          }),
          ui = Tr(function (e) {
            return e.push(void 0, Bl), ct(bi, void 0, e);
          });
        function pi(e, t, n) {
          var r = null == e ? void 0 : fr(e, t);
          return void 0 === r ? n : r;
        }
        function mi(e, t) {
          return null != e && rc(e, t, vr);
        }
        var vi = Cl(function (e, t, n) {
            null != t && "function" != typeof t.toString && (t = xe.call(t)), e[t] = n;
          }, Ui(qi)),
          Ei = Cl(function (e, t, n) {
            null != t && "function" != typeof t.toString && (t = xe.call(t)), _e.call(e, t) ? e[t].push(n) : e[t] = [n];
          }, Kl),
          Mi = Tr(Mr);
        function zi(e) {
          return Ia(e) ? Tn(e) : _r(e);
        }
        function ki(e) {
          return Ia(e) ? Tn(e, !0) : Wr(e);
        }
        var gi = kl(function (e, t, n) {
            Or(e, t, n);
          }),
          bi = kl(function (e, t, n, r) {
            Or(e, t, n, r);
          }),
          yi = Hl(function (e, t) {
            var n = {};
            if (null == e) return n;
            var r = !1;
            t = ut(t, function (t) {
              return t = il(t, e), r || (r = t.length > 1), t;
            }), Ml(e, $l(e), n), r && (n = Kn(n, 7, Ul));
            for (var l = t.length; l--;) Qr(n, t[l]);
            return n;
          });
        var _i = Hl(function (e, t) {
          return null == e ? {} : function (e, t) {
            return Nr(e, t, function (t, n) {
              return mi(e, n);
            });
          }(e, t);
        });
        function Wi(e, t) {
          if (null == e) return {};
          var n = ut($l(e), function (e) {
            return [e];
          });
          return t = Kl(t), Nr(e, n, function (e, n) {
            return t(e, n[0]);
          });
        }
        var wi = Tl(zi),
          xi = Tl(ki);
        function Si(e) {
          return null == e ? [] : jt(e, zi(e));
        }
        var Ci = _l(function (e, t, n) {
          return t = t.toLowerCase(), e + (n ? Oi(t) : t);
        });
        function Oi(e) {
          return Ti(ai(e).toLowerCase());
        }
        function ji(e) {
          return (e = ai(e)) && e.replace(oe, Ft).replace(Ne, "");
        }
        var Li = _l(function (e, t, n) {
            return e + (n ? "-" : "") + t.toLowerCase();
          }),
          Ni = _l(function (e, t, n) {
            return e + (n ? " " : "") + t.toLowerCase();
          }),
          Ii = yl("toLowerCase");
        var Ai = _l(function (e, t, n) {
          return e + (n ? "_" : "") + t.toLowerCase();
        });
        var Fi = _l(function (e, t, n) {
          return e + (n ? " " : "") + Ti(t);
        });
        var Ri = _l(function (e, t, n) {
            return e + (n ? " " : "") + t.toUpperCase();
          }),
          Ti = yl("toUpperCase");
        function Pi(e, t, n) {
          return e = ai(e), void 0 === (t = n ? void 0 : t) ? function (e) {
            return Re.test(e);
          }(e) ? function (e) {
            return e.match(Ae) || [];
          }(e) : function (e) {
            return e.match(ee) || [];
          }(e) : e.match(t) || [];
        }
        var Di = Tr(function (e, t) {
            try {
              return ct(e, void 0, t);
            } catch (e) {
              return Ta(e) ? e : new de(e);
            }
          }),
          Bi = Hl(function (e, t) {
            return it(t, function (t) {
              t = Wc(t), Gn(e, t, Ea(e[t], e));
            }), e;
          });
        function Ui(e) {
          return function () {
            return e;
          };
        }
        var Vi = xl(),
          Hi = xl(!0);
        function qi(e) {
          return e;
        }
        function $i(e) {
          return yr("function" == typeof e ? e : Kn(e, 1));
        }
        var Gi = Tr(function (e, t) {
            return function (n) {
              return Mr(n, e, t);
            };
          }),
          Yi = Tr(function (e, t) {
            return function (n) {
              return Mr(e, n, t);
            };
          });
        function Zi(e, t, n) {
          var r = zi(t),
            l = hr(t, r);
          null != n || Ua(t) && (l.length || !r.length) || (n = t, t = e, e = this, l = hr(t, zi(t)));
          var c = !(Ua(n) && "chain" in n && !n.chain),
            a = Pa(e);
          return it(l, function (n) {
            var r = t[n];
            e[n] = r, a && (e.prototype[n] = function () {
              var t = this.__chain__;
              if (c || t) {
                var n = e(this.__wrapped__),
                  l = n.__actions__ = El(this.__actions__);
                return l.push({
                  func: r,
                  args: arguments,
                  thisArg: e
                }), n.__chain__ = t, n;
              }
              return r.apply(e, pt([this.value()], arguments));
            });
          }), e;
        }
        function Ki() {}
        var Xi = jl(ut),
          Ji = jl(ot),
          Qi = jl(Et);
        function es(e) {
          return sc(e) ? Wt(Wc(e)) : function (e) {
            return function (t) {
              return fr(t, e);
            };
          }(e);
        }
        var ts = Nl(),
          ns = Nl(!0);
        function rs() {
          return [];
        }
        function ls() {
          return !1;
        }
        var cs = Ol(function (e, t) {
            return e + t;
          }, 0),
          as = Fl("ceil"),
          is = Ol(function (e, t) {
            return e / t;
          }, 1),
          ss = Fl("floor");
        var os,
          hs = Ol(function (e, t) {
            return e * t;
          }, 1),
          fs = Fl("round"),
          ds = Ol(function (e, t) {
            return e - t;
          }, 0);
        return Sn.after = function (e, t) {
          if ("function" != typeof t) throw new Me(c);
          return e = ni(e), function () {
            if (--e < 1) return t.apply(this, arguments);
          };
        }, Sn.ary = ma, Sn.assign = ii, Sn.assignIn = si, Sn.assignInWith = oi, Sn.assignWith = hi, Sn.at = fi, Sn.before = va, Sn.bind = Ea, Sn.bindAll = Bi, Sn.bindKey = Ma, Sn.castArray = function () {
          if (!arguments.length) return [];
          var e = arguments[0];
          return La(e) ? e : [e];
        }, Sn.chain = ea, Sn.chunk = function (e, t, n) {
          t = (n ? ic(e, t, n) : void 0 === t) ? 1 : cn(ni(t), 0);
          var l = null == e ? 0 : e.length;
          if (!l || t < 1) return [];
          for (var c = 0, a = 0, i = r(Jt(l / t)); c < l;) i[a++] = qr(e, c, c += t);
          return i;
        }, Sn.compact = function (e) {
          for (var t = -1, n = null == e ? 0 : e.length, r = 0, l = []; ++t < n;) {
            var c = e[t];
            c && (l[r++] = c);
          }
          return l;
        }, Sn.concat = function () {
          var e = arguments.length;
          if (!e) return [];
          for (var t = r(e - 1), n = arguments[0], l = e; l--;) t[l - 1] = arguments[l];
          return pt(La(n) ? El(n) : [n], cr(t, 1));
        }, Sn.cond = function (e) {
          var t = null == e ? 0 : e.length,
            n = Kl();
          return e = t ? ut(e, function (e) {
            if ("function" != typeof e[1]) throw new Me(c);
            return [n(e[0]), e[1]];
          }) : [], Tr(function (n) {
            for (var r = -1; ++r < t;) {
              var l = e[r];
              if (ct(l[0], this, n)) return ct(l[1], this, n);
            }
          });
        }, Sn.conforms = function (e) {
          return function (e) {
            var t = zi(e);
            return function (n) {
              return Xn(n, e, t);
            };
          }(Kn(e, 1));
        }, Sn.constant = Ui, Sn.countBy = ra, Sn.create = function (e, t) {
          var n = Cn(e);
          return null == t ? n : $n(n, t);
        }, Sn.curry = function e(t, n, r) {
          var l = Pl(t, 8, void 0, void 0, void 0, void 0, void 0, n = r ? void 0 : n);
          return l.placeholder = e.placeholder, l;
        }, Sn.curryRight = function e(t, n, r) {
          var l = Pl(t, 16, void 0, void 0, void 0, void 0, void 0, n = r ? void 0 : n);
          return l.placeholder = e.placeholder, l;
        }, Sn.debounce = za, Sn.defaults = di, Sn.defaultsDeep = ui, Sn.defer = ka, Sn.delay = ga, Sn.difference = Sc, Sn.differenceBy = Cc, Sn.differenceWith = Oc, Sn.drop = function (e, t, n) {
          var r = null == e ? 0 : e.length;
          return r ? qr(e, (t = n || void 0 === t ? 1 : ni(t)) < 0 ? 0 : t, r) : [];
        }, Sn.dropRight = function (e, t, n) {
          var r = null == e ? 0 : e.length;
          return r ? qr(e, 0, (t = r - (t = n || void 0 === t ? 1 : ni(t))) < 0 ? 0 : t) : [];
        }, Sn.dropRightWhile = function (e, t) {
          return e && e.length ? tl(e, Kl(t, 3), !0, !0) : [];
        }, Sn.dropWhile = function (e, t) {
          return e && e.length ? tl(e, Kl(t, 3), !0) : [];
        }, Sn.fill = function (e, t, n, r) {
          var l = null == e ? 0 : e.length;
          return l ? (n && "number" != typeof n && ic(e, t, n) && (n = 0, r = l), function (e, t, n, r) {
            var l = e.length;
            for ((n = ni(n)) < 0 && (n = -n > l ? 0 : l + n), (r = void 0 === r || r > l ? l : ni(r)) < 0 && (r += l), r = n > r ? 0 : ri(r); n < r;) e[n++] = t;
            return e;
          }(e, t, n, r)) : [];
        }, Sn.filter = function (e, t) {
          return (La(e) ? ht : lr)(e, Kl(t, 3));
        }, Sn.flatMap = function (e, t) {
          return cr(fa(e, t), 1);
        }, Sn.flatMapDeep = function (e, t) {
          return cr(fa(e, t), 1 / 0);
        }, Sn.flatMapDepth = function (e, t, n) {
          return n = void 0 === n ? 1 : ni(n), cr(fa(e, t), n);
        }, Sn.flatten = Nc, Sn.flattenDeep = function (e) {
          return (null == e ? 0 : e.length) ? cr(e, 1 / 0) : [];
        }, Sn.flattenDepth = function (e, t) {
          return (null == e ? 0 : e.length) ? cr(e, t = void 0 === t ? 1 : ni(t)) : [];
        }, Sn.flip = function (e) {
          return Pl(e, 512);
        }, Sn.flow = Vi, Sn.flowRight = Hi, Sn.fromPairs = function (e) {
          for (var t = -1, n = null == e ? 0 : e.length, r = {}; ++t < n;) {
            var l = e[t];
            r[l[0]] = l[1];
          }
          return r;
        }, Sn.functions = function (e) {
          return null == e ? [] : hr(e, zi(e));
        }, Sn.functionsIn = function (e) {
          return null == e ? [] : hr(e, ki(e));
        }, Sn.groupBy = sa, Sn.initial = function (e) {
          return (null == e ? 0 : e.length) ? qr(e, 0, -1) : [];
        }, Sn.intersection = Ac, Sn.intersectionBy = Fc, Sn.intersectionWith = Rc, Sn.invert = vi, Sn.invertBy = Ei, Sn.invokeMap = oa, Sn.iteratee = $i, Sn.keyBy = ha, Sn.keys = zi, Sn.keysIn = ki, Sn.map = fa, Sn.mapKeys = function (e, t) {
          var n = {};
          return t = Kl(t, 3), sr(e, function (e, r, l) {
            Gn(n, t(e, r, l), e);
          }), n;
        }, Sn.mapValues = function (e, t) {
          var n = {};
          return t = Kl(t, 3), sr(e, function (e, r, l) {
            Gn(n, r, t(e, r, l));
          }), n;
        }, Sn.matches = function (e) {
          return Sr(Kn(e, 1));
        }, Sn.matchesProperty = function (e, t) {
          return Cr(e, Kn(t, 1));
        }, Sn.memoize = ba, Sn.merge = gi, Sn.mergeWith = bi, Sn.method = Gi, Sn.methodOf = Yi, Sn.mixin = Zi, Sn.negate = ya, Sn.nthArg = function (e) {
          return e = ni(e), Tr(function (t) {
            return jr(t, e);
          });
        }, Sn.omit = yi, Sn.omitBy = function (e, t) {
          return Wi(e, ya(Kl(t)));
        }, Sn.once = function (e) {
          return va(2, e);
        }, Sn.orderBy = function (e, t, n, r) {
          return null == e ? [] : (La(t) || (t = null == t ? [] : [t]), La(n = r ? void 0 : n) || (n = null == n ? [] : [n]), Lr(e, t, n));
        }, Sn.over = Xi, Sn.overArgs = _a, Sn.overEvery = Ji, Sn.overSome = Qi, Sn.partial = Wa, Sn.partialRight = wa, Sn.partition = da, Sn.pick = _i, Sn.pickBy = Wi, Sn.property = es, Sn.propertyOf = function (e) {
          return function (t) {
            return null == e ? void 0 : fr(e, t);
          };
        }, Sn.pull = Pc, Sn.pullAll = Dc, Sn.pullAllBy = function (e, t, n) {
          return e && e.length && t && t.length ? Ir(e, t, Kl(n, 2)) : e;
        }, Sn.pullAllWith = function (e, t, n) {
          return e && e.length && t && t.length ? Ir(e, t, void 0, n) : e;
        }, Sn.pullAt = Bc, Sn.range = ts, Sn.rangeRight = ns, Sn.rearg = xa, Sn.reject = function (e, t) {
          return (La(e) ? ht : lr)(e, ya(Kl(t, 3)));
        }, Sn.remove = function (e, t) {
          var n = [];
          if (!e || !e.length) return n;
          var r = -1,
            l = [],
            c = e.length;
          for (t = Kl(t, 3); ++r < c;) {
            var a = e[r];
            t(a, r, e) && (n.push(a), l.push(r));
          }
          return Ar(e, l), n;
        }, Sn.rest = function (e, t) {
          if ("function" != typeof e) throw new Me(c);
          return Tr(e, t = void 0 === t ? t : ni(t));
        }, Sn.reverse = Uc, Sn.sampleSize = function (e, t, n) {
          return t = (n ? ic(e, t, n) : void 0 === t) ? 1 : ni(t), (La(e) ? Dn : Dr)(e, t);
        }, Sn.set = function (e, t, n) {
          return null == e ? e : Br(e, t, n);
        }, Sn.setWith = function (e, t, n, r) {
          return r = "function" == typeof r ? r : void 0, null == e ? e : Br(e, t, n, r);
        }, Sn.shuffle = function (e) {
          return (La(e) ? Bn : Hr)(e);
        }, Sn.slice = function (e, t, n) {
          var r = null == e ? 0 : e.length;
          return r ? (n && "number" != typeof n && ic(e, t, n) ? (t = 0, n = r) : (t = null == t ? 0 : ni(t), n = void 0 === n ? r : ni(n)), qr(e, t, n)) : [];
        }, Sn.sortBy = ua, Sn.sortedUniq = function (e) {
          return e && e.length ? Zr(e) : [];
        }, Sn.sortedUniqBy = function (e, t) {
          return e && e.length ? Zr(e, Kl(t, 2)) : [];
        }, Sn.split = function (e, t, n) {
          return n && "number" != typeof n && ic(e, t, n) && (t = n = void 0), (n = void 0 === n ? 4294967295 : n >>> 0) ? (e = ai(e)) && ("string" == typeof t || null != t && !Ga(t)) && !(t = Xr(t)) && Pt(e) ? ol($t(e), 0, n) : e.split(t, n) : [];
        }, Sn.spread = function (e, t) {
          if ("function" != typeof e) throw new Me(c);
          return t = null == t ? 0 : cn(ni(t), 0), Tr(function (n) {
            var r = n[t],
              l = ol(n, 0, t);
            return r && pt(l, r), ct(e, this, l);
          });
        }, Sn.tail = function (e) {
          var t = null == e ? 0 : e.length;
          return t ? qr(e, 1, t) : [];
        }, Sn.take = function (e, t, n) {
          return e && e.length ? qr(e, 0, (t = n || void 0 === t ? 1 : ni(t)) < 0 ? 0 : t) : [];
        }, Sn.takeRight = function (e, t, n) {
          var r = null == e ? 0 : e.length;
          return r ? qr(e, (t = r - (t = n || void 0 === t ? 1 : ni(t))) < 0 ? 0 : t, r) : [];
        }, Sn.takeRightWhile = function (e, t) {
          return e && e.length ? tl(e, Kl(t, 3), !1, !0) : [];
        }, Sn.takeWhile = function (e, t) {
          return e && e.length ? tl(e, Kl(t, 3)) : [];
        }, Sn.tap = function (e, t) {
          return t(e), e;
        }, Sn.throttle = function (e, t, n) {
          var r = !0,
            l = !0;
          if ("function" != typeof e) throw new Me(c);
          return Ua(n) && (r = "leading" in n ? !!n.leading : r, l = "trailing" in n ? !!n.trailing : l), za(e, t, {
            leading: r,
            maxWait: t,
            trailing: l
          });
        }, Sn.thru = ta, Sn.toArray = ei, Sn.toPairs = wi, Sn.toPairsIn = xi, Sn.toPath = function (e) {
          return La(e) ? ut(e, Wc) : Ka(e) ? [e] : El(_c(ai(e)));
        }, Sn.toPlainObject = ci, Sn.transform = function (e, t, n) {
          var r = La(e),
            l = r || Fa(e) || Xa(e);
          if (t = Kl(t, 4), null == n) {
            var c = e && e.constructor;
            n = l ? r ? new c() : [] : Ua(e) && Pa(c) ? Cn(qe(e)) : {};
          }
          return (l ? it : sr)(e, function (e, r, l) {
            return t(n, e, r, l);
          }), n;
        }, Sn.unary = function (e) {
          return ma(e, 1);
        }, Sn.union = Vc, Sn.unionBy = Hc, Sn.unionWith = qc, Sn.uniq = function (e) {
          return e && e.length ? Jr(e) : [];
        }, Sn.uniqBy = function (e, t) {
          return e && e.length ? Jr(e, Kl(t, 2)) : [];
        }, Sn.uniqWith = function (e, t) {
          return t = "function" == typeof t ? t : void 0, e && e.length ? Jr(e, void 0, t) : [];
        }, Sn.unset = function (e, t) {
          return null == e || Qr(e, t);
        }, Sn.unzip = $c, Sn.unzipWith = Gc, Sn.update = function (e, t, n) {
          return null == e ? e : el(e, t, al(n));
        }, Sn.updateWith = function (e, t, n, r) {
          return r = "function" == typeof r ? r : void 0, null == e ? e : el(e, t, al(n), r);
        }, Sn.values = Si, Sn.valuesIn = function (e) {
          return null == e ? [] : jt(e, ki(e));
        }, Sn.without = Yc, Sn.words = Pi, Sn.wrap = function (e, t) {
          return Wa(al(t), e);
        }, Sn.xor = Zc, Sn.xorBy = Kc, Sn.xorWith = Xc, Sn.zip = Jc, Sn.zipObject = function (e, t) {
          return ll(e || [], t || [], Vn);
        }, Sn.zipObjectDeep = function (e, t) {
          return ll(e || [], t || [], Br);
        }, Sn.zipWith = Qc, Sn.entries = wi, Sn.entriesIn = xi, Sn.extend = si, Sn.extendWith = oi, Zi(Sn, Sn), Sn.add = cs, Sn.attempt = Di, Sn.camelCase = Ci, Sn.capitalize = Oi, Sn.ceil = as, Sn.clamp = function (e, t, n) {
          return void 0 === n && (n = t, t = void 0), void 0 !== n && (n = (n = li(n)) == n ? n : 0), void 0 !== t && (t = (t = li(t)) == t ? t : 0), Zn(li(e), t, n);
        }, Sn.clone = function (e) {
          return Kn(e, 4);
        }, Sn.cloneDeep = function (e) {
          return Kn(e, 5);
        }, Sn.cloneDeepWith = function (e, t) {
          return Kn(e, 5, t = "function" == typeof t ? t : void 0);
        }, Sn.cloneWith = function (e, t) {
          return Kn(e, 4, t = "function" == typeof t ? t : void 0);
        }, Sn.conformsTo = function (e, t) {
          return null == t || Xn(e, t, zi(t));
        }, Sn.deburr = ji, Sn.defaultTo = function (e, t) {
          return null == e || e != e ? t : e;
        }, Sn.divide = is, Sn.endsWith = function (e, t, n) {
          e = ai(e), t = Xr(t);
          var r = e.length,
            l = n = void 0 === n ? r : Zn(ni(n), 0, r);
          return (n -= t.length) >= 0 && e.slice(n, l) == t;
        }, Sn.eq = Sa, Sn.escape = function (e) {
          return (e = ai(e)) && P.test(e) ? e.replace(R, Rt) : e;
        }, Sn.escapeRegExp = function (e) {
          return (e = ai(e)) && G.test(e) ? e.replace($, "\\$&") : e;
        }, Sn.every = function (e, t, n) {
          var r = La(e) ? ot : nr;
          return n && ic(e, t, n) && (t = void 0), r(e, Kl(t, 3));
        }, Sn.find = la, Sn.findIndex = jc, Sn.findKey = function (e, t) {
          return zt(e, Kl(t, 3), sr);
        }, Sn.findLast = ca, Sn.findLastIndex = Lc, Sn.findLastKey = function (e, t) {
          return zt(e, Kl(t, 3), or);
        }, Sn.floor = ss, Sn.forEach = aa, Sn.forEachRight = ia, Sn.forIn = function (e, t) {
          return null == e ? e : ar(e, Kl(t, 3), ki);
        }, Sn.forInRight = function (e, t) {
          return null == e ? e : ir(e, Kl(t, 3), ki);
        }, Sn.forOwn = function (e, t) {
          return e && sr(e, Kl(t, 3));
        }, Sn.forOwnRight = function (e, t) {
          return e && or(e, Kl(t, 3));
        }, Sn.get = pi, Sn.gt = Ca, Sn.gte = Oa, Sn.has = function (e, t) {
          return null != e && rc(e, t, mr);
        }, Sn.hasIn = mi, Sn.head = Ic, Sn.identity = qi, Sn.includes = function (e, t, n, r) {
          e = Ia(e) ? e : Si(e), n = n && !r ? ni(n) : 0;
          var l = e.length;
          return n < 0 && (n = cn(l + n, 0)), Za(e) ? n <= l && e.indexOf(t, n) > -1 : !!l && gt(e, t, n) > -1;
        }, Sn.indexOf = function (e, t, n) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var l = null == n ? 0 : ni(n);
          return l < 0 && (l = cn(r + l, 0)), gt(e, t, l);
        }, Sn.inRange = function (e, t, n) {
          return t = ti(t), void 0 === n ? (n = t, t = 0) : n = ti(n), function (e, t, n) {
            return e >= an(t, n) && e < cn(t, n);
          }(e = li(e), t, n);
        }, Sn.invoke = Mi, Sn.isArguments = ja, Sn.isArray = La, Sn.isArrayBuffer = Na, Sn.isArrayLike = Ia, Sn.isArrayLikeObject = Aa, Sn.isBoolean = function (e) {
          return !0 === e || !1 === e || Va(e) && ur(e) == h;
        }, Sn.isBuffer = Fa, Sn.isDate = Ra, Sn.isElement = function (e) {
          return Va(e) && 1 === e.nodeType && !$a(e);
        }, Sn.isEmpty = function (e) {
          if (null == e) return !0;
          if (Ia(e) && (La(e) || "string" == typeof e || "function" == typeof e.splice || Fa(e) || Xa(e) || ja(e))) return !e.length;
          var t = nc(e);
          if (t == m || t == z) return !e.size;
          if (fc(e)) return !_r(e).length;
          for (var n in e) if (_e.call(e, n)) return !1;
          return !0;
        }, Sn.isEqual = function (e, t) {
          return kr(e, t);
        }, Sn.isEqualWith = function (e, t, n) {
          var r = (n = "function" == typeof n ? n : void 0) ? n(e, t) : void 0;
          return void 0 === r ? kr(e, t, void 0, n) : !!r;
        }, Sn.isError = Ta, Sn.isFinite = function (e) {
          return "number" == typeof e && nn(e);
        }, Sn.isFunction = Pa, Sn.isInteger = Da, Sn.isLength = Ba, Sn.isMap = Ha, Sn.isMatch = function (e, t) {
          return e === t || gr(e, t, Jl(t));
        }, Sn.isMatchWith = function (e, t, n) {
          return n = "function" == typeof n ? n : void 0, gr(e, t, Jl(t), n);
        }, Sn.isNaN = function (e) {
          return qa(e) && e != +e;
        }, Sn.isNative = function (e) {
          if (hc(e)) throw new de("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
          return br(e);
        }, Sn.isNil = function (e) {
          return null == e;
        }, Sn.isNull = function (e) {
          return null === e;
        }, Sn.isNumber = qa, Sn.isObject = Ua, Sn.isObjectLike = Va, Sn.isPlainObject = $a, Sn.isRegExp = Ga, Sn.isSafeInteger = function (e) {
          return Da(e) && e >= -9007199254740991 && e <= 9007199254740991;
        }, Sn.isSet = Ya, Sn.isString = Za, Sn.isSymbol = Ka, Sn.isTypedArray = Xa, Sn.isUndefined = function (e) {
          return void 0 === e;
        }, Sn.isWeakMap = function (e) {
          return Va(e) && nc(e) == b;
        }, Sn.isWeakSet = function (e) {
          return Va(e) && "[object WeakSet]" == ur(e);
        }, Sn.join = function (e, t) {
          return null == e ? "" : rn.call(e, t);
        }, Sn.kebabCase = Li, Sn.last = Tc, Sn.lastIndexOf = function (e, t, n) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var l = r;
          return void 0 !== n && (l = (l = ni(n)) < 0 ? cn(r + l, 0) : an(l, r - 1)), t == t ? function (e, t, n) {
            for (var r = n + 1; r--;) if (e[r] === t) return r;
            return r;
          }(e, t, l) : kt(e, yt, l, !0);
        }, Sn.lowerCase = Ni, Sn.lowerFirst = Ii, Sn.lt = Ja, Sn.lte = Qa, Sn.max = function (e) {
          return e && e.length ? rr(e, qi, pr) : void 0;
        }, Sn.maxBy = function (e, t) {
          return e && e.length ? rr(e, Kl(t, 2), pr) : void 0;
        }, Sn.mean = function (e) {
          return _t(e, qi);
        }, Sn.meanBy = function (e, t) {
          return _t(e, Kl(t, 2));
        }, Sn.min = function (e) {
          return e && e.length ? rr(e, qi, wr) : void 0;
        }, Sn.minBy = function (e, t) {
          return e && e.length ? rr(e, Kl(t, 2), wr) : void 0;
        }, Sn.stubArray = rs, Sn.stubFalse = ls, Sn.stubObject = function () {
          return {};
        }, Sn.stubString = function () {
          return "";
        }, Sn.stubTrue = function () {
          return !0;
        }, Sn.multiply = hs, Sn.nth = function (e, t) {
          return e && e.length ? jr(e, ni(t)) : void 0;
        }, Sn.noConflict = function () {
          return Ge._ === this && (Ge._ = Ce), this;
        }, Sn.noop = Ki, Sn.now = pa, Sn.pad = function (e, t, n) {
          e = ai(e);
          var r = (t = ni(t)) ? qt(e) : 0;
          if (!t || r >= t) return e;
          var l = (t - r) / 2;
          return Ll(Qt(l), n) + e + Ll(Jt(l), n);
        }, Sn.padEnd = function (e, t, n) {
          e = ai(e);
          var r = (t = ni(t)) ? qt(e) : 0;
          return t && r < t ? e + Ll(t - r, n) : e;
        }, Sn.padStart = function (e, t, n) {
          e = ai(e);
          var r = (t = ni(t)) ? qt(e) : 0;
          return t && r < t ? Ll(t - r, n) + e : e;
        }, Sn.parseInt = function (e, t, n) {
          return n || null == t ? t = 0 : t && (t = +t), on(ai(e).replace(Z, ""), t || 0);
        }, Sn.random = function (e, t, n) {
          if (n && "boolean" != typeof n && ic(e, t, n) && (t = n = void 0), void 0 === n && ("boolean" == typeof t ? (n = t, t = void 0) : "boolean" == typeof e && (n = e, e = void 0)), void 0 === e && void 0 === t ? (e = 0, t = 1) : (e = ti(e), void 0 === t ? (t = e, e = 0) : t = ti(t)), e > t) {
            var r = e;
            e = t, t = r;
          }
          if (n || e % 1 || t % 1) {
            var l = hn();
            return an(e + l * (t - e + Ve("1e-" + ((l + "").length - 1))), t);
          }
          return Fr(e, t);
        }, Sn.reduce = function (e, t, n) {
          var r = La(e) ? mt : xt,
            l = arguments.length < 3;
          return r(e, Kl(t, 4), n, l, er);
        }, Sn.reduceRight = function (e, t, n) {
          var r = La(e) ? vt : xt,
            l = arguments.length < 3;
          return r(e, Kl(t, 4), n, l, tr);
        }, Sn.repeat = function (e, t, n) {
          return t = (n ? ic(e, t, n) : void 0 === t) ? 1 : ni(t), Rr(ai(e), t);
        }, Sn.replace = function () {
          var e = arguments,
            t = ai(e[0]);
          return e.length < 3 ? t : t.replace(e[1], e[2]);
        }, Sn.result = function (e, t, n) {
          var r = -1,
            l = (t = il(t, e)).length;
          for (l || (l = 1, e = void 0); ++r < l;) {
            var c = null == e ? void 0 : e[Wc(t[r])];
            void 0 === c && (r = l, c = n), e = Pa(c) ? c.call(e) : c;
          }
          return e;
        }, Sn.round = fs, Sn.runInContext = e, Sn.sample = function (e) {
          return (La(e) ? Pn : Pr)(e);
        }, Sn.size = function (e) {
          if (null == e) return 0;
          if (Ia(e)) return Za(e) ? qt(e) : e.length;
          var t = nc(e);
          return t == m || t == z ? e.size : _r(e).length;
        }, Sn.snakeCase = Ai, Sn.some = function (e, t, n) {
          var r = La(e) ? Et : $r;
          return n && ic(e, t, n) && (t = void 0), r(e, Kl(t, 3));
        }, Sn.sortedIndex = function (e, t) {
          return Gr(e, t);
        }, Sn.sortedIndexBy = function (e, t, n) {
          return Yr(e, t, Kl(n, 2));
        }, Sn.sortedIndexOf = function (e, t) {
          var n = null == e ? 0 : e.length;
          if (n) {
            var r = Gr(e, t);
            if (r < n && Sa(e[r], t)) return r;
          }
          return -1;
        }, Sn.sortedLastIndex = function (e, t) {
          return Gr(e, t, !0);
        }, Sn.sortedLastIndexBy = function (e, t, n) {
          return Yr(e, t, Kl(n, 2), !0);
        }, Sn.sortedLastIndexOf = function (e, t) {
          if (null == e ? 0 : e.length) {
            var n = Gr(e, t, !0) - 1;
            if (Sa(e[n], t)) return n;
          }
          return -1;
        }, Sn.startCase = Fi, Sn.startsWith = function (e, t, n) {
          return e = ai(e), n = null == n ? 0 : Zn(ni(n), 0, e.length), t = Xr(t), e.slice(n, n + t.length) == t;
        }, Sn.subtract = ds, Sn.sum = function (e) {
          return e && e.length ? St(e, qi) : 0;
        }, Sn.sumBy = function (e, t) {
          return e && e.length ? St(e, Kl(t, 2)) : 0;
        }, Sn.template = function (e, t, n) {
          var r = Sn.templateSettings;
          n && ic(e, t, n) && (t = void 0), e = ai(e), t = oi({}, t, r, Dl);
          var l,
            c,
            a = oi({}, t.imports, r.imports, Dl),
            i = zi(a),
            s = jt(a, i),
            o = 0,
            h = t.interpolate || he,
            f = "__p += '",
            d = ve((t.escape || he).source + "|" + h.source + "|" + (h === U ? ne : he).source + "|" + (t.evaluate || he).source + "|$", "g"),
            u = "//# sourceURL=" + (_e.call(t, "sourceURL") ? (t.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++Pe + "]") + "\n";
          e.replace(d, function (t, n, r, a, i, s) {
            return r || (r = a), f += e.slice(o, s).replace(fe, Tt), n && (l = !0, f += "' +\n__e(" + n + ") +\n'"), i && (c = !0, f += "';\n" + i + ";\n__p += '"), r && (f += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), o = s + t.length, t;
          }), f += "';\n";
          var p = _e.call(t, "variable") && t.variable;
          p || (f = "with (obj) {\n" + f + "\n}\n"), f = (c ? f.replace(N, "") : f).replace(I, "$1").replace(A, "$1;"), f = "function(" + (p || "obj") + ") {\n" + (p ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (l ? ", __e = _.escape" : "") + (c ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + f + "return __p\n}";
          var m = Di(function () {
            return ue(i, u + "return " + f).apply(void 0, s);
          });
          if (m.source = f, Ta(m)) throw m;
          return m;
        }, Sn.times = function (e, t) {
          if ((e = ni(e)) < 1 || e > 9007199254740991) return [];
          var n = 4294967295,
            r = an(e, 4294967295);
          e -= 4294967295;
          for (var l = Ct(r, t = Kl(t)); ++n < e;) t(n);
          return l;
        }, Sn.toFinite = ti, Sn.toInteger = ni, Sn.toLength = ri, Sn.toLower = function (e) {
          return ai(e).toLowerCase();
        }, Sn.toNumber = li, Sn.toSafeInteger = function (e) {
          return e ? Zn(ni(e), -9007199254740991, 9007199254740991) : 0 === e ? e : 0;
        }, Sn.toString = ai, Sn.toUpper = function (e) {
          return ai(e).toUpperCase();
        }, Sn.trim = function (e, t, n) {
          if ((e = ai(e)) && (n || void 0 === t)) return e.replace(Y, "");
          if (!e || !(t = Xr(t))) return e;
          var r = $t(e),
            l = $t(t);
          return ol(r, Nt(r, l), It(r, l) + 1).join("");
        }, Sn.trimEnd = function (e, t, n) {
          if ((e = ai(e)) && (n || void 0 === t)) return e.replace(K, "");
          if (!e || !(t = Xr(t))) return e;
          var r = $t(e);
          return ol(r, 0, It(r, $t(t)) + 1).join("");
        }, Sn.trimStart = function (e, t, n) {
          if ((e = ai(e)) && (n || void 0 === t)) return e.replace(Z, "");
          if (!e || !(t = Xr(t))) return e;
          var r = $t(e);
          return ol(r, Nt(r, $t(t))).join("");
        }, Sn.truncate = function (e, t) {
          var n = 30,
            r = "...";
          if (Ua(t)) {
            var l = "separator" in t ? t.separator : l;
            n = "length" in t ? ni(t.length) : n, r = "omission" in t ? Xr(t.omission) : r;
          }
          var c = (e = ai(e)).length;
          if (Pt(e)) {
            var a = $t(e);
            c = a.length;
          }
          if (n >= c) return e;
          var i = n - qt(r);
          if (i < 1) return r;
          var s = a ? ol(a, 0, i).join("") : e.slice(0, i);
          if (void 0 === l) return s + r;
          if (a && (i += s.length - i), Ga(l)) {
            if (e.slice(i).search(l)) {
              var o,
                h = s;
              for (l.global || (l = ve(l.source, ai(re.exec(l)) + "g")), l.lastIndex = 0; o = l.exec(h);) var f = o.index;
              s = s.slice(0, void 0 === f ? i : f);
            }
          } else if (e.indexOf(Xr(l), i) != i) {
            var d = s.lastIndexOf(l);
            d > -1 && (s = s.slice(0, d));
          }
          return s + r;
        }, Sn.unescape = function (e) {
          return (e = ai(e)) && T.test(e) ? e.replace(F, Gt) : e;
        }, Sn.uniqueId = function (e) {
          var t = ++We;
          return ai(e) + t;
        }, Sn.upperCase = Ri, Sn.upperFirst = Ti, Sn.each = aa, Sn.eachRight = ia, Sn.first = Ic, Zi(Sn, (os = {}, sr(Sn, function (e, t) {
          _e.call(Sn.prototype, t) || (os[t] = e);
        }), os), {
          chain: !1
        }), Sn.VERSION = "4.17.15", it(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
          Sn[e].placeholder = Sn;
        }), it(["drop", "take"], function (e, t) {
          Ln.prototype[e] = function (n) {
            n = void 0 === n ? 1 : cn(ni(n), 0);
            var r = this.__filtered__ && !t ? new Ln(this) : this.clone();
            return r.__filtered__ ? r.__takeCount__ = an(n, r.__takeCount__) : r.__views__.push({
              size: an(n, 4294967295),
              type: e + (r.__dir__ < 0 ? "Right" : "")
            }), r;
          }, Ln.prototype[e + "Right"] = function (t) {
            return this.reverse()[e](t).reverse();
          };
        }), it(["filter", "map", "takeWhile"], function (e, t) {
          var n = t + 1,
            r = 1 == n || 3 == n;
          Ln.prototype[e] = function (e) {
            var t = this.clone();
            return t.__iteratees__.push({
              iteratee: Kl(e, 3),
              type: n
            }), t.__filtered__ = t.__filtered__ || r, t;
          };
        }), it(["head", "last"], function (e, t) {
          var n = "take" + (t ? "Right" : "");
          Ln.prototype[e] = function () {
            return this[n](1).value()[0];
          };
        }), it(["initial", "tail"], function (e, t) {
          var n = "drop" + (t ? "" : "Right");
          Ln.prototype[e] = function () {
            return this.__filtered__ ? new Ln(this) : this[n](1);
          };
        }), Ln.prototype.compact = function () {
          return this.filter(qi);
        }, Ln.prototype.find = function (e) {
          return this.filter(e).head();
        }, Ln.prototype.findLast = function (e) {
          return this.reverse().find(e);
        }, Ln.prototype.invokeMap = Tr(function (e, t) {
          return "function" == typeof e ? new Ln(this) : this.map(function (n) {
            return Mr(n, e, t);
          });
        }), Ln.prototype.reject = function (e) {
          return this.filter(ya(Kl(e)));
        }, Ln.prototype.slice = function (e, t) {
          e = ni(e);
          var n = this;
          return n.__filtered__ && (e > 0 || t < 0) ? new Ln(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), void 0 !== t && (n = (t = ni(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
        }, Ln.prototype.takeRightWhile = function (e) {
          return this.reverse().takeWhile(e).reverse();
        }, Ln.prototype.toArray = function () {
          return this.take(4294967295);
        }, sr(Ln.prototype, function (e, t) {
          var n = /^(?:filter|find|map|reject)|While$/.test(t),
            r = /^(?:head|last)$/.test(t),
            l = Sn[r ? "take" + ("last" == t ? "Right" : "") : t],
            c = r || /^find/.test(t);
          l && (Sn.prototype[t] = function () {
            var t = this.__wrapped__,
              a = r ? [1] : arguments,
              i = t instanceof Ln,
              s = a[0],
              o = i || La(t),
              h = function h(e) {
                var t = l.apply(Sn, pt([e], a));
                return r && f ? t[0] : t;
              };
            o && n && "function" == typeof s && 1 != s.length && (i = o = !1);
            var f = this.__chain__,
              d = !!this.__actions__.length,
              u = c && !f,
              p = i && !d;
            if (!c && o) {
              t = p ? t : new Ln(this);
              var m = e.apply(t, a);
              return m.__actions__.push({
                func: ta,
                args: [h],
                thisArg: void 0
              }), new jn(m, f);
            }
            return u && p ? e.apply(this, a) : (m = this.thru(h), u ? r ? m.value()[0] : m.value() : m);
          });
        }), it(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
          var t = ze[e],
            n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
            r = /^(?:pop|shift)$/.test(e);
          Sn.prototype[e] = function () {
            var e = arguments;
            if (r && !this.__chain__) {
              var l = this.value();
              return t.apply(La(l) ? l : [], e);
            }
            return this[n](function (n) {
              return t.apply(La(n) ? n : [], e);
            });
          };
        }), sr(Ln.prototype, function (e, t) {
          var n = Sn[t];
          if (n) {
            var r = n.name + "";
            _e.call(zn, r) || (zn[r] = []), zn[r].push({
              name: t,
              func: n
            });
          }
        }), zn[Sl(void 0, 2).name] = [{
          name: "wrapper",
          func: void 0
        }], Ln.prototype.clone = function () {
          var e = new Ln(this.__wrapped__);
          return e.__actions__ = El(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = El(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = El(this.__views__), e;
        }, Ln.prototype.reverse = function () {
          if (this.__filtered__) {
            var e = new Ln(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else (e = this.clone()).__dir__ *= -1;
          return e;
        }, Ln.prototype.value = function () {
          var e = this.__wrapped__.value(),
            t = this.__dir__,
            n = La(e),
            r = t < 0,
            l = n ? e.length : 0,
            c = function (e, t, n) {
              var r = -1,
                l = n.length;
              for (; ++r < l;) {
                var c = n[r],
                  a = c.size;
                switch (c.type) {
                  case "drop":
                    e += a;
                    break;
                  case "dropRight":
                    t -= a;
                    break;
                  case "take":
                    t = an(t, e + a);
                    break;
                  case "takeRight":
                    e = cn(e, t - a);
                }
              }
              return {
                start: e,
                end: t
              };
            }(0, l, this.__views__),
            a = c.start,
            i = c.end,
            s = i - a,
            o = r ? i : a - 1,
            h = this.__iteratees__,
            f = h.length,
            d = 0,
            u = an(s, this.__takeCount__);
          if (!n || !r && l == s && u == s) return nl(e, this.__actions__);
          var p = [];
          e: for (; s-- && d < u;) {
            for (var m = -1, v = e[o += t]; ++m < f;) {
              var E = h[m],
                M = E.iteratee,
                z = E.type,
                k = M(v);
              if (2 == z) v = k;else if (!k) {
                if (1 == z) continue e;
                break e;
              }
            }
            p[d++] = v;
          }
          return p;
        }, Sn.prototype.at = na, Sn.prototype.chain = function () {
          return ea(this);
        }, Sn.prototype.commit = function () {
          return new jn(this.value(), this.__chain__);
        }, Sn.prototype.next = function () {
          void 0 === this.__values__ && (this.__values__ = ei(this.value()));
          var e = this.__index__ >= this.__values__.length;
          return {
            done: e,
            value: e ? void 0 : this.__values__[this.__index__++]
          };
        }, Sn.prototype.plant = function (e) {
          for (var t, n = this; n instanceof On;) {
            var r = xc(n);
            r.__index__ = 0, r.__values__ = void 0, t ? l.__wrapped__ = r : t = r;
            var l = r;
            n = n.__wrapped__;
          }
          return l.__wrapped__ = e, t;
        }, Sn.prototype.reverse = function () {
          var e = this.__wrapped__;
          if (e instanceof Ln) {
            var t = e;
            return this.__actions__.length && (t = new Ln(this)), (t = t.reverse()).__actions__.push({
              func: ta,
              args: [Uc],
              thisArg: void 0
            }), new jn(t, this.__chain__);
          }
          return this.thru(Uc);
        }, Sn.prototype.toJSON = Sn.prototype.valueOf = Sn.prototype.value = function () {
          return nl(this.__wrapped__, this.__actions__);
        }, Sn.prototype.first = Sn.prototype.head, Je && (Sn.prototype[Je] = function () {
          return this;
        }), Sn;
      }();
      Ge._ = Yt, void 0 === (l = function () {
        return Yt;
      }.call(t, n, t, r)) || (r.exports = l);
    }).call(this);
  }).call(this, n(5), n(13)(e));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), function (e) {
    e.REQUIRED = "Field is required.", e.PATTERN = "Invalid value.", e.MINLENGTH = "Value too short.", e.MAXLENGTH = "Value too long.", e.MIN = "Value must be <= than :minvalue:.", e.MAX = "Value must be >= than :maxvalue:.";
  }(t.ValidatorErrors || (t.ValidatorErrors = {}));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(8);
  t.Checkbox = r.Checkbox;
  var l = n(11);
  t.WaveSvgLogo = l.WaveSvgLogo;
  var c = n(12);
  t.Stepper = c.Stepper;
  var a = n(14);
  t.ButtonSelector = a.ButtonSelector;
  var i = n(15);
  t.FileBox = i.FileBox;
  var s = n(20);
  t.SelectMenu = s.SelectMenu;
  var o = n(24);
  t.FlagSVG = o.FlagSVG;
  var h = n(31);
  t.TwoPanelSelector = h.TwoPanelSelector;
  var f = n(33);
  t.ProgressBar = f.ProgressBar;
  var d = n(34);
  t.IconBadge = d.IconBadge;
  var u = n(35);
  t.LoadingRipple = u.LoadingRipple;
  var p = n(36);
  t.Switch = p.Switch;
  var m = n(37);
  t.CheckboxGroup = m.CheckboxGroup;
}, function (e, t) {
  var n;
  n = function () {
    return this;
  }();
  try {
    n = n || new Function("return this")();
  } catch (e) {
    "object" == typeof window && (n = window);
  }
  e.exports = n;
}, function (e, t, n) {
  e.exports = n(7);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(4);
  t.Components = r;
  var l = n(38);
  t.Utils = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0),
    l = n(1);
  var c = /*#__PURE__*/function (_r$Component) {
    _inherits(c, _r$Component);
    function c(e) {
      var _this;
      _classCallCheck(this, c);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, e)), _this.handleClick = function () {
        _this.setState({
          checked: !_this.state.checked
        }, _this.fireOnChange);
      }, _this.fireOnChange = function () {
        _this.props.onChange && "function" == typeof _this.props.onChange && _this.props.onChange(_this.state.checked);
      }, _this.state = {
        checked: _this.props.checked
      };
      return _this;
    }
    _createClass(c, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(e) {
        e.checked !== this.state.checked && (this.setState({
          checked: e.checked
        }), e.onChange && "function" == typeof e.onChange && !0 === e.triggerChange && e.onChange(this.state.checked));
      }
    }, {
      key: "render",
      value: function render() {
        return r.createElement("div", {
          className: "checkbox-container\n                    ".concat(this.props.noLabel ? "no-label-checkbox-container" : "", "\n                    ").concat(this.props.disabled ? "checkbox-container-disabled" : "", "\n                 "),
          onClick: this.handleClick
        }, r.createElement("div", {
          className: "checkbox ".concat(this.state.checked ? "checkbox-checked" : "checkbox-unchecked")
        }, this.state.checked && r.createElement("i", {
          className: "material-icons check-mark"
        }, this.props.tickIcon)), !this.props.noLabel && r.createElement("span", {
          className: "checkbox-label"
        }, this.props.children));
      }
    }]);
    return c;
  }(r.Component);
  t.Checkbox = c, c.defaultProps = {
    checked: !1,
    tickIcon: "check",
    triggerChange: !0
  }, c.propTypes = {
    checked: l.bool,
    noLabel: l.bool,
    disabled: l.bool,
    tickIcon: l.string,
    onChange: l.func
  };
}, function (e, t, n) {
  "use strict";

  var r = n(10);
  function l() {}
  function c() {}
  c.resetWarningCache = l, e.exports = function () {
    function e(e, t, n, l, c, a) {
      if (a !== r) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }
    function t() {
      return e;
    }
    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: c,
      resetWarningCache: l
    };
    return n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0),
    l = n(1);
  var c = /*#__PURE__*/function (_r$Component2) {
    _inherits(c, _r$Component2);
    function c(e) {
      _classCallCheck(this, c);
      return _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, e));
    }
    _createClass(c, [{
      key: "render",
      value: function render() {
        var e = {
            width: this.props.size,
            height: this.props.size,
            transform: "scaleY(-1)"
          },
          t = {
            fill: this.props.circleColor
          },
          n = {
            stroke: this.props.lineColor
          };
        return r.createElement("div", {
          id: "wave-logo",
          style: e
        }, r.createElement("svg", {
          viewBox: "0 0 603.4942 603.49419",
          id: "svg10297",
          version: "1.1"
        }, r.createElement("defs", {
          id: "defs10299"
        }), r.createElement("metadata", {
          id: "metadata10302"
        }), r.createElement("g", {
          id: "layer1",
          transform: "translate(-56.704928,-62.663668)"
        }, r.createElement("circle", {
          className: "wave-logo-background ",
          style: t,
          id: "circle",
          cx: "358.45203",
          cy: "364.41077",
          r: "301.2402"
        }), r.createElement("path", {
          className: "wave-logo-line",
          style: n,
          d: "m 570.25852,291.75116 c 0,0 -31.772,-9.24274 -54.3012,53.72351 -22.5293,62.96628 -43.6143,168.39149 -84.9179,168.68033 -44.1919,0.28884 -71.9202,-147.30644 -71.9202,-147.30644 l -0.6671,-2.43782 -0.6672,-2.43779 c 0,0 -27.7283,-147.59528 -71.9202,-147.30644 -41.3036,0.28884 -62.3886,105.71405 -84.9179,168.68034 -22.5292,62.96624 -54.3011,53.7235 -54.3011,53.7235",
          id: "path4284-0-1-2-2-7-6-2-7"
        }), r.createElement("path", {
          className: "wave-logo-line",
          style: n,
          d: "m 146.64572,437.07035 c 0,0 31.772,9.24274 54.3011,-53.7235 22.5293,-62.96629 43.6143,-117.55633 84.9179,-117.84517 44.1919,-0.28884 71.9202,96.47127 71.9202,96.47127 l 0.6672,2.43783 0.6671,2.43778 c 0,0 27.7283,96.76011 71.9202,96.47127 41.3036,-0.28884 62.3886,-54.87888 84.9179,-117.84516 22.5292,-62.96625 54.3012,-53.72351 54.3012,-53.72351",
          id: "path4284-7-62-2-8-1-5-4"
        }), r.createElement("path", {
          className: "wave-logo-line",
          style: n,
          d: "m 570.25852,291.75116 c 0,0 -31.772,-9.24274 -54.3012,53.72351 -22.5293,62.96628 -45.925,73.65319 -87.2286,73.94203 -44.1919,0.28885 -69.6095,-52.56814 -69.6095,-52.56814 l -0.6671,-2.43778 -0.6672,-2.43783 c 0,0 -25.4176,-52.85699 -69.6095,-52.56814 -41.3036,0.28884 -64.6993,10.97575 -87.2286,73.94204 -22.5292,62.96624 -54.3011,53.7235 -54.3011,53.7235",
          id: "path4284-7-6-6-9-2-9-2-4-4"
        }))));
      }
    }]);
    return c;
  }(r.Component);
  t.WaveSvgLogo = c, c.defaultProps = {
    size: "12rem",
    circleColor: "#5b2c7d",
    lineColor: "#ea2248"
  }, c.propTypes = {
    size: l.string,
    circleColor: l.string,
    lineColor: l.string
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0),
    l = n(1),
    c = n(2);
  var a = /*#__PURE__*/function (_r$Component3) {
    _inherits(a, _r$Component3);
    function a() {
      _classCallCheck(this, a);
      return _possibleConstructorReturn(this, _getPrototypeOf(a).apply(this, arguments));
    }
    _createClass(a, [{
      key: "render",
      value: function render() {
        var e = [];
        var t;
        for (var _n2 = 0; _n2 < this.props.totalSteps; _n2++) t = "stepper-ball ", _n2 < this.props.currentStep ? t += "stepper-ball-previous" : _n2 > this.props.currentStep && (t += "stepper-ball-inactive"), e.push(r.createElement("div", {
          className: t,
          key: c.uniqueId()
        }));
        return r.createElement("div", {
          className: "stepper-balls-container"
        }, e);
      }
    }]);
    return a;
  }(r.Component);
  t.Stepper = a, a.propTypes = {
    currentStep: l.number.isRequired,
    totalSteps: l.number.isRequired
  };
}, function (e, t) {
  e.exports = function (e) {
    return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
      enumerable: !0,
      get: function get() {
        return e.l;
      }
    }), Object.defineProperty(e, "id", {
      enumerable: !0,
      get: function get() {
        return e.i;
      }
    }), e.webpackPolyfill = 1), e;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0),
    l = n(1),
    c = n(2);
  var a = /*#__PURE__*/function (_r$Component4) {
    _inherits(a, _r$Component4);
    function a(e) {
      var _this2;
      _classCallCheck(this, a);
      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e)), _this2.select = function (e) {
        var t = _toConsumableArray(_this2.state.value);
        _this2.props.exclusive ? t = [e.value] : (t = _toConsumableArray(_this2.state.value), -1 === _this2.state.value.indexOf(e.value) ? t = [].concat(_toConsumableArray(t), [e.value]) : t.splice(t.indexOf(e.value), 1)), _this2.setState({
          value: t
        }, function () {
          _this2.props.onChange && "function" == typeof _this2.props.onChange && _this2.props.onChange(_this2.state.items.filter(function (e) {
            return -1 !== _this2.state.value.indexOf(e.value);
          }).map(function (e) {
            return e.value;
          }));
        });
      }, _this2.state = {
        items: e.items || [],
        value: e.value || []
      };
      return _this2;
    }
    _createClass(a, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(e) {
        var _this3 = this;
        var t = !c.isEqual(this.state.value, e.value || []),
          n = !c.isEqual(this.state.items, e.items);
        (t || n) && this.setState({
          items: n ? _toConsumableArray(e.items) : _toConsumableArray(this.state.items),
          value: t ? _toConsumableArray(e.value) : _toConsumableArray(this.state.value)
        }, function () {
          _this3.props.onChange && _this3.props.onChange(_this3.state.items.filter(function (e) {
            return -1 !== _this3.state.value.indexOf(e.value);
          }).map(function (e) {
            return e.value;
          }));
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;
        var e = this.state.items.map(function (e) {
          return r.createElement("div", {
            className: _this4.props.columnClass,
            key: c.uniqueId()
          }, r.createElement("div", {
            className: "button-selector-container"
          }, r.createElement("button", {
            type: "button",
            className: "button-selector-button " + (-1 !== _this4.state.value.indexOf(e.value) ? _this4.props.selectedClass : _this4.props.notSelectedClass),
            onClick: function onClick() {
              return _this4.select(e);
            },
            disabled: e.disabled
          }, r.createElement("div", {
            className: "button-selector-content"
          }, r.createElement("div", {
            className: "checkbox-container no-label-checkbox-container"
          }, r.createElement("div", {
            className: "checkbox " + (-1 !== _this4.state.value.indexOf(e.value) ? "checkbox-checked " : "checkbox-unchecked ")
          }, -1 !== _this4.state.value.indexOf(e.value) && r.createElement("i", {
            className: "material-icons check-mark"
          }, "check"))), r.createElement("span", {
            className: "button-selector-label"
          }, e.label)))));
        });
        return r.createElement("div", {
          className: "row no-gutters"
        }, e);
      }
    }]);
    return a;
  }(r.Component);
  t.ButtonSelector = a, a.propTypes = {
    exclusive: l.bool,
    selectedClass: l.string,
    notSelectedClass: l.string,
    columnClass: l.string,
    items: l.arrayOf(l.shape({
      label: l.any.isRequired,
      selected: l.bool,
      disabled: l.bool
    })).isRequired,
    onChange: l.func
  }, a.defaultProps = {
    exclusive: !1,
    selectedClass: "purple-btn",
    notSelectedClass: "outline-purple-btn",
    columnClass: "col-lg-3 col-md-4 col-sm-6 col-xs-12",
    items: []
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0),
    l = n(1),
    c = n(16),
    a = n(17),
    i = n(19);
  var s = /*#__PURE__*/function (_r$Component5) {
    _inherits(s, _r$Component5);
    function s(e) {
      var _this5;
      _classCallCheck(this, s);
      _this5 = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this, e)), _this5.handleDragIn = function (e) {
        e.preventDefault(), e.stopPropagation(), _this5.dragCounter++, e.dataTransfer.items && e.dataTransfer.items.length > 0 && _this5.setState({
          dragging: !0
        });
      }, _this5.handleDragOut = function (e) {
        e.preventDefault(), e.stopPropagation(), _this5.dragCounter--, _this5.dragCounter > 0 || _this5.setState({
          dragging: !1
        });
      }, _this5.handleDrag = function (e) {
        e.preventDefault(), e.stopPropagation();
      }, _this5.handleDrop = function (e) {
        if (e.preventDefault(), e.stopPropagation(), _this5.setState({
          dragging: !1
        }), e.dataTransfer.files && e.dataTransfer.files.length > 0) {
          var _t2 = _this5.props.multipleFilesAllowed ? _toConsumableArray(e.dataTransfer.files) : [_toConsumableArray(e.dataTransfer.files)[0]];
          _this5.props.onFilesChange(_t2), _this5.setState({
            currentFiles: _t2
          }), e.dataTransfer.clearData(), _this5.dragCounter = 0;
        }
      }, _this5.onBrowseClick = function () {
        _this5.fileInput.current.triggerClick();
      }, _this5.handleFilesChanged = function (e) {
        _this5.setState({
          currentFiles: e
        }), _this5.props.onFilesChange(e);
      }, _this5.cancelFile = function (e) {
        var t = _this5.state.currentFiles.filter(function (t, n) {
          return n !== e;
        });
        _this5.setState({
          currentFiles: t
        }), _this5.props.onFilesChange(t);
      }, _this5.fileInput = r.createRef(), _this5.state = {
        currentFiles: _this5.props.files,
        showingFileInput: !1,
        dragging: !1
      };
      return _this5;
    }
    _createClass(s, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var e = this.refs.rootSelector;
        e.addEventListener("dragenter", this.handleDragIn), e.addEventListener("dragleave", this.handleDragOut), e.addEventListener("dragover", this.handleDrag), e.addEventListener("drop", this.handleDrop), this.dragCounter = 0;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var e = this.refs.rootSelector;
        e.removeEventListener("dragenter", this.handleDragIn), e.removeEventListener("dragleave", this.handleDragOut), e.removeEventListener("dragover", this.handleDrag), e.removeEventListener("drop", this.handleDrop);
      }
    }, {
      key: "render",
      value: function render() {
        var e = 0 === this.state.currentFiles.length ? r.createElement("div", {
            className: "file-box"
          }, r.createElement("div", {
            className: "file-box-label"
          }, r.createElement("i", {
            className: "material-icons file-box-icon"
          }, this.props.displayIcon), r.createElement("span", {
            className: "file-box-label-text"
          }, this.props.displayMessage)), r.createElement("button", {
            className: "outline-red-btn file-box-button",
            onClick: this.onBrowseClick
          }, this.props.buttonText)) : null,
          t = r.createElement(c.FileInput, {
            ref: this.fileInput,
            multipleFilesAllowed: this.props.multipleFilesAllowed,
            handleFilesChanged: this.handleFilesChanged
          }),
          n = r.createElement(a.FileList, {
            files: this.state.currentFiles,
            cancelFile: this.cancelFile
          }),
          l = this.state.dragging ? r.createElement("div", {
            className: "file-box-overlay"
          }, i.FileBoxStrings.DROP_MESSAGE) : null,
          s = "file-box-container" + (this.state.currentFiles.length > 0 ? "-hasfiles" : "");
        return r.createElement("div", {
          className: s,
          ref: "rootSelector"
        }, l, n, e, t);
      }
    }]);
    return s;
  }(r.Component);
  t.FileBox = s, s.propTypes = {
    files: l.array,
    multipleFilesAllowed: l.bool,
    placeholder: l.array,
    displayMessage: l.string,
    displayIcon: l.any,
    buttonText: l.string,
    onFilesChange: l.func
  }, s.defaultProps = {
    files: [],
    multipleFilesAllowed: !0,
    placeholder: [],
    displayMessage: i.FileBoxStrings.DEFAULT_MESSAGE_MULTIPLE_FILES,
    displayIcon: i.FileBoxStrings.DEFAULT_ICON,
    buttonText: i.FileBoxStrings.BROWSE,
    onFilesChange: function onFilesChange() {
      return [];
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  var l = /*#__PURE__*/function (_r$Component6) {
    _inherits(l, _r$Component6);
    function l(e) {
      var _this6;
      _classCallCheck(this, l);
      _this6 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, e)), _this6.triggerClick = function () {
        _this6.refs.fileInput.click();
      }, _this6.handleFilesChanged = function (e) {
        e.preventDefault();
        var t = _this6.refs.fileInput;
        _this6.props.handleFilesChanged(_toConsumableArray(t.files));
      };
      return _this6;
    }
    _createClass(l, [{
      key: "render",
      value: function render() {
        return r.createElement("input", {
          type: "file",
          ref: "fileInput",
          hidden: !0,
          onChange: this.handleFilesChanged,
          multiple: this.props.multipleFilesAllowed
        });
      }
    }]);
    return l;
  }(r.Component);
  t.FileInput = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0),
    l = n(2),
    c = n(18);
  var a = /*#__PURE__*/function (_r$Component7) {
    _inherits(a, _r$Component7);
    function a(e) {
      _classCallCheck(this, a);
      return _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e));
    }
    _createClass(a, [{
      key: "render",
      value: function render() {
        var _this7 = this;
        var e = [];
        return this.props.files.map(function (t, n) {
          e.push(r.createElement(c.FileEntry, {
            fileName: t.name,
            fileIndex: n,
            onFileCancel: _this7.props.cancelFile,
            key: l.uniqueId()
          }));
        }), e.length > 0 ? r.createElement("div", {
          className: "file-box"
        }, r.createElement("div", {
          className: "files-list"
        }, e)) : null;
      }
    }]);
    return a;
  }(r.Component);
  t.FileList = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  var l = /*#__PURE__*/function (_r$Component8) {
    _inherits(l, _r$Component8);
    function l(e) {
      _classCallCheck(this, l);
      return _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, e));
    }
    _createClass(l, [{
      key: "render",
      value: function render() {
        var _this8 = this;
        return r.createElement("div", {
          className: "file-entry"
        }, r.createElement("div", {
          className: "file-entry-logo-container"
        }, r.createElement("i", {
          className: "material-icons file-entry-logo"
        }, "insert_drive_file")), r.createElement("div", {
          className: "file-entry-description"
        }, this.props.fileName), r.createElement("div", {
          className: "file-entry-remove-container",
          onClick: function onClick() {
            return _this8.props.onFileCancel(_this8.props.fileIndex);
          }
        }, r.createElement("i", {
          className: "material-icons file-entry-remove"
        }, "close")));
      }
    }]);
    return l;
  }(r.Component);
  t.FileEntry = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.FileBoxStrings = {
    DEFAULT_MESSAGE_MULTIPLE_FILES: "Drag & drop to upload",
    DEFAULT_MESSAGE_SINGLE_FILE: "Drag & drop single file to upload",
    DEFAULT_ICON: "cloud_upload",
    BROWSE: "Browse",
    DROP_MESSAGE: "Drop Here"
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(2),
    l = n(21),
    c = n(1),
    a = n(0),
    i = n(22),
    s = n(23);
  var o = /*#__PURE__*/function (_a$Component) {
    _inherits(o, _a$Component);
    function o(e) {
      var _this9;
      _classCallCheck(this, o);
      var t;
      if (_this9 = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, e)), _this9.popperInstance = null, _this9.toggleRef = a.createRef(), _this9.menuRef = a.createRef(), _this9.multipleMenuRef = a.createRef(), _this9.setDisplayString = function (e) {
        _this9.setState({
          displayString: e || _this9.props.noValueLabel
        });
      }, _this9.handleClickOutside = function (e) {
        var t = document.querySelector("#select-menu-header-".concat(_this9.state.id));
        _this9.props.headerContainer && null != t && (t.contains(e.target) || t == e.target) || (_this9.props.multipleSelection ? _this9.multipleMenuRef.current && _this9.multipleMenuRef.current.onSelectClick && !document.querySelector("#selectToggle".concat(_this9.state.id)).contains(e.target) && !document.querySelector("#selectMenu".concat(_this9.state.id, " .multiple-select-buttons-container")).contains(e.target) && _this9.multipleMenuRef && _this9.state.isOpen && _this9.multipleMenuRef.current.onSelectClick() : document.querySelector("#selectToggle".concat(_this9.state.id)).contains(e.target) || (_this9.menuRef.current.style.display = "none", _this9.popperInstance.scheduleUpdate(), _this9.setState({
          isOpen: !1
        })));
      }, _this9.toggle = function () {
        _this9.menuRef.current.style.display = _this9.state.isOpen ? "none" : "block", _this9.popperInstance.scheduleUpdate(), _this9.setState({
          isOpen: !_this9.state.isOpen
        });
      }, _this9.selectItem = function (e) {
        if (_this9.props.multipleSelection) {
          if (void 0 === e) _this9.props.onChange([]), _this9.setState({
            value: []
          }), _this9.multipleMenuRef && _this9.multipleMenuRef.current.clearSelection();else {
            var _t3 = e.map(function (e) {
              return e.value;
            });
            _this9.props.onChange(_t3), _this9.setState({
              value: _t3
            });
          }
        } else _this9.props.onChange(e.value), _this9.setState({
          value: e.value
        }), _this9.toggle();
      }, null != _this9.props.value) {
        var _n3 = _this9.props.value instanceof Array ? _this9.props.value : [_this9.props.value];
        t = e.items.filter(function (e) {
          return _n3.includes(e.value);
        });
      }
      _this9.state = {
        value: t,
        isOpen: !1,
        id: r.uniqueId(),
        displayString: e.noValueLabel
      };
      return _possibleConstructorReturn(_this9);
    }
    _createClass(o, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.menuRef.current.style.display = "none", document.addEventListener("click", this.handleClickOutside), this.popperInstance = new l.default(this.toggleRef.current, this.menuRef.current, {
          placement: "bottom"
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
      }
    }, {
      key: "render",
      value: function render() {
        var e = this.props.multipleSelection ? a.createElement(i.SelectMultipleOption, {
            onSelect: this.selectItem,
            items: this.props.items,
            values: this.state.value,
            closeMenu: this.toggle,
            key: this.state.id,
            ref: this.multipleMenuRef,
            setDisplayString: this.setDisplayString,
            auxiliaryButtons: !!this.props.multipleSelection && this.props.auxiliaryButtons
          }) : a.createElement(s.SelectSingleOption, {
            onSelect: this.selectItem,
            items: this.props.items,
            key: this.state.id,
            value: this.state.value ? this.state.value[0] : null,
            setDisplayString: this.setDisplayString
          }),
          t = this.props.noItemsPlaceholder && (null == this.props.items || 0 == this.props.items.length) ? this.props.noItemsPlaceholder : this.state.displayString;
        return a.createElement("div", {
          className: "select ".concat(this.props.disabled ? "disabled" : "")
        }, a.createElement("div", {
          className: "select-toggle " + (this.state.value ? "no-value" : null),
          ref: this.toggleRef,
          onClick: this.toggle,
          id: "selectToggle".concat(this.state.id)
        }, t), this.props.items.length > 0 && !this.props.disabled ? a.createElement("div", {
          className: "select-menu",
          id: "selectMenu".concat(this.state.id),
          ref: this.menuRef
        }, void 0 !== this.props.headerContainer && a.createElement("div", {
          id: "select-menu-header-".concat(this.state.id),
          className: "header-container"
        }, this.props.headerContainer), e) : a.createElement("div", {
          className: "".concat(void 0 !== this.props.headerContainer ? "select-menu" : ""),
          id: "selectMenu".concat(this.state.id),
          ref: this.menuRef
        }, void 0 !== this.props.headerContainer && a.createElement("div", {
          id: "select-menu-header-".concat(this.state.id),
          className: "header-container"
        }, this.props.headerContainer)));
      }
    }]);
    return o;
  }(a.Component);
  t.SelectMenu = o, o.propTypes = {
    value: c.any,
    noValueLabel: c.string.isRequired,
    items: c.arrayOf(c.shape({
      label: c.any.isRequired,
      value: c.any.isRequired
    })),
    onChange: c.func,
    multipleSelection: c.bool,
    auxiliaryButtons: c.bool,
    headerContainer: c.any
  }, o.defaultProps = {
    value: null,
    items: [],
    multipleSelection: !1,
    auxiliaryButtons: !1
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), function (e) {
    /**!
     * @fileOverview Kickass library to create and place poppers near their reference elements.
     * @version 1.16.1
     * @license
     * Copyright (c) 2016 Federico Zivolo and contributors
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */
    var n = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator,
      r = function () {
        for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1) if (n && navigator.userAgent.indexOf(e[t]) >= 0) return 1;
        return 0;
      }();
    var l = n && window.Promise ? function (e) {
      var t = !1;
      return function () {
        t || (t = !0, window.Promise.resolve().then(function () {
          t = !1, e();
        }));
      };
    } : function (e) {
      var t = !1;
      return function () {
        t || (t = !0, setTimeout(function () {
          t = !1, e();
        }, r));
      };
    };
    function c(e) {
      return e && "[object Function]" === {}.toString.call(e);
    }
    function a(e, t) {
      if (1 !== e.nodeType) return [];
      var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
      return t ? n[t] : n;
    }
    function i(e) {
      return "HTML" === e.nodeName ? e : e.parentNode || e.host;
    }
    function s(e) {
      if (!e) return document.body;
      switch (e.nodeName) {
        case "HTML":
        case "BODY":
          return e.ownerDocument.body;
        case "#document":
          return e.body;
      }
      var t = a(e),
        n = t.overflow,
        r = t.overflowX,
        l = t.overflowY;
      return /(auto|scroll|overlay)/.test(n + l + r) ? e : s(i(e));
    }
    function o(e) {
      return e && e.referenceNode ? e.referenceNode : e;
    }
    var h = n && !(!window.MSInputMethodContext || !document.documentMode),
      f = n && /MSIE 10/.test(navigator.userAgent);
    function d(e) {
      return 11 === e ? h : 10 === e ? f : h || f;
    }
    function u(e) {
      if (!e) return document.documentElement;
      for (var t = d(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling;) n = (e = e.nextElementSibling).offsetParent;
      var r = n && n.nodeName;
      return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === a(n, "position") ? u(n) : n : e ? e.ownerDocument.documentElement : document.documentElement;
    }
    function p(e) {
      return null !== e.parentNode ? p(e.parentNode) : e;
    }
    function m(e, t) {
      if (!(e && e.nodeType && t && t.nodeType)) return document.documentElement;
      var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
        r = n ? e : t,
        l = n ? t : e,
        c = document.createRange();
      c.setStart(r, 0), c.setEnd(l, 0);
      var a,
        i,
        s = c.commonAncestorContainer;
      if (e !== s && t !== s || r.contains(l)) return "BODY" === (i = (a = s).nodeName) || "HTML" !== i && u(a.firstElementChild) !== a ? u(s) : s;
      var o = p(e);
      return o.host ? m(o.host, t) : m(e, p(t).host);
    }
    function v(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top",
        n = "top" === t ? "scrollTop" : "scrollLeft",
        r = e.nodeName;
      if ("BODY" === r || "HTML" === r) {
        var l = e.ownerDocument.documentElement,
          c = e.ownerDocument.scrollingElement || l;
        return c[n];
      }
      return e[n];
    }
    function E(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        r = v(t, "top"),
        l = v(t, "left"),
        c = n ? -1 : 1;
      return e.top += r * c, e.bottom += r * c, e.left += l * c, e.right += l * c, e;
    }
    function M(e, t) {
      var n = "x" === t ? "Left" : "Top",
        r = "Left" === n ? "Right" : "Bottom";
      return parseFloat(e["border" + n + "Width"]) + parseFloat(e["border" + r + "Width"]);
    }
    function z(e, t, n, r) {
      return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], d(10) ? parseInt(n["offset" + e]) + parseInt(r["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0);
    }
    function k(e) {
      var t = e.body,
        n = e.documentElement,
        r = d(10) && getComputedStyle(n);
      return {
        height: z("Height", t, n, r),
        width: z("Width", t, n, r)
      };
    }
    var g = function g(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      },
      b = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      y = function y(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      },
      _ = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      };
    function W(e) {
      return _({}, e, {
        right: e.left + e.width,
        bottom: e.top + e.height
      });
    }
    function w(e) {
      var t = {};
      try {
        if (d(10)) {
          t = e.getBoundingClientRect();
          var n = v(e, "top"),
            r = v(e, "left");
          t.top += n, t.left += r, t.bottom += n, t.right += r;
        } else t = e.getBoundingClientRect();
      } catch (e) {}
      var l = {
          left: t.left,
          top: t.top,
          width: t.right - t.left,
          height: t.bottom - t.top
        },
        c = "HTML" === e.nodeName ? k(e.ownerDocument) : {},
        i = c.width || e.clientWidth || l.width,
        s = c.height || e.clientHeight || l.height,
        o = e.offsetWidth - i,
        h = e.offsetHeight - s;
      if (o || h) {
        var f = a(e);
        o -= M(f, "x"), h -= M(f, "y"), l.width -= o, l.height -= h;
      }
      return W(l);
    }
    function x(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        r = d(10),
        l = "HTML" === t.nodeName,
        c = w(e),
        i = w(t),
        o = s(e),
        h = a(t),
        f = parseFloat(h.borderTopWidth),
        u = parseFloat(h.borderLeftWidth);
      n && l && (i.top = Math.max(i.top, 0), i.left = Math.max(i.left, 0));
      var p = W({
        top: c.top - i.top - f,
        left: c.left - i.left - u,
        width: c.width,
        height: c.height
      });
      if (p.marginTop = 0, p.marginLeft = 0, !r && l) {
        var m = parseFloat(h.marginTop),
          v = parseFloat(h.marginLeft);
        p.top -= f - m, p.bottom -= f - m, p.left -= u - v, p.right -= u - v, p.marginTop = m, p.marginLeft = v;
      }
      return (r && !n ? t.contains(o) : t === o && "BODY" !== o.nodeName) && (p = E(p, t)), p;
    }
    function S(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        n = e.ownerDocument.documentElement,
        r = x(e, n),
        l = Math.max(n.clientWidth, window.innerWidth || 0),
        c = Math.max(n.clientHeight, window.innerHeight || 0),
        a = t ? 0 : v(n),
        i = t ? 0 : v(n, "left"),
        s = {
          top: a - r.top + r.marginTop,
          left: i - r.left + r.marginLeft,
          width: l,
          height: c
        };
      return W(s);
    }
    function C(e) {
      var t = e.nodeName;
      if ("BODY" === t || "HTML" === t) return !1;
      if ("fixed" === a(e, "position")) return !0;
      var n = i(e);
      return !!n && C(n);
    }
    function O(e) {
      if (!e || !e.parentElement || d()) return document.documentElement;
      for (var t = e.parentElement; t && "none" === a(t, "transform");) t = t.parentElement;
      return t || document.documentElement;
    }
    function j(e, t, n, r) {
      var l = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
        c = {
          top: 0,
          left: 0
        },
        a = l ? O(e) : m(e, o(t));
      if ("viewport" === r) c = S(a, l);else {
        var h = void 0;
        "scrollParent" === r ? "BODY" === (h = s(i(t))).nodeName && (h = e.ownerDocument.documentElement) : h = "window" === r ? e.ownerDocument.documentElement : r;
        var f = x(h, a, l);
        if ("HTML" !== h.nodeName || C(a)) c = f;else {
          var d = k(e.ownerDocument),
            u = d.height,
            p = d.width;
          c.top += f.top - f.marginTop, c.bottom = u + f.top, c.left += f.left - f.marginLeft, c.right = p + f.left;
        }
      }
      var v = "number" == typeof (n = n || 0);
      return c.left += v ? n : n.left || 0, c.top += v ? n : n.top || 0, c.right -= v ? n : n.right || 0, c.bottom -= v ? n : n.bottom || 0, c;
    }
    function L(e) {
      return e.width * e.height;
    }
    function N(e, t, n, r, l) {
      var c = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
      if (-1 === e.indexOf("auto")) return e;
      var a = j(n, r, c, l),
        i = {
          top: {
            width: a.width,
            height: t.top - a.top
          },
          right: {
            width: a.right - t.right,
            height: a.height
          },
          bottom: {
            width: a.width,
            height: a.bottom - t.bottom
          },
          left: {
            width: t.left - a.left,
            height: a.height
          }
        },
        s = Object.keys(i).map(function (e) {
          return _({
            key: e
          }, i[e], {
            area: L(i[e])
          });
        }).sort(function (e, t) {
          return t.area - e.area;
        }),
        o = s.filter(function (e) {
          var t = e.width,
            r = e.height;
          return t >= n.clientWidth && r >= n.clientHeight;
        }),
        h = o.length > 0 ? o[0].key : s[0].key,
        f = e.split("-")[1];
      return h + (f ? "-" + f : "");
    }
    function I(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
        l = r ? O(t) : m(t, o(n));
      return x(n, l, r);
    }
    function A(e) {
      var t = e.ownerDocument.defaultView.getComputedStyle(e),
        n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
        r = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
      return {
        width: e.offsetWidth + r,
        height: e.offsetHeight + n
      };
    }
    function F(e) {
      var t = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
      };
      return e.replace(/left|right|bottom|top/g, function (e) {
        return t[e];
      });
    }
    function R(e, t, n) {
      n = n.split("-")[0];
      var r = A(e),
        l = {
          width: r.width,
          height: r.height
        },
        c = -1 !== ["right", "left"].indexOf(n),
        a = c ? "top" : "left",
        i = c ? "left" : "top",
        s = c ? "height" : "width",
        o = c ? "width" : "height";
      return l[a] = t[a] + t[s] / 2 - r[s] / 2, l[i] = n === i ? t[i] - r[o] : t[F(i)], l;
    }
    function T(e, t) {
      return Array.prototype.find ? e.find(t) : e.filter(t)[0];
    }
    function P(e, t, n) {
      return (void 0 === n ? e : e.slice(0, function (e, t, n) {
        if (Array.prototype.findIndex) return e.findIndex(function (e) {
          return e[t] === n;
        });
        var r = T(e, function (e) {
          return e[t] === n;
        });
        return e.indexOf(r);
      }(e, "name", n))).forEach(function (e) {
        e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var n = e.function || e.fn;
        e.enabled && c(n) && (t.offsets.popper = W(t.offsets.popper), t.offsets.reference = W(t.offsets.reference), t = n(t, e));
      }), t;
    }
    function D() {
      if (!this.state.isDestroyed) {
        var e = {
          instance: this,
          styles: {},
          arrowStyles: {},
          attributes: {},
          flipped: !1,
          offsets: {}
        };
        e.offsets.reference = I(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = N(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = R(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = P(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e));
      }
    }
    function B(e, t) {
      return e.some(function (e) {
        var n = e.name;
        return e.enabled && n === t;
      });
    }
    function U(e) {
      for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), r = 0; r < t.length; r++) {
        var l = t[r],
          c = l ? "" + l + n : e;
        if (void 0 !== document.body.style[c]) return c;
      }
      return null;
    }
    function V() {
      return this.state.isDestroyed = !0, B(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[U("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
    }
    function H(e) {
      var t = e.ownerDocument;
      return t ? t.defaultView : window;
    }
    function q(e, t, n, r) {
      n.updateBound = r, H(e).addEventListener("resize", n.updateBound, {
        passive: !0
      });
      var l = s(e);
      return function e(t, n, r, l) {
        var c = "BODY" === t.nodeName,
          a = c ? t.ownerDocument.defaultView : t;
        a.addEventListener(n, r, {
          passive: !0
        }), c || e(s(a.parentNode), n, r, l), l.push(a);
      }(l, "scroll", n.updateBound, n.scrollParents), n.scrollElement = l, n.eventsEnabled = !0, n;
    }
    function $() {
      this.state.eventsEnabled || (this.state = q(this.reference, this.options, this.state, this.scheduleUpdate));
    }
    function G() {
      var e, t;
      this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (e = this.reference, t = this.state, H(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function (e) {
        e.removeEventListener("scroll", t.updateBound);
      }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t));
    }
    function Y(e) {
      return "" !== e && !isNaN(parseFloat(e)) && isFinite(e);
    }
    function Z(e, t) {
      Object.keys(t).forEach(function (n) {
        var r = "";
        -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && Y(t[n]) && (r = "px"), e.style[n] = t[n] + r;
      });
    }
    var K = n && /Firefox/i.test(navigator.userAgent);
    function X(e, t, n) {
      var r = T(e, function (e) {
          return e.name === t;
        }),
        l = !!r && e.some(function (e) {
          return e.name === n && e.enabled && e.order < r.order;
        });
      if (!l) {
        var c = "`" + t + "`",
          a = "`" + n + "`";
        console.warn(a + " modifier is required by " + c + " modifier in order to work, be sure to include it before " + c + "!");
      }
      return l;
    }
    var J = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
      Q = J.slice(3);
    function ee(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        n = Q.indexOf(e),
        r = Q.slice(n + 1).concat(Q.slice(0, n));
      return t ? r.reverse() : r;
    }
    var te = "flip",
      ne = "clockwise",
      re = "counterclockwise";
    function le(e, t, n, r) {
      var l = [0, 0],
        c = -1 !== ["right", "left"].indexOf(r),
        a = e.split(/(\+|\-)/).map(function (e) {
          return e.trim();
        }),
        i = a.indexOf(T(a, function (e) {
          return -1 !== e.search(/,|\s/);
        }));
      a[i] && -1 === a[i].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
      var s = /\s*,\s*|\s+/,
        o = -1 !== i ? [a.slice(0, i).concat([a[i].split(s)[0]]), [a[i].split(s)[1]].concat(a.slice(i + 1))] : [a];
      return (o = o.map(function (e, r) {
        var l = (1 === r ? !c : c) ? "height" : "width",
          a = !1;
        return e.reduce(function (e, t) {
          return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t, a = !0, e) : a ? (e[e.length - 1] += t, a = !1, e) : e.concat(t);
        }, []).map(function (e) {
          return function (e, t, n, r) {
            var l = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
              c = +l[1],
              a = l[2];
            if (!c) return e;
            if (0 === a.indexOf("%")) {
              var i = void 0;
              switch (a) {
                case "%p":
                  i = n;
                  break;
                case "%":
                case "%r":
                default:
                  i = r;
              }
              return W(i)[t] / 100 * c;
            }
            if ("vh" === a || "vw" === a) {
              return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * c;
            }
            return c;
          }(e, l, t, n);
        });
      })).forEach(function (e, t) {
        e.forEach(function (n, r) {
          Y(n) && (l[t] += n * ("-" === e[r - 1] ? -1 : 1));
        });
      }), l;
    }
    var ce = {
        placement: "bottom",
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function onCreate() {},
        onUpdate: function onUpdate() {},
        modifiers: {
          shift: {
            order: 100,
            enabled: !0,
            fn: function fn(e) {
              var t = e.placement,
                n = t.split("-")[0],
                r = t.split("-")[1];
              if (r) {
                var l = e.offsets,
                  c = l.reference,
                  a = l.popper,
                  i = -1 !== ["bottom", "top"].indexOf(n),
                  s = i ? "left" : "top",
                  o = i ? "width" : "height",
                  h = {
                    start: y({}, s, c[s]),
                    end: y({}, s, c[s] + c[o] - a[o])
                  };
                e.offsets.popper = _({}, a, h[r]);
              }
              return e;
            }
          },
          offset: {
            order: 200,
            enabled: !0,
            fn: function fn(e, t) {
              var n = t.offset,
                r = e.placement,
                l = e.offsets,
                c = l.popper,
                a = l.reference,
                i = r.split("-")[0],
                s = void 0;
              return s = Y(+n) ? [+n, 0] : le(n, c, a, i), "left" === i ? (c.top += s[0], c.left -= s[1]) : "right" === i ? (c.top += s[0], c.left += s[1]) : "top" === i ? (c.left += s[0], c.top -= s[1]) : "bottom" === i && (c.left += s[0], c.top += s[1]), e.popper = c, e;
            },
            offset: 0
          },
          preventOverflow: {
            order: 300,
            enabled: !0,
            fn: function fn(e, t) {
              var n = t.boundariesElement || u(e.instance.popper);
              e.instance.reference === n && (n = u(n));
              var r = U("transform"),
                l = e.instance.popper.style,
                c = l.top,
                a = l.left,
                i = l[r];
              l.top = "", l.left = "", l[r] = "";
              var s = j(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
              l.top = c, l.left = a, l[r] = i, t.boundaries = s;
              var o = t.priority,
                h = e.offsets.popper,
                f = {
                  primary: function primary(e) {
                    var n = h[e];
                    return h[e] < s[e] && !t.escapeWithReference && (n = Math.max(h[e], s[e])), y({}, e, n);
                  },
                  secondary: function secondary(e) {
                    var n = "right" === e ? "left" : "top",
                      r = h[n];
                    return h[e] > s[e] && !t.escapeWithReference && (r = Math.min(h[n], s[e] - ("right" === e ? h.width : h.height))), y({}, n, r);
                  }
                };
              return o.forEach(function (e) {
                var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                h = _({}, h, f[t](e));
              }), e.offsets.popper = h, e;
            },
            priority: ["left", "right", "top", "bottom"],
            padding: 5,
            boundariesElement: "scrollParent"
          },
          keepTogether: {
            order: 400,
            enabled: !0,
            fn: function fn(e) {
              var t = e.offsets,
                n = t.popper,
                r = t.reference,
                l = e.placement.split("-")[0],
                c = Math.floor,
                a = -1 !== ["top", "bottom"].indexOf(l),
                i = a ? "right" : "bottom",
                s = a ? "left" : "top",
                o = a ? "width" : "height";
              return n[i] < c(r[s]) && (e.offsets.popper[s] = c(r[s]) - n[o]), n[s] > c(r[i]) && (e.offsets.popper[s] = c(r[i])), e;
            }
          },
          arrow: {
            order: 500,
            enabled: !0,
            fn: function fn(e, t) {
              var n;
              if (!X(e.instance.modifiers, "arrow", "keepTogether")) return e;
              var r = t.element;
              if ("string" == typeof r) {
                if (!(r = e.instance.popper.querySelector(r))) return e;
              } else if (!e.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
              var l = e.placement.split("-")[0],
                c = e.offsets,
                i = c.popper,
                s = c.reference,
                o = -1 !== ["left", "right"].indexOf(l),
                h = o ? "height" : "width",
                f = o ? "Top" : "Left",
                d = f.toLowerCase(),
                u = o ? "left" : "top",
                p = o ? "bottom" : "right",
                m = A(r)[h];
              s[p] - m < i[d] && (e.offsets.popper[d] -= i[d] - (s[p] - m)), s[d] + m > i[p] && (e.offsets.popper[d] += s[d] + m - i[p]), e.offsets.popper = W(e.offsets.popper);
              var v = s[d] + s[h] / 2 - m / 2,
                E = a(e.instance.popper),
                M = parseFloat(E["margin" + f]),
                z = parseFloat(E["border" + f + "Width"]),
                k = v - e.offsets.popper[d] - M - z;
              return k = Math.max(Math.min(i[h] - m, k), 0), e.arrowElement = r, e.offsets.arrow = (y(n = {}, d, Math.round(k)), y(n, u, ""), n), e;
            },
            element: "[x-arrow]"
          },
          flip: {
            order: 600,
            enabled: !0,
            fn: function fn(e, t) {
              if (B(e.instance.modifiers, "inner")) return e;
              if (e.flipped && e.placement === e.originalPlacement) return e;
              var n = j(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed),
                r = e.placement.split("-")[0],
                l = F(r),
                c = e.placement.split("-")[1] || "",
                a = [];
              switch (t.behavior) {
                case te:
                  a = [r, l];
                  break;
                case ne:
                  a = ee(r);
                  break;
                case re:
                  a = ee(r, !0);
                  break;
                default:
                  a = t.behavior;
              }
              return a.forEach(function (i, s) {
                if (r !== i || a.length === s + 1) return e;
                r = e.placement.split("-")[0], l = F(r);
                var o = e.offsets.popper,
                  h = e.offsets.reference,
                  f = Math.floor,
                  d = "left" === r && f(o.right) > f(h.left) || "right" === r && f(o.left) < f(h.right) || "top" === r && f(o.bottom) > f(h.top) || "bottom" === r && f(o.top) < f(h.bottom),
                  u = f(o.left) < f(n.left),
                  p = f(o.right) > f(n.right),
                  m = f(o.top) < f(n.top),
                  v = f(o.bottom) > f(n.bottom),
                  E = "left" === r && u || "right" === r && p || "top" === r && m || "bottom" === r && v,
                  M = -1 !== ["top", "bottom"].indexOf(r),
                  z = !!t.flipVariations && (M && "start" === c && u || M && "end" === c && p || !M && "start" === c && m || !M && "end" === c && v),
                  k = !!t.flipVariationsByContent && (M && "start" === c && p || M && "end" === c && u || !M && "start" === c && v || !M && "end" === c && m),
                  g = z || k;
                (d || E || g) && (e.flipped = !0, (d || E) && (r = a[s + 1]), g && (c = function (e) {
                  return "end" === e ? "start" : "start" === e ? "end" : e;
                }(c)), e.placement = r + (c ? "-" + c : ""), e.offsets.popper = _({}, e.offsets.popper, R(e.instance.popper, e.offsets.reference, e.placement)), e = P(e.instance.modifiers, e, "flip"));
              }), e;
            },
            behavior: "flip",
            padding: 5,
            boundariesElement: "viewport",
            flipVariations: !1,
            flipVariationsByContent: !1
          },
          inner: {
            order: 700,
            enabled: !1,
            fn: function fn(e) {
              var t = e.placement,
                n = t.split("-")[0],
                r = e.offsets,
                l = r.popper,
                c = r.reference,
                a = -1 !== ["left", "right"].indexOf(n),
                i = -1 === ["top", "left"].indexOf(n);
              return l[a ? "left" : "top"] = c[n] - (i ? l[a ? "width" : "height"] : 0), e.placement = F(t), e.offsets.popper = W(l), e;
            }
          },
          hide: {
            order: 800,
            enabled: !0,
            fn: function fn(e) {
              if (!X(e.instance.modifiers, "hide", "preventOverflow")) return e;
              var t = e.offsets.reference,
                n = T(e.instance.modifiers, function (e) {
                  return "preventOverflow" === e.name;
                }).boundaries;
              if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
                if (!0 === e.hide) return e;
                e.hide = !0, e.attributes["x-out-of-boundaries"] = "";
              } else {
                if (!1 === e.hide) return e;
                e.hide = !1, e.attributes["x-out-of-boundaries"] = !1;
              }
              return e;
            }
          },
          computeStyle: {
            order: 850,
            enabled: !0,
            fn: function fn(e, t) {
              var n = t.x,
                r = t.y,
                l = e.offsets.popper,
                c = T(e.instance.modifiers, function (e) {
                  return "applyStyle" === e.name;
                }).gpuAcceleration;
              void 0 !== c && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
              var a = void 0 !== c ? c : t.gpuAcceleration,
                i = u(e.instance.popper),
                s = w(i),
                o = {
                  position: l.position
                },
                h = function (e, t) {
                  var n = e.offsets,
                    r = n.popper,
                    l = n.reference,
                    c = Math.round,
                    a = Math.floor,
                    i = function i(e) {
                      return e;
                    },
                    s = c(l.width),
                    o = c(r.width),
                    h = -1 !== ["left", "right"].indexOf(e.placement),
                    f = -1 !== e.placement.indexOf("-"),
                    d = t ? h || f || s % 2 == o % 2 ? c : a : i,
                    u = t ? c : i;
                  return {
                    left: d(s % 2 == 1 && o % 2 == 1 && !f && t ? r.left - 1 : r.left),
                    top: u(r.top),
                    bottom: u(r.bottom),
                    right: d(r.right)
                  };
                }(e, window.devicePixelRatio < 2 || !K),
                f = "bottom" === n ? "top" : "bottom",
                d = "right" === r ? "left" : "right",
                p = U("transform"),
                m = void 0,
                v = void 0;
              if (v = "bottom" === f ? "HTML" === i.nodeName ? -i.clientHeight + h.bottom : -s.height + h.bottom : h.top, m = "right" === d ? "HTML" === i.nodeName ? -i.clientWidth + h.right : -s.width + h.right : h.left, a && p) o[p] = "translate3d(" + m + "px, " + v + "px, 0)", o[f] = 0, o[d] = 0, o.willChange = "transform";else {
                var E = "bottom" === f ? -1 : 1,
                  M = "right" === d ? -1 : 1;
                o[f] = v * E, o[d] = m * M, o.willChange = f + ", " + d;
              }
              var z = {
                "x-placement": e.placement
              };
              return e.attributes = _({}, z, e.attributes), e.styles = _({}, o, e.styles), e.arrowStyles = _({}, e.offsets.arrow, e.arrowStyles), e;
            },
            gpuAcceleration: !0,
            x: "bottom",
            y: "right"
          },
          applyStyle: {
            order: 900,
            enabled: !0,
            fn: function fn(e) {
              var t, n;
              return Z(e.instance.popper, e.styles), t = e.instance.popper, n = e.attributes, Object.keys(n).forEach(function (e) {
                !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e);
              }), e.arrowElement && Object.keys(e.arrowStyles).length && Z(e.arrowElement, e.arrowStyles), e;
            },
            onLoad: function onLoad(e, t, n, r, l) {
              var c = I(l, t, e, n.positionFixed),
                a = N(n.placement, c, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
              return t.setAttribute("x-placement", a), Z(t, {
                position: n.positionFixed ? "fixed" : "absolute"
              }), n;
            },
            gpuAcceleration: void 0
          }
        }
      },
      ae = function () {
        function e(t, n) {
          var r = this,
            a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          g(this, e), this.scheduleUpdate = function () {
            return requestAnimationFrame(r.update);
          }, this.update = l(this.update.bind(this)), this.options = _({}, e.Defaults, a), this.state = {
            isDestroyed: !1,
            isCreated: !1,
            scrollParents: []
          }, this.reference = t && t.jquery ? t[0] : t, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(_({}, e.Defaults.modifiers, a.modifiers)).forEach(function (t) {
            r.options.modifiers[t] = _({}, e.Defaults.modifiers[t] || {}, a.modifiers ? a.modifiers[t] : {});
          }), this.modifiers = Object.keys(this.options.modifiers).map(function (e) {
            return _({
              name: e
            }, r.options.modifiers[e]);
          }).sort(function (e, t) {
            return e.order - t.order;
          }), this.modifiers.forEach(function (e) {
            e.enabled && c(e.onLoad) && e.onLoad(r.reference, r.popper, r.options, e, r.state);
          }), this.update();
          var i = this.options.eventsEnabled;
          i && this.enableEventListeners(), this.state.eventsEnabled = i;
        }
        return b(e, [{
          key: "update",
          value: function value() {
            return D.call(this);
          }
        }, {
          key: "destroy",
          value: function value() {
            return V.call(this);
          }
        }, {
          key: "enableEventListeners",
          value: function value() {
            return $.call(this);
          }
        }, {
          key: "disableEventListeners",
          value: function value() {
            return G.call(this);
          }
        }]), e;
      }();
    ae.Utils = ("undefined" != typeof window ? window : e).PopperUtils, ae.placements = J, ae.Defaults = ce, t.default = ae;
  }.call(this, n(5));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0),
    l = n(4),
    c = function c(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return {
        label: e.label,
        value: e.value,
        selected: t.includes(e)
      };
    };
  var a = /*#__PURE__*/function (_r$Component9) {
    _inherits(a, _r$Component9);
    function a(e) {
      var _this10;
      _classCallCheck(this, a);
      _this10 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e)), _this10.onSelectItem = function (e) {
        var t = _this10.state.newValues.map(function (t) {
          return Object.assign(Object.assign({}, t), {
            selected: t.label === e.label ? !t.selected : t.selected
          });
        });
        _this10.setState({
          newValues: t
        });
      }, _this10.onSelectClick = function () {
        var e = _this10.state.newValues.filter(function (e) {
          return e.selected;
        });
        _this10.props.onSelect(e), _this10.props.setDisplayString(_this10.getDisplayString(e)), _this10.setState({
          previousValues: _this10.state.newValues
        }), _this10.props.closeMenu();
      }, _this10.onAllClick = function () {
        var e = _this10.state.newValues.map(function (e) {
          return Object.assign(Object.assign({}, e), {
            selected: !0
          });
        });
        _this10.setState({
          newValues: e
        });
      }, _this10.onClearClick = function () {
        var e = _this10.state.newValues.map(function (e) {
          return Object.assign(Object.assign({}, e), {
            selected: !1
          });
        });
        _this10.setState({
          newValues: e
        });
      }, _this10.onCancelClick = function () {
        _this10.setState({
          newValues: _this10.state.previousValues
        }), _this10.props.closeMenu();
      }, _this10.getDisplayString = function (e) {
        return 0 === e.length ? null : e.length > 1 ? "".concat(e.length, " items selected") : e[0].label;
      }, _this10.clearSelection = function () {
        var e = _this10.state.newValues.map(function (e) {
          return Object.assign(Object.assign({}, e), {
            selected: !1
          });
        });
        _this10.setState({
          newValues: e
        });
      };
      var t = _this10.props.items.map(function (t) {
        return c(t, e.values);
      });
      _this10.state = {
        previousValues: _toConsumableArray(t),
        newValues: _toConsumableArray(t)
      }, e.values && e.setDisplayString(_this10.getDisplayString(_this10.state.previousValues.filter(function (e) {
        return e.selected;
      })));
      return _this10;
    }
    _createClass(a, [{
      key: "render",
      value: function render() {
        var _this11 = this;
        var e = this.state.newValues.map(function (e) {
          return r.createElement("div", {
            className: "select-menu-item multiple",
            onClick: function onClick() {
              return _this11.onSelectItem(e);
            },
            key: e.value,
            id: "selectMenuOption".concat(e.value)
          }, r.createElement(l.Checkbox, {
            checked: e.selected
          }, e.label));
        });
        return r.createElement(r.Fragment, null, r.createElement("div", {
          className: "multiple-select-buttons-container"
        }, this.props.auxiliaryButtons && r.createElement(r.Fragment, null, r.createElement("div", {
          className: "buttons-row"
        }, r.createElement("button", {
          className: "purple-btn",
          onClick: this.onAllClick
        }, r.createElement("i", {
          className: "material-icons"
        }, "check_box"), "Select All"), r.createElement("button", {
          className: "purple-btn",
          onClick: this.onClearClick
        }, r.createElement("i", {
          className: "material-icons"
        }, "check_box_outline_blank"), "Clear All")), r.createElement("div", {
          className: "gray-line"
        })), r.createElement("div", {
          className: "multiple-options-container"
        }, e), r.createElement("div", {
          className: "gray-line"
        }), r.createElement("div", {
          className: "buttons-row"
        }, r.createElement("button", {
          className: "red-btn",
          onClick: this.onCancelClick
        }, "Cancel"), r.createElement("button", {
          className: "purple-btn",
          onClick: this.onSelectClick
        }, "Select"))));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(e, t) {
        var n = e.items.map(function (t) {
          return c(t, e.values);
        });
        var r = [];
        return n.map(function (n) {
          var l = t.newValues.findIndex(function (e) {
            return e.value == n.value;
          });
          -1 == l ? r.push({
            label: n.label,
            value: n.value,
            selected: e.value && e.values.includes(n)
          }) : r.push({
            label: n.label,
            value: n.value,
            selected: t.newValues[l].selected
          });
        }), {
          newValues: r
        };
      }
    }]);
    return a;
  }(r.Component);
  t.SelectMultipleOption = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(2),
    l = n(0);
  var c = /*#__PURE__*/function (_l$Component) {
    _inherits(c, _l$Component);
    function c(e) {
      var _this12;
      _classCallCheck(this, c);
      _this12 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, e)), _this12.onSelectItem = function (e) {
        _this12.setState({
          value: e.value
        }), _this12.props.setDisplayString(e.label), _this12.props.onSelect(e);
      }, e.value && (_this12.state = {
        value: e.value
      }, e.setDisplayString(e.value.label));
      return _this12;
    }
    _createClass(c, [{
      key: "render",
      value: function render() {
        var _this13 = this;
        var e = this.props.items.map(function (e) {
          return l.createElement("div", {
            className: "select-menu-item",
            onClick: function onClick() {
              return _this13.onSelectItem(e);
            },
            key: r.uniqueId()
          }, e.label);
        });
        return l.createElement(l.Fragment, null, e);
      }
    }]);
    return c;
  }(l.Component);
  t.SelectSingleOption = c;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0),
    l = n(1),
    c = n(25),
    a = n(26),
    i = n(27),
    s = n(28),
    o = n(29),
    h = n(30),
    f = {
      es: function es(e) {
        return r.createElement(c.FlagES, Object.assign({}, e));
      },
      ie: function ie(e) {
        return r.createElement(a.FlagIE, Object.assign({}, e));
      },
      kh: function kh(e) {
        return r.createElement(i.FlagKH, Object.assign({}, e));
      },
      mx: function mx(e) {
        return r.createElement(s.FlagMX, Object.assign({}, e));
      },
      ph: function ph(e) {
        return r.createElement(o.FlagPH, Object.assign({}, e));
      },
      pt: function pt(e) {
        return r.createElement(h.FlagPT, Object.assign({}, e));
      }
    };
  var d = /*#__PURE__*/function (_r$Component10) {
    _inherits(d, _r$Component10);
    function d() {
      _classCallCheck(this, d);
      return _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments));
    }
    _createClass(d, [{
      key: "render",
      value: function render() {
        var e = {
          width: this.props.width,
          height: this.props.height
        };
        return r.createElement("div", {
          style: e,
          className: "flag-icon"
        }, f[this.props.country](Object.assign({}, this.props)));
      }
    }]);
    return d;
  }(r.Component);
  t.FlagSVG = d, d.propTypes = {
    country: l.oneOf(["es", "mx", "ie", "kh", "ph", "pt"]).isRequired,
    width: l.number.isRequired,
    height: l.number.isRequired
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  t.FlagES = function (_ref) {
    var e = _ref.width,
      t = _ref.height;
    return r.createElement("svg", {
      preserveAspectRatio: "none",
      height: t,
      width: e,
      viewBox: "0 0 750 500"
    }, r.createElement("path", {
      fill: "#c60b1e",
      d: "M0 0h750v500H0z"
    }), r.createElement("path", {
      fill: "#ffc400",
      d: "M0 125h750v250H0z"
    }), r.createElement("path", {
      d: "M167.99 222.24s-.51 0-.8-.16c-.27-.16-1.12-.96-1.12-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.9.9-1.23 1.42-1.5.5-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.33 1.3-.33s.28-.15.56-.26c.29-.1.68-.1.9-.16.23-.06.8-.24 1.14-.26.52-.02 1.35.1 1.64.1.28 0 1.24.05 1.64.05.39 0 1.8-.1 2.2-.1.4 0 .68-.06 1.13 0 .45.05 1.24.31 1.47.42.23.1 1.58.6 2.1.75.5.16 1.74.37 2.31.64.56.27.9.72 1.19 1.1.28.37.34.78.45 1.05.1.26.11.84 0 1.1-.11.27-.51.82-.51.82l-.62 1.02-.8.64s-.56.54-1 .48c-.46-.05-5.04-.86-7.98-.86-2.94 0-7.63.86-7.63.86",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M167.99 222.24s-.51 0-.8-.16c-.27-.16-1.12-.96-1.12-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.9.9-1.23 1.42-1.5.5-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.33 1.3-.33s.28-.15.56-.26c.29-.1.68-.1.9-.16.23-.06.8-.24 1.14-.26.52-.02 1.35.1 1.64.1.28 0 1.24.05 1.64.05.39 0 1.8-.1 2.2-.1.4 0 .68-.06 1.13 0 .45.05 1.24.31 1.47.42.23.1 1.58.6 2.1.75.5.16 1.74.37 2.31.64.56.27.9.72 1.19 1.1.28.37.34.78.45 1.05.1.26.11.84 0 1.1-.11.27-.51.82-.51.82l-.62 1.02-.8.64s-.56.54-1 .48c-.46-.05-5.04-.86-7.98-.86-2.94 0-7.63.86-7.63.86z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M174.28 215.68c0-1.38.62-2.5 1.38-2.5.76 0 1.38 1.12 1.38 2.5s-.62 2.5-1.38 2.5c-.76 0-1.38-1.12-1.38-2.5",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M174.28 215.68c0-1.38.62-2.5 1.38-2.5.76 0 1.38 1.12 1.38 2.5s-.62 2.5-1.38 2.5c-.76 0-1.38-1.12-1.38-2.5z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M175.05 215.68c0-1.27.28-2.3.63-2.3s.64 1.03.64 2.3c0 1.26-.28 2.3-.64 2.3-.35 0-.63-1.04-.63-2.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M175.05 215.68c0-1.27.28-2.3.63-2.3s.64 1.03.64 2.3c0 1.26-.28 2.3-.64 2.3-.35 0-.63-1.04-.63-2.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M174.75 213.04a.9.9 0 0 1 .93-.87c.5 0 .92.4.92.87 0 .49-.41.87-.92.87-.52 0-.93-.38-.93-.87",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M176.33 212.74v.58h-1.43v-.58h.47v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h.36",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M176.33 212.74v.58h-1.43v-.58h.47v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h.36",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".3"
    }), r.createElement("path", {
      d: "M176.97 212.74v.58h-2.54v-.58h.94v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h1",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M176.97 212.74v.58h-2.54v-.58h.94v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h1",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".3"
    }), r.createElement("path", {
      d: "M175.94 212.2c.38.1.66.45.66.84 0 .49-.41.87-.92.87-.52 0-.93-.38-.93-.87 0-.4.3-.75.69-.84",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M175.68 222.08h-4.8l-.12-1.18-.23-1.23-.24-1.53c-1.32-1.75-2.54-2.9-2.95-2.65.1-.32.22-.56.47-.71 1.18-.7 3.6.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.83-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.4-.24-1.62.9-2.95 2.65l-.24 1.53-.23 1.23-.1 1.18h-4.84",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M175.68 222.08h-4.8l-.12-1.18-.23-1.23-.24-1.53c-1.32-1.75-2.54-2.9-2.95-2.65.1-.32.22-.56.47-.71 1.18-.7 3.6.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.83-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.4-.24-1.62.9-2.95 2.65l-.24 1.53-.23 1.23-.1 1.18h-4.84z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M167.55 215.44c.9-.53 3.02 1.15 4.73 3.74m11.55-3.74c-.9-.53-3.01 1.15-4.73 3.74",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M168.58 224.25c-.2-.57-.58-1.08-.58-1.08a28.7 28.7 0 0 1 7.67-.94c3.01 0 5.75.37 7.69.94l-.52.91c-.17.3-.39.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.46.35-6.86.86.02 0-.1-.32-.23-.68",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M168.58 224.25c-.2-.57-.58-1.08-.58-1.08a28.7 28.7 0 0 1 7.67-.94c3.01 0 5.75.37 7.69.94l-.52.91c-.17.3-.39.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.46.35-6.86.86.02 0-.1-.32-.23-.68",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M175.67 226.73c2.43 0 5.11-.38 6.1-.63.66-.2 1.05-.5.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.7-.8-2.65 0-5.28.33-6.73.8-.19.08-.33.22-.36.38-.08.35.31.65.97.84.99.25 3.68.62 6.11.63",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M175.67 226.73c2.43 0 5.11-.38 6.1-.63.66-.2 1.05-.5.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.7-.8-2.65 0-5.28.33-6.73.8-.19.08-.33.22-.36.38-.08.35.31.65.97.84.99.25 3.68.62 6.11.63z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M183.48 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.7.5-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72c-.8.13-1.47-.62-1.47-.62s-.45.73-.99.92c-.53.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.18.47c1.93-.56 4.56-.9 7.53-.9 2.97 0 5.67.34 7.61.9l.2-.53",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M183.48 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.7.5-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72c-.8.13-1.47-.62-1.47-.62s-.45.73-.99.92c-.53.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.18.47c1.93-.56 4.56-.9 7.53-.9 2.97 0 5.67.34 7.61.9l.2-.53z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M175.69 219.5l.28.04a1.09 1.09 0 0 0 1.06 1.43c.5 0 .91-.3 1.06-.73.01.01.1-.38.15-.38.03 0 .03.41.05.4.07.53.55.9 1.1.9.62 0 1.1-.47 1.1-1.06v-.12l.35-.35.2.44a.9.9 0 0 0-.11.46c0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.15.66.49.72 0 0 .38.03.9-.38.52-.41.81-.75.81-.75l.03.42s-.5.84-.97 1.1c-.25.15-.64.3-.95.25-.32-.04-.55-.3-.67-.6-.23.13-.5.21-.8.21-.63 0-1.2-.35-1.42-.86a1.62 1.62 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26 1.63 1.63 0 0 1-2.42.08c-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.3.34.8.75c.53.41.92.38.92.38.34-.06.49-.37.49-.72v-.35l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.94.94 0 0 0-.1-.46l.2-.44.34.35-.01.12c0 .59.5 1.06 1.11 1.06.55 0 1.03-.37 1.1-.9.02.01.02-.4.05-.4.05 0 .14.4.16.38.14.42.56.73 1.06.73a1.09 1.09 0 0 0 1.06-1.43l.29-.05",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M175.69 219.5l.28.04a1.09 1.09 0 0 0 1.06 1.43c.5 0 .91-.3 1.06-.73.01.01.1-.38.15-.38.03 0 .03.41.05.4.07.53.55.9 1.1.9.62 0 1.1-.47 1.1-1.06v-.12l.35-.35.2.44a.9.9 0 0 0-.11.46c0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.15.66.49.72 0 0 .38.03.9-.38.52-.41.81-.75.81-.75l.03.42s-.5.84-.97 1.1c-.25.15-.64.3-.95.25-.32-.04-.55-.3-.67-.6-.23.13-.5.21-.8.21-.63 0-1.2-.35-1.42-.86a1.62 1.62 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26 1.63 1.63 0 0 1-2.42.08c-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.3.34.8.75c.53.41.92.38.92.38.34-.06.49-.37.49-.72v-.35l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.94.94 0 0 0-.1-.46l.2-.44.34.35-.01.12c0 .59.5 1.06 1.11 1.06.55 0 1.03-.37 1.1-.9.02.01.02-.4.05-.4.05 0 .14.4.16.38.14.42.56.73 1.06.73a1.09 1.09 0 0 0 1.06-1.43l.29-.05z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M175.67 222.23c-3.01 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.09 0 5.88.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M175.67 222.23c-3.01 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.09 0 5.88.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M172.75 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M172.75 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31 0-.17.14-.3.32-.3h1.96c.19 0 .33.13.33.3 0 .17-.15.31-.33.31h-.98",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31 0-.17.14-.3.32-.3h1.96c.19 0 .33.13.33.3 0 .17-.15.31-.33.31h-.98",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M170.85 223.81l-.7.1c-.17.03-.34-.08-.37-.25a.3.3 0 0 1 .27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11",
      fill: "#058e6e"
    }), r.createElement("path", {
      d: "M170.85 223.81l-.7.1c-.17.03-.34-.08-.37-.25a.3.3 0 0 1 .27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M168.05 224.3l.3-.5.66.13-.38.56-.58-.19",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M168.05 224.3l.3-.5.66.13-.38.56-.58-.19",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M177.72 223.3c0-.22.2-.4.44-.4s.43.18.43.4c0 .23-.2.41-.43.41-.25 0-.44-.18-.44-.4",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M177.72 223.3c0-.22.2-.4.44-.4s.43.18.43.4c0 .23-.2.41-.43.41-.25 0-.44-.18-.44-.4z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M180.5 223.81l.7.1c.17.03.34-.08.37-.25a.3.3 0 0 0-.27-.35l-.7-.1-.71-.11c-.18-.02-.34.09-.37.25-.03.17.1.33.27.35l.7.11",
      fill: "#058e6e"
    }), r.createElement("path", {
      d: "M180.5 223.81l.7.1c.17.03.34-.08.37-.25a.3.3 0 0 0-.27-.35l-.7-.1-.71-.11c-.18-.02-.34.09-.37.25-.03.17.1.33.27.35l.7.11",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M183.24 224.33l-.25-.53-.67.06.32.59.6-.12",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M183.24 224.33l-.25-.53-.67.06.32.59.6-.12",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.44-3.9.65-6.33.65",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.44-3.9.65-6.33.65z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M183.34 220.88c.06-.18 0-.37-.13-.41-.14-.04-.3.08-.37.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M183.34 220.88c.06-.18 0-.37-.13-.41-.14-.04-.3.08-.37.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M178.5 219.95c.02-.2-.08-.37-.22-.39-.14-.02-.28.13-.3.33-.02.2.07.37.21.38.14.02.28-.13.3-.32",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M178.5 219.95c.02-.2-.08-.37-.22-.39-.14-.02-.28.13-.3.33-.02.2.07.37.21.38.14.02.28-.13.3-.32z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M172.87 219.95c-.03-.2.07-.37.21-.39.14-.02.28.13.3.33.03.2-.07.37-.21.38-.14.02-.28-.13-.3-.32",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M172.87 219.95c-.03-.2.07-.37.21-.39.14-.02.28.13.3.33.03.2-.07.37-.21.38-.14.02-.28-.13-.3-.32z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M168.02 220.88c-.06-.18 0-.37.13-.41.14-.04.3.08.37.26.06.19 0 .38-.14.42-.13.04-.3-.08-.36-.27",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M168.02 220.88c-.06-.18 0-.37.13-.41.14-.04.3.08.37.26.06.19 0 .38-.14.42-.13.04-.3-.08-.36-.27z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M175.66 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M175.66 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M173.78 219.24l.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M173.78 219.24l.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M177.55 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M177.55 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M170.08 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M170.08 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M168.67 220.04l.5.48 1.23-.66.1-.21-.18-.16-1.4-.13-.25.68",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M168.67 220.04l.5.48 1.23-.66.1-.21-.18-.16-1.4-.13-.25.68",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M172.36 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M172.36 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M167.32 220.22l-.11.66-1.4.15-.21-.12.05-.23 1.05-.87.62.41",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M167.32 220.22l-.11.66-1.4.15-.21-.12.05-.23 1.05-.87.62.41",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M170.02 219.65c0-.26.22-.47.5-.47.26 0 .48.21.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M170.02 219.65c0-.26.22-.47.5-.47.26 0 .48.21.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M181.27 217.76l.67.64-.86 1.14-.23.09-.16-.18-.3-1.37.88-.32",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M181.27 217.76l.67.64-.86 1.14-.23.09-.16-.18-.3-1.37.88-.32",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M182.68 220.04l-.5.48-1.23-.66-.1-.21.19-.16 1.4-.13.24.68",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M182.68 220.04l-.5.48-1.23-.66-.1-.21.19-.16 1.4-.13.24.68",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M179 219.3l.25.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M179 219.3l.25.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M183.84 220.22l.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M183.84 220.22l.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M175.18 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46s-.49-.2-.49-.46",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M175.18 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46s-.49-.2-.49-.46z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M180.36 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M180.36 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M165.43 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.36.32c.1.29.04.72.04.72s-.05.2-.14.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M165.43 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.36.32c.1.29.04.72.04.72s-.05.2-.14.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M165.45 220.75c.12-.12.36-.1.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M165.45 220.75c.12-.12.36-.1.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M185.73 221c.01 0 .38-.49.66-.73.19-.18.67-.33.67-.33 0-.09-.28-.28-.58-.28a.58.58 0 0 0-.45.2l-.04-.2s-.24.05-.36.32c-.1.29-.03.72-.03.72s.04.2.13.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M185.73 221c.01 0 .38-.49.66-.73.19-.18.67-.33.67-.33 0-.09-.28-.28-.58-.28a.58.58 0 0 0-.45.2l-.04-.2s-.24.05-.36.32c-.1.29-.03.72-.03.72s.04.2.13.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M185.74 220.75c-.11-.12-.35-.1-.53.06-.18.15-.24.38-.12.5.12.13.36.1.54-.06.18-.15.22-.38.11-.5",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M185.74 220.75c-.11-.12-.35-.1-.53.06-.18.15-.24.38-.12.5.12.13.36.1.54-.06.18-.15.22-.38.11-.5z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M164.58 232.37h22.29v-5.84h-22.29v5.84z",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M164.58 232.37h22.29v-5.84h-22.29v5.84z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M166.92 236.26a.97.97 0 0 1 .41-.07h16.7c.16 0 .31.03.44.08a1.4 1.4 0 0 1-.98-1.32c0-.6.45-1.14 1.03-1.33-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.1.02c.59.18.93.71.93 1.3 0 .55-.38 1.12-.97 1.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M166.92 236.26a.97.97 0 0 1 .41-.07h16.7c.16 0 .31.03.44.08a1.4 1.4 0 0 1-.98-1.32c0-.6.45-1.14 1.03-1.33-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.1.02c.59.18.93.71.93 1.3 0 .55-.38 1.12-.97 1.3z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M167.33 236.2h16.7c.56 0 1.01.34 1.01.77 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M167.33 236.2h16.7c.56 0 1.01.34 1.01.77 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M167.33 232.37h16.7c.56 0 1.03.3 1.03.66 0 .37-.47.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M167.33 232.37h16.7c.56 0 1.03.3 1.03.66 0 .37-.47.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M191.28 330.68a8.48 8.48 0 0 1-3.93-.87 8.7 8.7 0 0 0-3.86-.82c-1.5 0-2.9.32-3.9.83-1.02.53-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.64 8.64 0 0 1-3.95.88v2.41c1.53 0 2.94-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.84 3.9-.84s2.87.32 3.87.84a8.4 8.4 0 0 0 3.91.86l.02-2.41",
      fill: "#005bbf"
    }), r.createElement("path", {
      d: "M191.28 330.68a8.48 8.48 0 0 1-3.93-.87 8.7 8.7 0 0 0-3.86-.82c-1.5 0-2.9.32-3.9.83-1.02.53-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.64 8.64 0 0 1-3.95.88v2.41c1.53 0 2.94-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.84 3.9-.84s2.87.32 3.87.84a8.4 8.4 0 0 0 3.91.86l.02-2.41z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M191.28 333.09a8.5 8.5 0 0 1-3.93-.86c-1-.52-2.36-.84-3.86-.84s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.69 8.69 0 0 1-3.95.88v2.4a8.7 8.7 0 0 0 3.95-.87c1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.84 3.9-.84s2.87.32 3.87.83c1.02.54 2.37.87 3.91.87l.02-2.41",
      fill: "#ccc"
    }), r.createElement("path", {
      d: "M191.28 333.09a8.5 8.5 0 0 1-3.93-.86c-1-.52-2.36-.84-3.86-.84s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.69 8.69 0 0 1-3.95.88v2.4a8.7 8.7 0 0 0 3.95-.87c1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.84 3.9-.84s2.87.32 3.87.83c1.02.54 2.37.87 3.91.87l.02-2.41",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M191.28 335.5a8.52 8.52 0 0 1-3.93-.87c-1-.5-2.36-.83-3.86-.83s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.7 8.7 0 0 1-3.95.88v2.4c1.53 0 2.94-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.37.86 3.91.86l.02-2.4",
      fill: "#005bbf"
    }), r.createElement("path", {
      d: "M191.28 335.5a8.52 8.52 0 0 1-3.93-.87c-1-.5-2.36-.83-3.86-.83s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.7 8.7 0 0 1-3.95.88v2.4c1.53 0 2.94-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.37.86 3.91.86l.02-2.4",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M191.26 340.32c-1.54 0-2.9-.33-3.9-.87a8.7 8.7 0 0 0-3.87-.82c-1.5 0-2.9.31-3.9.83-1.02.52-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.64 8.64 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.39.86 3.93.86l-.02 2.42",
      fill: "#ccc"
    }), r.createElement("path", {
      d: "M191.26 340.32c-1.54 0-2.9-.33-3.9-.87a8.7 8.7 0 0 0-3.87-.82c-1.5 0-2.9.31-3.9.83-1.02.52-2.41.86-3.93.86a8.48 8.48 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.64 8.64 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.39.86 3.93.86l-.02 2.42",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M191.26 342.73c-1.54 0-2.9-.33-3.9-.86a8.6 8.6 0 0 0-3.87-.84c-1.5 0-2.9.32-3.9.84-1.02.52-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.69 8.69 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .53 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.83 3.9-.83s2.87.31 3.87.82a8.5 8.5 0 0 0 3.93.87l-.02 2.4",
      fill: "#005bbf"
    }), r.createElement("path", {
      d: "M191.26 342.73c-1.54 0-2.9-.33-3.9-.86a8.6 8.6 0 0 0-3.87-.84c-1.5 0-2.9.32-3.9.84-1.02.52-2.41.86-3.93.86a8.52 8.52 0 0 1-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 0 0-3.85.82 8.69 8.69 0 0 1-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .53 2.39.9 3.93.9a8.7 8.7 0 0 0 3.92-.86c1-.52 2.4-.83 3.9-.83s2.87.31 3.87.82a8.5 8.5 0 0 0 3.93.87l-.02 2.4z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M166.92 320.78c.05.2.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.1-.62-.14.05-.3.06-.45.06h-16.69c-.13 0-.29-.02-.41-.06",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M166.92 320.78c.05.2.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.1-.62-.14.05-.3.06-.45.06h-16.69c-.13 0-.29-.02-.41-.06z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M167.33 319.27h16.7c.56 0 1.01.35 1.01.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M167.33 319.27h16.7c.56 0 1.01.35 1.01.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M164.27 329.86h22.88v-5.83h-22.88v5.83z",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M164.27 329.86h22.88v-5.83h-22.88v5.83z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.62.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07a5.76 5.76 0 0 0-.15-9.13",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.62.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07a5.76 5.76 0 0 0-.15-9.13z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M167.55 318.32h16.25V238.7h-16.25v79.63z",
      fill: "#ccc"
    }), r.createElement("path", {
      d: "M179.13 238.8v79.46m1.83-79.46v79.46M167.55 318.32h16.25V238.7h-16.25v79.63z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M200.4 268.47c-3.54-1.46-9.57-2.55-16.5-2.78a50.2 50.2 0 0 0-7.78.7c-9.72 1.63-17.13 5.5-16.54 8.67l.05.26s-3.64-8.2-3.7-8.52c-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.7-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M200.4 268.47c-3.54-1.46-9.57-2.55-16.5-2.78a50.2 50.2 0 0 0-7.78.7c-9.72 1.63-17.13 5.5-16.54 8.67l.05.26s-3.64-8.2-3.7-8.52c-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.7-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M167.52 278.47c-4.5-.32-7.59-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M167.52 278.47c-4.5-.32-7.59-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M183.83 272.38c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.1 5.67l.02-7.83",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M183.83 272.38c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.1 5.67l.02-7.83",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.8l-.09-.16c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.9 3.2-10.44 4.1-4.54 1.56-9.04 4.53-8.63 5.63l-1.5-8.1",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.8l-.09-.16c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.9 3.2-10.44 4.1-4.54 1.56-9.04 4.53-8.63 5.63l-1.5-8.1z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M166.43 264.65c1.98-.72 3.28-1.58 2.65-3.14-.4-1-1.43-1.19-2.97-.63l-2.72.99 2.45 6.03c.27-.12.54-.24.81-.34.28-.1.57-.18.85-.26l-1.07-2.64zm-1.19-2.9l.69-.26c.57-.2 1.22.1 1.5.8.21.53.16 1.13-.5 1.55-.21.13-.46.23-.7.33l-.99-2.43M172.78 259.22c-.29.07-.57.16-.86.22l-.88.13 1.41 6.27 4.38-.88c-.05-.13-.12-.26-.14-.38-.03-.14-.03-.28-.04-.41-.77.22-1.6.46-2.61.66l-1.26-5.61M181.56 264.63c.82-2.28 1.82-4.46 2.81-6.67a5.51 5.51 0 0 1-1.08.07c-.53 1.6-1.18 3.2-1.87 4.8-.82-1.51-1.73-2.99-2.43-4.51-.34.04-.69.1-1.03.12-.34.02-.7.01-1.04.02 1.26 2.06 2.48 4.1 3.64 6.23l.5-.08c.16 0 .33 0 .5.02M190.72 259.8c.15-.3.3-.6.48-.89a3.6 3.6 0 0 0-1.81-.63c-1.79-.18-2.81.61-2.93 1.7-.26 2.25 3.3 2.06 3.14 3.56-.07.64-.75.9-1.48.83-.81-.08-1.4-.53-1.51-1.19l-.22-.02c-.12.4-.3.77-.48 1.15.53.34 1.2.53 1.85.6 1.83.18 3.22-.55 3.35-1.75.23-2.15-3.37-2.27-3.23-3.54.06-.53.47-.88 1.4-.79.67.07 1.08.43 1.26.95l.18.02",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.5-1.08.64c-.59.14-1.41-.67-1.41-.67s-.57.8-1.07 1c-.51.18-1.13-.24-1.13-.24s-.23.4-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.3-1.07l-.1-.57c-.12-.64.88-1.4 2.31-1.72.82-.2 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.2.82a4.1 4.1 0 0 1 2.06.02c1.42.32 2.43 1.08 2.3 1.72l-.08.57c-.03.16-.31 1.07-.31 1.07l-.63.24-.68.72-.59.38s-.3.14-.47.05a1.76 1.76 0 0 1-.66-.61s-.62.42-1.13.24c-.5-.2-1.07-1-1.07-1s-.82.8-1.42.67c-.59-.13-1.07-.64-1.07-.64s-.68.6-1.21.49c-.54-.11-1.27-.89-1.27-.89",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.5-1.08.64c-.59.14-1.41-.67-1.41-.67s-.57.8-1.07 1c-.51.18-1.13-.24-1.13-.24s-.23.4-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.3-1.07l-.1-.57c-.12-.64.88-1.4 2.31-1.72.82-.2 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.2.82a4.1 4.1 0 0 1 2.06.02c1.42.32 2.43 1.08 2.3 1.72l-.08.57c-.03.16-.31 1.07-.31 1.07l-.63.24-.68.72-.59.38s-.3.14-.47.05a1.76 1.76 0 0 1-.66-.61s-.62.42-1.13.24c-.5-.2-1.07-1-1.07-1s-.82.8-1.42.67c-.59-.13-1.07-.64-1.07-.64s-.68.6-1.21.49c-.54-.11-1.27-.89-1.27-.89z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".27"
    }), r.createElement("path", {
      d: "M323.45 216.2c0-1.09.61-1.96 1.37-1.96.76 0 1.38.87 1.38 1.96 0 1.08-.62 1.96-1.38 1.96-.76 0-1.37-.88-1.37-1.96",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M323.45 216.2c0-1.09.61-1.96 1.37-1.96.76 0 1.38.87 1.38 1.96 0 1.08-.62 1.96-1.38 1.96-.76 0-1.37-.88-1.37-1.96z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M324.22 216.2c0-1 .28-1.8.63-1.8s.63.8.63 1.8-.28 1.8-.63 1.8-.63-.8-.63-1.8",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M324.22 216.2c0-1 .28-1.8.63-1.8s.63.8.63 1.8-.28 1.8-.63 1.8-.63-.8-.63-1.8z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M317.75 224.25a4.72 4.72 0 0 0-.58-1.08c1.94-.57 4.65-.93 7.67-.94 3.01 0 5.74.37 7.69.94l-.52.91c-.17.3-.4.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.47.35-6.86.86.02 0-.1-.32-.24-.68h.02",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M317.75 224.25a4.72 4.72 0 0 0-.58-1.08c1.94-.57 4.65-.93 7.67-.94 3.01 0 5.74.37 7.69.94l-.52.91c-.17.3-.4.81-.38.81a23.8 23.8 0 0 0-6.8-.82c-2.79 0-5.47.35-6.86.86.02 0-.1-.32-.24-.68h.02",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M324.84 226.73c2.43 0 5.1-.38 6.1-.63.66-.2 1.05-.5.97-.84-.03-.16-.17-.3-.37-.38-1.45-.47-4.06-.8-6.7-.8-2.64 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.65.98.84.99.25 3.68.62 6.1.63",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M324.84 226.73c2.43 0 5.1-.38 6.1-.63.66-.2 1.05-.5.97-.84-.03-.16-.17-.3-.37-.38-1.45-.47-4.06-.8-6.7-.8-2.64 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.65.98.84.99.25 3.68.62 6.1.63z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M330.74 217.07c0-.23.2-.42.44-.42.26 0 .46.19.46.42 0 .24-.2.43-.45.43a.44.44 0 0 1-.45-.43",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M330.74 217.07c0-.23.2-.42.44-.42.26 0 .46.19.46.42 0 .24-.2.43-.45.43a.44.44 0 0 1-.45-.43zM330.48 215.58c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42zm-1.13-.94c0-.24.2-.43.45-.43s.45.2.45.43c0 .24-.2.43-.45.43a.44.44 0 0 1-.45-.43zm-1.42-.45c0-.24.2-.44.46-.44.25 0 .45.2.45.44 0 .23-.2.42-.45.42s-.46-.2-.46-.42zm-1.44.05c0-.24.2-.43.45-.43.26 0 .46.19.46.43 0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".21"
    }), r.createElement("path", {
      d: "M335.2 219.99a2.85 2.85 0 0 0-2.6-3.96c-.5 0-.97.13-1.38.37",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M330.17 217.96c.15-.26.25-.57.25-.87 0-1.15-1.18-2.08-2.64-2.08-.62 0-1.2.17-1.64.45",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M335.6 218.68c0-.24.2-.43.45-.43s.45.2.45.43c0 .24-.2.43-.45.43s-.45-.2-.45-.43zm-.18-1.58c0-.24.21-.42.46-.42s.45.18.45.42-.2.43-.45.43-.45-.2-.45-.43zm-1-1.2c0-.24.2-.43.44-.43.25 0 .45.2.45.43 0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42zm-1.37-.65c0-.23.2-.42.46-.42.25 0 .45.19.45.42 0 .24-.2.44-.45.44a.44.44 0 0 1-.46-.44zm-1.44.06c0-.24.2-.43.45-.43s.46.2.46.43c0 .23-.2.43-.46.43-.25 0-.45-.2-.45-.43z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".21"
    }), r.createElement("path", {
      d: "M332.65 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.71.5-1.33.46c-.62-.06-1.22-.83-1.22-.83s-.62.8-1.24.86c-.62.05-1.13-.54-1.13-.54s-.29.59-1.08.72-1.47-.62-1.47-.62-.44.73-.98.92c-.54.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.17.47c1.94-.56 4.57-.9 7.54-.9 2.97 0 5.67.34 7.6.9l.2-.53",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M332.65 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 0 1-1.07-.62s-.71.5-1.33.46c-.62-.06-1.22-.83-1.22-.83s-.62.8-1.24.86c-.62.05-1.13-.54-1.13-.54s-.29.59-1.08.72-1.47-.62-1.47-.62-.44.73-.98.92c-.54.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.17.47c1.94-.56 4.57-.9 7.54-.9 2.97 0 5.67.34 7.6.9l.2-.53z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M317.98 217.07c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.43-.45.43s-.45-.19-.45-.43",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M317.98 217.07c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.43-.45.43s-.45-.19-.45-.43zM318.23 215.58c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.44.42-.26 0-.46-.19-.46-.42zm1.13-.94c0-.24.2-.43.45-.43s.46.2.46.43c0 .24-.2.43-.46.43a.44.44 0 0 1-.45-.43zm1.41-.45c0-.24.2-.44.46-.44.25 0 .45.2.45.44 0 .23-.2.42-.45.42s-.46-.2-.46-.42zm1.45.05c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.45.42a.44.44 0 0 1-.45-.42z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".21"
    }), r.createElement("path", {
      d: "M314.4 219.99a2.85 2.85 0 0 1 2.6-3.96c.51 0 .98.13 1.4.37",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M319.48 217.93a1.75 1.75 0 0 1-.29-.84c0-1.15 1.19-2.08 2.64-2.08.62 0 1.2.17 1.65.45",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M313.11 218.68c0-.24.2-.43.46-.43.24 0 .45.2.45.43 0 .24-.2.43-.45.43s-.46-.2-.46-.43zm.17-1.58c0-.24.2-.42.46-.42.25 0 .45.18.45.42s-.2.43-.45.43-.46-.2-.46-.43zm1.02-1.2c0-.24.2-.43.46-.43.24 0 .45.2.45.43 0 .23-.2.42-.45.42a.44.44 0 0 1-.46-.42zm1.36-.65c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.44-.45.44a.44.44 0 0 1-.45-.44zm1.44.06c0-.24.2-.43.45-.43s.45.2.45.43c0 .23-.2.43-.45.43s-.45-.2-.45-.43z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".21"
    }), r.createElement("path", {
      d: "M324.85 219.5l.28.04c-.04.12-.05.24-.05.38 0 .58.5 1.05 1.12 1.05.5 0 .91-.3 1.05-.73.02.01.11-.38.16-.38.04 0 .03.41.04.4.07.53.56.9 1.1.9.62 0 1.12-.47 1.12-1.06l-.01-.12.35-.35.19.44c-.08.14-.1.3-.1.46 0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.14.66.48.72 0 0 .4.03.91-.38.53-.41.81-.75.81-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.3-.95.25-.33-.04-.55-.3-.68-.6-.23.13-.5.21-.8.21-.62 0-1.19-.35-1.41-.86a1.63 1.63 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26c-.3.35-.75.58-1.26.58-.47 0-.87-.19-1.16-.5-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.28.34.8.75.92.38.92.38c.34-.06.48-.37.48-.72v-.35l.23.29c.19.27.51.45.88.45.6 0 1.07-.45 1.07-1.01a.93.93 0 0 0-.1-.46l.18-.44.35.35-.01.12c0 .59.5 1.06 1.1 1.06.56 0 1.04-.37 1.11-.9.02.01.01-.4.05-.4.05 0 .14.4.15.38.15.42.57.73 1.06.73a1.09 1.09 0 0 0 1.07-1.43l.29-.05",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M324.85 219.5l.28.04c-.04.12-.05.24-.05.38 0 .58.5 1.05 1.12 1.05.5 0 .91-.3 1.05-.73.02.01.11-.38.16-.38.04 0 .03.41.04.4.07.53.56.9 1.1.9.62 0 1.12-.47 1.12-1.06l-.01-.12.35-.35.19.44c-.08.14-.1.3-.1.46 0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.14.66.48.72 0 0 .4.03.91-.38.53-.41.81-.75.81-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.3-.95.25-.33-.04-.55-.3-.68-.6-.23.13-.5.21-.8.21-.62 0-1.19-.35-1.41-.86a1.63 1.63 0 0 1-2.42-.08 1.63 1.63 0 0 1-2.43-.26 1.62 1.62 0 0 1-2.42.26c-.3.35-.75.58-1.26.58-.47 0-.87-.19-1.16-.5-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.28.34.8.75.92.38.92.38c.34-.06.48-.37.48-.72v-.35l.23.29c.19.27.51.45.88.45.6 0 1.07-.45 1.07-1.01a.93.93 0 0 0-.1-.46l.18-.44.35.35-.01.12c0 .59.5 1.06 1.1 1.06.56 0 1.04-.37 1.11-.9.02.01.01-.4.05-.4.05 0 .14.4.15.38.15.42.57.73 1.06.73a1.09 1.09 0 0 0 1.07-1.43l.29-.05z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M324.84 222.23c-3.02 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.08 0 5.87.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M324.84 222.23c-3.02 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.08 0 5.87.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 0 0-7.68-.94z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M321.92 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M321.92 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M324.88 223.48h-.98c-.18 0-.33-.14-.33-.31 0-.17.15-.3.33-.3h1.96c.18 0 .32.13.32.3 0 .17-.14.31-.32.31h-.99",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M324.88 223.48h-.98c-.18 0-.33-.14-.33-.31 0-.17.15-.3.33-.3h1.96c.18 0 .32.13.32.3 0 .17-.14.31-.32.31h-.99",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M320.02 223.81l-.7.1a.33.33 0 0 1-.37-.25.3.3 0 0 1 .27-.35l.7-.1.7-.11c.18-.02.35.09.38.25.02.17-.1.33-.27.35l-.71.11",
      fill: "#058e6e"
    }), r.createElement("path", {
      d: "M320.02 223.81l-.7.1a.33.33 0 0 1-.37-.25.3.3 0 0 1 .27-.35l.7-.1.7-.11c.18-.02.35.09.38.25.02.17-.1.33-.27.35l-.71.11",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M317.21 224.3l.31-.5.66.13-.38.56-.59-.19",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M317.21 224.3l.31-.5.66.13-.38.56-.59-.19",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M326.89 223.3c0-.22.2-.4.43-.4.25 0 .44.18.44.4 0 .23-.2.41-.44.41s-.43-.18-.43-.4",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M326.89 223.3c0-.22.2-.4.43-.4.25 0 .44.18.44.4 0 .23-.2.41-.44.41s-.43-.18-.43-.4z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M329.66 223.81l.7.1c.18.03.34-.08.37-.25a.3.3 0 0 0-.26-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.38.25-.03.17.1.33.28.35l.7.11",
      fill: "#058e6e"
    }), r.createElement("path", {
      d: "M329.66 223.81l.7.1c.18.03.34-.08.37-.25a.3.3 0 0 0-.26-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.38.25-.03.17.1.33.28.35l.7.11",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M332.4 224.33l-.24-.53-.68.06.33.59.6-.12",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M332.4 224.33l-.24-.53-.68.06.33.59.6-.12",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M324.83 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.32.7-1.67.44-3.88.65-6.32.65",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M324.83 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.32.7-1.67.44-3.88.65-6.32.65z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M332.5 220.88c.07-.18.01-.37-.13-.41-.13-.04-.3.08-.36.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M332.5 220.88c.07-.18.01-.37-.13-.41-.13-.04-.3.08-.36.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M327.66 219.95c.03-.2-.07-.37-.21-.39-.14-.02-.28.13-.3.33-.03.2.06.37.2.38.15.02.28-.13.31-.32",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M327.66 219.95c.03-.2-.07-.37-.21-.39-.14-.02-.28.13-.3.33-.03.2.06.37.2.38.15.02.28-.13.31-.32z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M322.04 219.95c-.03-.2.06-.37.2-.39.15-.02.28.13.31.33.02.2-.07.37-.2.38-.15.02-.29-.13-.31-.32",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M322.04 219.95c-.03-.2.06-.37.2-.39.15-.02.28.13.31.33.02.2-.07.37-.2.38-.15.02-.29-.13-.31-.32z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M317.2 220.88c-.07-.18-.01-.37.12-.41.13-.04.3.08.36.26.07.19.01.38-.12.42-.14.04-.3-.08-.37-.27",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M317.2 220.88c-.07-.18-.01-.37.12-.41.13-.04.3.08.36.26.07.19.01.38-.12.42-.14.04-.3-.08-.37-.27z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M324.83 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M324.83 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M322.95 219.24l.4.57 1.33-.42.14-.18-.14-.2-1.34-.39-.39.62",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M322.95 219.24l.4.57 1.33-.42.14-.18-.14-.2-1.34-.39-.39.62",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M326.72 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M326.72 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M319.25 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M319.25 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M317.84 220.04l.5.48 1.23-.66.09-.21-.18-.16-1.4-.13-.24.68",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M317.84 220.04l.5.48 1.23-.66.09-.21-.18-.16-1.4-.13-.24.68",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M321.53 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M321.53 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M316.5 220.22l-.12.66-1.4.15-.22-.12.06-.23 1.05-.87.62.41",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M316.5 220.22l-.12.66-1.4.15-.22-.12.06-.23 1.05-.87.62.41",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M319.19 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M319.19 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 0 1-.48-.46z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M330.44 217.76l.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M330.44 217.76l.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M331.85 220.04l-.5.48-1.23-.66-.1-.21.18-.16 1.4-.13.25.68",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M331.85 220.04l-.5.48-1.23-.66-.1-.21.18-.16 1.4-.13.25.68",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M328.16 219.3l.26.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M328.16 219.3l.26.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M333 220.22l.12.66 1.4.15.2-.12-.04-.23-1.05-.87-.62.41",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M333 220.22l.12.66 1.4.15.2-.12-.04-.23-1.05-.87-.62.41",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M324.35 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M324.35 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46a.48.48 0 0 1-.49-.46z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M329.52 219.65c0-.26.23-.47.5-.47s.5.21.5.47c0 .25-.23.46-.5.46a.48.48 0 0 1-.5-.46",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M329.52 219.65c0-.26.23-.47.5-.47s.5.21.5.47c0 .25-.23.46-.5.46a.48.48 0 0 1-.5-.46z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M323.92 213.95a.9.9 0 0 1 .92-.87c.51 0 .93.39.93.87 0 .49-.42.88-.93.88a.9.9 0 0 1-.92-.88",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M325.5 213.64v.58h-1.43v-.58h.47v-1.3h-.62v-.59h.62v-.57h.6v.57h.61v.59h-.6v1.3h.34",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M325.5 213.64v.58h-1.43v-.58h.47v-1.3h-.62v-.59h.62v-.57h.6v.57h.61v.59h-.6v1.3h.34z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".3"
    }), r.createElement("path", {
      d: "M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.59h.62v-.57h.6v.57h.62v.59h-.61v1.3h.98",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M325.1 213.12c.39.1.67.44.67.83a.9.9 0 0 1-.93.88.9.9 0 0 1-.92-.88c0-.4.29-.74.68-.84",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M314.6 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.03-.2s.25.05.36.32c.11.29.04.72.04.72s-.05.2-.13.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M314.6 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.03-.2s.25.05.36.32c.11.29.04.72.04.72s-.05.2-.13.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M314.62 220.75c.11-.12.35-.1.53.06.18.15.23.38.11.5-.11.13-.35.1-.53-.06-.18-.15-.23-.38-.11-.5",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M314.62 220.75c.11-.12.35-.1.53.06.18.15.23.38.11.5-.11.13-.35.1-.53-.06-.18-.15-.23-.38-.11-.5z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M334.9 221c.01 0 .38-.49.65-.73.2-.18.68-.33.68-.33 0-.09-.28-.28-.59-.28a.58.58 0 0 0-.44.2l-.04-.2s-.25.05-.36.32c-.1.29-.04.72-.04.72s.05.2.14.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M334.9 221c.01 0 .38-.49.65-.73.2-.18.68-.33.68-.33 0-.09-.28-.28-.59-.28a.58.58 0 0 0-.44.2l-.04-.2s-.25.05-.36.32c-.1.29-.04.72-.04.72s.05.2.14.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M334.91 220.75c-.12-.12-.36-.1-.54.06-.18.15-.23.38-.11.5.11.13.35.1.53-.06.18-.15.24-.38.12-.5",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M334.91 220.75c-.12-.12-.36-.1-.54.06-.18.15-.23.38-.11.5.11.13.35.1.53-.06.18-.15.24-.38.12-.5z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M313.71 232.37H336v-5.84H313.7v5.84z",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M313.71 232.37H336v-5.84H313.7v5.84z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M333.66 236.26a.98.98 0 0 0-.41-.07h-16.7c-.16 0-.31.03-.45.08.57-.19.98-.7.98-1.32 0-.6-.44-1.14-1.02-1.33.14.04.32.08.49.08h16.7c.17 0 .32-.01.47-.06l-.1.02c-.6.18-.93.71-.93 1.3 0 .55.37 1.12.97 1.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M333.66 236.26a.98.98 0 0 0-.41-.07h-16.7c-.16 0-.31.03-.45.08.57-.19.98-.7.98-1.32 0-.6-.44-1.14-1.02-1.33.14.04.32.08.49.08h16.7c.17 0 .32-.01.47-.06l-.1.02c-.6.18-.93.71-.93 1.3 0 .55.37 1.12.97 1.3z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M316.56 236.2h16.69c.56 0 1.02.34 1.02.77 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M316.56 236.2h16.69c.56 0 1.02.34 1.02.77 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M316.55 232.37h16.7c.56 0 1.02.3 1.02.66 0 .37-.46.67-1.02.67h-16.7c-.57 0-1.03-.3-1.03-.67 0-.36.46-.66 1.03-.66",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M316.55 232.37h16.7c.56 0 1.02.3 1.02.66 0 .37-.46.67-1.02.67h-16.7c-.57 0-1.03-.3-1.03-.67 0-.36.46-.66 1.03-.66z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M309.3 330.68c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.82 3.86-.82s2.9.32 3.9.83c1.01.53 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8a8.5 8.5 0 0 1 3.85.82c1.01.54 2.42.88 3.95.88v2.41a8.67 8.67 0 0 1-3.95-.88c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.84a8.4 8.4 0 0 1-3.9.86l-.02-2.41",
      fill: "#005bbf"
    }), r.createElement("path", {
      d: "M309.3 330.68c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.82 3.86-.82s2.9.32 3.9.83c1.01.53 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8a8.5 8.5 0 0 1 3.85.82c1.01.54 2.42.88 3.95.88v2.41a8.67 8.67 0 0 1-3.95-.88c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.84a8.4 8.4 0 0 1-3.9.86l-.02-2.41z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M309.3 333.09a8.5 8.5 0 0 0 3.93-.86c1-.52 2.36-.84 3.86-.84s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.67 8.67 0 0 1-3.95-.87c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.83a8.43 8.43 0 0 1-3.9.87l-.02-2.41",
      fill: "#ccc"
    }), r.createElement("path", {
      d: "M309.3 333.09a8.5 8.5 0 0 0 3.93-.86c1-.52 2.36-.84 3.86-.84s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.67 8.67 0 0 1-3.95-.87c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.83a8.43 8.43 0 0 1-3.9.87l-.02-2.41",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M309.3 335.5c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.83 3.86-.83s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.63 8.63 0 0 1-3.95-.88c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.37 8.37 0 0 1-3.9.86l-.02-2.4",
      fill: "#005bbf"
    }), r.createElement("path", {
      d: "M309.3 335.5c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.83 3.86-.83s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.63 8.63 0 0 1-3.95-.88c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.37 8.37 0 0 1-3.9.86l-.02-2.4",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M309.32 340.32a8.4 8.4 0 0 0 3.9-.87c1.01-.51 2.37-.82 3.87-.82s2.9.31 3.9.83c1.01.52 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.63 8.63 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.46 8.46 0 0 1-3.92.86l.02 2.42",
      fill: "#ccc"
    }), r.createElement("path", {
      d: "M309.32 340.32a8.4 8.4 0 0 0 3.9-.87c1.01-.51 2.37-.82 3.87-.82s2.9.31 3.9.83c1.01.52 2.4.86 3.93.86a8.5 8.5 0 0 0 3.93-.9c1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.63 8.63 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.46 8.46 0 0 1-3.92.86l.02 2.42",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M309.32 342.73c1.54 0 2.9-.33 3.9-.86a8.6 8.6 0 0 1 3.87-.84c1.5 0 2.9.32 3.9.84 1.01.52 2.4.86 3.93.86 1.54 0 2.92-.37 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.61 8.61 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .53-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.31-3.88.82a8.5 8.5 0 0 1-3.92.87l.02 2.4",
      fill: "#005bbf"
    }), r.createElement("path", {
      d: "M309.32 342.73c1.54 0 2.9-.33 3.9-.86a8.6 8.6 0 0 1 3.87-.84c1.5 0 2.9.32 3.9.84 1.01.52 2.4.86 3.93.86 1.54 0 2.92-.37 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.61 8.61 0 0 1-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .53-2.4.9-3.93.9a8.7 8.7 0 0 1-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.31-3.88.82a8.5 8.5 0 0 1-3.92.87l.02 2.4z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M333.66 320.78c-.06.2-.13.4-.13.62 0 1.46 1.27 2.63 2.8 2.63H313.4c1.55 0 2.8-1.17 2.8-2.63 0-.21-.03-.41-.08-.62.12.05.28.06.44.06h16.69c.13 0 .29-.02.4-.06",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M333.66 320.78c-.06.2-.13.4-.13.62 0 1.46 1.27 2.63 2.8 2.63H313.4c1.55 0 2.8-1.17 2.8-2.63 0-.21-.03-.41-.08-.62.12.05.28.06.44.06h16.69c.13 0 .29-.02.4-.06z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M316.56 319.27h16.69c.56 0 1.02.35 1.02.78 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M316.56 319.27h16.69c.56 0 1.02.35 1.02.78 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M313.43 329.86h22.88v-5.83h-22.88v5.83z",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M313.43 329.86h22.88v-5.83h-22.88v5.83z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M338.1 298.62c2.26 1.3 3.8 2.64 3.55 3.31-.12.62-.84 1.07-1.87 1.75-1.62 1.13-2.6 3.14-1.83 4.07a5.76 5.76 0 0 1 .15-9.13",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M338.1 298.62c2.26 1.3 3.8 2.64 3.55 3.31-.12.62-.84 1.07-1.87 1.75-1.62 1.13-2.6 3.14-1.83 4.07a5.76 5.76 0 0 1 .15-9.13z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M316.78 318.32h16.25V238.7h-16.25v79.63z",
      fill: "#ccc"
    }), r.createElement("path", {
      d: "M328.57 238.66v79.46m1.82-79.46v79.46M316.78 318.32h16.25V238.7h-16.25v79.63z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M300.17 268.47c3.55-1.46 9.58-2.55 16.5-2.78 2.38.02 5.04.25 7.79.7 9.72 1.63 17.12 5.5 16.54 8.67l-.05.26s3.64-8.2 3.7-8.52c.65-3.51-7.56-7.82-18.35-9.62a55.7 55.7 0 0 0-9.56-.76c-6.9 0-12.9.89-16.52 2.23l-.05 9.82",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M300.17 268.47c3.55-1.46 9.58-2.55 16.5-2.78 2.38.02 5.04.25 7.79.7 9.72 1.63 17.12 5.5 16.54 8.67l-.05.26s3.64-8.2 3.7-8.52c.65-3.51-7.56-7.82-18.35-9.62a55.7 55.7 0 0 0-9.56-.76c-6.9 0-12.9.89-16.52 2.23l-.05 9.82",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M333.06 278.47c4.5-.32 7.59-1.53 7.94-3.41.28-1.5-1.25-3.17-3.97-4.68-1.22.14-2.59.3-4 .3l.03 7.79",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M333.06 278.47c4.5-.32 7.59-1.53 7.94-3.41.28-1.5-1.25-3.17-3.97-4.68-1.22.14-2.59.3-4 .3l.03 7.79",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M316.75 272.38c-2.82.43-4.93 1.13-5.99 1.99l-.1.17c-.5 1.03 1.98 3.22 6.11 5.67l-.02-7.83",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M316.75 272.38c-2.82.43-4.93 1.13-5.99 1.99l-.1.17c-.5 1.03 1.98 3.22 6.11 5.67l-.02-7.83",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M343.15 293.83c.43-1.28-3.96-3.86-10.17-6.14-2.84-1.01-5.19-2.07-8.1-3.35-8.62-3.82-15-8.2-14.2-9.8l.08-.16c-.46.38-1.17 8.24-1.17 8.24-.79 1.46 5.05 5.78 12.98 9.58 2.55 1.22 7.92 3.2 10.45 4.1 4.54 1.56 9.04 4.53 8.63 5.63l1.5-8.1",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M343.15 293.83c.43-1.28-3.96-3.86-10.17-6.14-2.84-1.01-5.19-2.07-8.1-3.35-8.62-3.82-15-8.2-14.2-9.8l.08-.16c-.46.38-1.17 8.24-1.17 8.24-.79 1.46 5.05 5.78 12.98 9.58 2.55 1.22 7.92 3.2 10.45 4.1 4.54 1.56 9.04 4.53 8.63 5.63l1.5-8.1z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M310.3 264.98c.62-2.33 1.41-4.58 2.2-6.87a5.52 5.52 0 0 1-1.08.16 54.67 54.67 0 0 1-1.42 4.94c-.95-1.44-2-2.84-2.83-4.3-.34.07-.68.15-1.02.2-.34.05-.7.07-1.04.1 1.45 1.95 2.85 3.9 4.2 5.92.16-.04.32-.1.5-.12.16-.02.33-.02.5-.03M316.49 258.16l-.9.03c-.29 0-.59-.04-.88-.06l-.12 6.41 4.49.08c-.03-.13-.06-.27-.06-.41 0-.13.04-.27.07-.4-.8.05-1.68.1-2.71.08l.1-5.73M323.52 259.21c.72.06 1.41.19 2.1.31-.01-.13-.03-.27-.02-.4 0-.14.06-.27.1-.4l-6.07-.5c.01.13.03.27.02.4-.01.14-.06.27-.1.4a20.1 20.1 0 0 1 2.2.05l-.52 5.77c.3 0 .59 0 .88.03.3.02.6.07.88.11l.53-5.77M326 265.53c.3.05.6.09.89.15.28.06.57.15.85.23l.72-2.94.08.01.5 1.19.9 2.22c.35.06.7.1 1.04.18.36.08.7.18 1.04.28l-.31-.67c-.48-1-1-2-1.41-3.02 1.12.04 1.98-.36 2.2-1.26.15-.62-.1-1.11-.69-1.53-.43-.31-1.27-.48-1.82-.6l-2.44-.53-1.54 6.3m3.14-5.43c.7.16 1.59.27 1.59 1.07 0 .2-.03.35-.06.48-.23.94-.94 1.26-2.13.9l.6-2.45M337.57 267.45c-.05.7-.18 1.38-.31 2.1.3.15.6.28.9.45.3.16.57.34.86.52l.6-7.23a4.03 4.03 0 0 1-.78-.43l-6.38 4.05c.17.08.35.16.51.25l.47.28c.54-.45 1.1-.82 1.74-1.3l2.39 1.31zm-1.8-1.65l2.12-1.37-.25 2.4-1.88-1.03",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M225.2 200.45c0-1.14.97-2.06 2.17-2.06 1.19 0 2.16.92 2.16 2.06 0 1.13-.97 2.05-2.16 2.05-1.2 0-2.17-.92-2.17-2.05z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M249.65 182.72c6.64 0 12.56.99 16.4 2.51 2.21 1 5.17 1.73 8.41 2.17 2.47.33 4.81.4 6.85.24 2.73-.06 6.67.74 10.62 2.48 3.26 1.45 5.99 3.2 7.8 4.91l-1.57 1.4-.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6.21-.79 2.25-32.91-3.86-33.02 3.86-.8-2.25-2.6-.21-5.08-4.07-2.15-1.83-4.3-4.92-.44-3.96-1.58-1.4a28.79 28.79 0 0 1 7.8-4.91c3.95-1.74 7.9-2.54 10.62-2.48 2.04.15 4.38.09 6.85-.24a31.2 31.2 0 0 0 8.4-2.17c3.86-1.52 9.44-2.5 16.08-2.5z",
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M250.15 226.18c-12.26-.02-23.25-1.47-31.09-3.83a1.2 1.2 0 0 1-.84-1.25c0-.52.29-1 .84-1.17 7.84-2.36 18.83-3.81 31.1-3.83 12.26.02 23.23 1.47 31.08 3.83.55.17.84.65.83 1.17a1.2 1.2 0 0 1-.83 1.25c-7.85 2.36-18.82 3.81-31.09 3.83",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M250.12 224.57c-11.06-.01-21.07-1.3-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.2 11.07.03 21.13 1.23 28.74 3.2-7.61 1.97-17.67 3.25-28.74 3.26",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M250.95 224.64v-6.57",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".09"
    }), r.createElement("path", {
      d: "M249.16 224.64v-6.57",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".14"
    }), r.createElement("path", {
      d: "M247.48 224.64v-6.57",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".18"
    }), r.createElement("path", {
      d: "M245.8 224.64v-6.57",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".23"
    }), r.createElement("path", {
      d: "M244.32 224.64v-6.57",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".28"
    }), r.createElement("path", {
      d: "M241.48 224.28l-.03-5.97m1.38 6.05v-6.25",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".33"
    }), r.createElement("path", {
      d: "M238.87 224.01v-5.5m1.32 5.66l-.04-5.86",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37"
    }), r.createElement("path", {
      d: "M235.35 223.7v-4.84m1.15 4.92v-5.08m1.2 5.24v-5.28",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".42"
    }), r.createElement("path", {
      d: "M234.12 223.66v-4.68",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".46"
    }), r.createElement("path", {
      d: "M232.97 223.42v-4.36",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".51"
    }), r.createElement("path", {
      d: "M231.74 223.3v-4.05",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".56"
    }), r.createElement("path", {
      d: "M229.22 222.95l-.04-3.22m1.33 3.38v-3.62",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".6"
    }), r.createElement("path", {
      d: "M227.93 222.68v-2.84",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".63"
    }), r.createElement("path", {
      d: "M226.74 222.45v-2.36",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".68"
    }), r.createElement("path", {
      d: "M225.45 222.13v-1.84",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".73"
    }), r.createElement("path", {
      d: "M224.12 221.98v-1.38",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".77"
    }), r.createElement("path", {
      d: "M222.72 221.66V221",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".91"
    }), r.createElement("path", {
      d: "M258.04 224.28v-6.01m-3.02 6.21l.04-6.37m-2.24 6.45v-6.49",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M250.07 216.1c-12.41.02-23.55 1.57-31.4 3.99.66-.31.6-1.12-.21-3.2-.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44.02 25.6 1.62 34.27 4.18 0 0-1.53-.1-2.5 2.42-.82 2.08-.88 2.89-.22 3.2-7.84-2.42-19.2-3.97-31.6-4",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M250.12 210.3c-13.43.02-25.5 1.61-34.16 4.18-.58.17-1.2-.05-1.38-.6-.19-.55.12-1.18.7-1.35 8.7-2.68 21.09-4.35 34.84-4.38 13.77.03 26.2 1.7 34.9 4.38.58.17.89.8.7 1.35-.19.55-.8.77-1.38.6-8.67-2.56-20.78-4.16-34.22-4.19",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M250.12 224.57c-11.06-.01-21.07-1.3-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.2 11.07.03 21.13 1.23 28.74 3.2-7.61 1.97-17.67 3.25-28.74 3.26z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M240.54 213.35c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M250.15 214.16h-3.29c-.6 0-1.1-.46-1.1-1.03 0-.58.49-1.04 1.09-1.04h6.64c.6 0 1.1.46 1.1 1.04 0 .57-.5 1.03-1.11 1.03h-3.33",
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M233.64 215.07l-2.36.27c-.6.07-1.17-.33-1.24-.9-.08-.57.35-1.09.96-1.15l2.37-.28 2.42-.28c.6-.07 1.15.33 1.22.9.07.57-.36 1.09-.96 1.16l-2.41.28",
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M224.03 215.28c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M216.72 217.16l1.22-1.6 3.37.44-2.7 1.96-1.89-.8",
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M266.66 215.07l2.36.27c.6.07 1.17-.33 1.24-.9a1.05 1.05 0 0 0-.96-1.15l-2.37-.28-2.42-.28c-.6-.07-1.15.33-1.22.9-.08.57.36 1.09.96 1.16l2.41.28",
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M257.56 213.35c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M274.07 215.28c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M283.57 217.16l-1.21-1.6-3.37.44 2.7 1.96 1.88-.8",
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M220.12 221.66c7.75-2.17 18.3-3.52 30-3.54 11.71.02 22.31 1.37 30.06 3.54",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M225.34 191.42l1.38 1.11 2.09-3.4a7.7 7.7 0 0 1-3.75-7.42c.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86a18.11 18.11 0 0 0-9.05-2.28c-7.7 0-13.74 4.38-14.03 9.57a9.25 9.25 0 0 0 3.22 7.9l-1.11 1.82",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M225.34 191.42l1.38 1.11 2.09-3.4a7.7 7.7 0 0 1-3.75-7.42c.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86a18.11 18.11 0 0 0-9.05-2.28c-7.7 0-13.74 4.38-14.03 9.57a9.25 9.25 0 0 0 3.22 7.9l-1.11 1.82",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M225.43 191.46c-2.64-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.4a8.84 8.84 0 0 0-3.56 7.14 9.25 9.25 0 0 0 3.26 6.99l-1.01 1.85",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M225.43 191.46c-2.64-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.4a8.84 8.84 0 0 0-3.56 7.14 9.25 9.25 0 0 0 3.26 6.99l-1.01 1.85",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M202.2 194.89a9.16 9.16 0 0 1-2.37-6.12c0-1.4.32-2.75.91-3.95 2.13-4.38 8.81-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.35 2.83-15.12 6.65a7.36 7.36 0 0 0-.73 3.2c0 2.32 1.09 4.4 2.8 5.82l-2.64 4.3-1.41-1.12 1.8-2.88",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M202.2 194.89a9.16 9.16 0 0 1-2.37-6.12c0-1.4.32-2.75.91-3.95 2.13-4.38 8.81-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.35 2.83-15.12 6.65a7.36 7.36 0 0 0-.73 3.2c0 2.32 1.09 4.4 2.8 5.82l-2.64 4.3-1.41-1.12 1.8-2.88z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M204.9 180.48a10.98 10.98 0 0 0-4.16 4.34 8.95 8.95 0 0 0-.91 3.95c0 2.33.9 4.47 2.38 6.12l-1.6 2.6a10.87 10.87 0 0 1-2.42-6.7c0-4.2 2.67-7.88 6.71-10.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M204.9 180.48a10.98 10.98 0 0 0-4.16 4.34 8.95 8.95 0 0 0-.91 3.95c0 2.33.9 4.47 2.38 6.12l-1.6 2.6a10.87 10.87 0 0 1-2.42-6.7c0-4.2 2.67-7.88 6.71-10.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M250.04 171.27a3.69 3.69 0 0 1 3.64 2.72c.23 1.39.38 2.96.41 4.63l-.01.52c0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.28-8.52 0-.2.05-.41.05-.61l-.01-.51c.03-1.68.18-3.25.41-4.63.36-1.57 1.94-2.73 3.7-2.73",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M250.04 171.27a3.69 3.69 0 0 1 3.64 2.72c.23 1.39.38 2.96.41 4.63l-.01.52c0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.28-8.52 0-.2.05-.41.05-.61l-.01-.51c.03-1.68.18-3.25.41-4.63.36-1.57 1.94-2.73 3.7-2.73z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M250.04 172.94c.91 0 1.69.58 1.87 1.4a30 30 0 0 1 .4 4.37l-.01.48c0 .2.03.4.04.6.05 3.31.53 6.24 1.21 8.04l-3.54 3.35-3.54-3.35c.68-1.8 1.15-4.73 1.21-8.05 0-.2.04-.4.04-.59v-.48c.02-1.58.16-3.07.39-4.38.18-.8 1.02-1.39 1.93-1.39",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M250.04 172.94c.91 0 1.69.58 1.87 1.4a30 30 0 0 1 .4 4.37l-.01.48c0 .2.03.4.04.6.05 3.31.53 6.24 1.21 8.04l-3.54 3.35-3.54-3.35c.68-1.8 1.15-4.73 1.21-8.05 0-.2.04-.4.04-.59v-.48c.02-1.58.16-3.07.39-4.38.18-.8 1.02-1.39 1.93-1.39z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M274.7 191.42l-1.39 1.11-2.08-3.4a7.71 7.71 0 0 0 3.75-7.42c-.21-4.34-5.5-7.92-12.2-7.92-3.5 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86a18.12 18.12 0 0 1 9.06-2.28c7.7 0 13.74 4.38 14.03 9.57a9.24 9.24 0 0 1-3.22 7.9l1.11 1.82",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M274.7 191.42l-1.39 1.11-2.08-3.4a7.71 7.71 0 0 0 3.75-7.42c-.21-4.34-5.5-7.92-12.2-7.92-3.5 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86a18.12 18.12 0 0 1 9.06-2.28c7.7 0 13.74 4.38 14.03 9.57a9.24 9.24 0 0 1-3.22 7.9l1.11 1.82",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.4a8.87 8.87 0 0 1 3.56 7.14 9.24 9.24 0 0 1-3.27 6.99l1.02 1.85",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.4a8.87 8.87 0 0 1 3.56 7.14 9.24 9.24 0 0 1-3.27 6.99l1.02 1.85",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M297.83 194.89a9.02 9.02 0 0 0 1.46-10.07c-2.13-4.38-8.8-7.57-16.75-7.57-2.17 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.8-2.88",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M297.83 194.89a9.02 9.02 0 0 0 1.46-10.07c-2.13-4.38-8.8-7.57-16.75-7.57-2.17 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.8-2.88z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M295.13 180.48a11.02 11.02 0 0 1 4.17 4.34 9.06 9.06 0 0 1-1.47 10.07l1.6 2.6a10.86 10.86 0 0 0 2.41-6.7c0-4.2-2.67-7.88-6.7-10.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M295.13 180.48a11.02 11.02 0 0 1 4.17 4.34 9.06 9.06 0 0 1-1.47 10.07l1.6 2.6a10.86 10.86 0 0 0 2.41-6.7c0-4.2-2.67-7.88-6.7-10.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M248.13 188.93c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M248.13 188.93c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M248.13 185.4c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8M248.51 181.6c0-.8.69-1.44 1.53-1.44.83 0 1.51.64 1.51 1.44 0 .8-.68 1.44-1.51 1.44-.84 0-1.53-.64-1.53-1.44M248.94 178.17c0-.57.5-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.05-1.1 1.05-.6 0-1.09-.47-1.09-1.05M249.16 175.18c0-.47.39-.83.88-.83.48 0 .87.37.87.83 0 .45-.4.83-.87.83a.86.86 0 0 1-.88-.83",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M250.2 199.78l1.23.22a4.8 4.8 0 0 0 4.68 6.28 4.9 4.9 0 0 0 4.68-3.21c.07.05.46-1.68.67-1.66.17.02.15 1.8.22 1.77.31 2.34 2.46 3.93 4.87 3.93a4.78 4.78 0 0 0 4.87-5.22l1.54-1.52.83 1.94c-.33.61-.46 1.3-.46 2.03 0 2.46 2.1 4.44 4.7 4.44 1.62 0 3.05-.78 3.9-1.97l.98-1.25v1.53c0 1.55.65 2.93 2.15 3.18 0 0 1.73.1 4.03-1.7 2.3-1.8 3.56-3.29 3.56-3.29l.2 1.8s-1.91 2.95-3.98 4.15c-1.14.66-2.86 1.35-4.23 1.13-1.44-.24-2.47-1.4-3-2.74a7 7 0 0 1-3.56.97c-2.8 0-5.33-1.54-6.32-3.86a7.28 7.28 0 0 1-10.77-.3 7.22 7.22 0 0 1-4.88 1.86 7.2 7.2 0 0 1-5.94-3.05 7.19 7.19 0 0 1-5.94 3.05c-1.89 0-3.61-.71-4.87-1.86a7.27 7.27 0 0 1-10.77.3c-1 2.32-3.52 3.86-6.32 3.86-1.3 0-2.52-.36-3.55-.97-.54 1.34-1.57 2.5-3.01 2.74-1.37.22-3.1-.47-4.23-1.13-2.07-1.2-3.98-4.14-3.98-4.14l.2-1.8s1.27 1.48 3.56 3.28c2.3 1.8 4.02 1.7 4.02 1.7 1.5-.25 2.16-1.63 2.16-3.18v-1.53l.98 1.25a4.76 4.76 0 0 0 3.9 1.97c2.6 0 4.7-1.98 4.7-4.44 0-.73-.14-1.42-.47-2.03l.83-1.94 1.54 1.52-.03.57c0 2.57 2.19 4.65 4.9 4.65 2.42 0 4.56-1.59 4.88-3.93.06.03.05-1.75.22-1.77.2-.02.6 1.7.67 1.66a4.9 4.9 0 0 0 4.68 3.21 4.79 4.79 0 0 0 4.67-6.28l1.29-.22",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M283.96 205.91c.28-.83.03-1.66-.57-1.84-.6-.18-1.32.34-1.6 1.17-.3.83-.04 1.65.56 1.84.6.18 1.32-.34 1.6-1.17M262.58 201.77c.11-.87-.3-1.63-.93-1.7-.63-.07-1.22.57-1.34 1.44-.11.86.3 1.63.93 1.7.63.07 1.23-.57 1.34-1.44M237.76 201.77c-.1-.87.31-1.63.93-1.7.63-.07 1.23.57 1.34 1.44.11.86-.3 1.63-.93 1.7-.63.07-1.22-.57-1.34-1.44M216.4 205.91c-.3-.83-.04-1.66.56-1.84.6-.18 1.32.34 1.6 1.17.28.83.03 1.65-.57 1.84-.6.18-1.31-.34-1.6-1.17",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M225.68 191.65a5.34 5.34 0 0 1 2.3 3.03s.13-.25.71-.6c.6-.32 1.09-.31 1.09-.31s-.17.97-.25 1.32c-.09.34-.1 1.38-.32 2.32a7.72 7.72 0 0 1-.63 1.68 1.98 1.98 0 0 0-1.58-.41 1.9 1.9 0 0 0-1.32.9s-.66-.58-1.2-1.38c-.56-.8-.94-1.78-1.14-2.08-.21-.3-.72-1.15-.72-1.15s.47-.18 1.14-.05c.67.12.88.32.88.32a5.1 5.1 0 0 1 1.04-3.59",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M226.13 201.86c-.34-.27-.6-.64-.68-1.08a1.7 1.7 0 0 1 .23-1.23s-.88-.44-1.83-.7c-.72-.18-1.99-.19-2.37-.2l-1.15-.02s.07.17.28.55c.26.46.5.75.5.75a5.25 5.25 0 0 0-3.03 2.09c.99.68 2.3 1.1 3.6.97 0 0-.12.34-.2.86-.06.43-.06.61-.06.61l1.07-.4c.35-.12 1.54-.54 2.15-.95.8-.54 1.49-1.25 1.49-1.25M228.97 201.38a1.72 1.72 0 0 0-.42-2.3s.67-.71 1.47-1.26c.6-.4 1.8-.82 2.15-.95l1.07-.4s0 .18-.06.61c-.08.52-.2.87-.2.87 1.3-.14 2.62.3 3.6.98a5.27 5.27 0 0 1-3.03 2.08 6.82 6.82 0 0 0 .78 1.3l-1.15-.03c-.38 0-1.65 0-2.37-.2-.95-.25-1.84-.7-1.84-.7",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M225.2 200.45c0-1.14.97-2.06 2.17-2.06 1.19 0 2.16.92 2.16 2.06 0 1.13-.97 2.05-2.16 2.05-1.2 0-2.17-.92-2.17-2.05",
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M250.11 188.37a5.91 5.91 0 0 1 1.95 3.8s.19-.26.91-.52 1.28-.16 1.28-.16-.39 1.05-.56 1.42c-.16.37-.38 1.53-.83 2.53a8.58 8.58 0 0 1-1.05 1.76c-.4-.45-1-.75-1.67-.75-.67 0-1.27.3-1.67.75 0 0-.61-.76-1.06-1.76-.44-1-.66-2.16-.83-2.53-.17-.37-.56-1.42-.56-1.42s.56-.1 1.28.16.92.53.92.53c.1-1.46.86-2.87 1.9-3.81",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M248.5 199.83a1.96 1.96 0 0 1-.01-2.65s-.9-.67-1.9-1.12c-.77-.35-2.18-.59-2.6-.67l-1.28-.24s.04.2.2.67c.2.56.4.93.4.93a6.1 6.1 0 0 0-3.81 1.76 6.17 6.17 0 0 0 3.8 1.75s-.19.36-.39.93c-.16.46-.2.66-.2.66l1.28-.23c.42-.09 1.83-.32 2.6-.67 1-.46 1.9-1.11 1.9-1.11M251.76 199.83a1.95 1.95 0 0 0 .01-2.65s.9-.67 1.9-1.12c.77-.35 2.18-.59 2.6-.67l1.28-.24s-.03.2-.2.67c-.2.56-.4.93-.4.93 1.47.08 2.86.81 3.81 1.76a6.15 6.15 0 0 1-3.8 1.75 7.05 7.05 0 0 0 .59 1.6l-1.27-.24c-.43-.09-1.84-.32-2.6-.67-1-.46-1.92-1.11-1.92-1.11M274.67 191.65a5.36 5.36 0 0 0-2.3 3.03s-.13-.25-.72-.6c-.58-.32-1.09-.31-1.09-.31s.17.97.26 1.32c.09.34.09 1.38.31 2.32.23.93.64 1.68.64 1.68.42-.34.99-.5 1.57-.41.59.1 1.06.44 1.33.9 0 0 .66-.58 1.2-1.38.55-.8.93-1.78 1.13-2.08.21-.3.72-1.15.72-1.15s-.47-.18-1.14-.05c-.67.12-.88.32-.88.32a5.06 5.06 0 0 0-1.03-3.59",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M274.22 201.86c.34-.27.6-.64.67-1.08.09-.44 0-.87-.22-1.23 0 0 .88-.44 1.82-.7.73-.18 2-.19 2.37-.2l1.15-.02s-.06.17-.28.55c-.26.46-.5.75-.5.75a5.26 5.26 0 0 1 3.04 2.09 5.5 5.5 0 0 1-3.6.97s.11.34.2.86c.06.43.05.61.05.61l-1.06-.4c-.36-.12-1.55-.54-2.16-.95-.8-.54-1.48-1.25-1.48-1.25M271.38 201.38a1.74 1.74 0 0 1-.25-1.23c.09-.44.33-.8.67-1.08 0 0-.67-.7-1.47-1.25-.61-.4-1.8-.82-2.16-.95l-1.06-.4s0 .18.06.61c.08.52.2.87.2.87-1.3-.14-2.62.3-3.6.98a5.27 5.27 0 0 0 3.02 2.08s-.23.28-.49.74c-.22.39-.28.56-.28.56l1.14-.03c.38 0 1.66 0 2.37-.2.95-.25 1.84-.7 1.84-.7",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M270.81 200.45c0-1.14.97-2.06 2.17-2.06s2.17.92 2.17 2.06c0 1.13-.97 2.05-2.17 2.05s-2.17-.92-2.17-2.05M295.05 205c-.5-.53-1.57-.42-2.36.26-.79.67-1.02 1.66-.5 2.2.5.53 1.56.41 2.35-.26.8-.67 1.02-1.66.51-2.2",
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M291.97 206.31c.11-.36.36-.74.72-1.05.8-.68 1.85-.8 2.36-.25.06.07.14.17.18.25 0 0 1.1-2.08 2.4-2.78 1.3-.7 3.5-.52 3.5-.52 0-1.6-1.3-2.89-3-2.89-.99 0-1.92.41-2.48 1.1l-.22-1.06s-1.36.27-1.98 1.82c-.62 1.55.05 3.8.05 3.8s-.33-.96-.84-1.6a8.33 8.33 0 0 0-2.49-1.66 11.2 11.2 0 0 1-1.37-.8s-.03.18-.06.6c-.02.52.02.84.02.84a8.21 8.21 0 0 0-3.83.48c.48.95 1.4 1.84 2.61 2.3 0 0-.43.36-.83.75-.33.34-.44.5-.44.5l1.28.18c.43.05 1.84.28 2.68.22.63-.04 1.32-.14 1.74-.22M208.37 206.31c-.1-.36-.35-.74-.72-1.05-.79-.68-1.84-.8-2.36-.25a1.1 1.1 0 0 0-.17.25s-1.1-2.08-2.4-2.78c-1.3-.7-3.5-.52-3.5-.52 0-1.6 1.3-2.89 2.99-2.89 1 0 1.92.41 2.48 1.1l.23-1.06s1.36.27 1.98 1.82c.62 1.55-.06 3.8-.06 3.8s.34-.96.85-1.6a8.36 8.36 0 0 1 2.49-1.66c.67-.32 1.37-.8 1.37-.8a8.21 8.21 0 0 0 .04 1.44c1.24-.17 2.7.04 3.83.48a4.92 4.92 0 0 1-2.62 2.3s.44.36.83.75c.34.34.44.5.44.5l-1.27.18c-.43.05-1.84.28-2.69.22-.62-.04-1.32-.14-1.74-.22",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M205.3 205c.5-.53 1.56-.42 2.35.26.8.67 1.02 1.66.51 2.2-.5.53-1.57.41-2.36-.26-.79-.67-1.02-1.66-.5-2.2M247.97 198.5c0-1.13.97-2.05 2.17-2.05s2.17.92 2.17 2.05c0 1.14-.97 2.06-2.17 2.06s-2.17-.92-2.17-2.06",
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M245.63 167.3c0-2.32 1.98-4.2 4.42-4.2a4.32 4.32 0 0 1 4.43 4.2 4.31 4.31 0 0 1-4.43 4.2 4.32 4.32 0 0 1-4.43-4.2",
      fill: "#005bbf",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M248.9 155.54v2.26h-2.43v2.3h2.42V166.7h-3.05c-.03.21-.22.37-.22.6 0 .57.12 1.13.35 1.63 0 .02.02.02.03.03h8.12l.03-.03a4 4 0 0 0 .34-1.63c0-.23-.18-.39-.22-.6h-2.95v-6.61h2.42v-2.3h-2.42v-2.26h-2.43z",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M250.5 344.33a85.31 85.31 0 0 1-36.96-8.54 23.65 23.65 0 0 1-13.36-21.19v-33.3h100.43v33.3c0 9.19-5.33 17.21-13.37 21.2a84.42 84.42 0 0 1-36.75 8.53",
      fill: "#ccc"
    }), r.createElement("path", {
      d: "M250.5 344.33a85.31 85.31 0 0 1-36.96-8.54 23.65 23.65 0 0 1-13.36-21.19v-33.3h100.43v33.3c0 9.19-5.33 17.21-13.37 21.2a84.42 84.42 0 0 1-36.75 8.53z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M250.28 281.25h50.32v-55.72h-50.32v55.72z",
      fill: "#ccc"
    }), r.createElement("path", {
      d: "M250.28 281.25h50.32v-55.72h-50.32v55.72z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.2v33.36",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M211.08 334.23c1.57.83 3.72 2.22 6.03 2.77l-.15-56.96h-5.88v54.19z",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M200.03 314.12a25.4 25.4 0 0 0 5.73 15.67v-49.47h-5.66l-.07 33.8z",
      fill: "#c8b100",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".5"
    }), r.createElement("path", {
      d: "M222.28 338.25c2.3.23 4.01.19 5.87 0v-58.21h-5.88v58.21z",
      fill: "#c7b500",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M233.32 337c2.3-.46 4.9-1.9 6.03-2.63v-54.33h-5.88l-.15 56.96z",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M200.12 281.25h50.18v-55.72h-50.18v55.72z",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M200.12 281.25h50.18v-55.72h-50.18v55.72z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M244.81 329.24c2.45-2.18 4.75-7.13 5.59-12.76l.14-36.44h-5.87l.14 49.2z",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.2v33.36",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M300.65 281.21v33.36c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.33",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M300.65 281.21v33.36c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.33",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M259.47 306.39c.08.17.13.34.13.52 0 .61-.52 1.1-1.17 1.1-.65 0-1.17-.49-1.17-1.1 0-.18.04-.35.12-.5l-1.63-.02a2.6 2.6 0 0 0 1.85 2.99v4.01l1.71.01v-4.04c.8-.26 1.43-.86 1.7-1.62h4.6v-1.35h-6.14m22.58 0v1.35l-4.14.01c-.06.19-.16.35-.26.51l4.8 5.46-1.29 1.05-4.78-5.47-.23.09v9.04h-1.7v-9.08c-.08-.02-.14-.05-.2-.09l-4.98 5.5-1.3-1.04 4.98-5.52c-.08-.14-.15-.3-.2-.46h-4.28v-1.35h13.59zm2.76 0v1.35h4.6c.28.76.9 1.36 1.7 1.62v4.04h1.71v-4.02a2.6 2.6 0 0 0 1.91-2.47c0-.18-.02-.36-.06-.52h-1.63c.08.17.12.34.12.52 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1 0-.18.04-.35.12-.5l-6.14-.02m-6.96 23.04c1.34-.21 2.58-.58 3.8-1.1l.85 1.43c-1.41.6-2.93 1.04-4.5 1.28a2.7 2.7 0 0 1-2.67 2.04 2.7 2.7 0 0 1-2.67-2.02 18.23 18.23 0 0 1-4.73-1.3l.84-1.43c1.29.55 2.66.9 4.08 1.1a2.6 2.6 0 0 1 1.58-1.38l.01-7.01h1.7l.01 6.98c.75.22 1.38.74 1.7 1.4zm-11.5-2.35l-.83 1.44a17.35 17.35 0 0 1-3.8-3.22c-.86.26-1.85.1-2.59-.5a2.49 2.49 0 0 1-.3-3.64l.14-.16a15.9 15.9 0 0 1-1.32-5h1.71c.13 1.51.51 2.94 1.1 4.28.48-.06.99 0 1.45.16l4.28-4.73 1.29 1.04-4.25 4.73c.57.87.55 2-.1 2.85a15.8 15.8 0 0 0 3.23 2.75zm-6.33-4.96a1.21 1.21 0 0 1 1.65-.13c.49.4.55 1.1.13 1.56-.42.47-1.16.52-1.65.13-.5-.4-.55-1.1-.13-1.56zm-2.16-4.69l-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52l1.75.41s.09 2.87.05 2.22c-.04-.75.2 2.24.2 2.24l-1.77.58c-.18-.9-.24-1.84-.24-2.8v-2.65zm5.77 14.25a16.32 16.32 0 0 0 5.04 2.68l.4-1.7a14.27 14.27 0 0 1-4.18-2.1l-1.26 1.12m-.84 1.46c1.5 1.13 3.2 2.03 5.04 2.65l-1.31 1.23a19.49 19.49 0 0 1-4.12-2.11l.38-1.77m2.29-9.81l1.67.7 3.06-3.39-1-1.44-3.73 4.13m-1.3-1.05l-1-1.45 3.06-3.4 1.67.72-3.73 4.13m18.84 10.32l.83 1.44a17.4 17.4 0 0 0 3.8-3.22c.87.26 1.85.1 2.6-.5a2.5 2.5 0 0 0 .3-3.64l-.15-.16c.7-1.56 1.17-3.24 1.32-5h-1.7c-.14 1.51-.52 2.94-1.1 4.28-.48-.06-1 0-1.46.16l-4.27-4.73-1.3 1.04 4.26 4.73c-.57.87-.55 2 .1 2.85a15.71 15.71 0 0 1-3.23 2.75zm6.34-4.96a1.2 1.2 0 0 0-1.65-.13c-.5.4-.55 1.1-.13 1.56.42.47 1.16.52 1.65.13.5-.4.55-1.1.13-1.56zm2.15-4.69l1.76-.39.25-4.45-1.74-.58v2.56c0 .99-.1 1.92-.27 2.86zm-1.45-5.52l-1.75.41s-.1 2.87-.06 2.22c.05-.75-.2 2.24-.2 2.24l1.77.58c.18-.9.24-1.84.24-2.8v-2.65m-5.78 14.25a16.38 16.38 0 0 1-5.04 2.68l-.39-1.7a14.24 14.24 0 0 0 4.17-2.1l1.26 1.12m.85 1.46a18.18 18.18 0 0 1-5.04 2.65l1.31 1.23a19.5 19.5 0 0 0 4.12-2.11l-.39-1.77m-2.28-9.81l-1.67.7-3.06-3.39 1-1.44 3.73 4.13m1.3-1.05l1-1.45-3.06-3.4-1.67.72 3.72 4.13m-20.94-9.01l.51 1.67h4.72l.5-1.67h-5.73m22.02 0l-.52 1.67h-4.71l-.5-1.67h5.73m-12.11 22.75c0-.62.52-1.12 1.17-1.12.64 0 1.17.5 1.17 1.12 0 .6-.53 1.1-1.17 1.1-.65 0-1.17-.5-1.17-1.1zm1.98-8.08l1.76-.5v-4.45l-1.76-.48v5.43m-1.7 0l-1.76-.5v-4.45l1.76-.48v5.43",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M255.75 306.43c.2-.93.93-1.69 1.86-1.97l-.01-5.5h1.7v5.53c.84.26 1.48.88 1.74 1.68h4.57v.26h-6.14a1.2 1.2 0 0 0-2.09.02l-1.63-.02m12.71 0v-.25h4.25c.05-.14.11-.28.19-.4l-5.25-5.85 1.3-1.04 5.17 5.75.27-.12.01-7.66h1.7v7.61l.26.07 5.06-5.76 1.3 1.03-5.08 5.74c.13.19.22.4.3.63h4.1v.25h-13.58zm22.5 0a1.2 1.2 0 0 1 1.04-.6c.45 0 .85.26 1.04.62l1.63-.02a2.68 2.68 0 0 0-1.86-1.97l.01-5.5h-1.7v5.54c-.83.26-1.48.87-1.73 1.67h-4.58v.26h6.14m-31.38-15.54l6.3 7.07 1.3-1.05-6.34-7.04c.12-.19.21-.4.29-.62h4.61v-1.6h-4.61a2.72 2.72 0 0 0-2.61-1.8 2.67 2.67 0 0 0-2.73 2.6c0 1.13.76 2.1 1.84 2.45l-.01 5.45h1.69v-5.42l.27-.04zm33.27.03l-.01 5.43h-1.7v-5.45c-.13-.04-.26-.1-.38-.15l-6.27 7.07-1.3-1.03 6.4-7.21c-.06-.1-.12-.21-.15-.33h-4.64v-1.6h4.62a2.71 2.71 0 0 1 2.6-1.8c1.5 0 2.73 1.17 2.73 2.6a2.6 2.6 0 0 1-1.9 2.47zm-16.73-.02l-.01 3.35h-1.7v-3.32a2.68 2.68 0 0 1-1.78-1.68h-4.13v-1.6h4.13a2.7 2.7 0 0 1 2.6-1.8c1.2 0 2.23.75 2.6 1.8h4.21v1.6h-4.23a2.63 2.63 0 0 1-1.69 1.65zm-18.49 4.06l-1.76.5v4.46l1.76.49v-5.45m1.7 0l1.76.5v4.46l-1.75.49v-5.45m31.78 0l-1.75.5v4.46l1.75.49v-5.45m1.71 0l1.76.5v4.46l-1.76.49v-5.45m-26.61.88l1.67-.7 3.06 3.4-1 1.44-3.73-4.14m-1.3 1.06l-1 1.45 3.06 3.4 1.67-.72-3.73-4.13m19.22-1.19l-1.68-.7-3.03 3.43 1.02 1.44 3.69-4.17m1.3 1.04l1.02 1.45-3.03 3.42-1.68-.7 3.7-4.17m-21.19 9.43l.51-1.67h4.72l.5 1.67h-5.73m-6.91-17.73c0-.61.52-1.11 1.17-1.11.64 0 1.17.5 1.17 1.11 0 .61-.53 1.1-1.17 1.1-.65 0-1.17-.49-1.17-1.1zm12.6.8l-.51 1.68h-4.71l-.51-1.67h5.74m0-1.62l-.52-1.67h-4.71l-.51 1.67h5.74m16.32 18.54l-.52-1.67h-4.71l-.5 1.67h5.73m4.57-17.73c0-.61.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm-16.8 0c0-.61.53-1.11 1.17-1.11.65 0 1.17.5 1.17 1.11 0 .61-.52 1.1-1.17 1.1-.64 0-1.17-.49-1.17-1.1zm6.53.8l.52 1.68h4.7l.52-1.67h-5.74m0-1.62l.52-1.67h4.7l.52 1.67h-5.74m-6.15 5.22l-1.76.5v4.46l1.76.49v-5.45m1.69 0l1.75.5v4.46l-1.75.49v-5.45",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M277.85 329.43c1.34-.21 2.58-.58 3.8-1.1l.85 1.43c-1.41.6-2.93 1.04-4.5 1.28a2.7 2.7 0 0 1-2.67 2.04 2.7 2.7 0 0 1-2.67-2.02 18.23 18.23 0 0 1-4.73-1.3l.84-1.43c1.29.55 2.66.9 4.08 1.1a2.6 2.6 0 0 1 1.58-1.38l.01-7.01h1.7l.01 6.98c.75.22 1.38.74 1.7 1.4zm-4.9-21.23c-.09-.14-.15-.3-.2-.46h-4.29v-1.6h4.25c.05-.14.12-.27.19-.4l-5.25-5.83 1.3-1.05 5.17 5.74.28-.12v-7.64h1.7v7.6c.07.02.19.04.26.07l5.06-5.75 1.3 1.03-5.08 5.72c.13.19.22.4.3.63h4.1v1.6l-4.13.01c-.06.19-.17.35-.26.51l4.8 5.47-1.29 1.04-4.78-5.47c-.09.03-.13.07-.23.1l-.01 9.03h-1.7v-9.08c-.07-.02-.13-.05-.2-.09l-4.98 5.51-1.29-1.04 4.98-5.53m-13.38-17.32l6.3 7.05 1.3-1.04-6.34-7.03c.12-.19.21-.4.29-.61h4.61v-1.6h-4.61a2.72 2.72 0 0 0-2.61-1.8 2.66 2.66 0 0 0-2.73 2.6c0 1.12.76 2.09 1.84 2.44l-.01 5.44h1.69v-5.4c.07-.03.2-.03.27-.05zm6.79 36.2l-.84 1.44a17.35 17.35 0 0 1-3.8-3.22c-.86.26-1.85.1-2.59-.5a2.49 2.49 0 0 1-.3-3.64l.14-.16a15.9 15.9 0 0 1-1.32-5h1.71c.13 1.51.51 2.94 1.1 4.28.48-.06.99 0 1.45.16l4.28-4.73 1.29 1.04-4.25 4.73c.57.87.55 2-.1 2.85a15.8 15.8 0 0 0 3.23 2.75zm-8.76-13.69v-4.01a2.6 2.6 0 0 1-1.9-2.47c0-1.16.8-2.15 1.91-2.48l-.01-5.5h1.7v5.53c.84.26 1.48.88 1.74 1.67h4.57v1.61h-4.6c-.27.76-.9 1.36-1.7 1.62v4.04h-1.71m2.42 8.72a1.21 1.21 0 0 1 1.65-.13c.49.4.55 1.1.13 1.56-.42.47-1.16.52-1.65.13-.5-.4-.55-1.1-.13-1.56zm-2.16-4.69l-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52l1.75.41s.09 2.87.05 2.22c-.04-.75.2 2.24.2 2.24l-1.77.58c-.18-.9-.24-1.84-.24-2.8v-2.65zm5.77 14.25a16.32 16.32 0 0 0 5.04 2.68l.4-1.7a14.27 14.27 0 0 1-4.18-2.1l-1.26 1.12m-.84 1.46c1.5 1.13 3.2 2.03 5.04 2.65l-1.31 1.23a19.49 19.49 0 0 1-4.12-2.11l.38-1.77",
      fill: "none",
      stroke: "#c8b100",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M266.53 317.8l1.67.72 3.06-3.4-1-1.44-3.73 4.13m-1.3-1.05l-1-1.45 3.06-3.4 1.67.72-3.73 4.13m-7.97-9.85c0-.62.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm26.8 20.17l.84 1.44a17.4 17.4 0 0 0 3.8-3.22c.87.26 1.85.1 2.6-.5a2.5 2.5 0 0 0 .3-3.64l-.15-.16c.7-1.56 1.17-3.24 1.32-5h-1.7c-.14 1.51-.52 2.94-1.1 4.28-.48-.06-1 0-1.46.16l-4.27-4.73-1.3 1.04 4.26 4.73c-.57.87-.55 2 .1 2.85a15.71 15.71 0 0 1-3.23 2.75zm8.77-13.69v-4.01a2.6 2.6 0 0 0 1.9-2.47c0-1.16-.81-2.15-1.92-2.48l.01-5.5h-1.7v5.53c-.83.26-1.48.88-1.73 1.67h-4.58v1.61h4.6c.28.76.9 1.36 1.7 1.62v4.04h1.71zm-2.42 8.73a1.2 1.2 0 0 0-1.65-.13c-.5.4-.55 1.1-.13 1.56.42.47 1.16.52 1.65.13.5-.4.55-1.1.13-1.56zm2.15-4.69l1.76-.39.25-4.45-1.74-.58v2.56c0 .99-.1 1.92-.27 2.86zm-1.45-5.52l-1.75.41s-.1 2.87-.06 2.22c.05-.75-.2 2.24-.2 2.24l1.77.58c.18-.9.24-1.84.24-2.8v-2.65m1.73-21l-.01 5.42h-1.7v-5.44c-.13-.04-.26-.1-.38-.15l-6.27 7.06-1.3-1.03 6.4-7.2c-.06-.1-.12-.2-.15-.32h-4.64v-1.6h4.62a2.71 2.71 0 0 1 2.6-1.8c1.5 0 2.73 1.16 2.73 2.6a2.6 2.6 0 0 1-1.9 2.46zm-16.73-.02l-.01 3.34h-1.7v-3.31a2.68 2.68 0 0 1-1.78-1.67h-4.13v-1.6h4.13a2.7 2.7 0 0 1 2.6-1.8c1.2 0 2.23.75 2.6 1.8h4.21v1.6h-4.23a2.63 2.63 0 0 1-1.69 1.64zm9.22 35.27a16.38 16.38 0 0 1-5.04 2.68l-.39-1.7a14.24 14.24 0 0 0 4.17-2.1l1.26 1.12m.85 1.46a18.18 18.18 0 0 1-5.04 2.65l1.31 1.23a19.5 19.5 0 0 0 4.12-2.11l-.39-1.77m-28.56-32.68l-1.76.5v4.46l1.76.48v-5.44m1.7 0l1.76.5v4.46l-1.75.48v-5.44m31.78 0l-1.75.5v4.46l1.75.48v-5.44",
      fill: "none",
      stroke: "#c8b100",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M292.82 294.94l1.76.5v4.46l-1.76.48v-5.44m-8.92 22.87l-1.67.7-3.06-3.39 1-1.44 3.73 4.13m1.3-1.05l1-1.45-3.06-3.4-1.67.72 3.72 4.13m-18.98-20.94l1.67-.7 3.06 3.39-1 1.45-3.73-4.14m-1.3 1.05l-1 1.46 3.06 3.39 1.67-.72-3.73-4.13m19.22-1.18l-1.68-.7-3.03 3.43 1.02 1.43 3.69-4.16m1.3 1.04l1.02 1.44-3.03 3.42-1.68-.7 3.7-4.16m-21.19 9.4l.51-1.66h4.72l.5 1.67h-5.73m0 1.6l.51 1.68h4.72l.5-1.67h-5.73m-6.91-19.3c0-.62.52-1.11 1.17-1.11.64 0 1.17.5 1.17 1.1 0 .62-.53 1.1-1.17 1.1-.65 0-1.17-.48-1.17-1.1zm12.6.8l-.51 1.67h-4.71l-.51-1.67h5.74m0-1.62l-.52-1.66h-4.71l-.51 1.66h5.74m20.88 19.28c0-.62.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm-4.56-.77l-.52-1.67h-4.71l-.5 1.67h5.73m0 1.6l-.52 1.68h-4.71l-.5-1.67h5.73m-12.11 22.75c0-.62.52-1.12 1.17-1.12.64 0 1.17.5 1.17 1.12 0 .6-.53 1.1-1.17 1.1-.65 0-1.17-.5-1.17-1.1zm1.98-8.08l1.76-.5v-4.45l-1.76-.48v5.43m-1.7 0l-1.76-.5v-4.45l1.76-.48v5.43m16.4-33.98c0-.6.52-1.1 1.17-1.1.64 0 1.16.5 1.16 1.1 0 .62-.52 1.1-1.16 1.1-.65 0-1.17-.48-1.17-1.1zm-16.8 0c0-.6.53-1.1 1.17-1.1.65 0 1.17.5 1.17 1.1 0 .62-.52 1.1-1.17 1.1-.64 0-1.17-.48-1.17-1.1zm6.53.81l.52 1.67h4.7l.52-1.67h-5.74m0-1.62l.52-1.66h4.7l.52 1.66h-5.74M274.42 292.85l-1.76.49v4.46l1.76.48v-5.43m1.69 0l1.75.49v4.46l-1.75.48v-5.43",
      fill: "none",
      stroke: "#c8b100",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M272.6 306.94c0-1.44 1.22-2.6 2.73-2.6 1.5 0 2.73 1.16 2.73 2.6a2.66 2.66 0 0 1-2.73 2.58c-1.51 0-2.74-1.15-2.74-2.58",
      fill: "#058e6e"
    }), r.createElement("path", {
      d: "M275.93 239.26l.06-.62.08-.34s-1.61.13-2.46-.1a6.15 6.15 0 0 1-2.4-1.26c-.8-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.3a4.85 4.85 0 0 0 1.95 1.54c.6.18 2.66.05 3.22.07.57.03 1.84.2 1.84.2",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M275.93 239.26l.06-.62.08-.34s-1.61.13-2.46-.1a6.15 6.15 0 0 1-2.4-1.26c-.8-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.3a4.85 4.85 0 0 0 1.95 1.54c.6.18 2.66.05 3.22.07.57.03 1.84.2 1.84.2z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M283.46 237s0 .72.08 1.4c.06.67-.22 1.24-.1 1.61.1.37.15.66.3.93.13.26.2.94.2.94l-.74-.54c-.35-.27-.6-.44-.6-.44l.1 1.03c.04.31.22.9.51 1.24.29.33.87.89 1.05 1.33.18.45.14 1.44.14 1.44s-.46-.75-.87-.89c-.4-.14-1.26-.62-1.26-.62s.8.8.8 1.55-.33 1.6-.33 1.6-.36-.68-.83-1.13c-.47-.44-1.13-.89-1.13-.89s.52 1.17.52 1.95c0 .8-.15 2.47-.15 2.47s-.4-.64-.8-.96c-.4-.3-.86-.58-1-.78-.15-.2.46.64.53 1.16.07.51.32 2.35 1.92 4.7.94 1.36 2.39 3.76 5.5 2.97 3.11-.78 1.95-4.97 1.3-6.92a17.52 17.52 0 0 1-.94-4.87c.04-.75.58-2.97.5-3.39-.06-.4-.23-2 .15-3.28.4-1.33.73-1.85.94-2.4.22-.55.4-.86.47-1.34.07-.48.07-1.37.07-1.37s.58 1.06.72 1.44c.15.38.15 1.5.15 1.5s.1-1.12.98-1.67c.87-.55 1.88-1.13 2.13-1.44.25-.31.33-.51.33-.51s-.08 1.92-.62 2.67c-.36.5-1.77 2.1-1.77 2.1s.73-.29 1.23-.31c.5-.04.87 0 .87 0s-.62.48-1.41 1.64c-.8 1.16-.47 1.26-1.05 2.22-.58.96-1.05 1-1.78 1.58-1.08.87-.5 4.34-.36 4.86.15.51 2.03 4.76 2.07 5.8.03 1.02.21 3.32-1.6 4.79-1.16.95-3.07.96-3.5 1.23-.44.28-1.3 1.13-1.3 2.91 0 1.79.64 2.06 1.15 2.5.5.45 1.16.21 1.3.56.15.34.22.54.44.75.22.2.36.44.29.82-.07.38-.9 1.23-1.2 1.85-.29.61-.87 2.23-.87 2.47 0 .24-.06 1 .18 1.37 0 0 .9 1.06.3 1.26-.4.14-.8-.25-.98-.2-.54.14-.82.47-.98.44-.36-.06-.36-.24-.4-.75-.03-.51-.01-.72-.18-.72-.21 0-.32.18-.36.45-.04.27-.04.89-.29.89-.25 0-.61-.45-.83-.55-.22-.1-.83-.2-.87-.48-.03-.27.36-.85.76-.96.4-.1.76-.3.5-.5-.25-.21-.5-.21-.75 0-.25.2-.8.03-.76-.28.04-.31.1-.69.07-.86-.03-.17-.47-.51.1-.82.59-.3.84.27 1.42.17s.87-.31 1.08-.65c.22-.34.18-1.06-.21-1.5-.4-.45-.8-.52-.95-.8-.14-.27-.36-.92-.36-.92s.1 1.2.04 1.37c-.07.17-.04.89-.04.89l-.72-.79a5.1 5.1 0 0 1-.65-1.37l-.03 1.34c0 .37.43.72.29.86-.15.13-.83-.72-1.02-.86a3.81 3.81 0 0 1-1.01-1.06c-.25-.48-.44-1.16-.5-1.4-.08-.25-.2-1.32-.08-1.59.18-.4.47-1.13.47-1.13h-1.41c-.76 0-1.3-.23-1.6.28-.28.51-.14 1.54.22 2.88.37 1.33.58 1.98.48 2.22-.11.24-.58.8-.76.9-.19.1-.7.06-.91-.04a2.6 2.6 0 0 0-1.26-.27c-.69 0-1.12.03-1.38-.03-.25-.07-.87-.38-1.16-.31-.29.07-.79.32-.65.72.22.61-.21.75-.5.72-.3-.04-.54-.14-.91-.24-.36-.1-.9 0-.83-.42.07-.4.22-.44.4-.75.18-.3.25-.5.04-.53-.25-.02-.5-.05-.7.11-.2.16-.5.5-.76.38-.26-.14-.46-.43-.46-1.08 0-.64-.68-1.2-.05-1.17.62.03 1.41.48 1.55.13.14-.35.06-.5-.28-.78-.34-.26-.76-.43-.3-.77.44-.35.55-.35.73-.54.17-.18.4-.79.72-.64.63.3.03.73.66 1.42.62.7 1.01.94 2.06.83 1.04-.1 1.33-.24 1.33-.54 0-.3-.09-.82-.12-1.04-.02-.21.15-1 .15-1s-.48.3-.63.6c-.13.3-.42.8-.42.8s-.11-.6-.08-1.1c.02-.28.12-.78.11-.88-.03-.27-.22-.94-.22-.94s-.18.73-.29.94c-.1.21-.17 1.07-.17 1.07s-.66-.58-.47-1.55c.13-.75-.12-1.74.1-2.06.23-.33.77-1.64 2.07-1.7 1.3-.04 2.31.06 2.77.04.45-.03 2.06-.32 2.06-.32s-2.97-1.53-3.65-1.99a9.89 9.89 0 0 1-2.06-2.16c-.34-.54-.65-1.58-.65-1.58s-.53.03-1.02.3a5.13 5.13 0 0 0-1.97 2.03s.08-.94.08-1.24c0-.28-.06-.85-.06-.85s-.33 1.28-1.01 1.76c-.68.49-1.47 1.15-1.47 1.15s.08-.71.08-.88c0-.16.17-.99.17-.99s-.48.72-1.21.86c-.74.13-1.81.1-1.9.56-.08.45.2 1.07.03 1.4-.17.31-.54.53-.54.53s-.42-.35-.79-.38c-.36-.03-.7.16-.7.16s-.32-.4-.2-.67c.11-.26.68-.66.54-.83-.15-.16-.6.06-.88.2-.28.13-.88.26-.82-.2.06-.45.2-.72.06-1.04-.15-.32-.06-.53.17-.62.22-.07 1.13.03 1.21-.18.08-.21-.22-.48-.82-.61-.6-.14-.88-.49-.56-.78.3-.3.4-.38.53-.64.14-.27.2-.75.74-.51.53.24.42.82.99 1.01.56.2 1.89-.07 2.17-.23.29-.17 1.19-.84 1.5-1 .31-.16 1.6-1.12 1.6-1.12s-.75-.53-1.04-.8c-.28-.27-.78-.91-1.04-1.05a8.72 8.72 0 0 0-1.92-.64 12 12 0 0 1-1.73-.48s.6-.19.8-.35c.2-.16.64-.56.87-.53l.28.03s-1.21-.06-1.47-.14c-.25-.08-.99-.54-1.27-.54s-.84.11-.84.11.76-.48 1.38-.59c.62-.1 1.1-.08 1.1-.08s-.96-.26-1.19-.58c-.22-.33-.45-.8-.62-1.02-.17-.21-.28-.56-.6-.59-.3-.03-.84.38-1.15.35-.3-.02-.54-.22-.57-.67-.02-.46 0-.3-.1-.53-.12-.25-.57-.81-.15-.94.43-.14 1.33.08 1.42-.08.08-.16-.48-.65-.85-.83-.37-.19-.96-.51-.65-.78.31-.27.62-.37.8-.61.16-.24.36-.91.73-.7.36.21.87 1.26 1.16 1.18.28-.08.3-.83.25-1.15-.06-.32 0-.88.28-.83.28.05.5.43.96.46.45.02 1.13-.11 1.07.2-.05.33-.3.72-.62 1.08a1.6 1.6 0 0 0-.25 1.5c.2.45.7 1.18 1.16 1.47.45.3 1.3.5 1.84.85.53.36 1.78 1.34 2.2 1.45.42.1.85.32.85.32s.48-.21 1.13-.21c.65 0 2.15.1 2.71-.14.57-.24 1.3-.64 1.08-1.15-.23-.5-1.47-.96-1.36-1.36.11-.4.57-.43 1.33-.46.76-.02 1.8.14 2-.94.2-1.06.25-1.68-.81-1.92-1.08-.24-1.87-.27-2.07-1.04-.2-.78-.4-.97-.17-1.18.23-.21.62-.32 1.41-.37.8-.06 1.7-.06 1.95-.25.26-.18.31-.7.62-.91.31-.21 1.53-.4 1.53-.4s1.45.7 2.8 1.7c1.21.91 2.3 2.24 2.3 2.24",
      fill: "#ed72aa",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.33.37-.06.1-.2.27-.2.27"
    }), r.createElement("path", {
      d: "M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.33.37-.06.1-.2.27-.2.27z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M277.06 234.85l-.06-.43s.77 0 1.13.26c.57.4.93 1.02.9 1.05-.09.1-.53-.27-.84-.38 0 0-.23.06-.45.06-.23 0-.34-.1-.37-.22-.03-.1.03-.29.03-.29l-.34-.05"
    }), r.createElement("path", {
      d: "M277.06 234.85l-.06-.43s.77 0 1.13.26c.57.4.93 1.02.9 1.05-.09.1-.53-.27-.84-.38 0 0-.23.06-.45.06-.23 0-.34-.1-.37-.22-.03-.1.03-.29.03-.29l-.34-.05z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M282.57 240.9s-.34-.49-.42-.65c-.09-.15-.23-.48-.23-.48",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.06 0 .17-.54.11-.9a1.84 1.84 0 0 0-1.3-1.48s.33.73.17 1.07c-.23.48-.65.86-.65.86",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.06 0 .17-.54.11-.9a1.84 1.84 0 0 0-1.3-1.48s.33.73.17 1.07c-.23.48-.65.86-.65.86z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M259.59 237.12s-.42-.77-1.33-.67c-.9.1-1.5.8-1.5.8s1-.02 1.25.14c.37.24.48.86.48.86s.54-.32.7-.54c.17-.21.4-.59.4-.59",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M259.59 237.12s-.42-.77-1.33-.67c-.9.1-1.5.8-1.5.8s1-.02 1.25.14c.37.24.48.86.48.86s.54-.32.7-.54c.17-.21.4-.59.4-.59z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M258.49 240.25s-.76.11-1.19.6c-.43.48-.37 1.39-.37 1.39s.51-.54.96-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.8-.34-.8",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M258.49 240.25s-.76.11-1.19.6c-.43.48-.37 1.39-.37 1.39s.51-.54.96-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.8-.34-.8z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M273.08 240.15l.33-.54.34.49-.67.05"
    }), r.createElement("path", {
      d: "M273.08 240.15l.33-.54.34.49-.67.05",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M273.9 240.12l.39-.53.42.48-.82.05"
    }), r.createElement("path", {
      d: "M273.9 240.12l.39-.53.42.48-.82.05",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M273.53 236.83l.82.3-.74.37-.08-.67"
    }), r.createElement("path", {
      d: "M273.53 236.83l.82.3-.74.37-.08-.67",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M274.51 237.1l.74.18-.6.46-.13-.64"
    }), r.createElement("path", {
      d: "M274.51 237.1l.74.18-.6.46-.13-.64",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M269 243.39s-.8.23-1.1.67c-.37.53-.34 1.07-.34 1.07s.68-.56 1.56-.33c.87.24.96.33 1.33.3.37-.03 1.27-.35 1.27-.35s-.74.86-.65 1.45c.08.59.2.85.17 1.15-.06.72-.6 1.6-.6 1.6s.31-.18 1.05-.34a4.77 4.77 0 0 0 1.75-.8c.4-.3.9-1.03.9-1.03s-.16 1 0 1.43c.17.42.23 1.66.23 1.66s.47-.42.85-.62c.2-.11.7-.38.9-.7.14-.22.31-1.06.31-1.06s.12.9.4 1.34c.28.42.7 1.74.7 1.74s.29-.86.6-1.21c.3-.35.68-.8.7-1.07.03-.27-.08-.85-.08-.85l.4.85m-11.42.61s.48-.83.93-1.1c.46-.27 1.08-.75 1.25-.8.16-.05.9-.46.9-.46m.99 5.17s1.09-.55 1.41-.75a4.11 4.11 0 0 0 1.16-1.12",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M261.06 250.37s-.43-.45-1.16-.32c-.73.14-1.21.97-1.21.97s.62-.17.99-.08c.36.08.62.45.62.45s.33-.3.45-.45c.11-.16.3-.57.3-.57",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M261.06 250.37s-.43-.45-1.16-.32c-.73.14-1.21.97-1.21.97s.62-.17.99-.08c.36.08.62.45.62.45s.33-.3.45-.45c.11-.16.3-.57.3-.57z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M260.21 253.34s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.5-.43.9-.37c.4.05.88.27.88.27l.11-.64c.09-.38-.17-.84-.17-.84",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M260.21 253.34s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.5-.43.9-.37c.4.05.88.27.88.27l.11-.64c.09-.38-.17-.84-.17-.84z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M261.65 256.08s-.04.8.34 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.8.06-.8.06",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M261.65 256.08s-.04.8.34 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.8.06-.8.06zM278.33 257.41s2.04 1.26 1.98 2.3c-.06 1.05-1.13 2.42-1.13 2.42",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M269 263.12s-.5-.64-1.21-.62c-.71.03-1.45.7-1.45.7s.88-.08 1.1.21c.24.3.46.67.46.67s.4-.21.57-.35c.17-.13.53-.61.53-.61",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M269 263.12s-.5-.64-1.21-.62c-.71.03-1.45.7-1.45.7s.88-.08 1.1.21c.24.3.46.67.46.67s.4-.21.57-.35c.17-.13.53-.61.53-.61z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M266.83 265.93s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56c.51.05 1.08.32 1.08.32s-.09-.53-.15-.78c-.05-.24-.2-.7-.2-.7",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M266.83 265.93s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56c.51.05 1.08.32 1.08.32s-.09-.53-.15-.78c-.05-.24-.2-.7-.2-.7z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M268.83 268.9s-.45.64-.1 1.15a2.3 2.3 0 0 0 1.04.75s-.26-.37-.14-.8c.09-.34.68-.8.68-.8l-1.48-.3",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M268.83 268.9s-.45.64-.1 1.15a2.3 2.3 0 0 0 1.04.75s-.26-.37-.14-.8c.09-.34.68-.8.68-.8l-1.48-.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M281.24 270.1s-.81-.18-1.27.09c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M281.24 270.1s-.81-.18-1.27.09c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M281.64 273.1s-.62.64-.4 1.18c.23.54.63 1.1.63 1.1s-.03-.8.22-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M281.64 273.1s-.62.64-.4 1.18c.23.54.63 1.1.63 1.1s-.03-.8.22-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M284.75 274.04s-.31.78.28 1.28c.6.51 1.1.57 1.1.57s-.45-.8-.3-1.23c.14-.45.53-.73.53-.73s-.74-.24-.85-.21c-.1.02-.76.32-.76.32",
      fill: "#db4446"
    }), r.createElement("path", {
      d: "M284.75 274.04s-.31.78.28 1.28c.6.51 1.1.57 1.1.57s-.45-.8-.3-1.23c.14-.45.53-.73.53-.73s-.74-.24-.85-.21c-.1.02-.76.32-.76.32z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M252.9 329.55c2.1.63 3.16 2.19 3.16 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.41-1.8-5.41-4.18 0-1.8 1-3.8 3.07-3.94 0 0-.06-.2-.24-.5l-.64-.66s.8-.15 1.25.02c.46.18.77.47.77.47s.21-.43.52-.76c.3-.33.7-.53.7-.53s.46.38.61.64c.15.27.25.59.25.59s.42-.35.8-.5c.36-.14.83-.25.83-.25s-.13.46-.22.69c-.1.23-.14.72-.14.72",
      fill: "#ffd691",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M250.32 340.32s-3.98-2.68-5.7-3.04c-2.2-.47-4.69-.1-5.76-.15.03.03 1.29.93 1.84 1.48.55.55 2.39 1.65 3.43 1.91 3.22.81 6.2-.2 6.2-.2M251.46 340.56s2.54-2.66 5.21-3.02c3.15-.44 5.22.26 6.44.58.03 0-1.01.5-1.56.87-.55.38-1.97 1.56-4.14 1.59-2.18.03-4.58-.23-4.98-.17l-.97.14",
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M250.7 337.28a5.05 5.05 0 0 1 0-7.43 5.05 5.05 0 0 1 0 7.43",
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M249.68 342.71s.61-1.52.67-2.83c.06-1.09-.15-2.17-.15-2.17h.8s.4 1.16.4 2.17c0 1.02-.2 2.37-.2 2.37s-.54.08-.72.17c-.19.09-.8.29-.8.29",
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: ".52"
    }), r.createElement("path", {
      d: "M300 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M300 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M301.5 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M301.5 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M302.5 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M302.5 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M302.63 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M302.63 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M301.82 186.4c0-.58.49-1.04 1.09-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M301.82 186.4c0-.58.49-1.04 1.09-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M300.13 183.45c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M300.13 183.45c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M297.88 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.03",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M297.88 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.03z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M295.26 179.01c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M295.26 179.01c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M292.14 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M292.14 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M288.9 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M288.9 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M285.28 175.54c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M285.28 175.54c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M281.84 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M281.84 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M278.47 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M278.47 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M275.1 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M275.1 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M276.79 178.37c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M277.47 181.57c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.6 0-1.1-.46-1.1-1.03M277.6 184.75c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M276.6 187.65c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04M274.73 190.31c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M272.54 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M272.54 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M269.55 171.81c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M269.55 171.81c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M266.25 170.82c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M266.25 170.82c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M262.81 170.23c0-.57.5-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.49 1.03-1.1 1.03-.6 0-1.09-.46-1.09-1.03",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M262.81 170.23c0-.57.5-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.49 1.03-1.1 1.03-.6 0-1.09-.46-1.09-1.03z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M259.45 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M259.45 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M255.95 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M255.95 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M252.7 172c0-.58.5-1.05 1.1-1.05.61 0 1.1.47 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M252.7 172c0-.58.5-1.05 1.1-1.05.61 0 1.1.47 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M197.84 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M197.84 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M196.34 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M196.34 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M195.34 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M195.34 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M195.22 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M195.22 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M196.03 186.4c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M196.03 186.4c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M197.71 183.45c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M197.71 183.45c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M199.97 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M199.97 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M202.58 179.01c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M202.58 179.01c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M205.7 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M205.7 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M208.94 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M208.94 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M212.57 175.54c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M212.57 175.54c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M216 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M216 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M219.38 175.48c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M219.38 175.48c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M222.75 175.48c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M222.75 175.48c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M221.06 178.37c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M220.38 181.57c0-.58.48-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.03-1.1 1.03-.6 0-1.1-.46-1.1-1.03M220.25 184.75c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04M221.25 187.65c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04M223.11 190.31c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M225.3 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M225.3 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M228.3 171.81c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M228.3 171.81c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M231.6 170.82c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M231.6 170.82c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M235.04 170.23c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.61 0-1.1-.46-1.1-1.03",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M235.04 170.23c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.61 0-1.1-.46-1.1-1.03z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M238.4 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M238.4 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M241.9 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M241.9 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M245.13 172c0-.58.5-1.05 1.1-1.05.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04",
      fill: "#fff"
    }), r.createElement("path", {
      d: "M245.13 172c0-.58.5-1.05 1.1-1.05.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".39"
    }), r.createElement("path", {
      d: "M217.34 238.41h-.92v-.92h-1.62v3.7h1.62v2.54h-3.47v7.4h1.85v14.78h-3.7v7.63h28.42v-7.63h-3.7v-14.79h1.86v-7.4h-3.47v-2.53h1.62v-3.7h-1.62v.92h-.93v-.92h-1.61v.92h-1.16v-.92h-1.62v3.7h1.62v2.54h-3.46v-8.1h1.84v-3.69h-1.84v.93h-.93v-.93h-1.62v.93h-.92v-.93h-1.85v3.7h1.85v8.09h-3.47v-2.54h1.62v-3.7h-1.62v.92h-.92v-.92h-1.85v.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.85h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.3h7.16m-12.47 7.85h3.7m-5.32-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.7-1.85v1.85m3.46-1.85v1.85m-1.85-1.85v-2.08m1.85-1.85v1.85m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.7-1.85v1.85m-1.61-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.7-1.85v1.85m-1.61-3.7v1.85m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.84 1.85v1.85m-3.46 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.85v1.85m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.54v-1.84m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.7m3.46-5.54h3.47m3.46 5.55h3.7",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".46"
    }), r.createElement("path", {
      d: "M230.05 273.54v-4.86c0-.92-.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".46"
    }), r.createElement("path", {
      d: "M222.2 268.91l-2.32-.23c0-.92.23-2.3.93-2.77l2.08 1.62c-.23.23-.7.92-.7 1.38zM228.43 268.91l2.31-.23c0-.92-.23-2.3-.92-2.77l-2.08 1.62c.23.23.7.92.7 1.38zM226.12 266.6l1.16-2.08a5.52 5.52 0 0 0-2.08-.46c-.46 0-1.39.23-1.85.46l1.15 2.08h1.62zM221.73 260.83v-5.09c0-1.38-.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08zM228.9 260.83v-5.09c0-1.38.92-2.54 2.54-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09zM227.05 248.35l.46-4.62h-4.4l.24 4.62h3.7zM230.51 248.35l-.46-4.62h4.62l-.46 4.62h-3.7zM220.11 248.35l.23-4.62h-4.39l.47 4.62h3.7z",
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: ".46"
    }), r.createElement("path", {
      d: "M228.43 273.54v-4.17c0-.69-.46-2.77-3.23-2.77a2.8 2.8 0 0 0-3 2.77v4.17h6.23zM221.27 260.36v-4.39c0-1.15-.7-2.3-2.08-2.3-1.39 0-2.08 1.15-2.08 2.3v4.4h4.16zM229.36 260.36v-4.39c0-1.15.69-2.3 2.08-2.3 1.38 0 2.08 1.15 2.08 2.3v4.4h-4.16z",
      fill: "#0039f0"
    }), r.createElement("path", {
      d: "M234.18 281c0-10.1 7.27-18.29 16.25-18.29s16.26 8.2 16.26 18.3c0 10.1-7.28 18.29-16.26 18.29s-16.25-8.2-16.25-18.3",
      fill: "#ad1519"
    }), r.createElement("path", {
      d: "M234.18 281c0-10.1 7.27-18.29 16.25-18.29s16.26 8.2 16.26 18.3c0 10.1-7.28 18.29-16.26 18.29s-16.25-8.2-16.25-18.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".61"
    }), r.createElement("path", {
      d: "M239 280.97c0-7.4 5.12-13.41 11.44-13.41 6.31 0 11.43 6 11.43 13.41s-5.12 13.42-11.43 13.42c-6.32 0-11.44-6-11.44-13.42",
      fill: "#005bbf"
    }), r.createElement("path", {
      d: "M239 280.97c0-7.4 5.12-13.41 11.44-13.41 6.31 0 11.43 6 11.43 13.41s-5.12 13.42-11.43 13.42c-6.32 0-11.44-6-11.44-13.42z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".61"
    }), r.createElement("path", {
      d: "M245.03 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.5.99c.15-.37.53-.57.97-.57.6 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05H246a1.04 1.04 0 0 1 1.04-1.26c.44 0 .82.2.99.57l.48-.99c.1-.2.24-.55.24-.77 0-.79-.66-1.42-1.5-1.42-.65 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M245.03 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.5.99c.15-.37.53-.57.97-.57.6 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05H246a1.04 1.04 0 0 1 1.04-1.26c.44 0 .82.2.99.57l.48-.99c.1-.2.24-.55.24-.77 0-.79-.66-1.42-1.5-1.42-.65 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".34"
    }), r.createElement("path", {
      d: "M242.87 281.11h4.36v-1.04h-4.36v1.04z",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M242.87 281.11h4.36v-1.04h-4.36v1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".34"
    }), r.createElement("path", {
      d: "M255.66 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.6 0 1.07.45 1.07 1.01 0 .09 0 .17-.03.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05h-1.22a.88.88 0 0 1-.03-.25c0-.56.48-1 1.07-1 .44 0 .82.2.98.56l.49-.99c.1-.2.24-.55.24-.77 0-.79-.67-1.42-1.5-1.42-.64 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M255.66 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.6 0 1.07.45 1.07 1.01 0 .09 0 .17-.03.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05h-1.22a.88.88 0 0 1-.03-.25c0-.56.48-1 1.07-1 .44 0 .82.2.98.56l.49-.99c.1-.2.24-.55.24-.77 0-.79-.67-1.42-1.5-1.42-.64 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".34"
    }), r.createElement("path", {
      d: "M253.5 281.11h4.35v-1.04h-4.35v1.04z",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M253.5 281.11h4.35v-1.04h-4.35v1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".34"
    }), r.createElement("path", {
      d: "M250.35 280.88s-1.36 1.49-1.36 2.87c0 1.38.57 2.53.57 2.53a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .23.14.58.25.78l.48.98c.17-.36.54-.57.99-.57.59 0 1.07.45 1.07 1.02a.9.9 0 0 1-.03.25h-1.22v1.04h1.09l-.81 1.6 1.07-.42.8.91.85-.9 1.07.41-.81-1.6h1.09v-1.04h-1.22a.94.94 0 0 1-.03-.25c0-.57.47-1.02 1.07-1.02.44 0 .81.2.98.57l.49-.98c.1-.2.24-.55.24-.78 0-.79-.67-1.42-1.5-1.42-.65 0-1.2.4-1.41.94 0 0 .57-1.15.57-2.53s-1.39-2.87-1.39-2.87",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M250.35 280.88s-1.36 1.49-1.36 2.87c0 1.38.57 2.53.57 2.53a1.5 1.5 0 0 0-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .23.14.58.25.78l.48.98c.17-.36.54-.57.99-.57.59 0 1.07.45 1.07 1.02a.9.9 0 0 1-.03.25h-1.22v1.04h1.09l-.81 1.6 1.07-.42.8.91.85-.9 1.07.41-.81-1.6h1.09v-1.04h-1.22a.94.94 0 0 1-.03-.25c0-.57.47-1.02 1.07-1.02.44 0 .81.2.98.57l.49-.98c.1-.2.24-.55.24-.78 0-.79-.67-1.42-1.5-1.42-.65 0-1.2.4-1.41.94 0 0 .57-1.15.57-2.53s-1.39-2.87-1.39-2.87z",
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: ".34"
    }), r.createElement("path", {
      d: "M248.19 290.26h4.35v-1.04h-4.35v1.04z",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M248.19 290.26h4.35v-1.04h-4.35v1.04z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".34"
    }), r.createElement("path", {
      d: "M282.88 232.7l-.29.03c-.01.03-.14.24-.26.35-.26.25-.64.27-.86.07a.5.5 0 0 1-.14-.4.52.52 0 0 1-.51-.02c-.26-.14-.32-.5-.14-.8.03-.05.06-.13.1-.17l-.01-.32-.35.08-.1.2c-.22.24-.54.3-.7.16a.58.58 0 0 1-.13-.27c0 .01-.09.09-.18.1-.53.14-.74-1.04-.76-1.34l-.17.25s.16.7.08 1.3c-.08.6-.3 1.2-.3 1.2.75.18 1.87.79 2.98 1.64a9.39 9.39 0 0 1 2.35 2.42s.57-.32 1.17-.5c.6-.2 1.36-.2 1.36-.2l.22-.22c-.32.05-1.59.1-1.56-.43 0-.08.07-.18.08-.18 0 .01-.21 0-.3-.06-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.1.09-.15.13-.27.23-.65.25-.86.03a.44.44 0 0 1-.11-.46.57.57 0 0 1-.45-.05c-.26-.15-.31-.52-.11-.8.1-.14.28-.3.3-.32l-.06-.3",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M282.88 232.7l-.29.03c-.01.03-.14.24-.26.35-.26.25-.64.27-.86.07a.5.5 0 0 1-.14-.4.52.52 0 0 1-.51-.02c-.26-.14-.32-.5-.14-.8.03-.05.06-.13.1-.17l-.01-.32-.35.08-.1.2c-.22.24-.54.3-.7.16a.58.58 0 0 1-.13-.27c0 .01-.09.09-.18.1-.53.14-.74-1.04-.76-1.34l-.17.25s.16.7.08 1.3c-.08.6-.3 1.2-.3 1.2.75.18 1.87.79 2.98 1.64a9.39 9.39 0 0 1 2.35 2.42s.57-.32 1.17-.5c.6-.2 1.36-.2 1.36-.2l.22-.22c-.32.05-1.59.1-1.56-.43 0-.08.07-.18.08-.18 0 .01-.21 0-.3-.06-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.1.09-.15.13-.27.23-.65.25-.86.03a.44.44 0 0 1-.11-.46.57.57 0 0 1-.45-.05c-.26-.15-.31-.52-.11-.8.1-.14.28-.3.3-.32l-.06-.3z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M280.63 233.4c.05-.07.16-.06.23 0 .08.06.1.16.06.21-.05.06-.15.06-.24 0-.07-.06-.1-.16-.05-.22"
    }), r.createElement("path", {
      d: "M280.63 233.4c.05-.07.16-.06.23 0 .08.06.1.16.06.21-.05.06-.15.06-.24 0-.07-.06-.1-.16-.05-.22z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M281.58 234.2l-.33-.26c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.32.26.34.25c.06.04.08.12.04.16-.04.04-.12.04-.18 0l-.33-.26"
    }), r.createElement("path", {
      d: "M281.58 234.2l-.33-.26c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.32.26.34.25c.06.04.08.12.04.16-.04.04-.12.04-.18 0l-.33-.26",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M279.84 233l-.26-.15c-.07-.04-.1-.12-.07-.16.03-.06.1-.07.17-.03l.26.16.26.15c.06.03.1.1.07.16-.03.05-.1.06-.17.02l-.26-.15"
    }), r.createElement("path", {
      d: "M279.84 233l-.26-.15c-.07-.04-.1-.12-.07-.16.03-.06.1-.07.17-.03l.26.16.26.15c.06.03.1.1.07.16-.03.05-.1.06-.17.02l-.26-.15",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M278.8 232.29c.05-.06.16-.06.24 0 .08.06.1.16.05.22-.05.05-.15.05-.23 0-.08-.07-.1-.16-.06-.22"
    }), r.createElement("path", {
      d: "M278.8 232.29c.05-.06.16-.06.24 0 .08.06.1.16.05.22-.05.05-.15.05-.23 0-.08-.07-.1-.16-.06-.22z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M282.63 234.93c.05-.06.02-.15-.05-.22-.08-.06-.19-.06-.23 0-.05.05-.03.15.05.21s.18.06.23 0"
    }), r.createElement("path", {
      d: "M282.63 234.93c.05-.06.02-.15-.05-.22-.08-.06-.19-.06-.23 0-.05.05-.03.15.05.21s.18.06.23 0z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M283.2 235.58l.22.2c.05.06.13.08.18.04.04-.04.04-.11-.01-.16l-.21-.2-.22-.22c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21"
    }), r.createElement("path", {
      d: "M283.2 235.58l.22.2c.05.06.13.08.18.04.04-.04.04-.11-.01-.16l-.21-.2-.22-.22c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M284.15 236.4c.05-.07.03-.16-.05-.22-.08-.07-.18-.07-.23 0-.05.05-.03.14.05.2s.18.07.23.01"
    }), r.createElement("path", {
      d: "M284.15 236.4c.05-.07.03-.16-.05-.22-.08-.07-.18-.07-.23 0-.05.05-.03.14.05.2s.18.07.23.01z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M281.4 230.35l-.59.02-.11.87.06.14h.15l.76-.52-.27-.5",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M281.4 230.35l-.59.02-.11.87.06.14h.15l.76-.52-.27-.5",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M279.8 230.84l-.02.54.92.12.15-.07-.02-.15-.53-.7-.5.26",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M279.8 230.84l-.02.54.92.12.15-.07-.02-.15-.53-.7-.5.26",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M281.7 231.92l-.5.27-.53-.71v-.15l.13-.06.93.11-.03.54",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M281.7 231.92l-.5.27-.53-.71v-.15l.13-.06.93.11-.03.54",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M280.51 231.25a.3.3 0 0 1 .4-.1c.13.08.17.25.1.38a.3.3 0 0 1-.4.1.27.27 0 0 1-.1-.38",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M280.51 231.25a.3.3 0 0 1 .4-.1c.13.08.17.25.1.38a.3.3 0 0 1-.4.1.27.27 0 0 1-.1-.38z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M278.36 230.35c-.01 0-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.06.42-.2.87.1.38.3-.03.86-.03.86s-.1.14-.19.18",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M278.36 230.35c-.01 0-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.06.42-.2.87.1.38.3-.03.86-.03.86s-.1.14-.19.18z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M279.4 230.66l-.43.37-.68-.6.06-.08.02-.15.93-.07.1.53",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M279.4 230.66l-.43.37-.68-.6.06-.08.02-.15.93-.07.1.53",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M278.24 230.3c.05-.16.18-.24.28-.21.1.04.15.18.1.33-.05.15-.18.23-.29.2-.1-.03-.15-.18-.1-.33",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M278.24 230.3c.05-.16.18-.24.28-.21.1.04.15.18.1.33-.05.15-.18.23-.29.2-.1-.03-.15-.18-.1-.33z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M283.67 231.77l-.6-.06-.24.85.05.14h.15l.83-.4-.2-.53",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M283.67 231.77l-.6-.06-.24.85.05.14h.15l.83-.4-.2-.53",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M282 232.03l-.09.54.9.24.15-.05v-.14l-.42-.79-.53.2",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M282 232.03l-.09.54.9.24.15-.05v-.14l-.42-.79-.53.2",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M283.73 233.35l-.53.22-.42-.79.01-.15.15-.03.9.23-.1.52",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M283.73 233.35l-.53.22-.42-.79.01-.15.15-.03.9.23-.1.52",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M282.65 232.54c.1-.12.28-.13.4-.04.13.1.15.26.05.38a.3.3 0 0 1-.4.04.26.26 0 0 1-.05-.38",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M282.65 232.54c.1-.12.28-.13.4-.04.13.1.15.26.05.38a.3.3 0 0 1-.4.04.26.26 0 0 1-.05-.38z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M285.64 233.6l.11.56-.87.3-.15-.03-.02-.15.36-.8.57.13",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M285.64 233.6l.11.56-.87.3-.15-.03-.02-.15.36-.8.57.13",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M285.49 235.2l-.56.13-.31-.84.03-.14.16-.02.85.35-.17.52",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M285.49 235.2l-.56.13-.31-.84.03-.14.16-.02.85.35-.17.52",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M283.97 233.66l-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M283.97 233.66l-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M284.91 234.63c.12-.11.12-.28.02-.4a.31.31 0 0 0-.41 0 .27.27 0 0 0-.01.38c.1.11.29.12.4.02",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M284.91 234.63c.12-.11.12-.28.02-.4a.31.31 0 0 0-.41 0 .27.27 0 0 0-.01.38c.1.11.29.12.4.02z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M286.29 236.43c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.11-.42-.28-.78-.4-.29-.88.2-.88.2s-.12.13-.15.22",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M286.29 236.43c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.11-.42-.28-.78-.4-.29-.88.2-.88.2s-.12.13-.15.22z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M285.75 235.53l-.29.47.76.51.1-.08.12-.04-.12-.88-.57.03",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M285.75 235.53l-.29.47.76.51.1-.08.12-.04-.12-.88-.57.03",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M286.37 236.53c.14-.07.2-.22.15-.3-.06-.1-.22-.1-.36-.03-.14.08-.2.22-.14.31.05.1.21.1.35.02",
      fill: "#c8b100"
    }), r.createElement("path", {
      d: "M286.37 236.53c.14-.07.2-.22.15-.3-.06-.1-.22-.1-.36-.03-.14.08-.2.22-.14.31.05.1.21.1.35.02z",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26"
    }), r.createElement("path", {
      d: "M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.59h.62v-.57h.6v.57h.62v.59h-.61v1.3h.98",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".3"
    }), r.createElement("path", {
      d: "M175.44 226.15v-1.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".02"
    }), r.createElement("path", {
      d: "M175.1 226.15v-1.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".03"
    }), r.createElement("path", {
      d: "M174.77 226.15v-1.27M174.44 226.15v-1.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".04"
    }), r.createElement("path", {
      d: "M174.16 226.15v-1.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M173.6 226.08v-1.15m.27 1.17v-1.21",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".06"
    }), r.createElement("path", {
      d: "M173.1 226.03v-1.06m.26 1.09v-1.13",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".07"
    }), r.createElement("path", {
      d: "M172.43 225.97v-.94m.22.95v-.97m.23 1V225",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".08"
    }), r.createElement("path", {
      d: "M172.19 225.96v-.9",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".09"
    }), r.createElement("path", {
      d: "M171.97 225.92v-.85",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".1"
    }), r.createElement("path", {
      d: "M171.73 225.9v-.79",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".11"
    }), r.createElement("path", {
      d: "M171.24 225.82v-.62m.25.66v-.7M171 225.77v-.55",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".12"
    }), r.createElement("path", {
      d: "M170.76 225.73v-.46",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".13"
    }), r.createElement("path", {
      d: "M170.51 225.67v-.36",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".14"
    }), r.createElement("path", {
      d: "M170.26 225.64v-.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".15"
    }), r.createElement("path", {
      d: "M169.99 225.58v-.13",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".18"
    }), r.createElement("path", {
      d: "M176.8 226.08v-1.16m-.58 1.2v-1.23m-.42 1.25v-1.26",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".01"
    }), r.createElement("path", {
      d: "M324.77 226.17v-1.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".02"
    }), r.createElement("path", {
      d: "M324.42 226.17v-1.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".03"
    }), r.createElement("path", {
      d: "M324.1 226.17v-1.27M323.78 226.17v-1.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".04"
    }), r.createElement("path", {
      d: "M323.49 226.17v-1.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".05"
    }), r.createElement("path", {
      d: "M322.94 226.1v-1.15m.26 1.17v-1.2",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".06"
    }), r.createElement("path", {
      d: "M322.44 226.05V225m.25 1.1v-1.14",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".07"
    }), r.createElement("path", {
      d: "M321.76 226v-.94m.22.95v-.98m.23 1v-1.01",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".08"
    }), r.createElement("path", {
      d: "M321.52 225.98v-.9",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".09"
    }), r.createElement("path", {
      d: "M321.3 225.94v-.84",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".1"
    }), r.createElement("path", {
      d: "M321.06 225.91v-.78",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".11"
    }), r.createElement("path", {
      d: "M320.57 225.85v-.63m.25.66v-.7M320.32 225.8v-.55",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".12"
    }), r.createElement("path", {
      d: "M320.1 225.75v-.46",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".13"
    }), r.createElement("path", {
      d: "M319.85 225.69v-.36",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".14"
    }), r.createElement("path", {
      d: "M319.6 225.66v-.27",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".15"
    }), r.createElement("path", {
      d: "M319.32 225.6v-.13",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".18"
    }), r.createElement("path", {
      d: "M326.14 226.1v-1.16m-.58 1.2v-1.23m-.43 1.25v-1.26",
      fill: "none",
      stroke: "#000",
      strokeWidth: ".01"
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  t.FlagIE = function (_ref2) {
    var e = _ref2.width,
      t = _ref2.height;
    return r.createElement("svg", {
      preserveAspectRatio: "none",
      height: t,
      width: e,
      viewBox: "0 0 600 300"
    }, r.createElement("defs", {
      id: "defs4"
    }), r.createElement("g", {
      id: "layer1",
      transform: "translate(0,-752.36216)"
    }, r.createElement("rect", {
      fill: "#169b62",
      stroke: "none",
      fillOpacity: "1",
      id: "rect4148",
      width: "200",
      height: "300",
      x: "0",
      y: "752.36218"
    }), r.createElement("rect", {
      fill: "#ffffff",
      stroke: "none",
      fillOpacity: "1",
      id: "rect4150",
      width: "200",
      height: "300",
      x: "200",
      y: "752.36212"
    }), r.createElement("rect", {
      fill: "#ff883e",
      stroke: "none",
      fillOpacity: "1",
      id: "rect4152",
      width: "200",
      height: "300",
      x: "400",
      y: "752.36218"
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  t.FlagKH = function (_ref3) {
    var e = _ref3.width,
      t = _ref3.height;
    return r.createElement("svg", {
      preserveAspectRatio: "none",
      height: t,
      width: e,
      viewBox: "0 0 625 400"
    }, r.createElement("rect", {
      width: "625",
      height: "400",
      fill: "#032ea1"
    }), r.createElement("rect", {
      width: "625",
      height: "200",
      y: "100",
      fill: "#e00025"
    }), r.createElement("g", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "0.96",
      transform: "translate(117.14286,-434.9336)"
    }, r.createElement("g", {
      strokeLinejoin: "bevel"
    }, r.createElement("path", {
      d: "m139.02,623.46,113.8,0,0,43.788-113.8,0z"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "246.95",
      y: "647.64"
    }), r.createElement("rect", {
      width: "113.8",
      height: "5.0903",
      x: "139.02",
      y: "639.49"
    }), r.createElement("rect", {
      width: "113.8",
      height: "4.489",
      x: "139.02",
      y: "632.59"
    }), r.createElement("rect", {
      strokeWidth: "0.94545",
      width: "113.8",
      height: "4.354",
      x: "139.02",
      y: "625.7"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "168.98",
      y: "647.64"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "217.97",
      y: "647.64"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "139.92",
      y: "647.64"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "146.95",
      y: "647.64"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "154.45",
      y: "647.64"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "161.95",
      y: "647.64"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "224.77",
      y: "647.64"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "232.27",
      y: "647.64"
    }), r.createElement("rect", {
      width: "3.5864",
      height: "16.495",
      x: "239.77",
      y: "647.64"
    }), r.createElement("path", {
      strokeLinejoin: "miter",
      d: "m94.509,669.55c1.7604-0.89672,3.7684-2.9836,4.425-5.319h193.07c0.65665,2.3354,2.6647,4.4222,4.425,5.319z"
    })), r.createElement("g", null, r.createElement("g", null, r.createElement("path", {
      d: "m193,556.8s-0.14437-4.1125,2.2507-4.1572c2.3951,0.0447,2.2507,4.1572,2.2507,4.1572z"
    }), r.createElement("path", {
      d: "m180.51,611.34,0-5.5357c-0.0789-2.768-2.7591-2.9681-2.838-4.9862,0,0-0.34606-3.0266,0.45159-4.4082,1.0845,4.0474,3.0561,3.3039,3.0561,1.6397,0-1.4526-1.117-2.8031-3.408-6.3302-0.73206-1.127-0.27901-4.6597,0.74692-5.9224,0.39808,3.0709,0.85311,4.5398,2.1717,4.5398,0.80428,0,1.4612-0.52417,1.4612-2.0621,0-1.9565-1.325-2.9445-1.9762-4.725-0.76004-2.0777-0.23675-4.1957,1.0259-5.3795,0.54129,3.0293,0.38028,4.2372,1.7255,4.2372,2.7133-0.8584,0.00063-4.7866-0.57911-5.7773-0.667-1.1553,0.89682-3.4598,0.89682-3.4598,0.86209,2.6898,1.1394,2.909,2.0699,2.6597,1.1738-0.31452,1.0224-2.056-0.40996-3.4633-0.90449-0.88866-0.80857-2.2116,0.16248-3.274,0.97489,1.9056,2.2229,1.7898,2.343,0.65821l-0.78373-4.3931h17.255l-0.85683,4.2488c-0.24526,1.2162,1.396,1.4801,2.4162-0.51392,0.97105,1.0624,1.067,2.3854,0.16248,3.274-1.4323,1.4073-1.5837,3.1488-0.40996,3.4633,0.93041,0.2493,1.2078,0.0302,2.0699-2.6597,0,0,1.403,1.5708,0.89682,3.4598-0.57974,0.99071-3.2924,4.9189-0.57911,5.7773,1.3453,0,1.1842-1.2079,1.7255-4.2372,1.2627,1.1838,1.786,3.3017,1.0259,5.3795-0.65127,1.7804-1.9762,2.7685-1.9762,4.725,0,1.538,0.65688,2.0621,1.4612,2.0621,1.3186,0,1.7736-1.4689,2.1717-4.5398,1.0259,1.2627,1.479,4.7953,0.74692,5.9224-2.291,3.527-3.408,4.8776-3.408,6.3302,0,1.6641,1.9716,2.4076,3.0561-1.6397,0.79765,1.3816,0.4516,4.4082,0.4516,4.4082-0.0789,2.018-2.7591,2.2182-2.838,4.9862v5.5357z"
    }), r.createElement("path", {
      d: "m187.73,565.32-0.39721-3.125,15.838,0-0.39721,3.125z"
    }), r.createElement("path", {
      d: "m188.79,562.13-0.34117-2.5686,13.604,0-0.34117,2.5686z"
    }), r.createElement("path", {
      d: "m190.95,559.47-0.22717-2.5686,9.0585,0-0.22718,2.5686z"
    }), r.createElement("path", {
      d: "m223.97,669.55c-2.0266-0.78125-4.9773-2.9188-4.9773-5.0695v-24.297l2.6385-3.3588-52.776,0.00008,2.5293,3.3588v24.297c0,2.1508-2.0264,4.2883-4.0529,5.0695z"
    }), r.createElement("rect", {
      strokeLinejoin: "bevel",
      width: "3.5864",
      height: "16.495",
      x: "178.24",
      y: "647.64"
    }), r.createElement("rect", {
      strokeLinejoin: "bevel",
      width: "3.5864",
      height: "16.495",
      x: "208.56",
      y: "647.64"
    }), r.createElement("path", {
      d: "m167.91,609.17,0,14.648,0,7.0117,0,5.9961,54.023,0,0-5.957,0.0783-21.699c-2.2097,0.8681-2.5976,2.8711-2.5976,2.8711v11.777h-48.75v-11.777s-0.5442-2.003-2.7539-2.8711z"
    }), r.createElement("path", {
      d: "m214.6,669.55c-1.7655-0.78125-5.6118-2.9188-5.6118-5.0695v-27.192c0.37751-1.518,2.436-2.414,3.761-3.3588h-35.823c1.7049,0.90271,3.6054,1.6522,4.2846,3.3588v27.192c0,2.1508-3.041,4.2883-4.8065,5.0695z"
    }), r.createElement("path", {
      d: "m219.41,634.22-0.00027-19.587-4.9104-0.00008,0-1.9085-38.839,0,0,1.9085-4.9109-0.00018,0.00017,19.587z"
    }), r.createElement("path", {
      d: "m206.86,669.55c-1.7299-0.78125-4.2489-2.9186-4.2489-5.0694v-23.215l1.4205-2.1088h-17.691l1.4205,2.109v23.215c0,2.1508-2.5189,4.2883-4.2488,5.0695z"
    }), r.createElement("path", {
      strokeWidth: "0.981",
      d: "m190.71,639.16,8.9655-0.00005,0,30.377-8.9655,0z"
    }), r.createElement("path", {
      strokeLinejoin: "bevel",
      d: "m204.38,632.48c0.0215-2.0012,5.8375-2.091,8.8318-3.7949h-35.952c2.9943,1.7039,8.6755,1.8441,8.6755,3.7949l1.2166,3.8818,14.883,0.59776z"
    }), r.createElement("path", {
      d: "m211.41,611.34c0-4.8986,0.20532-6.7857,1.7103-6.7857l0.00001,15.58c-3.6912,1.3393-6.3254,6.0491-6.3254,6.0491l-23.211-0.00027s-2.6342-4.7096-6.3254-6.0488v-15.58c1.856,0,1.8682,1.9717,1.8682,6.7857z"
    }), r.createElement("path", {
      d: "m213.12,609.33c0-5.6184,4.8512-6.2503,4.8512-6.2503v5c-1.8465-0.0789-2.7368,1.578-2.7368,4.0444,0,2.4663,1.4868,2.5056,1.4868,2.5056v14.19h-3.6012z"
    }), r.createElement("path", {
      d: "m177.28,609.33c0-5.6184-4.8512-6.2503-4.8512-6.2503v5c1.8465-0.0789,2.7368,1.578,2.7368,4.0444,0,2.4663-1.4868,2.5056-1.4868,2.5056v14.19h3.6012z"
    })), r.createElement("g", {
      fill: "none",
      strokeWidth: "0.8"
    }, r.createElement("path", {
      d: "m186.84,570.62h17.128"
    }), r.createElement("path", {
      d: "m184.81,575.97h20.921"
    }), r.createElement("path", {
      d: "m182.78,582.46h24.904"
    }), r.createElement("path", {
      d: "m180.66,590.39h29.536"
    }), r.createElement("path", {
      d: "m179.98,599.43h30.426"
    }), r.createElement("path", {
      strokeWidth: "0.96",
      d: "m170.75,628.92h48.661"
    }), r.createElement("rect", {
      strokeWidth: "0.96",
      width: "18.036",
      height: "6.6291",
      x: "186.19",
      y: "628.93"
    })), r.createElement("g", null, r.createElement("path", {
      d: "m183.93,614.24c2.9903,3.59,2.7128,9.6801,2.6786,13.27h17.343c-0.0342-3.59-0.31172-9.68,2.6786-13.27z"
    }), r.createElement("path", {
      d: "m193.68,573.11-2.3764-1.2239,0-3.4974c0.97149,0.29214,2.062,0.41142,2.1686,1.9595,0.33824-2.2099,0.94822-2.1018,1.9064-2.963,0.95814,0.86127,1.5681,0.75315,1.9064,2.963,0.10661-1.5481,1.1971-1.6674,2.1686-1.9595v3.4974l-2.3764,1.2239z"
    }), r.createElement("path", {
      d: "m193.52,578.85-3.9464-2.7128,0-3.2231c1.3836,0.32035,2.9366,0.45115,3.0885,2.1488,0.48172-2.4232,1.3504-3.6754,2.715-4.6198,1.3646,0.94444,2.2332,2.1966,2.715,4.6198,0.15183-1.6976,1.7049-1.8284,3.0885-2.1488v3.2231l-3.9464,2.7128z"
    }), r.createElement("path", {
      d: "m193.24,587.8-4.5378-3.9854,0-4.7351c1.5909,0.47062,3.3767,0.66279,3.5513,3.1567,0.55391-3.56,1.5528-5.3995,3.1218-6.787,1.569,1.3875,2.5679,3.227,3.1218,6.787,0.17458-2.4939,1.9604-2.6861,3.5513-3.1567v4.7351l-4.5378,3.9854z"
    }), r.createElement("path", {
      d: "m201.61,593.09-4.1037,5.6759-4.6463,0-4.1037-5.6759z"
    }), r.createElement("path", {
      d: "m186.39,602.62c2.0526,1.1219,2.8106,3.3568,3.0299,7.5527h11.55c0.21927-4.1959,0.97728-6.4308,3.0298-7.5527z"
    }), r.createElement("path", {
      strokeLinejoin: "bevel",
      d: "m204.17,593.09,0-5.7018c-1.9498,0.53675-3.2129,1.6912-3.7755,3.2577,0-1.8927-2.4906-6.2573-5.2071-8.4294-2.7242,2.4314-5.2575,6.3801-5.2066,8.4294-0.46332-1.4918-1.8258-2.7209-3.7755-3.2577v5.702z"
    }), r.createElement("path", {
      strokeLinejoin: "bevel",
      d: "m205.04,602.62-0.00021-5.7022c-2.1373,0.53675-3.522,1.6912-4.1387,3.2577,0-1.8927-2.7299-6.2573-5.7077-8.4294-2.9863,2.4314-5.7635,6.3801-5.7077,8.4294-0.50788-1.4918-2.0014-2.7209-4.1387-3.2577v5.702z"
    }), r.createElement("path", {
      strokeLinejoin: "bevel",
      d: "m207.44,614.32,0-6.5765c-2.6591,0.68624-4.3124,2.653-5.1491,3.7996,0-3.5614-4.0212-8.9902-7.1011-10.768-3.1599,1.8244-7.1011,7.435-7.1011,10.768-0.85883-1.1395-2.49-3.1134-5.1491-3.7996v6.5765z"
    }), r.createElement("path", {
      strokeLinejoin: "bevel",
      d: "m206,628.92,0-6.7617c-2.3465,0.9193-3.0479,3.1802-3.7862,4.7163,0.28981-6.8584-3.8614-14.23-7.0239-16.1-3.1624,1.8699-7.3926,9.3996-7.0239,16.1-0.75787-1.5265-1.4397-3.797-3.7862-4.7163v6.7618z"
    }), r.createElement("path", {
      d: "m204.36,639.16,0-6.7618c-2.4581,0.58449-2.61,1.491-3.3916,3.0055,0.28981-4.0963-2.6114-8.7695-5.7739-10.639-3.1624,1.8699-6.0637,6.5431-5.7739,10.639-0.78168-1.5145-0.87771-2.421-3.3916-3.0055v6.7618z"
    }))), r.createElement("g", {
      id: "tower"
    }, r.createElement("g", null, r.createElement("path", {
      d: "m98.935,664.23,0-20.44c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-17.993l3.7418,2.0232,4.2712,18.811v22.965z"
    }), r.createElement("path", {
      d: "m98.935,664.31,0-20.519c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-19.243c2.5118,0,3.7418,3.2732,3.7418,3.2732l4.2712,18.811v22.886z"
    }), r.createElement("path", {
      d: "m96.275,669.55c1.7299-0.78125,4.2487-2.9188,4.2487-5.0695v-25.547l-1.1852-2.1088h43.522l-1.6983,2.1088v25.547c0,2.1508,1.7297,4.2883,3.4596,5.0695z"
    }), r.createElement("path", {
      d: "m135.84,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-24.297l3.619-3.359-29.588,0.00008,3.6191,3.3589v24.297c0,2.1508-2.5189,4.2883-4.2488,5.0695z"
    }), r.createElement("path", {
      d: "m131.69,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-21.965l2.369-3.359h-18.798l2.3688,3.359v21.965c0,2.1508-2.5189,4.2883-4.2488,5.0695z"
    }), r.createElement("path", {
      d: "m115.92,639.16,8.9819-0.00004-0.00002,30.393-8.9818,0z"
    }), r.createElement("rect", {
      strokeLinejoin: "bevel",
      width: "3.5864",
      height: "16.495",
      x: "103.7",
      y: "647.64"
    }), r.createElement("rect", {
      strokeLinejoin: "bevel",
      width: "3.5864",
      height: "16.495",
      x: "134.45",
      y: "647.64"
    }), r.createElement("path", {
      strokeLinejoin: "bevel",
      d: "m100.64,619.82h4.3202v16.909h-4.3202z"
    }), r.createElement("path", {
      strokeLinejoin: "bevel",
      d: "m100.64,616.64h4.2946v3.1387h-4.2946z"
    }), r.createElement("path", {
      strokeWidth: "1.0337",
      strokeLinejoin: "bevel",
      d: "m136.17,623.46h6.1594v13.054h-6.1594z"
    }), r.createElement("path", {
      d: "m104.89,636.6,0-28.941c1.2321,0,1.4222,4.2418,4.249,4.2418,1.4716,0,1.3152-1.757,0.4889-3.1882-0.73168-1.2673-1.6372-3.0176-0.40702-6.2783,0.84298,2.4949,3.1119,3.2866,2.6927,1.722-0.72042-2.6886-2.7945-3.1298-1.2383-7.3021,0.54049,3.4806,2.7732,3.3273,2.2309,1.3034-0.61083-2.2796-1.8732-3.2139-0.3157-6.4275,0.87209,3.6492,2.0519,3.4352,2.0519,1.1711,0-3.347-0.1285-6.9568,4.2027-8.296,0,0,0.25002-3.0682,1.8123-3.0682s1.8123,3.0682,1.8123,3.0682c4.3312,1.3393,4.2027,4.949,4.2027,8.296,0,2.264,1.1798,2.4781,2.0519-1.1711,1.5574,3.2136,0.29513,4.1479-0.3157,6.4275-0.54227,2.0238,1.6904,2.1772,2.2309-1.3034,1.5562,4.1722-0.5179,4.6134-1.2383,7.3021-0.41923,1.5646,1.8497,0.77297,2.6927-1.722,1.2302,3.2606,0.32466,5.011-0.40702,6.2783-0.82627,1.4311-0.98274,3.1882,0.4889,3.1882,2.8268,0,3.0168-4.2418,4.249-4.2418v28.941z"
    }), r.createElement("path", {
      d: "m98.124,614.74,0.000081,22.079,2.5111,0-0.00019-22.135c-0.90498-0.45686-1.7546-0.5274-2.511,0.0558z"
    }), r.createElement("path", {
      d: "m98.203,629.03c3.1124,1.5914,6.1949,3.4325,6.9754,7.7931h-6.9754z"
    }), r.createElement("path", {
      d: "m141.37,622.42,0.00006,14.407,2.0354,0,0-14.443c-0.63587-0.2981-1.5039-0.34413-2.0354,0.0364z"
    }), r.createElement("path", {
      d: "m143.41,628.92c-3.1124,1.5914-6.1949,3.4325-6.9754,7.7931h6.9754z"
    })), r.createElement("g", null, r.createElement("path", {
      d: "m122.83,595.27,1.8142-1.5247,0-1.9528c-0.6637,0.0645-1.0258,0.29275-1.516,0.93531-0.41694-1.2944-1.3337-2.3051-2.5624-2.9327-1.2287,0.6276-2.1454,1.5924-2.5624,2.8867-0.49022-0.64256-0.8523-0.8249-1.516-0.88935v1.9528l1.8142,1.5247z"
    }), r.createElement("path", {
      d: "m123.8,600.16,0.8432-1.8253,0-2.5384c-0.6637,0.0654-1.0258,0.29688-1.516,0.94855-0.41694-1.3127-1.3337-2.3377-2.5624-2.9742-1.2287,0.63649-2.1454,1.6149-2.5624,2.9276-0.49022-0.65166-0.8523-0.83658-1.516-0.90194v2.5384l0.8432,1.8253z"
    }), r.createElement("path", {
      d: "m123.93,606.79,2.6948-3.2865,0-3.2432c-0.98588,0.11068-1.5237,0.50272-2.2519,1.6061-0.61934-2.2227-1.9811-2.7084-3.8062-3.7861-1.8251,1.0777-3.1869,1.4845-3.8062,3.7072-0.72818-1.1034-1.266-1.4165-2.2519-1.5272v3.2432l2.6949,3.2865z"
    }), r.createElement("path", {
      d: "m124.72,613.3s3.1405-2.7397,3.3269-4.2436v-3.4672c-1.2171,0.14291-2.3682,0.45834-3.2672,1.8831-0.76458-2.8701-1.9586-3.6704-4.2117-5.0621-2.2532,1.3916-3.4471,2.192-4.2117,5.0621-0.89895-1.4248-2.0501-1.7402-3.2672-1.8831v3.4672c0.3965,1.5039,3.3269,4.2436,3.3269,4.2436z"
    }), r.createElement("path", {
      d: "m126.06,625.32s4.3013-4.7614,4.3999-6.6164v-5.4059c-1.6097,0.22281-3.1321,1.3298-4.321,3.5513-1.0112-4.4748-2.5903-7.5949-5.5702-9.7647-2.9799,2.1698-4.559,5.2898-5.5702,9.7647-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.30884,1.8551,4.3999,6.6164,4.3999,6.6164z"
    }), r.createElement("path", {
      d: "m126.06,632.43s3.6763-3.7418,4.3999-5.3664v-5.4059c-1.6097,0.22281-3.1321,1.3299-4.321,3.5513-1.0112-4.4748-2.5903-7.0369-5.5702-9.2067-2.9799,2.1698-4.559,4.7318-5.5702,9.2067-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.93384,1.6247,4.3999,5.3664,4.3999,5.3664z"
    }), r.createElement("path", {
      d: "m127.54,636.56c-1.0733-4.6678-1.9959-8.1303-7.163-11.641-5.167,3.5104-6.0894,6.9728-7.1627,11.641z"
    }), r.createElement("path", {
      d: "m130.2,639.16,0-6.7618c-2.3465,0.91931-4.467,2.2802-5.2487,3.7947-0.87376-3.754-2.5569-5.4078-4.6536-7.6786-2.0967,2.2708-3.5008,3.9245-4.3746,7.6786-0.78168-1.5145-2.9024-2.8754-5.2489-3.7946l0.00022,6.7618z"
    }))), r.createElement("use", {
      transform: "matrix(-1,0,0,1,390.73979,0)"
    }), r.createElement("g", null, r.createElement("path", {
      d: "m72.694,694.25,245.33,0,0.00018,12.531-245.33,0.00001z"
    }), r.createElement("path", {
      d: "m66.228,706.76,258.26,0,0.00018,12.512-258.26,0.00002z"
    }), r.createElement("path", {
      d: "m85.576,675.51,219.56,0,0.00015,8.1093-219.56,0.00001z"
    }), r.createElement("path", {
      d: "m79.157,683.56,232.4,0,0.00017,10.622-232.4,0.00001z"
    }), r.createElement("path", {
      d: "m89.412,669.28,211.89,0,0.00015,6.174-211.89,0z"
    }), r.createElement("path", {
      d: "m112.41,669.31h16.005v49.935h-16.005z",
      strokeWidth: "1.0446"
    }), r.createElement("path", {
      d: "m115.95,669.31h8.9171v49.936h-8.917z",
      strokeWidth: "1.0429"
    }), r.createElement("path", {
      d: "m187.08,669.31h16.006v49.935h-16.005z",
      strokeWidth: "1.0446"
    }), r.createElement("path", {
      d: "m190.73,669.31h8.9171v49.936h-8.917z",
      strokeWidth: "1.0429"
    }), r.createElement("path", {
      d: "m262.19,669.31h16.005v49.935h-16.005z",
      strokeWidth: "1.0446"
    }), r.createElement("path", {
      d: "m265.73,669.31h8.9171v49.936h-8.917z",
      strokeWidth: "1.0429"
    })), r.createElement("g", {
      fill: "none"
    }, r.createElement("path", {
      d: "m98.935,664.23h193.07"
    }), r.createElement("path", {
      d: "m115.79,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438"
    }), r.createElement("path", {
      d: "m190.77,712.98h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071"
    }), r.createElement("path", {
      d: "m265.57,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438"
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  t.FlagMX = function (_ref4) {
    var e = _ref4.width,
      t = _ref4.height;
    return r.createElement("svg", {
      preserveAspectRatio: "none",
      height: t,
      width: e,
      viewBox: "0 0 840 480"
    }, r.createElement("defs", null, r.createElement("linearGradient", {
      id: "a"
    }, r.createElement("stop", {
      stopColor: "#fff",
      offset: "0"
    }), r.createElement("stop", {
      stopColor: "#f15770",
      offset: "1"
    })), r.createElement("radialGradient", {
      id: "b",
      gradientUnits: "userSpaceOnUse",
      cx: "842.31",
      cy: "103.66",
      r: "25.86",
      gradientTransform: "matrix(.18574 .04718 -.04532 .18635 233.8 198.77)"
    }), r.createElement("radialGradient", {
      id: "c",
      gradientUnits: "userSpaceOnUse",
      cx: "651.52",
      cy: "550.46",
      r: "25.86",
      gradientTransform: "matrix(-.17642 -.07067 .06515 -.16392 430.54 377.88)"
    }), r.createElement("radialGradient", {
      id: "d",
      gradientUnits: "userSpaceOnUse",
      cx: "380.84",
      cy: "740.37",
      r: "25.86",
      gradientTransform: "matrix(.0989 .0037 -.0045 .1943 442.36 123.3)"
    })), r.createElement("path", {
      fill: "#ce1126",
      d: "M0 0h840v480H0z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M0 0h560v480H0z"
    }), r.createElement("path", {
      fill: "#006847",
      d: "M0 0h280v480H0z"
    }), r.createElement("g", {
      fill: "#fcca3e",
      stroke: "#aa8c30"
    }, r.createElement("path", {
      strokeWidth: ".35",
      d: "M466.96 303.53l.3 5.88 2.21-1.47-1.7-4.84z"
    }), r.createElement("circle", {
      strokeWidth: ".3",
      cx: "466.7",
      cy: "301.93",
      r: "1.89"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M474 312.69l-4.3-4.12-1.93 1.55 5.84 3.4z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M473.63 315.01c-.6-.81-.4-2 .45-2.66a1.87 1.87 0 0 1 2.64.29c.6.81.4 2-.45 2.66-.85.65-2.03.52-2.64-.29z"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M507.04 251.22l4.4 4.38.52-2.22-4.03-2.7z"
    }), r.createElement("circle", {
      strokeWidth: ".3",
      cx: "506.45",
      cy: "250.09",
      r: "1.84"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M518.65 253.82l-6.73 1.92.55-2.22 5.79-.57z"
    }), r.createElement("circle", {
      strokeWidth: ".3",
      cx: "519.74",
      cy: "252.89",
      r: "1.8"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M496.03 287l-4.1-6.4.65-.33 4.65 5.5z"
    }), r.createElement("circle", {
      strokeWidth: ".3",
      cx: "491.52",
      cy: "279.12",
      r: "1.91"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M496.29 287.17l5.22.95.19-.71-4.37-1.73z"
    }), r.createElement("circle", {
      strokeWidth: ".3",
      cx: "503.1",
      cy: "288.18",
      r: "1.89"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M373.59 301.72c0 .91-.71 1.56-1.4 1.56-.66 0-1.21-.74-1.21-1.64 0-.91.55-1.65 1.22-1.65.68 0 1.39.83 1.39 1.73z"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M373.56 304.65l1.2 6.57-1.6-.63-.57-5.7z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M375.01 302.42c.77 1-.53 2.51-1.9 2.89-1.39.37-3.1-.26-3.09-1.52.02-1.44 2.01-.69 2.54-.86.83-.26 1.63-1.58 2.45-.51z"
    }), r.createElement("ellipse", {
      strokeWidth: ".3",
      cx: "363.57",
      cy: "312.49",
      rx: "2.04",
      ry: "1.48"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M367.03 312.14l6.3-.31-1.06-1.26-5.18.56z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M367.56 311.41c.53 1.6.57 3.77-1.22 3.54-1.79-.23-1.45-1.83-1.59-2.44-.26-1.13-1.3-2.14-.23-3.23 1.08-1.1 2.51.53 3.04 2.13z"
    }), r.createElement("ellipse", {
      strokeWidth: ".3",
      cx: "347.01",
      cy: "276.95",
      rx: "1.24",
      ry: "1.88"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M347.03 281.12l.14 6.11-1.59-1.44.12-4.87z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M349.39 279.26c.32 1.41-1.75 2.2-3.15 1.94-1.4-.26-2.47-1-2.26-2.29.21-1.3 1.96-1 2.56-.64.6.35 2.4-.99 2.85.99z"
    }), r.createElement("ellipse", {
      strokeWidth: ".3",
      cx: "336.23",
      cy: "286.5",
      rx: "2.13",
      ry: ".97"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M340.06 286.5l4.8-.32 2.04 1.58-6.91-.26z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M338.3 283.93c1.3.04 2.19 1.47 2 2.98-.18 1.51-1.35 2.74-2.54 2.55-1.2-.19-1.1-1.2-1.08-1.5.03-.3.7-.85.77-1.34.07-.48-.34-1.57-.19-2.07.16-.5.46-.64 1.04-.62zM334.43 246.74c-.54.85-1.55 1.5-2.07 1.17-.52-.34-.33-1.52.2-2.38.53-.85 1.39-1.27 1.9-.94.52.34.5 1.3-.03 2.15z"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M329.08 256.35l2.68-6.31-.4-.35-3.04 4.44z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M331.27 250.05c-1.33-.97-1.62-1.96-1.2-2.94.43-.98 1.43-.35 1.43-.35s.65.73 1.13.98c.49.26 1.25-.08 1.82.72.57.8.23 1.61-.23 1.82-.45.2-1.84.57-2.95-.23zM320.14 249.22c.95.54 1.46 1.46 1.13 2.06-.33.59-1.37.63-2.32.09-.95-.54-1.45-1.46-1.12-2.06.32-.6 1.36-.63 2.31-.09z"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M322.92 251.99l4.95 2.97-.15 2.33-5.37-4.61z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M322.88 252.55c-1.1 1.23-2.1 1.41-3.01.87-.92-.54-.18-1.47-.18-1.47s.78-.58 1.09-1.04c.3-.45.06-1.27.91-1.75.86-.47 1.6-.04 1.76.44.14.48.35 1.93-.57 2.95z"
    })), r.createElement("g", {
      fill: "#aa8c30"
    }, r.createElement("path", {
      d: "M468.03 303.97s-.36.24-.56.63c-.19.38-.4 1.16-.4 1.16l.02-1.9.64-.37.3.48z"
    }), r.createElement("path", {
      d: "M468.31 302.78s-.44.75-1.5.7c-1.04-.07-1.55-.55-1.68-1.09-.13-.53-.13-.92.21-1.54.34-.62-.5.59-.5.59v1.18l.77.91.65.2.65.04.82-.27.55-.42.03-.3zM473.84 312.44s-.53.28-.93.13a21.72 21.72 0 0 1-4.57-2.34l4.99 3.1.51-.89zM476.94 313.85s-.06.87-1.02 1.3c-.96.44-1.64.24-1.99-.18a1.87 1.87 0 0 1-.5-1.47c.03-.7-.18.75-.18.75l.53 1.06 1.09.45.68-.12.58-.26.61-.62.31-.63-.11-.28zM508.79 251.4s-.13.2-.13.52l-.02.9-1.08-1.2.55-.71.68.49zM508.21 249.83c.06.86-1.2 2.1-2.13 1.7-.94-.38-1.62-1.36-1.1-2.33.5-.97-.26.37-.26.37l.13 1.43.89.81 1.11.07.87-.5.54-.97-.05-.58zM521.38 252.18s-.21-.6-.1.07c.1.68-.76 2.11-1.76 1.98-1-.13-1.46-1-1.38-1.81.09-.81-.16.28-.16.28l.15 1.08.54.5.77.46.89-.15.8-.52.37-.76v-.55l-.12-.58z"
    }), r.createElement("path", {
      d: "M516.87 253.18s.03.45-.56.78c-.6.32-1.73 1-1.73 1l3.7-1.09-.3-.9-1.11.21zM494.43 282.57s-.2.22-.21.68c-.01.47.1 1.02.1 1.02l-2.08-3.29.61-.39 1.58 1.98zM493.29 279.48c-.37.87-1.88 1.42-2.6 1-.73-.43-1.35-2-.46-2.69l-.46.4-.24.9.33.94.73.82.67.2 1.06-.2.78-.62s.56-1.61.19-.75zM500.61 287.01s.02.39-.66.39l-2.1.02 3.44.67.17-.7-.85-.38z"
    }), r.createElement("path", {
      d: "M504.85 287.82c.3 1.15-.71 2.26-2.03 1.87-1.32-.39-1.68-1.7-1.26-2.4l-.33.82.24 1.1.8.7.84.18.84-.21.86-.82.21-.98-.17-.26zM374.92 302.46c.36.4-.2 1.9-1.69 2.5-1.49.6-2.23.03-2.63-.47-.4-.5-.37-1.04-.37-1.04l-.2.28.2.78.74.64 1.32.29.99-.19.96-.51.5-.52.42-.64.06-.77-.24-.4h-.06l-.02.04.02.01z"
    }), r.createElement("path", {
      d: "M373.59 305.73s-.26.08-.48.46c-.23.37-.31 1.04-.31 1.04l-.12-1.76.77-.4.14.66zM368.62 311.01s-.14.38.26.58c.4.2 1.33.43 1.33.43l-2.44.08-.26-.94 1.11-.15zM367.79 312.53s.03.09.02.25c0 .16-.05.4-.19.7-.29.6-.4 1.3-1.28 1.12a1.62 1.62 0 0 1-1.33-1.4c-.09-.58-.29-.81-.29-.81v.77l.54 1.3.88.4h.77l.6-.23.28-.78.14-.63-.14-.69z"
    }), r.createElement("path", {
      d: "M361.63 312.36s.29 1.12 1.53 1.15c1.25.03 1.57-.35 1.57-.35l.14.44-.46.23-1.08.12-.96-.19-.44-.33-.34-.59.04-.48zM349.24 279.02s.04.13-.04.54c-.09.4-.85 1.38-2.28 1.4-1.43.03-2.02-.45-2.4-.93-.4-.47-.46-1.14-.46-1.14l-.04.71.55.89 1.41.66h1.34l1.37-.4.6-.65.13-.73-.18-.35zM346.98 282.05s-.51.04-.77.27c-.25.23-.48.5-.48.5l-.02-1.69 1.27.1v.82zM340.84 286.53s-.1.1.64.43c.74.33 4.1.7 4.1.7l-5.4-.15.2-.92.46-.06zM340.23 286.63s-.01.2-.28.75-.95 2-2.09 1.8c-1.14-.2-1-1-1-1.12v-.4l-.2.82.26.57.47.3.92.1.63-.27.68-.65.35-.69.29-.73-.03-.48zM337.32 286.77s-.03.26-.92.29c-.9.02-2.18-.36-2.18-.36l.43.53.74.19.92.01.72-.07.29-.59zM334.57 248.86s.2.58-.31.95-1.62.6-2.33.2c-.71-.4-2-1.7-2-1.7l.6 1.07.94.78 1.3.37 1.26-.2.57-.5.17-.4-.2-.57z"
    }), r.createElement("path", {
      d: "M330.76 250.59s.03.15 0 .72c-.03.58-.26 1.53-.26 1.53l1.14-2.54-.45-.4-.43.69zM323.72 252.58s-.17-.17.17.58 3.12 3.42 3.12 3.42l-4.43-3.74.51-.72.63.46zM322.24 253.01s-.57.35-1.08.38c-.51.03-1.36-.03-1.48-.64-.1-.6.17-.86.17-.86l-.36.83.14.46.65.38.91.09.82-.4.23-.24zM320.45 251.11s.06.17-.77.06c-.82-.12-1.81-1.07-1.81-1.07l.65 1.04 1.39.57.54-.6z"
    })), r.createElement("g", {
      fill: "#9ca168"
    }, r.createElement("path", {
      d: "M524.81 238.85c-.4 5.03-5.37 7.6-7.96 9.48-2.6 1.89-3.86 4.22-3.86 4.22l-.88 2.93-.42 1.88-.09.65c.17.53.4 1.43.43 2.8.07 2.28-.15 5.54-.15 5.54l3.5-2.5 2.53-.95.76-.13s-2.8 2.8-3.91 5.82c-1.1 3.03-3.16 9.45-6.99 11.53-3.83 2.07-6.22 1.21-7.5 2.33-1.27 1.12-1.32 1.43-1.32 1.43l-1.63 2.23-1.3 1.67-1.2.84-.76.62c-.03.62-.1 1.43-.31 2.17-.42 1.48-.92 3.12-.92 3.12s.76-.47 1.7-.58c.92-.12 1.78-.11 1.78-.11s-.72.89-.98 1.75c-.25.87.17 6.05-4.77 9.16-4.94 3.11-17.52 2.62-17.52 2.62l-2.38.95-2.25 1.68-2.05 2.24-.15.6s-1.55 1.9-2.66 2.63l-3.66 2.42s2.17-.09 2.9.17c.72.26 4.6 1.99 4.6 1.99s-2.84-.06-4.77.69c-1.94.75-10.74 5.73-15 5.59-4.25-.14-10.33-6.37-10.33-6.37l-2.76-1.93-4.57-.89-5.65-.32.08-.74.1-.91s1.92-.22 5 .14c2.65.32 3.52 1.2 5.74 1.45a9.45 9.45 0 0 0 4.66-.43c.81-.37 7.65-6.16 7.65-6.16l7.69-2.7 2.93.44 1.3.34 1.2.35s-.4.63-1.26 1.42c-.85.8-1.92 1.35-1.92 1.35l.94.75 4.86-.78 1.58.41s.13.03.46.24c.07-.35.27-1.07.7-1.64.6-.78 3.33-3 4.5-3.78 1.17-.78 1.43-.89 1.81-1.3.38-.41 1.96-4.47 1.96-4.47l.21-2.07 5.37-5.17 3.62-3.85 1.58-4.38-.17-.89s1.3 1.34 1.06 4.06c-.23 2.73-.83 3.68-.83 3.68s3.66-2.53 5.62-3.4a6.28 6.28 0 0 1 3.14-.6 8.82 8.82 0 0 0 2.78-2.42c1.07-1.55 1.35-2.01 1.35-2.64 0-.62.17-3.65.17-3.65l-.34-9.27 3.15-6.98 4.58-4.1.87-.52s-.36.97-.43 1.64c-.06.67-.06 1.86-.06 1.86s2.32-3.18 3.51-3.76l.74-.35c.25-.44.68-1.33.94-2.56.37-1.76.43-4.12.43-4.12l.07-3.84-.75-2.98-2.13-5.73-.08-7.54-1.6-2.15s1.51-.12 3.39 2.59c1.87 2.7 2.43 6.5 2.43 6.5l4.35-13.35s1.16 1.57 1.99 4.21c.83 2.64 1.09 4.43 1.09 4.43l1.71-3.7c-.01.03-.05.25.2 1.3.3 1.23 2.96 2.77 2.56 7.8zm-88.33 85.35s-.81-2.05-5-4.12c-4.19-2.08-7.31-2.48-7.31-2.48l-.05 1.54 6.58 2.87 3.28 2.68 2.5-.5z"
    }), r.createElement("path", {
      fill: "#717732",
      d: "M466.42 311.65c.4-.54 3.94-3.7 5.75-4.62 1.81-.93 4.22-1.1 4.22-1.1 2.5-.46 2.9-.1 8.65-3.27s7.03-6.83 8.13-7.71c1.11-.89 3.13-1.1 3.13-1.1s-2.4 2.83-4.51 5.14c-2.1 2.31-4.37 3.78-7.6 5.96-3.24 2.19-9.97 2.3-9.97 2.3-2.84.64-3.8 1.33-5.37 2.71-1.58 1.39-2.65 2.9-2.65 2.9s-.18-.67.22-1.21zm15.87-16.66c-5.32 4.86-7.07 9.38-7.07 9.38s4.73-4.06 7.16-6.4c2.42-2.33 5.83-3.45 7.36-4.88 1.54-1.43 1.62-2.63 2.6-3.54.98-.9 1.7-1.34 1.7-1.34s-2.34-1.82-11.75 6.78zm-11.23 11.25s2.28-1 3.14-3.04c.64-1.51.3-1.9 1.28-3.63 0 0 5.53-5.34 7.49-7.65 3.5-4.1 1.92-7.47 1.92-7.47s.38 1.73-1.07 3.54c-1.45 1.81-8.59 6.7-9.45 9.51-.87 2.8-.39 2.91-.77 4.4-.89 3.45-2.54 4.35-2.54 4.35zm-3.68 13.82s-2.79-1.87-5.9-1.67c-6.37.4-11.75 4.32-15.95 4.43-4.2.12-5.86-2-9.1-4.2-3.47-2.36-12.04-2.02-12.04-2.02l-.06.2-.06.25s5.9.06 8.41.76c4.8 1.33 7.4 6.33 12.85 6 7.08-.41 12.88-4.72 15.77-4.7 4.97.03 6.08.95 6.08.95zm-31.56-3.22s4.94.89 8.77-1.93c3.84-2.8 8.4-6.6 10.9-6.78 2.52-.17 5.16.48 5.16.48s-3.2-1.43-5.75-1.39c-2.56.05-5.15.4-7.54 1.82-2.39 1.43-3.54 4.01-6.13 5.66a16.79 16.79 0 0 1-5.4 2.14zm-.88 6.63c-.66 0-1.42.43-1.68.39-.25-.04-1.77-1.6-3.88-2.72-2.1-1.12-5.25-1.8-5.25-1.8s-.39.1.31.33c.7.24 3.3 1.12 4.96 1.9 1.67.78 3.35 2.55 3.5 2.83.15.28.74 1.08 1.98 1.04 1.23-.05 1.73-.76 1.6-1.23-.13-.48-.88-.74-1.54-.74zm3.47-4.8s1.96 1.12 5.2 1.04c6.9-.17 11.25-4.9 15.77-6.62 4.5-1.73 6.82-.24 6.82-.24s.12-.24-.02-.35a9.23 9.23 0 0 0-5.05-1.58c-7.58.12-14.68 4.9-17.77 6.2-3 1.25-4.94 1.56-4.94 1.56zm73.4-52.26c-2.33 2.4-5.8 10.07-7.33 12.16-1.53 2.1-3.45 2.72-4.28 3.57-.73.74-3.51 4.49-4.15 5.4-.64.9-.84.65-1.28 1.04-.45.38-.68.4.06.21.75-.2.98-.65 2.13-1.94 1.15-1.3 1.09-1.88 2.92-3.52 1.83-1.65 5.15-3.52 6.8-5.54 1.64-2.01 5-9.82 6.76-11.72 1.9-2.06 5.22-3.29 5.22-3.29s-2.62-.76-6.85 3.63zM500 280.95s-.09-1.38 1.62-3.42c1.7-2.03 2.3-1.77 3.66-4.75 1.36-2.98 1.96-5.88 3.07-9.03 1.1-3.16 3.02-6.27 3.02-6.27s-1.79.17-3.62 2.64c-1.83 2.46-4.73 6.96-6.22 11.36-1.5 4.41-1.53 9.47-1.53 9.47zm-2.17 2.89s.63-.34.72-4.19c.09-3.84-.21-9.24.9-11.92 1.1-2.68 6.98-9.12 6.98-9.12s-2.43.6-5.84 3.32c-3.4 2.72-4.85 6.14-4.68 8.73.17 2.6 1.62 5.53 1.75 8.09.12 2.54.17 5.09.17 5.09zm13.84-26.47s1.45-5.22 2.04-6.48c.6-1.27.63-2.02 3.58-5.33 1.7-1.9 3.35-3.12 4.06-5.77.71-2.65.69-10.05.69-10.05s-.77.69-1.4 1.99c-.62 1.3-.17 6.1-1.28 8.32-1.1 2.22-3.6 7.44-4.85 8.56 0 0-.26-3.75.2-7.52.45-3.77 1.73-4.92 2.3-7.4.57-2.48.22-8.88.22-8.88s-2.01 2.08-3 4.47c-1 2.39-1.6 6.68-1.62 9.9-.03 3.24.74 5.86.85 7.7.1 1.84.25 2.7-.49 4.73-.73 2.01-.36.63-.82 2.59a45.72 45.72 0 0 1-.93 3.43l.45-.26zm-4.6-28.3s1.76 2.23 1.47 4.76c-.28 2.54-1.25 5.88-.25 8.53 1 2.65 2.47 2.9 2.87 4.43.4 1.53.42 4.51.42 4.51s.83-5.66.26-7.22c-.57-1.55-.82-.83-1.65-2.47-.82-1.64.03-6.14-.6-8.76-.62-2.62-2.52-3.77-2.52-3.77z"
    }), r.createElement("path", {
      d: "M402.55 323.75s.53-1.49 4.11-3.24c3.58-1.75 8.97-4.1 9.48-3.8.5.3-.28 2.25-.28 2.25l-3.47 1.05-2.77 1.63-3.24 2.1-3.83.01z"
    }), r.createElement("path", {
      d: "M411.67 314.34c-4.57.17-7.07 1.3-7.94 1.47-.3.06-.97.53-1.53.25-1.07-.53-2-2-2-2l-.97-.81-.23 3.28-6.67-5.79-.71 3.83-.85 1.76-6.62-6.25.31 4.84s-1.73.23-1.81.17l-4.72-3.28-1.39.46 1.54 2.85-5.97.46s-.48.26-1.3 1c-.8.76-1.25 1.46-1.25 1.46s-.18.3.03.44c.22.14 1.85.1 2.36-.09.5-.2.84-.9.99-.61.15.29.34 1.6 1.13 1.47.79-.13 3.56-2.23 5.53-1.31 2.2 1.03-2.85 2.52-2.33 4.08s4.17.9 5.1.4c.92-.5 3.68-3.94 4.82-2.63 1.57 1.82-3.31 3.24-2.41 5.06.87 1.76 3.6 1.37 4.92.6 1.32-.75 4.39-5.47 5.07-4.45 1.18 1.77-2.59 3.45-1.64 4.82.95 1.38 3.03-.05 4.42-1.02 1.38-.97 1.94-3.29 3.85-4.37 1.92-1.08 1.79-.63 2.32-.64.53-.03 2-1.5 2-1.5l4.51-1.9 2.2.15 1.15.54 2.25.32.27-1.9s-2.61-1.23-4.43-1.16zm-36.05.04l.95-1.7-.54-.82s-1.59-.89-3.04-2.36c-1.45-1.47-1.98-1.8-2.64-2.14-.66-.33-2.9-1.78-2.9-1.78l-1-3.72-.6-1.07-1.72.67-2.26-7.98-.45-1.43-.93-.06-1.86 4.84-2.08-3.02-.53-6.62-1.3 1.45-1.66 1.7-2.97-6s-.24-.16-.39.34c-.15.49-.4 2.38-.22 3.5-.8-.49-2.15-1.42-3.98-3-3-2.59-3.73-3.92-3.73-3.92l-1.4-3.17 1.31-2.8.66-3.32-2.9 1.19-.5-7.52-.45-2.38-3.5 5s-1.36-1.93-1.36-2.15l.07-4.75-.94-.28-1.43 2.68s-1.37-2.77-1.98-3.35c.1-1.07.26-3.78-.39-5.87-.81-2.67-1.77-4.09-1.43-6.26.34-2.18 1.23-2.39 1.13-3.36-.1-.96-1.54.63-1.06-.65s5.04-4.18 4.09-5.7c-.96-1.53-5.35 2.38-4.33-.24 1.02-2.63 5.25-2.67 5.49-6.33.15-2.28-3.99 1.42-4.36.27-.38-1.14 2.55-3.49 2.52-4.97-.04-1.49.54-1.66-.28-2.46-.81-.8-3.33 3.11-3.33 3.11l-2.76-1.04-.96 3.95-.85 3.35-3.4-2 .91 4.08.82 3.97-3.55-.9 1.88 3.39 2.44 2.48 1.51 2.05 1.1.58 1.46 1.46.5 2.18s.86 2.38.86 2.49l.14 2.34.03 1.56-.07 1.2-.06.46-.07.52-.03 1.42c-.67.07-1.75-1.02-2.15-.34-.42.73 2.05 2.63 1.58 3.1-.47.49-4.09-.73-4.3.44-.22 1.17.34 2.8 2.43 3.33 2.08.52 6.94 1.64 6.13 2.59-.8.95-6.09-2.9-5.88-.08a4.96 4.96 0 0 0 3.41 4.49c1.36.52 6.69-.09 6.39 1.17-.3 1.25-4.34-.4-4.73 1.42-.38 1.82 2.81 2.07 3.5 2.07.68 0 2.9-.08 3.74.57.86.65 3.84 3.8 5.71 5.4a98.67 98.67 0 0 0 6.03 4.43h-.05c-1-.1-3.1-.32-3.43.43-.42.97 8.01 3.98 5.59 4.91-2.42.93-5.03-2.57-5.73-.43-.7 2.14 1.6 3.95 2.92 4.73 1.31.78 8.79.16 7.32 1.85-1.46 1.7-6.88-1.14-6.93.87-.05 2 3.61 5.18 5.49 5.1 1.87-.09 3.93-3.1 4.78-1.47.86 1.62-1.44 2.28.36 2.71 1.8.43 3.09-1.85 5.18-1.44 2.1.42 5.39 1.75 7.23 3.42 1.84 1.68 3.73 3.62 3.73 3.62z"
    }), r.createElement("path", {
      fill: "#717732",
      d: "M404.74 322.82c1.28.02 1.45.71 1.62.7.17-.03 2.32-1.87 4.37-2.99 2.04-1.12 5.15-1.8 5.15-1.8l.2.29s-3.71.92-5.5 2.18c-2.22 1.56-3.96 2.53-4.07 2.8-.1.29-.92.83-2.17.85-1.26.02-1.8-.73-1.8-1.1 0-.37.92-.95 2.2-.93zm11.16-5.65s-1.1.11-1.73-.44a5.67 5.67 0 0 0-3.35-1.03c-1.34 0-3.47.73-5.17 2.36-.14.13-.48.75-1.93 1.73.5.1 1.48-.58 2.55-1.44 1.54-1.25 3.47-1.59 4.83-1.79 1.36-.2 2.22.58 2.84 1 .63.44 1.9.32 1.9.32l.06-.71zm-66.25-27.08c.14-.06.12-.36.03-.88-.2-.08-1.03-.43-2.89-1.53-2.17-1.3-6.68-4.89-6.68-4.89s1.87 1.82 3.75 3.5c1.87 1.69 5.24 3.76 5.24 3.76l.01.02c.3.03.5.04.54.02zm46.77 33.13s.68-.9 1.9-2.84c1.21-1.96 2.32-2.58 2.49-2.82.17-.24-.47-1.19-.83-1.92-.36-.74-.3-1.51-.3-1.58 0-.06.45 1.15 1.34 1.82.9.66 1.43 1.23 1.43 1.23s1.79-.24 1.83-.59c.04-.34-.04-.58-.34-.7-.3-.14-.64.26-1.45-.1-1.68-.73-2.36-3.28-3.37-3.37-1-.08-.28 2.7-.72 2.75-1.55.15-2.77-5.66-6.5-5.9-2.62-.17-3.08.32-3.21.9-.13.59 3.17 4.07 2.06 4.56-1.1.5-4.62-5.46-7.17-5.53-2.56-.06-2.77.91-2.58 1.47.19.56 2.83 1.06 2.21 2.92-.6 1.8-3.17-2.78-5.53-2.53-2.37.26-2.62.43-2.73 1.1-.1.67.83 1.65.5 1.88-.35.24-1.84.17-3.03 1-1.2.82-2.86 3.07-2.86 3.07s1.56-2.2 3.62-2.45c2.07-.23 7.29.03 7.29.03s-.7-.44-1.47-1.13-1.43-2.1-1.43-2.1 1.15 1.09 2.26 2c1.1.9 2.49 1.6 2.49 1.6s2.22.21 2.36.47c.15.26-.06.78-.97 1.77-.92 1-2.24 2.16-2.24 2.16s2.21-1.68 2.64-2.05c.43-.37 1.96-1.53 1.96-1.53s1.62.21 1.79.17c.17-.04.09-.6-1-2.2-1.08-1.6-2.11-3.33-2.11-3.33s1.33 1.22 2.68 3 1.15 2.6 1.7 2.69c.56.08 1.45.2 1.86.19.54-.03.4.77-.54 2.2-.93 1.42-1.48 3.26-1.48 3.26s.95-1.54 1.97-2.6c1.03-1.05 1.56-2.3 1.96-2.37.41-.06 1.78.1 1.97.02.2-.08-.33-.65-1.05-2.12-.72-1.47-.96-3.5-.96-3.5s.7 1.9 1.81 3.29c1.11 1.38 1.54 2.5 1.78 2.5.24.02 1.1-.1 1.72-.08.3 0 .34-.07.38.13.1.6-.15.97-.9 2.37-.74 1.4-1.23 2.8-1.23 2.8zm-28.28-16.4c1.6.54 2.21.54 2.21.54s-2.2-1.3-2.77-3.13c-.57-1.84-.06-5.7-1-5.66-.94.04-1.47 2.85-2.4 2.29-.94-.56.31-5.73-.7-7.93-1.03-2.2-3.44-3.74-4-2.94-.54.8-.42 5.55-1.9 4.52-1.5-1.04.12-5.1-.33-6.96-.44-1.86-1.57-3.2-2.42-2.75-.86.46.33 3.94-1 3.98-1.35.04-1.16-2.44-1.73-2.68-.58-.24-.77.5-1.09.03-.32-.48-.15-2.25-.85-2.08-.7.17-.57 1.53-.38 2.29.19.75.61 1.84.91 2.33.3.5 1.37 1.12 1.28 1.54-.08.4-.64.76-1.36.78-.73.02-2.37-.05-2.37-.05s1.75.54 2.4.6c.67.07 1.95-.27 2.27.31.32.58 1.85 2.66 1.85 2.66s.36-1.08.55-2.99c.2-1.9.1-3.56.1-3.56s.52 2.2.46 3.52c-.07 1.32-.56 3.89-.56 3.89s1.45 1.21 1.03 1.53c-.43.33-1.94.29-3.71.27-1.77-.03-4.28-.63-4.28-.63s2.26 1.08 3.83 1.34c1.58.26 5 .34 5 .34l2.35 2.66s1.12-1.93 1.28-3.84c.16-1.92-.04-4.15-.04-4.15s.49 2 .57 3.71c.09 1.71-.55 4.74-.77 5-.2.25-1.4 1-2.46 1.26-1.55.4-4.65.79-4.65.79s2.86.38 4.92-.11 2.3-1.06 2.88-.72c.57.35 1.08.98 1.08.98s1.24.96 1.8 1.2c.08.2-.96.63-1.49.96-.52.33-1.9.97-1.9.97s2.02-.73 2.91-.97c.45-.12 1.54-.52 1.54-.52l.6.32s.04-.43-.13-1.64c-.17-1.2-.43-2.38-.43-2.38s.7 1.1.92 2.15c.2 1.03.2 2.09.2 2.09s.18.3 1.78.84zm-40.81-46.75s.45-2.2.45-4.73c0-2.54-1.76-6.46-2.04-6.86-.29-.4-.46-.75-.46-.75l1.2-1.84-1.54 1.2s-.85-.17-1.59-.62c-.74-.46-1.1-1.15-1.1-1.15s.78.57 1.53.89c.75.3.94.2.94.2l-.6-2.56s-.78-.31-2.52-1.28-3.3-2.49-3.3-2.49 2.35 1.42 3.68 1.97c1.33.56 2.08.6 2.08.6s1.4-.43 2.11-.84 2.18-1.52 2.18-1.52-1.4.8-2.32 1c-.92.21-2.08.34-2.08.34l-.4-3.1-1.47-1.52c-1.16-1.53-2.05-3.7-2.05-3.7s1.2 1.52 2.15 2.24c.96.73 1.84 1.9 1.84 1.9s1.1-.58 2.15-1.3c1.05-.73 3.68-2.64 3.68-2.64s-1.5.8-3.58 1.77c-2.08.96-2.15.86-2.15.86s-.17-1.35.14-1.94c.3-.58.96-1.55.85-2.14-.1-.59-.54-.38-.71-.86-.17-.49.54-3.46.54-3.46s.17 1.07.2 1.62c.04.56-.26 1.32.49 1.32s4.26-3.53 4.7-4.18c.44-.66 1.09-2.46-.75-1.73-1.84.72-1.4 2.3-2.93 2.17-.45-.03-.96-2-1.54-1.52-.58.5-1.87 1.7-2.11 3.08-.24 1.38.3 3.5-.48 4.11-.78.63-1.46-2.38-3-1.97-1.53.42-1.87 2.53-1.63 3.36.24.83 3.58 4.7 2.52 5.18-1.06.49-3.65-3.28-5.04-.72-1.4 2.55 4.4 5.18 5.1 5.8.72.63.08.8 1.1 2.08s2.38 1.59 3.1 2.46c.71.86 2.83 4.97 2.83 7.63s-.17 3.64-.17 3.64zm15.39 22.43s-1.42-1.65-.95-4.37 2.34-7.52 1.7-8.13c-.64-.6-2.64 2.94-3.15 2.12-.51-.82 1.15-5.62.3-7.6-.85-2-.94-3.25-2.64-3.07-1.7.17-2.43 5.79-3.24 4.8-.81-1 .47-3.5-.08-4.84-.56-1.34-.86-1.82-1.7-1.6-.86.21-1.24 2.8-1.84 2.76-.6-.04-1.58-3.11-2.81-2.68-1.24.43 2.94 5.88 2.94 5.88s.74-.65 1.13-1.58c.38-.93.76-1.94.76-1.94s.34 1.77.05 2.46c-.3.69-.54 2.31-.54 2.31s-1.02.33-2.7.07c-1.68-.26-3.07-.95-3.07-.95s1.13.75 2.85 1.2c1.73.46 3.56 1.02 3.56 1.02s.45.56 1.22 1.58l1.42 1.88s.5-1.04.98-2.75c.5-1.7 1.66-4.51 1.66-4.51s-.36 3.4-.76 5.05c-.4 1.67-.83 4.02-.83 4.02s-1.5-.15-3.5-.51c-2-.37-4.72-1.06-4.72-1.06s2.38.95 4.7 1.57l3.77 1.02 1.83 2.41s.5-.88 1.22-1.89c.72-1.02 1.28-2.4 1.28-2.4s-.32 1.88-.88 3c-.55 1.13-.93 1.8-.93 1.8s-1.18.28-2.26.25l-3.3-.04s1.85.63 3.32.87c1.47.24 2.53.39 2.53.39s.11.66.9 1.8a6.01 6.01 0 0 0 1.78 1.66z"
    })), r.createElement("path", {
      fill: "#fff",
      d: "M412.7 331.62s-.83-.9-1.94-1.48c-1.1-.58-1.48-.4-1.48-.4l-.51-.19.97-2.53 7.3-6.97 1.12-7h.27l4.23-.05-.05 9.56 1.34.6 8.15 4.89-.03 2.12-1.19.46c-.79.31-.98.54-.98.54l-3.07.29-5.37-3.9-2.21-2.32-4.05 5.18-2.5 1.2z"
    }), r.createElement("path", {
      fill: "#016848",
      d: "M418.44 313.04s-.12.37-.17 1.45c-.06 1.07.07 6.72-.2 7.5-.28.76-4.2 2.38-6.45 4.34s-2.33 3.4-2.33 3.4-.74.06-2.13.58c-1.4.51-2.02 1.3-2.02 1.3s.83-3.5 4.46-6.72c3.64-3.23 5.4-3.5 5.8-4.04.4-.54 0-6.72.09-7.22.08-.5.52-.54.82-.58.3-.05 2.13 0 2.13 0zM427.71 333.68s.57-1.12.94-1.5c.37-.37 1.25-1 1.25-1s.14-.15-1.85-1.01c-1.99-.87-3-.58-4.43-1.59-1.42-1-2.84-2.73-2.84-2.73l-1.9 1.7s1.14 1.6 2.22 2.65c1.07 1.03 3.51 1.38 4.6 1.98 1.07.6 2.01 1.5 2.01 1.5z"
    }), r.createElement("path", {
      fill: "#cd202a",
      d: "M422 313s2.15-.13 2.45.2c.3.34.25.7.27.82 0 .1.1 5.22-.27 6.9-.4 1.76-1.3 3.51-1.82 4.03-.51.52-3.75 3.35-5.28 4.84-1.53 1.5-3.1 3.63-3.1 3.63s-.56-.63-1.05-1.24c-.48-.6-.96-.8-.85-1.2.11-.4 1.73-2.83 4.32-4.53 2.58-1.7 4.74-3.63 5.22-6.4.49-2.76.11-7.05.11-7.05z"
    }), r.createElement("path", {
      fill: "#cd202a",
      d: "M436.38 330.48s-.52-.52-2.34-.55c-1.82-.03-1.97.24-1.97.24s-1-1.26-2.62-2.3c-1.6-1.06-2.82-.9-4.55-2.04-1.73-1.14-2.64-2.8-2.64-2.8l1.33-2.72s1.5 2.1 3.04 3.24c1.55 1.14 4.98 2.25 6.08 3.2 1.09.96 3.67 3.73 3.67 3.73z"
    }), r.createElement("g", null, r.createElement("path", {
      fill: "#30c2dc",
      stroke: "#0872a7",
      strokeWidth: ".7",
      d: "M452.73 299.48s-4.69-1.82-4.35-3.46c.34-1.64 10.83-4.4 10.83-4.4l.16-2.77s-1.53-.09-4.17.78a37.32 37.32 0 0 1-11.33 1.98c-2.74 0-4.23-.28-4.97-.5-.48-.15-36.95-2.3-38.14-2.28-.51 0-1.16-.01-1.99-.07-4.85-.34-7.98-7.78-7.98-7.78l-2.3.4s.7 3.66-.51 3.98c-2.38.64-18.23-7.84-18.23-7.84l-.87 3.44s9.68 5.18 9.4 7.11c-.3 1.93-3.17 1.78-3.17 1.78l1.23 2.31c.43.04 15.95.79 16.21 5.45.11 1.88-3.8 3-3.8 3l1.3 1.59v.79s8.62.05 11 1.38c2.4 1.34 3.6 3.26 6.53 4.94 2.92 1.68 22.75 1.27 25.85.4 3.5-.99 5.65-4.96 11.35-6.69 5.7-1.72 7.53-1.81 7.53-1.81z"
    }), r.createElement("circle", {
      fill: "#fff",
      stroke: "#0872a7",
      strokeWidth: "1.37",
      cx: "373.42",
      cy: "292.05",
      r: "2.75"
    }), r.createElement("circle", {
      fill: "#fff",
      stroke: "#0872a7",
      strokeWidth: "1.37",
      cx: "389.1",
      cy: "279.26",
      r: "2.75"
    }), r.createElement("circle", {
      fill: "#fff",
      stroke: "#0872a7",
      strokeWidth: "1.37",
      cx: "454.82",
      cy: "299.74",
      r: "2.82"
    }), r.createElement("path", {
      fill: "#f8c83c",
      d: "M361.11 275.15c-.9 2.07 2.64 6 5.1 6.44 2.48.43 3.84-.17 4.27-1.39.43-1.2.1-2.52-.47-3.28-1.57-2.12-8-3.84-8.9-1.77z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M368.9 278.31c-.07-1.25-2.13-2.47-3.45-2.47-1.32 0-2.64-.04-2.43.66.21.68 3.62 1.6 3.7 1.98.1.4-1.01.86-.46 1.38.55.52 1.23.14 1.79-.25.55-.4.9-.52.85-1.3z"
    }), r.createElement("path", {
      fill: "#f8c83c",
      d: "M390.71 301.99c.57 1.83-.85 2.72-2.68 3.54-1.84.82-5.58.34-6.43-1.12-.86-1.47 1.36-3.85 3.62-4.41 2.25-.56 4.98.35 5.49 1.99z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M386.92 303.07c.72-.12.73 1.08 1.36 1 .64-.1 1.2-1.13 1.03-1.82-.17-.7-1.37-1.64-2.39-1.56-1.02.1-4.05 2.64-3.7 3.33.33.69 1.02.6 1.57.35.56-.26 1.36-1.17 2.13-1.3z"
    }), r.createElement("path", {
      fill: "#f8c83c",
      d: "M458.35 292.53c1.66 2.2 4.66.17 5.45-.69.8-.86 3.24-2.27 2.24-3.72-1-1.44-2.7-1.32-3.83-1.27-1.14.06-3.47 1.74-3.86 2.51-.4.78-.74 2.2 0 3.17z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M458.89 291.07s.14-2.4 2.39-2.5c1.28-.06 1.33.34 2.3.89.96.54 1.33-.72 1.33-.72s.06 1.7-1.5 1.75c-1.56.06-1-.69-2.53-.92-1.35-.2-1.99 1.5-1.99 1.5z"
    })), r.createElement("g", {
      fill: "#f9aa51",
      stroke: "#953220",
      strokeWidth: ".7",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, r.createElement("path", {
      d: "M422.43 286.4l-1.1-.72s-2.22-.11-3.73-.08c-1.5.02-4.48.17-4.48.17l4.45 12.93 5.34 7.7 2.05.73 4.14-.27.7-2.02-1.55-12.47-5.82-5.97z"
    }), r.createElement("path", {
      d: "M407.71 287.21l.21-1.47s1.01-.13 2.42-.17c1.4-.05 2.63.1 2.78.2.15.11 3.11 3.73 4.13 6.1 1.02 2.39 2.22 6.36 3.54 8.78 1.32 2.42 4.17 6.48 4.17 6.48s-1.43.09-2.68.09c-1.26 0-2.66.04-2.66.04l-2.4-.93-7.5-11.68-2.01-7.44z"
    }), r.createElement("path", {
      d: "M404.57 285.62s3.07-.06 3.35.12c.29.17 3.7 3.2 5.05 6.94 1.37 3.74.69 4.26 2.45 8.12 1.76 3.86 4.2 6.46 4.2 6.46s-5.11.28-8-.24c-2.9-.51-3.93-.46-4.6-1.26-.69-.81-2.28-1.79-2.28-1.79h-2.9l.68-4.03-.79-9.05.17-4.67 2.67-.6zM435.24 288.01l-4.88-2.02-9.1-.46s.35 2.43.69 4.67c.34 2.25 1.93 7.55 3.4 10.14 1.48 2.6 2.96 5.76 3.76 6.51.8.75 6.02-1.41 6.02-1.41l3.4-.52-.45-3.72-.48-1.15.8-10.57-.75-1.64-2.41.17z"
    }), r.createElement("path", {
      d: "M403.09 288.07c0 1.15 1.22 1.21 1.53 1.15.32-.05 1.37-.46 1.37-2.02 0-1.55-.97-2.76-2.87-2.87-1.9-.12-3.35 2.27-3.35 3.88 0 1.62 1.62 2.45 1.62 3.06 0 0-1.62 1.5-1.54 4.12.09 2.62 2.22 4.64 2.22 4.64s-2.27 1.81-2.27 3.63c0 1.81 1.73 3.02 3.35 3.02s3.69-1.04 3.69-2.42-1.22-2.21-2.24-2.21c-1.03 0-1.45.6-1.45 1.06M436.8 288.8c0 1.12-.73 1.17-1.37 1.17-.63 0-1.49-.35-1.49-1.78 0-1.42 1.88-2.2 3.07-2.2 1.2 0 3.24 1.64 3.24 3.63s-1.45 3.33-1.45 3.33.9.43.9 2.94c0 2.5-1.62 4.32-1.62 4.32s2.1.82 2.1 3.41c0 2.6-1.78 3.44-3.02 3.44s-3.39-.74-3.39-2.5c0-1.78 1.11-2.4 1.96-2.4.85 0 1.69.99 1.69 1.96"
    }), r.createElement("path", {
      fill: "#953220",
      d: "M406.22 302.5s.32.2.56.72c.24.5.41 1.33.97 1.83 1.11 1 9.54 1.3 12.1 1.3 2.56 0 10.22.34 11.67-.52 1.45-.87 1.62-2.3 2.52-2.94.89-.65 1.15-.6 1.15-.6l-1.11.94-.08 1.82.65 1s-.14.51-1.04 1.07c-.9.57-1.7.74-2.94.87-1.23.13-17.38.08-19.98-.35-2.6-.43-2.42-.39-3.2-.95a5.65 5.65 0 0 1-1.18-1.16l.34-1.17-.43-1.86zM432.41 287.01l1.45.63s-1.24.39-2.17 2.94c-.94 2.55-.17 3.37-.81 3.63-.64.26-7.63.05-7.63.05l-1.2-2.9 10.36-4.35z",
      stroke: "none"
    })), r.createElement("g", {
      fill: "#231f20"
    }, r.createElement("path", {
      d: "M454.69 286s-1.2-.43-1.75-1.43-1.02-2.24-.6-2.5c.44-.26 1.33.6 1.24 1.38-.08.78 1.11 2.55 1.11 2.55zM468.34 282.23s.85 1.55 1.15 1.73c.3.17 1.66.78 1.66.78s-1.92 0-2.51-.52c-.6-.52-1.45-1.95-1.45-1.95l1.15-.04z"
    }), r.createElement("path", {
      d: "M472.46 283.49s-1.15.69-2.13.3c-.98-.39-1.74-.95-1.36-1.38.38-.43.63-.26 1.15.3.5.57 2.34.78 2.34.78zM479.4 277.61s-.94.83-1.62.83-2.05-.27-2.05-.57c0-.3 1.8-.47 2.1-.43l1.57.17zM469 263.83s-1.54.47-2.04 1.25c-.51.78-.39 1.65.25 1.6.64-.04.81-.9.81-1.16 0-.26.98-1.69.98-1.69zM462.15 267.59s-1.15.73-1.45 1.38c-.3.65-.55 2.03.13 2.08.68.04.9-1.04.93-1.6.05-.57.39-1.86.39-1.86z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: ".7",
      d: "M449.89 275.88l-3.76 3.98s8.65 4.84 15.3 4.63c6.64-.22 14.22-5.4 14.73-6.49.51-1.07.09-5.7-.77-7.17-.85-1.47-5.45-5.06-7.2-4.88-1.74.17-4.81 2.5-7.66 5.27-2.86 2.76-2.56 5.1-6.52 4.88l-4.12-.22z"
    }), r.createElement("path", {
      fill: "#0c8489",
      d: "M448.93 277.47s9.26 1.39 11.92-.98c2.68-2.36 5.57-6.97 7.45-8s2.72-1.05 2.72-1.05 1.38.88 2.02 1.43c.64.55 2.35 1.96 2.35 1.96l.74 4.4.06 2.41-2.9 2.37-5.3 2.45-5.09 1.58-4.32-.12-8.74-2.53-2.22-1.57-.57-.5 1.88-1.85z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M463.04 272.14c0-.79.52-.75 1.22-.75s1.48.13 1.48.92c0 .8-.77 1.93-1.48 1.93-.7 0-1.22-1.31-1.22-2.1zM466.76 274.47c0-.71.54-1.1 1.39-1.1.85 0 1.62.95 1.62 1.66s-.69 1.28-1.53 1.28c-.85 0-1.48-1.13-1.48-1.84zM465.48 280.01c0-.89.54-1.07 1.4-1.07.84 0 1.36.4 1.36 1.28s-.7 1.6-1.54 1.6c-.85 0-1.22-.93-1.22-1.81zM460.6 278.31c0-.95.9-1.24 1.66-1.24.76 0 1.38.77 1.38 1.72 0 .94-.62 1.7-1.38 1.7-.76 0-1.66-1.23-1.66-2.18zM452.87 279.25a1.89 1.89 0 1 1 3.78 0 1.89 1.89 0 0 1-3.78 0z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      d: "M466.76 274.47c0-.64.87-1.1 1.39-1.1.52 0 .94.52.94 1.16 0 .63-.42 1.15-.94 1.15s-1.39-.58-1.39-1.21zM465.51 279.78c0-.73.68-1.04 1.45-1.04.77 0 1.36.3 1.36 1.04 0 .73-.63 1.32-1.4 1.32-.78 0-1.41-.59-1.41-1.32zM460.63 278.16c0-.8 1.33-1.18 1.88-1.18.55 0 .45.54.45 1.35 0 .82-.45 1.47-1 1.47-.54 0-1.33-.82-1.33-1.64zM462.93 272.05c0-.74.58-.78 1.05-.78.48 0 .83.22.83.97 0 .74-.4 1.34-.87 1.34-.48 0-1.01-.79-1.01-1.53zM452.85 278.68c0-.86.75-1.67 1.85-1.67s2.21.38 2.21 1.24-1.34 2.33-2.44 2.33c-1.1 0-1.62-1.04-1.62-1.9z"
    }), r.createElement("path", {
      d: "M456.39 277.18s-1.28.22-1.96.87c-.68.64-.77 1.38-.38 1.6.38.21.85-.48.98-.78a16.5 16.5 0 0 1 1.36-1.69zM462.53 275.84s-1.23.87-1.36 1.73c-.13.87 0 1.3.34 1.34.34.04.55-1.12.43-1.56-.13-.42.59-1.51.59-1.51z"
    }), r.createElement("path", {
      d: "M463.55 277.14s-.8.04-1.36.56c-.55.52-1.07 1.17-.68 1.21.38.04.98-.26 1.02-.6.04-.35 1.02-1.17 1.02-1.17zM464.87 270.01s-.64.52-.98.82c-.34.3-.77 1.17-.34 1.39.43.21.72-.18 1.02-.78.3-.61.3-1.43.3-1.43zM469.52 272.99s-1.2.17-1.58.69c-.38.52-.64 1.12-.12 1.12.5 0 .63-.26.85-.73.21-.47.85-1.08.85-1.08zM468.79 278.48s-.25.82-.98 1.2c-.72.4-.93.75-1.23.23-.3-.52.08-.78.46-.91.39-.13 1.75-.52 1.75-.52z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M476.2 274.76s.51 2.55-1.7 3.8c-2.22 1.26-8.44 5.66-14.31 5.14-5.88-.52-12.57-3.88-12.57-3.88l-.94.43 1.5.64 4.55 1.9 5.2 1.52 3.24.21 2.8-.34 5.2-1.73 4.4-2.25 2.29-1.81.61-.75-.06-1.07v-1.47l-.21-.34z"
    }), r.createElement("path", {
      d: "M360.78 241.54s1.36 1.17 1.24 2.16c-.13 1-.47 1.39-.86 1.21-.38-.17-.38-1.21-.3-1.64a9.11 9.11 0 0 0-.08-1.73zM370.86 250.91s-.38 1.73-1.07 1.9c-.68.17-1.19-.56-1.06-.86.13-.3.68-.05.98-.3.3-.26 1.15-.74 1.15-.74zM348.92 252.25s.47 1 1.36 1.17c.9.17 1.32-.44 1.2-.74-.13-.3-.52-.22-.98-.22-.47 0-1.58-.21-1.58-.21zM352.84 259.94s.81.95 1.92 1.08c1.1.13 1.66-.73 1.74-1 .09-.25-1.27-.21-1.7.14-.43.34-1.96-.22-1.96-.22zM359.78 265.86s1.79-.35 2.09-.82c.3-.48.76-1.3.38-1.77-.38-.48-.68.73-.9 1.2-.2.48-1.57 1.39-1.57 1.39z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: ".7",
      d: "M370.95 261.16s1.2-8.01-5.28-13.66c-6.48-5.64-10.68-4.26-12.9-2.18-2.21 2.07-4.14 8.87 2.73 14.8 6.87 5.94 15.34 4.1 15.34 4.1l.1-3.06z"
    }), r.createElement("path", {
      fill: "#0c8489",
      d: "M351.2 252.68s-.12-4.4 1.96-5.71c2.07-1.32 8.92-2.46 12.3 4.04 3.37 6.5 3.44 9.75 2.59 13.04l-3.62-.04-5.59-2.28-4.63-3.42-3.01-5.63z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M370.09 262.31s-1.13 1.27-3.46 1.15c-2.33-.11-13.18-2.94-15.9-12.67l.16 2.13.12.7.71 1.95 2.28 3.32 2.87 2.45 3.61 1.87 2.6.76 3.36.59h1.95l1.7-2.25z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M364.44 259.5c0-.87.44-.9 1.14-.9.69 0 1.22-.3 1.22.57 0 .86-.48 2.11-1.17 2.11s-1.19-.92-1.19-1.78zM364.9 254.35c0-.6.55-1.08 1.22-1.08.68 0 1.22.48 1.22 1.08 0 .6-.54 1.08-1.22 1.08-.67 0-1.22-.48-1.22-1.08zM359.98 260.03c0-.47.62-.85 1.38-.85.76 0 1.37.38 1.37.85s-1.36 1.1-2.13 1.1c-.75 0-.62-.63-.62-1.1zM359.53 253.96c0-.76.37-.52 1.04-.52s1.49.22 1.49.98c0 .77-.83 1.79-1.5 1.79-.66 0-1.03-1.49-1.03-2.25zM354.96 254.98c0-.64.43-1.54 1.25-1.54.81 0 1.7.9 1.7 1.54s-.66 1.17-1.48 1.17c-.8 0-1.47-.53-1.47-1.17zM355.78 249.61c0-.67.45-.63 1.3-.63.83 0 1.51.34 1.51 1 0 .68-.98 1.5-1.82 1.5-.84 0-.99-1.2-.99-1.87zM360.73 249.09c0-.65.55-.43 1.33-.43.8 0 1.43.52 1.43 1.16 0 .65-1 1.37-1.8 1.37-.78 0-.96-1.46-.96-2.1z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      d: "M355.78 249.47c.11-.46.43-.78 1.02-.78.59 0 1.1.11 1.1.78s-.47 1.21-1.06 1.21c-.58 0-1.22-.56-1.06-1.21zM354.87 254.74c0-.65.33-1.27 1-1.27.66 0 1.19.07 1.19.72 0 .66-.59 1.42-1.25 1.42-.67 0-.94-.22-.94-.87zM360.69 249.18c0-.52.44-.58 1.08-.58.63 0 1.05.14 1.05.65 0 .52-.52.94-1.15.94-.64 0-.98-.5-.98-1.01zM359.56 254.23c0 .7.52 1.29 1.16 1.29.65 0 1.34-.57 1.34-1.27 0-.72-.72-1.39-1.36-1.39-.65 0-1.14.66-1.14 1.37zM365.1 253.49c0 .64.56 1.17 1.25 1.17s1.25-.53 1.25-1.17c0-.65-.56-1.17-1.25-1.17-.7 0-1.25.52-1.25 1.17zM359.76 259.97c0-.56.59-1.1 1.17-1.1.57 0 1.13.35 1.13.91 0 .57-1 1.33-1.59 1.33-.58 0-.71-.58-.71-1.14zM364.47 259.14c0-.7.53-.75 1.25-.75s1.08.07 1.08.76c0 .7-.59 1.26-1.3 1.26-.73 0-1.03-.58-1.03-1.27z"
    }), r.createElement("path", {
      d: "M365.75 251.04s.72.9.85 1.6c.13.69.13 1.47-.13 1.55-.25.09-.68-.43-.8-1.08-.13-.65.08-2.07.08-2.07zM361.62 246.63s.47.74.47 1.39c0 .64-.09 1.33-.43 1.33-.34 0-.34-.64-.34-1.12 0-.47.3-1.6.3-1.6zM356.76 247.28s.47.74.47 1.39c0 .64-.09 1.33-.43 1.33-.34 0-.34-.64-.34-1.12 0-.48.3-1.6.3-1.6z"
    }), r.createElement("path", {
      d: "M355.06 248.19s.64.17 1.2.6c.55.44.76.95.55 1.21-.22.26-.73-.12-.86-.43-.12-.3-.89-1.38-.89-1.38zM358.76 253.28s.94.04 1.45.52c.51.48.93.87.64 1.21-.3.35-1.03-.26-1.32-.6-.3-.35-.77-1.13-.77-1.13zM354.25 253.11s.85.21 1.28.52c.42.3.55.9.34 1.04-.21.12-.51-.1-.9-.48-.38-.4-.72-1.08-.72-1.08zM365.15 256.53s.3 1.04.3 1.77c0 .74.08 1.38-.26 1.38s-.5-.9-.5-1.47c0-.56.46-1.68.46-1.68z"
    }), r.createElement("path", {
      d: "M363.92 258.21s.77.3 1.1.6c.35.3.43.78.18.87-.26.09-.43-.48-.64-.7-.21-.2-.64-.77-.64-.77zM359.06 258.51s.82.1 1.18.34c.35.25.39 1.37.35 1.51-.03.15-.57.05-.78-.49-.21-.53-.75-1.36-.75-1.36z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M357.18 243.69s-4.3.93-5.07 3.7a25.71 25.71 0 0 0-.82 5.84l-.62-3.52.86-2.29 1.24-2.1 1.9-1.18 1.7-.59.81.14zM370.57 260.1s.44-1.07-.82-4.46c-1.26-3.39-3.85-7.81-3.85-7.81l2.01 2.28 1.6 2.6.79 2.38.58 2.18-.04 2.14-.27.69z"
    }), r.createElement("path", {
      d: "M374.91 254.62s1.49.98 1.64 1.51c.15.55.21.72-.17.87-.38.15-1-.45-1.17-.87a8.59 8.59 0 0 1-.3-1.51zM368.62 271.52s.7-1.32 1.64-1.81c.94-.5 1.64-.44 1.9-.13.25.3-.62.99-1.26 1.23s-2.28.71-2.28.71zM379.19 275.56s1.04-.5 1.73-1.23c.68-.73.76-1.25.5-1.51-.25-.26-1.1.17-1.48.75-.39.58-.75 1.99-.75 1.99zM378.04 274.57s.36-1.36.73-1.8c.36-.43.87-.66 1.25-.43.39.24.15.85-.13 1.17-.27.33-1.85 1.06-1.85 1.06z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: ".7",
      d: "M395.71 266.52s-6.58-9.52-16.81-10.03c-8.18-.4-10.76 6.9-10.47 9.1.3 2.18 3.37 6.94 14.27 7.74 10.9.8 12.67-5.14 13.12-5.43.46-.29-.11-1.38-.11-1.38z"
    }), r.createElement("path", {
      fill: "#0c8489",
      d: "M387.94 259.98s2.73 2.08 3.88 3.72c1.15 1.64 1.4 2.85.72 3.07-.68.2-6.6-5.28-11.46-6.44-4.85-1.17-9.07-.09-10 2.25-.94 2.33-.6 5.83 1.61 7.25 2.22 1.43 12.61 3.12 12.61 3.12s4.73-.65 4.9-.74c.17-.08 3.02-1.68 3.02-1.68l.64-1.65.77-2.16.34-.86-2.51-2.77-4.52-3.11z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M379.59 261.32c0 .61-.64.91-1.28.91-.63 0-1.17-.32-1.17-.93 0-.6.52-1.1 1.15-1.1.64 0 1.3.51 1.3 1.12zM373.59 263.48c0-.61.69-.6 1.38-.6.68 0 1.24.5 1.24 1.11 0 .61-1.08 1.45-1.7 1.16-.77-.37-.92-1.05-.92-1.67zM380.04 267.01c0-.78.66-1.4 1.47-1.4.81 0 1.47.62 1.47 1.4 0 .77-1.1 1.62-1.92 1.62-.8 0-1.02-.85-1.02-1.62z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      d: "M375.16 268.45c0-.68.7-.82 1.3-.82.6 0 1.36.64 1.36 1.32s-.76 1.14-1.36 1.14c-.6 0-1.3-.96-1.3-1.64z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M383.89 270.82c0-.55.33-1.05.9-1.05.56 0 1.25.33 1.25.89 0 .55-.56 1.16-1.13 1.16-.56 0-1.02-.44-1.02-1zM387.81 267.83c0-.7.4-.63 1.09-.63.69 0 1.38.4 1.38 1.1 0 .7-.86 1.08-1.55 1.08-.7 0-.92-.85-.92-1.55z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      d: "M379.21 260.76c0 .55-.23.84-.77.84s-1.2-.3-1.2-.84c0-.55.26-.72.8-.72s1.17.17 1.17.72zM376.08 263.31c0 .6-.9.97-1.47.97s-.94-.37-.94-.97.44-.78 1-.78c.57 0 1.41.18 1.41.78zM377.47 268.35c0 .52-.2.93-.8.93-.62 0-1.42-.4-1.42-.93 0-.52.23-.89.84-.89.6 0 1.38.37 1.38.89zM382.68 266.64c0 .55-1.07 1.17-1.64 1.17-.57 0-.81-1.01-.81-1.56a1 1 0 0 1 1.02-.99c.57 0 1.43.83 1.43 1.38zM390.24 268.26c0 .57-.9.54-1.43.54-.51 0-.98-.64-.98-1.2 0-.58.17-1.11 1.45-.96.52.06.96 1.05.96 1.62zM385.77 270.57c0 .57-.44 1.04-.98 1.04s-.98-.47-.98-1.04c0-.57.44-.8.98-.8s.98.23.98.8z"
    }), r.createElement("path", {
      d: "M386.45 267.42s1.06-.35 1.87-.26c.81.09.86.39.86.52s-.64.39-.94.3a113 113 0 0 1-1.79-.56zM382.02 271.17s.85-.52 1.5-.65c.63-.12 1.14.09 1.1.48-.04.39-.26.48-.9.48-.63 0-1.7-.31-1.7-.31zM379.17 264.61s1.83.78 2.22 1.51c.38.74.55.91.16 1.13-.38.21-.8-.27-1.06-.6a71.74 71.74 0 0 1-1.32-2.04z"
    }), r.createElement("path", {
      d: "M378.7 266.94s1.4-.39 2.04-.39c.64 0 .82.05.9.35.09.3-.14.43-.67.4-.52-.03-2.27-.36-2.27-.36zM374.21 267.03s1.53.2 1.92.6c.38.4.38.77.22 1-.15.23-.88.09-1.1-.15-.23-.23-1.04-1.45-1.04-1.45z"
    }), r.createElement("path", {
      d: "M373.99 269.24c.07-.07.6-.87 1.15-1.05.55-.19 1.2-.16 1.3.13.12.29-.48.72-.87.8-.4.09-1.58.12-1.58.12zM372.83 262.53l1.52.42c.55.42.68.75.55.9-.13.16-.66.25-1.12-.05a2.82 2.82 0 0 1-.95-1.27zM376.16 258.66s1.55.43 2.06 1.14c.51.7.44 1.12.18 1.27-.25.14-.85-.22-1.19-.53-.34-.32-1.05-1.88-1.05-1.88z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M393.86 269.79s-3.15 2.68-10.26 2.42c-7.12-.26-13.55-3.28-15.17-6.61l.64 1.64 1.58 2.12 4.98 2.55 5.58 1.25 4.43.26 4.18-.73 3.23-1.56c.17-.08.51-.82.51-.82l.3-.52zM394.8 266.42s-1.2-1.47-2.85-3.03c-1.67-1.55-8.14-5.75-8.14-5.75l5.24 2.38 3.45 2.9 2.47 2.72-.17.78z"
    }), r.createElement("path", {
      d: "M395.1 260.11s1.79.7 2.09 1.12c.3.43.68.83.68.83s-.47 1.16-.9.69c-.42-.48-.5-.48-.98-1.13-.46-.65-.89-1.51-.89-1.51zM400.42 257.26s1.66.7 2.26 1.51c.6.83.47 1.52.21 1.6-.25.1-1.36-.86-1.53-1.25-.17-.39-.94-1.86-.94-1.86z"
    }), r.createElement("path", {
      d: "M402.09 256.92s1.57 1.17 1.83 1.69c.26.51.77 1.2.26 1.38-.52.17-1.24-.6-1.45-1.08-.22-.48-.64-1.99-.64-1.99zM411.07 259.03s1.24.43 1.36 1.47c.13 1.04-.12 1.77-.12 1.77s-.86-.73-.86-.95c0-.21.13-.39 0-.86l-.38-1.43zM413.46 259.86s.98 1 1.1 1.64c.14.65.26 1.08-.29 1.17-.55.09-.85-.56-.85-1.12 0-.57.04-1.69.04-1.69zM397.36 279.48s.77.34 1.49.09c.72-.26 1.32-.91 1.2-1.34-.13-.44-.52-.83-1.07-.26-.56.56-.26.82-.68 1.03l-.94.48zM406.22 281.89s1.2-.17 2-1.04c.81-.86 1.15-1.47.6-1.68-.55-.22-1.28 0-1.4.69-.13.69-1.2 2.03-1.2 2.03zM413.5 282.15s.9-.52 1.58-1.17c.68-.64 1.06-1.03.6-1.5-.47-.49-.82-.14-1.03.08-.21.22 0 .22-.25.9-.26.7-.9 1.69-.9 1.69z"
    }), r.createElement("path", {
      d: "M415.72 282.11s.96-1.17 1.18-1.82c.22-.64.34-1.38-.1-1.34-.43.04-.96.65-.98 1.13-.04.47-.1 2.03-.1 2.03z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: ".7",
      d: "M393.56 270.31c.06-3.2 4.6-10.59 9.84-10.5 2.18.04 6.46 1.17 9.92 2.72 2.9 1.3 3.84 2.73 5.76 3.2 1.91.47 4.8.13 4.8.13l6.53-.74-5.12 7.48-1.82 1.64s-1.63 3.16-6.27 4.97c-4.64 1.82-12.48.48-16.02-.39-3.53-.86-7.7-4.23-7.62-8.51z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M393.56 270.31h.34c.01-.71.29-1.74.79-2.84.74-1.66 1.98-3.5 3.5-4.93 1.51-1.41 3.3-2.39 5.12-2.39h.08c1.04.02 2.64.3 4.4.78 1.76.48 3.68 1.15 5.4 1.91 1.41.64 2.34 1.3 3.18 1.88a7.8 7.8 0 0 0 2.62 1.34c.83.2 1.8.27 2.66.27 1.24 0 2.27-.13 2.28-.13l5.77-.65-4.66 6.82-1.85 1.66-.03.05v.01c-.08.14-1.68 3.08-6.08 4.8-1.63.64-3.7.88-5.85.88-3.76 0-7.74-.74-9.97-1.28a11.04 11.04 0 0 1-4.96-2.85 7.42 7.42 0 0 1-2.4-5.2v-.12l-.34-.01-.34-.01v.14c0 2.23 1.09 4.2 2.6 5.7a11.72 11.72 0 0 0 5.28 3.02 45.9 45.9 0 0 0 10.13 1.3c2.2 0 4.34-.24 6.1-.93 4.74-1.85 6.41-5.08 6.43-5.13l-.3-.16.23.26 1.86-1.67 5.56-8.13-7.26.82-.17.01c-.34.04-1.13.1-2.04.1-.83 0-1.75-.05-2.49-.24a7.16 7.16 0 0 1-2.4-1.24c-.83-.57-1.81-1.28-3.3-1.93a38 38 0 0 0-5.49-1.95c-1.79-.49-3.42-.79-4.56-.81h-.1c-1.37 0-2.69.49-3.88 1.25a14.74 14.74 0 0 0-4.41 4.7c-1.1 1.79-1.76 3.6-1.8 4.9h.35z"
    }), r.createElement("path", {
      fill: "#0c8489",
      d: "M425.21 271.31c-.55.43-1.15.43-1.83.43-.69 0-15.2-8.86-19.72-8.47-4.52.39-8.82 2.34-8.95 6.96-.13 4.62 1.02 4.67 1.96 5.96.94 1.3 9.8 3.25 9.8 3.25l5.4-.1 4.36-.47 3.83-2.07 2.09-1.69 1.4-1.72 1.66-2.08z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M402.26 268.95c0 .9-.35 1.54-1.23 1.54s-1.54-.4-1.54-1.3.5-1.25 1.38-1.25c.88 0 1.39.1 1.39 1.01zM403.78 264.91c0-.75.73-1.08 1.56-1.08.84 0 1.48.3 1.48 1.05s-.66 1.33-1.5 1.33c-.83 0-1.54-.55-1.54-1.3zM412.48 267.27c0-.65.56-1.19 1.26-1.19.69 0 1.25.54 1.25 1.19 0 .66-.56 1.19-1.25 1.19-.7 0-1.26-.53-1.26-1.19zM414.23 272.6c0-.84.6-1.51 1.36-1.51.76 0 1.46.35 1.46 1.18 0 .84-.27 1.65-1.03 1.65-.75 0-1.79-.49-1.79-1.32zM410.01 276.01c0-.72.64-1.3 1.43-1.3.79 0 1.42.58 1.42 1.3 0 .72-.56 1.18-1.35 1.18s-1.5-.46-1.5-1.18zM402.04 274.63c0-.7.56-1.25 1.26-1.25a1.25 1.25 0 1 1 0 2.5c-.7 0-1.26-.56-1.26-1.25z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      d: "M402.21 268.76c0 .71-.61 1.3-1.36 1.3-.76 0-1.37-.59-1.37-1.3 0-.72.6-1 1.36-1 .75 0 1.37.28 1.37 1zM406.43 264.65c0 .7-.22 1.14-.95 1.14-.72 0-1.7-.45-1.7-1.14 0-.7.6-1.25 1.33-1.25.73 0 1.32.56 1.32 1.25zM414.86 266.9c0 .6-.55 1.08-1.24 1.08-.68 0-1.23-.49-1.23-1.08 0-.6.55-1.08 1.23-1.08.69 0 1.24.48 1.24 1.08z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M410.39 270.46c0 .91-.35 1.55-1.23 1.55-.89 0-1.54-.4-1.54-1.31s.5-1.24 1.38-1.24c.88 0 1.39.1 1.39 1z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      d: "M404.3 274.33c0 .72-.61 1.3-1.36 1.3-.76 0-1.37-.58-1.37-1.3 0-.71.87-1.08 1.62-1.08.75 0 1.11.37 1.11 1.08zM410.13 270.31c0 .72-.6 1.3-1.32 1.3a1.3 1.3 0 0 1-1.32-1.3c0-.71.6-1.3 1.32-1.3.73 0 1.32.59 1.32 1.3zM417.02 272.09c0 .79-.48 1.42-1.3 1.42-.83 0-1.5-.64-1.5-1.43 0-.78.25-1.05 1.07-1.05.82 0 1.73.27 1.73 1.06zM412.61 275.71c0 .74-.5 1.16-1.25 1.16-.76 0-1.48-.42-1.48-1.16s.65-1.04 1.4-1.04c.75 0 1.33.3 1.33 1.04z"
    }), r.createElement("path", {
      d: "M413.12 271.39s2.17-.22 2.55.17c.39.4.34.95.17 1.13-.17.17-1.02.21-1.23-.09-.21-.3-1.49-1.21-1.49-1.21zM410.99 264.39s1.66.43 2.34 1.12c.68.7.56 1.39.43 1.51-.13.13-.73.27-1.2-.25-.46-.52-1.57-2.38-1.57-2.38zM406.05 267.76s1.94 1.06 2.36 1.66c.43.6.54 1.08.35 1.34-.2.26-1.16-.07-1.3-.39-.15-.32-1.41-2.61-1.41-2.61z"
    }), r.createElement("path", {
      d: "M405.2 269.25s2.17.28 2.7.7c.54.4.92.42.88.75-.04.32-.28.56-.62.52a4.72 4.72 0 0 1-1.49-.65l-1.47-1.32zM402.7 262.89s2.22.35 2.67.7c.46.34.57 1.32.06 1.61-.51.28-1.08-.29-1.25-.7-.17-.4-1.48-1.61-1.48-1.61zM397.92 266.24s2.04.97 2.67 1.87c.34.49.64.9 0 1.13-.58.19-1.2-.87-1.2-1.13 0-.26-1.47-1.87-1.47-1.87z"
    }), r.createElement("path", {
      d: "M397.47 268.89s1.3-.29 1.93-.29c.62 0 1.52-.22 1.53.29.01.5-.76.6-1.22.46-.46-.16-2.24-.46-2.24-.46zM408.75 276.17s1.43-.89 2.13-.74c.7.16.94.1.94.52 0 .43-.83.35-1.1.35-.25 0-1.97-.13-1.97-.13zM400.85 275.02s.55-.82 1.15-.9c.6-.1.85-.05.94.2.08.27-.51.74-.77.74l-1.32-.04z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M423.43 273.58s-2.17 2.61-5.2 3.91c-3.02 1.3-5.32 1.73-9.54 1.47-4.21-.26-6.26-.9-9.11-2.38-2.86-1.47-5.12-3.58-5.54-4.49-.43-.91.47 1.51.47 1.51l2.6 3.41 3.1 1.39 4.56 1.12 4.3.52 3.28-.08 3.92-.61 2.52-.9 1.7-1.05 1.32-1.08 1.62-2.74zM419.37 265.86s-1.18.4-3.78-1.21c-2.6-1.6-5.7-3.68-11.59-3.72-5.87-.04-7.75 3.98-8.13 4.28-.39.3 2.64-3.5 2.64-3.5l2.68-1.42 2.09-.35 2 .09 2.6.69 2.34.73 2.73.9 2.38 1.31 2.88 1.5 1.16.7zM427.26 267.59s-3.45-.04-4.43.04c-.98.09-1.02.26-1.15.52-.13.26-.39.6-.39.6l-1.06-2.29 4.69-.65 2.55.96-.21.82z"
    }), r.createElement("path", {
      fill: "#0c8489",
      stroke: "#04534e",
      strokeWidth: ".7",
      d: "M420.91 291.7c.24.63.78 1.2 1.47 1.22.69.02 2.13-.03 2.13-.03l4.67-.28 1.64-1.88 1-4.22s1.26-1.53 1.26-1.6 4.34-2.4 4.34-2.4l3.75-1.07 2.4-.26 3.33-1.1 2.45-1.28 1.06-1.58 1.04-2.4-1.04-3.24-2.6-3.47-4.4-1.8h-3.65l-4.09 1.5-7.2 1.7s-3.96 1.73-5.6 4.82c-1.63 3.09-1.62 3.89-1.9 7.97-.27 4.09-.06 9.4-.06 9.4z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      d: "M422.86 290.09c1.38 0 .31-2.28 1.88-4.99 1.56-2.7 3.46-6 3.94-6 .49 0 .57.5 1.14.33a3.79 3.79 0 0 0 1.59-1.27c.06-.23.06-1.76 1.25-2.74 1.2-.98 2.87-2.36 3.66-2.53.8-.17 1.17-.32 1.3.06.15.37-.45.89.1 1.06.53.18 1.78.12 2.1-.69.3-.8.22-1.24.22-1.24s.83-.8 2.39-.46c1.56.35 1.76.26 1.9.87.14.6-.71.69-.54 1.12.17.43-.12.38.04.71.16.33.41 1.25 1.46 1.22 1.06-.03 1.5-.64 1.5-.64l.32-.55s.29-.65-.11-.91c-.4-.26-.26-.58.14-.4.4.17 1.99 2.38 2.53 1.46.54-.92.6-2.22.31-2.53-.28-.32-2.53-3.7-2.53-3.7l-4-1.35-5.31.44-5.14 2.94-4.72 2.5s-.25 3.86-1.1 3.17c-.86-.7-2.08-2.6-2.44-1.96-.38.64-1.2 3.46-1.68 4.87-.48 1.41-1.87 5.76-1.74 7.38.15 1.61 1.03 3.83 1.54 3.83z"
    }), r.createElement("path", {
      fill: "#8cbebf",
      d: "M427.6 283.85a2 2 0 0 0-1.08.62c-.17.22-.41.68-.26 1.18.16.5.9 1 .96 1.05l.59-.01 1.28-.38s.4-.46.43-1.06c.02-.6-.35-.77-.53-.82-.19-.06-1.39-.58-1.39-.58zM435.72 277.14c-.73-.26-1.05.24-1.17.45-.13.22-.07.75-.07.75s.15 1 .54 1.19c.38.18 1.38.53 1.7.18.32-.34.64-.58.62-1.23-.01-.65-.92-.97-.92-.97l-.7-.37zM442.26 278.71c-.03-.25-.67-.42-1.1-.34-.42.07-1 .61-.79 1.43.2.82.98.9 1.6.74.6-.16.49-1.03.49-1.15 0-.13-.2-.68-.2-.68zM423.37 280.03c0 .37.68 1.15 1.6 1.1.9-.06 1.46-.75 1.55-1.3.09-.55-.48.46-1.16.63-.68.17-1.08.35-1.4-.03-.3-.37-.59-.4-.59-.4z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M429.52 285.25s.1.83-.5 1.27c-.6.43-.99.38-1.34.38-.34 0-.72-.07-.97-.41-.26-.35-.44-.84-.44-.84s.66 1.1 1.7.8c1.05-.28 1.55-1.2 1.55-1.2zM447.11 274.35s0 .84-.66 1.19c-.65.35-.95.45-1.3.4-.34-.04-.82-.18-1.04-.55-.78-1.2-.32-1.99-.32-1.99s.56 2.1 1.63 1.95c1.07-.15 1.69-1 1.69-1zM431.43 278.1s-.54 1.64-1.62 1.64-.99-.31-.9-.52c.08-.2.48.2.96.06s1.56-1.18 1.56-1.18zM434.47 277.81s-.11 1.19.29 1.59c.4.4.85.61 1.3.61.46 0 .8-.12 1.14-.58.34-.46.14-.95.14-.95s0 .25-.33.6c-.34.34-.62.4-.96.4-.34 0-.93-.05-1.1-.45-.17-.4-.48-1.22-.48-1.22zM440.04 272.09s.34.89-.34 1.61c-.68.72-1.99.32-1.99.32s1.05.26 1.57-.32c.5-.57.76-1.61.76-1.61z"
    }), r.createElement("path", {
      fill: "#04534e",
      d: "M422.26 292.59s6.91-.12 7.47-1.07c.55-.95-.6-4.66 3.58-7.6 4.17-2.94 7.4-2.9 9.62-3.07 2.22-.17 7-1.66 7.84-5.92.5-2.6-2.98-2.77-4.3-5.23-1.32-2.46-4.73-1.47-4.9-1.47-.17 0-3.95-.1-5.75 1.64-1.07 1.04-.94 2.34-1.45 2.94-.51.6-5.07 0-5.58.74-.51.73.13 2.28-.22 2.63-.33.35-1.44-1-1.44-1l.38-3.67 5.84-3.4 6.64-3.68s4.35.21 4.52.13c.17-.1 4.47 2.24 4.6 2.29.12.04 2.25 2.6 2.25 2.6s.42 1.03.6 3.06c.09.96 0 1.79-.2 2.54-1.08 3.83-4.82 6.4-8.77 6.6-3.94.2-7.5 1.97-9.3 3.28-1.8 1.3-2.7 7.06-2.72 7.76-.03.69-8.6.22-8.6.22l-.11-.32z"
    }), r.createElement("path", {
      d: "M425.17 279.13c-.35.28-.87.27-.98-.13-.32-1.13.35-2.8.35-2.8s-.01 1.75.12 2.04c.13.28.48.22.63.46.06.08.16.2-.12.43zM429.52 278.24c-.33-.1-.28-1.17-.02-1.62.25-.45 2.2-1.88 2.2-1.88l-.86 1.95c-.23.51-.9 1.68-1.32 1.55zM427.81 285.26c-.27.06-.36-.54-.36-1.3 0-.75 1.32-2.14 1.32-2.14s-.4 1.22-.45 1.6c-.04.4.22.74.17 1.2-.04.44-.38.58-.68.64z"
    }), r.createElement("path", {
      d: "M431.03 283.32s-.62.71-1.32 1.1c-.7.39-1.47.97-1.9.85-.42-.14.28-1.06.51-1.15 1.2-.48 2.71-.8 2.71-.8zM436.95 274.87s-.79.65-1.17 1.58c-.38.93-.55 1.68-.17 1.86.39.17.96-1.06 1-1.47.04-.41.34-1.97.34-1.97z"
    }), r.createElement("path", {
      d: "M439.12 277.83s-.55-.52-1.53-.75c-.98-.24-1.43-.03-1.54.26-.1.27-.83.72-.46.93.36.22.78-.37 1.08-.44.3-.06.64-.28 1.17-.2.53.1 1.28.2 1.28.2zM437.85 272.03c.35.3.88-.26 1.37-.8.48-.56.85-1.56.85-1.56s-1 .52-1.42.86c-.43.35-1 1.33-.8 1.5zM446.88 271.82s-1.16.55-1.56 1.07c-.4.52-.91 1.09-.51 1.38.4.29.76-.26 1.08-.69.3-.43.99-1.76.99-1.76zM444.3 277.87s-.4.8-1.13 1.3c-.74.49-1.62.72-1.76.46-.15-.26.11-.81.4-.95.28-.15.45-.12 1.1-.29a9.58 9.58 0 0 0 1.39-.52z"
    })), r.createElement("g", null, r.createElement("ellipse", {
      fill: "url(#b)",
      cx: "385.55",
      cy: "257.83",
      rx: "3.77",
      ry: "5.63",
      transform: "rotate(8.67 385.55 257.83)"
    }), r.createElement("g", {
      fill: "#fcca3e",
      stroke: "#aa8c30"
    }, r.createElement("path", {
      strokeWidth: ".35",
      d: "M387.66 247.73l-2.24 5.6 1.83-.25 1.06-4.93z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M388.7 245.35c-.8-.1-1.53.5-1.63 1.36-.1.85.45 1.62 1.25 1.72.8.1 1.53-.5 1.64-1.36.1-.85-.46-1.62-1.26-1.72z"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M485.22 259.35l-5.52 5.18 2.28.58 3.78-5z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M487.68 257.21a2 2 0 0 0-2.62.74c-.56.9-.3 2.02.58 2.5a2 2 0 0 0 2.62-.73c.56-.9.3-2.02-.58-2.51z"
    }), r.createElement("path", {
      strokeWidth: ".35",
      d: "M344.88 229.45l2.91 6.42 1.26-1.79-3.3-4.86z"
    }), r.createElement("path", {
      strokeWidth: ".3",
      d: "M343.71 226.65a1.8 1.8 0 0 0-.17 2.5c.63.78 1.73.9 2.46.3.72-.61.8-1.74.16-2.5a1.73 1.73 0 0 0-2.45-.3z"
    })), r.createElement("g", {
      fill: "#aa8c30"
    }, r.createElement("path", {
      d: "M389.25 245.56s.45.24-.07.08c-.52-.15-1.76.45-1.76 1.32 0 .87.65 1.36 1.3 1.36.66 0-.24.12-.24.12l-.84-.25-.35-.5-.28-.7.21-.76.5-.65.65-.23.43.05.45.16z"
    }), r.createElement("path", {
      d: "M387.99 249.33s-.36-.07-.68.4c-.32.49-.97 1.4-.97 1.4l1.25-3.09.68.36-.28.93zM488.22 257.69s.4.48-.13.06-2.28-.34-2.74.63c-.46.98.06 1.82.82 2.13.76.32-.35.02-.35.02l-.86-.67-.14-.73.03-.92.65-.73.92-.49.88.05.47.26.45.39z"
    }), r.createElement("path", {
      d: "M484.78 261.3s-.38-.25-1.01.13c-.62.39-1.86 1.08-1.86 1.08l3.06-2.84.62.72-.81.91zM344.33 226.33s.56-.2.01.13c-.55.32-1.04 1.87-.3 2.57.73.7 1.66.53 2.19-.03s-.1.3-.1.3l-.88.54-.7-.11-.82-.32-.47-.79-.14-.95.32-.75.4-.33.49-.26z"
    }), r.createElement("path", {
      d: "M346.49 230.45s-.35.25-.2.91c.15.67.38 1.95.38 1.95l-1.59-3.54.85-.31.56.99z"
    })), r.createElement("ellipse", {
      fill: "url(#c)",
      cx: "351.47",
      cy: "241.61",
      rx: "6.06",
      ry: "4.08",
      transform: "rotate(62.9 351.47 241.6)"
    }), r.createElement("g", {
      fill: "#e92736"
    }, r.createElement("path", {
      d: "M344.65 240.24s1.25.29 1.93-.06c.68-.34.8-.86.96-1.03.18-.17.35-.8.29-1.21a4.99 4.99 0 0 0-1.25-1.9c-.28-.12-1.25 0-1.42-.18-.17-.17.14-.55-.23-.63-.37-.09-2.27 2.08-1.93 2.42.34.34.54-.17.65.12.12.28.03 1.09.03 1.43 0 .35.97 1.04.97 1.04z"
    }), r.createElement("path", {
      d: "M346.5 236.2c.15.3.85 1.24 1.14 1.35.28.12 1.13.15 1.42.04.28-.12 1.19-.99 1.22-1.36.03-.38 0-.66-.17-1.04-.17-.37-.07-1.38-.41-1.44-.35-.06-.5-.1-.66-.3-.17-.2.1-.56-.15-.94-.26-.37-3.3 1.42-3.07 1.76.23.35.54-.03.65.2.11.23-.14 1.38.03 1.73z"
    }), r.createElement("path", {
      d: "M353.37 235.43c.17-.46.11-1.96-.2-2.28-.31-.31-.82-.34-.85-.54-.03-.2.37-.3.37-.64s-3.38.12-3.15.5c.22.37.8.17.76.4-.03.22-.57.51-.62.8-.06.3.17 1.24.31 1.47.14.24-.05.52.34.66.4.15.34.15.71.26.37.12 1.7.06 1.88-.08.17-.15.28-.09.45-.55zM382.1 252.31s.55.96 1.17 1.19c.6.23 1 0 1.2 0 .2 0 .7-.25.9-.53.22-.27.54-1.65.44-1.9-.1-.25-.73-.8-.72-1 0-.21.42-.23.25-.51-.16-.29-2.6-.23-2.61.2-.01.41.42.23.31.47-.11.25-.65.66-.87.86-.21.2-.07 1.22-.07 1.22z"
    }), r.createElement("path", {
      d: "M385.66 251.11c-.1.27-.26 1.26-.17 1.51.1.25.58.8.82.91.23.12 1.3.19 1.54-.02.25-.2.41-.38.54-.71.13-.33.8-.86.64-1.1-.16-.25-.22-.37-.2-.6.03-.23.41-.26.49-.64.08-.38-2.8-1.26-2.87-.91-.08.35.33.32.25.53-.07.2-.93.72-1.04 1.03z"
    }), r.createElement("path", {
      d: "M390.16 255c.38-.16 1.27-1.07 1.28-1.46.01-.38-.27-.72-.16-.86.1-.13.4.07.6-.14.22-.2-2.04-2.06-2.14-1.7-.1.36.36.6.2.72-.16.12-.65-.05-.86.08-.21.13-.66.83-.72 1.06-.06.22-.35.27-.2.6.14.34.1.3.25.6.14.3.96 1.11 1.15 1.13.19.03.22.14.6-.03zM476.9 262.25s.05 1.07.46 1.55c.42.48.84.47 1.01.57.17.1.7.11 1-.01a4.03 4.03 0 0 0 1.19-1.4c.03-.25-.27-1.01-.17-1.19.1-.17.45 0 .43-.3-.01-.32-2.08-1.42-2.28-1.08-.19.35.25.4.06.56-.2.15-.85.24-1.1.3-.28.08-.6 1-.6 1z"
    }), r.createElement("path", {
      d: "M480.26 262.95c-.21.16-.84.82-.9 1.05-.04.23.06.86.2 1.05.12.2.93.73 1.23.69.3-.04.52-.1.78-.29.27-.19 1.07-.27 1.07-.53s0-.38.14-.54c.13-.15.46 0 .7-.25.26-.25-1.57-2.21-1.8-1.99-.25.22.09.4-.07.51-.17.12-1.1.12-1.35.3z"
    }), r.createElement("path", {
      d: "M480.96 267.83c.36.14 1.56.14 1.82-.1.26-.22.3-.6.46-.62.16-.01.22.29.5.3.27 0 0-2.55-.3-2.39-.31.17-.18.6-.35.57-.19-.03-.4-.44-.63-.49a3.1 3.1 0 0 0-1.18.2c-.18.1-.4-.06-.53.24s-.13.25-.23.53c-.1.27-.1 1.27.02 1.4.1.14.06.22.42.36z"
    })), r.createElement("g", {
      fill: "#f7e204"
    }, r.createElement("path", {
      d: "M346.72 237.45c.28.42-.09 1.42-.32 1.7-.22.29-1.74-.12-1.76-.4-.02-.29-.13-.76.07-1.03.2-.26.7-.87 1.09-.8.38.07.82.39.92.53zM347.13 235.57c-.18.38.08.8.27 1.02.2.2 1.29.48 1.58.3.3-.19.75-1.87.54-2.13-.2-.26-.79-.3-.99-.28-.2.04-1.28.83-1.4 1.09zM350.75 233.85c-.15.34-.1.82.03.97.12.15.83.64 1.24.62.42-.03.62-1.2.62-1.42 0-.22-.13-.32-.42-.45-.3-.12-1.47.28-1.47.28zM385.02 251.98c-.1.42-.93.78-1.23.8-.31.02-.94-1.18-.78-1.36.16-.18.38-.53.66-.55.28-.03.96-.07 1.13.22.18.28.25.74.22.89zM386.42 251.14c-.34.1-.45.52-.47.77-.01.24.46 1.09.74 1.17.29.08 1.6-.62 1.63-.9.03-.29-.28-.68-.42-.79a3.9 3.9 0 0 0-1.48-.25zM389.59 252.43c-.3.1-.56.42-.58.58-.02.17.09.9.35 1.15.26.25 1.09-.3 1.23-.44.13-.13.12-.26.03-.52-.1-.26-1.03-.77-1.03-.77zM479.57 263.19c-.26.31-1.11.22-1.38.09-.27-.13-.28-1.43-.07-1.5.21-.08.56-.27.8-.16.25.1.83.4.86.72.02.32-.12.74-.21.85zM480.84 263.31c-.32-.07-.62.19-.76.36-.13.18-.18 1.02 0 1.2.18.2 1.57.27 1.74.07.17-.2.12-.63.07-.77a3.5 3.5 0 0 0-1.05-.86zM482.29 265.9c-.27-.11-.65-.1-.77 0-.12.09-.54.6-.53.92 0 .32.93.49 1.1.5.19 0 .27-.09.38-.3.1-.22-.18-1.12-.18-1.12z"
    })), r.createElement("ellipse", {
      fill: "url(#d)",
      cx: "476.69",
      cy: "268.57",
      rx: "2.94",
      ry: "5.86",
      transform: "rotate(47.85 476.7 268.57)"
    })), r.createElement("g", null, r.createElement("g", {
      fill: "#78732e"
    }, r.createElement("path", {
      fill: "#a8ac71",
      d: "M375.12 185.22s-5.03.43-8.52-.17c-3.5-.6-2.73-9.51-2.81-9.77-.09-.26-2.13-2.42-1.8-4.4.35-2 6.8-7.24 7.68-7.52.6-.2 1.87.34 1.87.34s1.63-1.58 2.12-1.58c.5 0 1.18.91 1 1.3-.2.39-2.42 1.68-2.59 2.68-.17 1 .03 1.99-.62 2.96-.63.97-1.87 2.29-2.02 3.11-.15.82-.5 1.54.1 1.84.63.3 2.74.04 4.55-.78 1.8-.82 2.55-1.92 2.8-1.82.26.11-1.04 2.27-3.04 3.12-2 .84-3.32 1.81-4.32 1.66 0 0-1.11 2.66 2.32 2.8 3.43.16 5.32-.75 5.32-.75l-2.04 6.98zM355.48 206.18s2.64 1.04 2.64 3.98c0 2.93-2.9 5.4-2.81 10.58.09 5.19.9 5.24 7.75 10.8a7.45 7.45 0 0 1 2.05 3.34c.38 1.68 1.62 11.62 8.22 11.57 6.6-.04 7.5-4.23 7.5-4.23l-2.82-4.15s-2.3.7-3.53.4a4.51 4.51 0 0 1-3.07-2.73c-.72-1.6-.92-5.4-2.04-7.09-2.77-4.15-7.71-4.84-7.76-9.2-.04-4.37 3.03-4.84 2.18-10.03-.85-5.18-7.03-7.7-7.03-7.7l-2.51-1-.88 5.2 2.11.26z"
    }), r.createElement("path", {
      fill: "#f1a720",
      d: "M373.67 169.89c2.21-.52.94-6.29.94-6.29l-1.54 1.28s.95 1.23.95 2.56c0 1.32-.35 2.45-.35 2.45z"
    }), r.createElement("path", {
      fill: "#a8ac71",
      d: "M377.71 227.47s-1.03-.84-1.13-.91c-.79-.53-4.26-3.33-3.7-11.66.63-9.42 14.32-14.38 15.22-18.12 1-4.15 4.1-5.96-6.82-14.5l-2.55 3 4.47 3.36s.99-.55 1.05.72c.06 1.26-1.2 2.35-1.5 3.34-.29.9-7.09 5.64-7.6 6.1-.51.46-3.9 3.1-3.9 3.1s-1.78 1.74-3.42 5.4c-1.65 3.66-.8 8.35-.8 8.35s.05 10 10.68 11.82z"
    }), r.createElement("path", {
      d: "M371.03 232.74l.77 3.54-2.17.8-.94-.04-.68.3-1.69 1.62-.42-.13s-.26.09-.34-.95c-.09-1.03-.24-1.94-.24-1.94l2.05.84.72.04.51-.17.9-1.94 1.53-1.97zM364.68 233.39s-.68-.82-1.02-1.32c-.3-.42-.44-.52-1.2-1.12l1.5-.84 1.6.02-.24 1.92-.64 1.34zM368.31 227.7s1 .5 1.32 1.25c.32.76.79 1.69.79 1.69l-2.54-.2-1.93-.6 1.25-1.75 1.11-.39zM367.32 243.37s-.51-.32-.81-1.14c-.3-.82-.53-2.14-.53-2.14l1.68-.32 1.98.8.56.04s-.47 1-.54 1.04l-1.91 1.66-.43.06zM374.04 237.94s-1.49-.47-1.72-1.17c-.26-.75-.45-.6-.45-.6l-.47 2-.6 1.89s.13.32.2.32c.06 0 1.42-.35 1.51-.39.08-.04 1.13-1.12 1.15-1.18l.38-.87zM367.77 244.25s.75.41 1.79 1.02c1.04.6 1.66.6 1.66.6l.79-.84.8-1.6.11-.2-4.02.37-1.13.65zM373.59 242.7l3.43-2.05.23-1.86-.68-.52s.13.06-.8.06h-1.18l-.62 2.27-.38 2.1zM371.14 245.94s2.4 1.04 6.56-.48c1.88-.68 2.24-1.6 2.24-1.6l-1.67-.64-1.57 1.4-5.56 1.32zM367.86 219.31s-.24-.78-.48-1.79c-.23-1.01-.21-1.45-.21-1.45l1.22.64 1.77 1.31-1.26 1-1.04.29zM370.75 224.2s-.6-.6-1.1-1.38c-.52-.78-.87-1.5-.87-1.5l1.3.27 1.5.73-.66 1.95-.17-.07z"
    }), r.createElement("path", {
      fill: "#c6c7a6",
      d: "M363.02 169.18c-.23.84-.54 2.36.62 2.65.64.16 3.13-.05 5.97-3.28 1.36-1.56 1.39-3.09 1.39-3.09l.54-1.75s-1.1-.81-2.9.31c-1.6 1.01-5.62 5.16-5.62 5.16z"
    }), r.createElement("ellipse", {
      fill: "#1c242f",
      cx: "370.77",
      cy: "164.64",
      rx: ".5",
      ry: ".53"
    }), r.createElement("path", {
      fill: "#a8ac71",
      d: "M367.16 165.17c-1.21.95-2.34 2.16-2.34 2.16s1.91-.54 3.44-1.92a4.52 4.52 0 0 1 3.44-.89c.46.1.3-.49.08-.66-.5-.4-1.88-.59-2.18-.36-.05.03-1.22.72-2.44 1.67z"
    }), r.createElement("path", {
      d: "M372.92 218.3s-.08-.4-.14-1.4c-.05-.99.06-1.49.06-1.49l-1.13.99-1.09 1.51 1.68.6.62-.21zM367.04 214.94s-.16-1.55-.07-3.01c.08-1.47.68-4.14.68-4.14l.72 1.83 2.06 3.21.66.48-1.74 1.28-1.8.58-.51-.23zM372.96 214.12s.1-.73.29-1.41c.17-.67.7-1.73.7-1.73s.02.1-.07.13a33.73 33.73 0 0 0-2.66 2.24l1.09.83.7-.04M368.19 206.48s.26-.96 1.18-2.13l1.82-2.36.78 3.13.46 2.68.09.56s-.64.28-.9.26c-.25-.02-2.17-.13-2.4-.45a42.79 42.79 0 0 1-1.03-1.69zM374.4 210.13s.58-.62 1.1-1.1c.5-.47 1.32-1.39 1.32-1.39l-4.21.77.6 1.43 1.19.29zM371.86 201.43s.39-.14 1.52-1.28c1.13-1.15 1.7-1.01 1.7-1.01l.47 4.52-2.21-.65-1.48-1.58z"
    }), r.createElement("path", {
      d: "M377.1 207.36l2.53-2.57-4.21-1.2.77 2.95zM378.87 200.56l.26-4.36s-.86.4-1.95 1.3a13 13 0 0 1-1.59 1.2l.51.78 1.5.97 1.27.11zM382.62 196.33v-3.44l-.14.07s-.6.93-1.3 1.51c-.71.59-1.03 1-1.03 1l1.13.73 1.34.13zM384.19 200.93s1.19-.99 2.06-1.67c1.3-1.03 1.94-2.15 1.94-2.15l-5.45-.42.22 2.19 1.23 2.05zM371.51 182.88l-.17 2.4 4.55-.03-1.11-1.53-1.4-.87-1.3-1.32zM380.29 204.19c.24-.18 1.42-1.07 1.98-1.63.62-.63 1.59-1.26 1.59-1.26l-4.33-.47.09 2.85.67.51zM388.52 196.4s.46-1.74.42-3.4c-.04-1.67-.31-2.41-.31-2.41l-3.24 2.2.47 1.64 1.23 1.35 1.43.62z"
    }), r.createElement("path", {
      d: "M382.98 192.4s.96-1.16 1.02-1.83c.07-.67.06-.46.06-.46l2.56.04 1.53.13.19.15-1.15 1.36-1.58.91-2.02.24-.61-.54zM388.16 189.85l-1.57-2.67a5.64 5.64 0 0 0-1.11-1.4l-1.25 3.71-.13.36h4.06z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M356.53 215.28l-.49 1.03s1.7-.88 3.03-.84c1.31.05 2.79 1.7 2.79 1.7l.31-1.2s-1.74-1.7-2.9-1.79c-1.14-.09-2.74 1.1-2.74 1.1zm.85-7.63s.36.43.45.56c.08.13.13-1.27 1.85-2 1.73-.74 2.67-.16 2.67-.16s-.35-1-1.11-1.2c-.77-.22-1.51-.07-2.45.6-.94.67-1.4 2.2-1.4 2.2zm5.86 5.75s-.81-1.73-2.21-2.07c-1.41-.35-3.2.73-3.2.73l-.3.9s1.92-1.08 3.32-.51c1.41.56 1.96 2.16 1.96 2.16l.43-1.21zm-6.58-6.7c.08.3.42.69.42.69s-.19-1.85.66-2.8c.86-.96 1.5-1.3 1.5-1.3l-.8-.41s-1.12.75-1.5 1.57a4.18 4.18 0 0 0-.28 2.25zm-.76-3.04c.4-.92 1.57-1.32 1.57-1.32s-.12-.2-.39-.35c-.26-.14-.54.01-.54.01s-.75.4-1.21 1.43c-.45 1.04-.4 2.54-.4 2.54l.7.39s-.13-1.78.27-2.7zm10.34-25.06c1.08-.58 1.87-.46 1.87-.46s-1.6 1.68-.83 3.76c-.9 1.76-1.18 3.09-1.18 3.09h.85s.28-1.37.62-2.44c.92 1.78 2.47 2.79 2.47 2.79l1.3-.06s0-1.74.68-3.25l.12.14a6.64 6.64 0 0 0 2.62 1.85l.01-.45s-1.5-.88-2.34-2.03l-.09-.13.03-.05c1.02-1.6 2.39-2.13 2.39-2.13l.9.75.23-.29-.68-.86-.79.02s-1.41 1.18-2.32 2.2a12.01 12.01 0 0 1-1.04-2.05l-.58-.21s-1.41.16-2.68 2.2c-.16-1.5 1.57-3.13 1.57-3.13l-.08-.63s-1.75.33-3.11.73c-1.36.4-2.2 1.7-2.2 1.7l-.05.91s1.23-1.4 2.3-1.97zm1.87 2.76c.8-1.15 2.56-1.9 2.56-1.9s.04.94 1.01 2.18c-.66 1.16-.96 2.95-.96 2.95s-1.36-.86-2.55-2.6a2.12 2.12 0 0 1-.21-.38l.15-.25zm-9.94 27.76l.06 1.01s1.05-1.14 2.62-1.18c1.58-.05 2.92 1.18 2.92 1.18s.02-1.35-.19-1.48a5.95 5.95 0 0 0-2.68-.87c-1.2 0-2.73 1.34-2.73 1.34zm28.12-14.74c-.21-.37-.44-.9-.62-1.35.24-.09.48-.2.7-.37 1.32-1 2.26-2.08 2.26-2.08l-.47-.73h-2.13c-.42 0-1.3-.1-1.8-.17.09-.33.35-1.24.66-2.2.38-1.19.73-1.82.73-1.82l-.73-.74s.17.68-1.1.85c-1.28.17-3.64-1.03-3.64-1.03v.51s2.07.67 3.27.84c.7.1 1.25-.14 1.59-.35-.19.38-.52 1.11-.7 1.77-.16.57-.38.94-.37 1.18.01.16.24.3.24.3l-.1 1.12s1.27.17 1.86.17c.6 0 2.22.13 2.22.13s-1.15 1.34-2.26 1.86c-.14.07-.3.12-.46.17a59.15 59.15 0 0 0-1.32-2.09l-.13.72s.9 1.24 1 1.5c-.82.1-2-.17-2-.17l-.5.56s-.05 1.6 0 3.26c-1.1-.3-2.34-.75-2.34-.75l-.46.34.03-.08-.6.47s-.5 1.94-.37 4.15v.11c-2.1-.52-3.16-1.75-3.16-1.75l-.5.43s-.35 1.9.12 4.2a7.73 7.73 0 0 1-3.35-1.9l-.67.55s.4 3.72.83 5.75c.03.17.08.32.13.48-.36.03-.7.05-.99.04-1.83-.09-2.96-1.77-2.96-1.77l-.54 1.3s.7 3.58 2.7 5.18l.45.36a7.95 7.95 0 0 1-3.76 1.61l.12 1.13s1.22.96 2.42 1.78l.37.23c-.95.84-2.12 1.19-2.12 1.19l.32.75s1.58-1.1 2.31-1.7c1.06.42 2.46.6 2.46.6v-.62s-1.03-.09-1.98-.4l.14-.12c.6-.58 1.76-2.36 1.76-2.36l.11-1.3s-.73-.1-1.52-.73c2.41-1.66 2.5-2.4 2.5-2.4l.46-.86s-.82-.35-1.42-1.54a28.4 28.4 0 0 0 3.84-.95c.04-.13.28-.27.28-.27s-.92-1.52-1.32-3.38c1.9.5 3.86.81 3.86.81l.6-.52s-.46-1.55-.61-3.23c2.26.15 4.18.32 4.18.32l.39-.44s-1.28-2.44-1.24-3.82v-.13c.44.08.88.14 1.28.13 1.87-.05 3.96 0 3.96 0l.32-.71s-1.81-1.24-2.23-2.02zm-13.8 20.33s-.6 1.24-1.84 2.67l-.3.3a6.05 6.05 0 0 1-.64-.3c-1.44-.83-1.81-1.76-1.81-1.76s.8-.4 3.23-2.03c1.3 1.02 1.37 1.12 1.37 1.12zm1.14-4.12s-.76.9-2.53 2.49a5.42 5.42 0 0 1-.55-.6c-1.13-1.47-2.55-2.74-2.41-4.96 0 0 .88 1.59 2.84 1.38.4-.03.86-.1 1.34-.19a4.36 4.36 0 0 0 1.31 1.88zm2.64-3.33s-1.81.6-3.5.87a6.96 6.96 0 0 1-.2-.56c-.64-2.08-.64-5.23-.64-5.23s1.42.98 3.4 1.53c.58 2.35.94 3.4.94 3.4zm-.6-3.83c-.3-1.94.1-3.86.1-3.86s1.05 1.06 3.02 1.39c.13 1.78.34 2.67.34 2.67s-1.5.09-3.46-.2zm7.63-2.95s-1.27.5-3.7.15l-.05-.71c-.08-2.2.11-3.99.11-3.99l.01-.03c.35.16 1.65.69 2.86.98v.14c.18 1.99.77 3.46.77 3.46zm-.17-4.1l-.13-.04c.08-1.4.08-3.47.08-3.47s1.18.32 2.1.2c.24.6.08.75.68 1.66.6.91 1.49 1.65 1.49 1.65s-3.02.25-4.22 0zm-9.88 24.44l-.17-.71s-1.2.89-1.53 1.8a2.16 2.16 0 0 1-.37-.1c-.8-.29-2.67-1.02-2.67-1.02l.27.53s1.94.9 2.45 1.01l.17.03a72.1 72.1 0 0 1-.65 1.84l.31.44s.18-1.32.68-2.24c.67.07 1.6.1 1.6.1s-.12.52-.29 1.1c-.17.57-.51 1.93-.51 1.93l.58.36 2.72.06-.46-.54s-.09-.14-.97-.17-1.42.12-1.42.12.12-.55.46-1.65c.34-1.1.35-1.03.35-1.03l-.34-.95s-.87.24-1.44.22c.5-.74 1.23-1.13 1.23-1.13zm-14.82-1.72a5.57 5.57 0 0 1 3.06 1.13l-.06-.8s-1.3-1.75-2.79-1.75c-1.5 0-3.26 1.53-3.26 1.53v1.64s1.38-1.75 3.05-1.75zm17.5 25.5c-1.7.73-3.62.73-3.62.73s.52-.74 1.03-2.02c3.33-.94 4-3.16 4-3.16l-.21-.82s-.81 2.03-3.5 3.15c.5-1.57 1-4.23 1-4.23l-.91-.24s-1.31 1.65-2.55 2.06c.84-1.63.95-3.5.95-3.5l-.4-.72s-.9.8-2.3 1.06c-.22.04-.45.03-.7 0h.01c.77-1.08 2.24-4.2 2.24-4.2l-.26-.58s-1.12 2.75-2.27 4.13l-.44.5c-1.18-.33-2.86-1.34-2.86-1.34l.19.52s.95.73 2.35 1.17c-.85.9-1.78 1.72-1.78 1.72l.09 1.25s2.15.41 3.93.6a9.63 9.63 0 0 1-2.6 2.69l.58.86s1.76 0 4.9-.78c-.89 1.69-1.57 2.43-1.57 2.43s2.87.2 4.83-.8 2.56-2.03 2.56-2.03l-.56-.61s-.42 1.43-2.13 2.16zm-9.07-5.4s.85-.94 1.57-1.89l.1.02c2 .44 2.55-.17 2.55-.17s.38 1.09-.84 3.04c-1.44-.06-3.38-1-3.38-1zm1.79 4.01l1.79-2.07c.13-.15.24-.3.34-.44 1.96-.07 3.07-1.68 3.07-1.68s.23 1.63-.65 3.63c-2.5.9-4.55.56-4.55.56zm-2.43-12.87c1.88.12 4.3 1 4.3 1l-.3-.98s-2.3-.57-3.74-.75c.64-1.44 2.06-2.13 2.06-2.13l-.64-.34s-.78.13-1.85 1.94l-.24.45a5.48 5.48 0 0 0-3.53.93l.26.52s1.48-.64 2.94-.66c-.53 1.47-.92 3.15-.92 3.15l.38.89 1.27-4.02h.01zm-3.94-8.04l-.4-1.04s-2-.71-3.54.02c-1.53.74-2.68 2.5-2.68 2.5l.64 1.22s1.06-1.97 2.47-2.44c1.4-.48 3.51-.26 3.51-.26zm3.9 3.04l-1.32-.69s-2.17.63-2.94 1.4c-.77.79-1.39 2.77-1.17 3.33.21.56.9.93.9.93s.35-2.1 1.42-3.09c1.07-.99 3.1-1.88 3.1-1.88zm-5.07-.62a5.9 5.9 0 0 1 2.51-1.2l-.8-.73s-1.97.24-2.99 1.15c-1.02.9-2.34 2.79-2.34 2.79l1.15 1.12s1.58-2.27 2.47-3.13zm6.75-58.72l.07-.09c1.03-1.33 2.03-1.33 2.42-1.22.17.05.39.03.59 0h-.01l.03-.01.14-.03c.05 0 .1.02.12.07-.33.52-.8 1.94-1.04 3.13-.3 1.47-.93 1.64-1.4 2.55-.47.9-1.45 2.42-1.5 3.71-.03 1.3.3 2 .65 2.16.34.18.96-.56.93-.86-.04-.43-.38 0-.63 0s-.22-.43-.35-1.2c-.12-.79.94-2.95 1.33-3.64.38-.7 1.19-1.51 1.36-2.68.15-1.04.9-3.32.9-3.33 0-.06-.57-.22-1.7-.3-.84-.06-1.97.68-2.5 1.5-.54.82-2.22 1.48-2.22 1.48s1.84.01 2.8-1.24z"
    }), r.createElement("path", {
      d: "M374.33 178.91l-3.27.09.94 2.44zM370.48 178.78s-.48-.3-.7-.56c-.23-.26-.4-.37-.4-.37l-1.19.74-.68 2.42.34.35 2.63-2.58zM370.04 185.34l-2.39-3.52-1.36 2.94.65.23s.66.06 1.65.2c1 .15 1.45.15 1.45.15zM379.74 244.06l-.12.08c-.57.38-3.07 1.9-6.14 1.9a8.76 8.76 0 0 1-4.54-1.24 5.14 5.14 0 0 1-2-2.35c-.7-1.47-1-3.33-1.31-5.14-.32-1.8-.65-3.55-1.44-4.83-1.08-1.71-3.1-2.78-4.9-4.3a9.62 9.62 0 0 1-3.81-7.9c0-2.26.72-4.23 1.46-5.95.73-1.73 1.49-3.2 1.5-4.53 0-.22-.03-.44-.08-.65-.24-1.02-1.13-1.88-1.94-2.52-.81-.63-1.57-1.01-1.57-1.02h-.02l-1.27-.36-.1.4 1.24.35.05-.2-.09.18.12.07c.29.15 1 .57 1.69 1.15.68.57 1.33 1.31 1.5 2.04.03.18.05.37.05.56 0 1.17-.71 2.63-1.46 4.36a15.42 15.42 0 0 0-1.5 6.12c0 .35.02.7.06 1.06.34 3.56 2.05 5.61 3.9 7.16 1.86 1.55 3.84 2.63 4.82 4.2.98 1.57 1.24 4.09 1.71 6.5.24 1.2.54 2.4 1.02 3.43a5.53 5.53 0 0 0 2.17 2.53 9.17 9.17 0 0 0 4.74 1.3c3.66 0 6.48-2.05 6.5-2.06l-.24-.34z"
    }), r.createElement("path", {
      d: "M376.91 237.6l-.03.02c-.14.08-.8.45-1.64.45-.67 0-1.47-.23-2.28-1.02a5.32 5.32 0 0 1-1.52-3.03c-.25-1.14-.44-2.53-1.22-4.34-.8-1.86-2.78-3.35-4.62-4.82-1.85-1.45-3.55-2.88-3.85-4.44a4.3 4.3 0 0 1-.09-.88c0-1.31.56-2.64 1.15-4.15a14 14 0 0 0 1.18-5.22c0-.34-.01-.7-.05-1.05-.27-2.61-2.26-4.55-4.15-5.84a18.5 18.5 0 0 0-3.73-1.96l-.13.4.3.11c.68.28 2.41 1.05 4.02 2.3 1.6 1.23 3.07 2.92 3.28 5.03.04.35.05.69.05 1.01 0 1.94-.57 3.56-1.15 5.07-.58 1.5-1.18 2.87-1.18 4.3 0 .32.03.64.1.96.37 1.79 2.15 3.22 4 4.7 1.85 1.45 3.77 2.94 4.5 4.65.76 1.76.94 3.09 1.19 4.26.24 1.17.58 2.2 1.64 3.24a3.58 3.58 0 0 0 4.46.6l-.23-.35z"
    }), r.createElement("path", {
      fill: "#a8ac71",
      d: "M388.97 227.59s2.29.54 2.2 2.4a17.5 17.5 0 0 1-1.1 4.45l-3.16-2.86 1.78-1.57.65-.93-.37-1.49z"
    }), r.createElement("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: ".35",
      d: "M349.61 205.23s-2.26.78-2.73-.22c-.46-.99-.25-1.77-.3-1.98-.04-.22-1.36-.3-1.23-1.6.13-1.3 1.79-1.21 2.13-1.21.34 0 .43-2 1.58-1.9 1.15.08 1.7 1.42 1.7 1.42l-1.15 5.49z"
    }), r.createElement("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: ".35",
      d: "M352.12 205.84s-1.92 1-2.51.04c-.6-.95 0-2.16-.22-2.37-.21-.22-1.36-.6-1.15-1.73.22-1.13 1.4-.78 1.84-1 .42-.21.72-1.9 1.91-1.6 1.2.3 1.4 1.26 1.4 1.26s-.93 4.5-1.27 5.4z"
    }), r.createElement("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: ".35",
      d: "M355.36 206.27s-.55 1.21-1.92.95c-1.36-.26-.93-2.25-1.15-2.6-.21-.34-1.19-.6-1.02-1.85.17-1.25 1.4-1.08 1.87-1.25.47-.18.98-2.12 1.88-1.82.9.3 1.74 1.43 1.57 1.95 0 0-1.91.6-2.17 1.9-.25 1.3.94 2.72.94 2.72z"
    }), r.createElement("path", {
      fill: "#af7029",
      d: "M385.51 227.14s-1.7-1.87-2.9-3.51a37.44 37.44 0 0 0-3.04-3.52l-2.92-1.47-1.84-3.08-.23-3.63.8-2.1 1.1-1.62s-6.06 2.17-2.98 13.77c1.3 4.93 4.65 5.65 4.65 5.65l5.57-.34 1.79-.15z"
    }), r.createElement("path", {
      fill: "#816c2a",
      d: "M382.71 188.39c.58.02.86.2 1.03.45.18.24.23.57.23.85 0 .15-.01.29-.03.39l-.02.1v.04l.2.06-.2-.09c-2 4.44-6.25 6.51-10.07 9.28a18.1 18.1 0 0 0-5 5.08c-1.32 2.13-2.15 4.83-2.15 8.46v.56c.16 6.68 2.68 10.27 5.46 12.15a12.7 12.7 0 0 0 6.9 2.07h.48v-.01c.01 0 .79-.1 1.9-.2 1.12-.1 2.57-.2 3.9-.2.86 0 1.67.04 2.31.14.64.1 1.1.3 1.24.49.18.22.25.44.25.67 0 .5-.37 1.09-.82 1.55-.44.47-.96.83-1.15.91l.18.38c.26-.13.78-.5 1.27-1 .48-.5.92-1.14.93-1.84 0-.32-.1-.65-.34-.94-.3-.34-.82-.5-1.5-.63-.67-.1-1.5-.15-2.36-.15-2.72 0-5.85.4-5.85.4l.02.21-.01-.2h-.44c-1.1 0-4.02-.19-6.69-2-2.66-1.81-5.1-5.23-5.26-11.8V213c0-3.57.8-6.18 2.07-8.24 1.9-3.1 4.88-4.99 7.79-6.95 2.9-1.96 5.75-4 7.31-7.46l.01-.01v-.02c0-.01.08-.28.08-.64 0-.33-.06-.74-.3-1.1-.25-.35-.7-.6-1.36-.62l-.01.42z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M390.88 229.04s-1.44 2.63-1.8 2.66c-.37.02 1.24.41 1.6 1.03l-.34.65s-1.59-1.13-2.58-1.18l-.1-.97s.82-.28 1.5-.9a5.27 5.27 0 0 0 1.14-2.24l.58.95z"
    }), r.createElement("path", {
      fill: "#fcca3d",
      d: "M396.48 230.77l-3.58.98-1.82-1.14s.15-1.49-.66-2.13c-.84-.66-1.33-.85-2.06-1.16-.72-.3-3.28-.35-3.28-.35l-6.46-7 2.41.25 3.82-.47 3.55-.3 1.88.27 2 .62 1.05.9 1.09.96 1.1 1.8.7 2.03.27 2.19-.01 2.55z"
    }), r.createElement("path", {
      fill: "#af7029",
      d: "M396.62 230.54s-1.28.38-2.9.34c-1.62-.02-2.65-.27-2.65-.27s.1.1-.24 1.17a15.07 15.07 0 0 1-.66 1.73l.06 4.2 3.4.67 1.8-.7.9-4.58.29-2.56z"
    }), r.createElement("path", {
      fill: "#fcca3d",
      d: "M395.67 228.76l.15 1.63.67.2-.01-1.47zM392.46 189.47l-.4-2.87-1.12-1.9-1.42-1.94-1.52-1.67-.85-.76-.36-.57-3.73.18-1.96 2.33s5.1 3.6 7.02 7.53a9.26 9.26 0 0 1 3.67 2.26l.17-.31.5-2.28z"
    }), r.createElement("path", {
      fill: "#af7029",
      d: "M388.84 192.63c-.05 2.92-.55 4.3-.94 4.95l2.26-2.59 1.63-2.93a9.26 9.26 0 0 0-3.67-2.25c.46.93.74 1.89.72 2.82z"
    }), r.createElement("path", {
      fill: "#816c2a",
      d: "M394.11 235.87s-1.05-1.31-1.83-2.08c-.8-.78-1.73-1.2-1.74-1.2l-.17.37.15.07c.28.15.92.52 1.47 1.06a22 22 0 0 1 1.8 2.04l.32-.26z"
    }), r.createElement("path", {
      fill: "#6f5b24",
      d: "M396.31 232.73s-.34 1.26-1.62 2.42c-1.28 1.15-2.9 1.93-2.9 1.93l3.67 1.35 2.44-2.27-1.59-3.43z"
    }), r.createElement("path", {
      fill: "#404118",
      d: "M396.85 235.77l-.22.43-.7.67-.53.57.91-3.8.65 1.12.09.6z"
    }), r.createElement("path", {
      fill: "none",
      stroke: "#78732e",
      strokeWidth: ".3",
      d: "M375.12 185.22s-5.03.43-8.52-.17c-3.5-.6-2.73-9.51-2.81-9.77-.09-.26-2.13-2.42-1.8-4.4.35-2 6.8-7.24 7.68-7.52.6-.2 1.87.34 1.87.34s1.63-1.58 2.12-1.58c.5 0 1.18.91 1 1.3-.2.39-2.42 1.68-2.59 2.68-.17 1 .03 1.99-.62 2.96-.63.97-1.87 2.29-2.02 3.11-.15.82-.5 1.54.1 1.84.63.3 2.74.04 4.55-.78 1.8-.82 2.55-1.92 2.8-1.82.26.11-1.04 2.27-3.04 3.12-2 .84-3.32 1.81-4.32 1.66 0 0-1.11 2.66 2.32 2.8 3.43.16 5.32-.75 5.32-.75l-2.04 6.98z"
    })), r.createElement("g", {
      fill: "#d2a567"
    }, r.createElement("path", {
      fill: "#ab6d29",
      stroke: "#4d2a15",
      strokeWidth: ".51",
      d: "M418.24 147.56s-9.2-1.74-9.05 5.93c.04 2.42.58 3.25 2.53 3.8 1.94.54 5.84.74 9.15 3.7 3.3 2.97 3.55 5.14 3.55 6.92 0 1.77-.82 3.4-.82 3.4l2.09 10.13 2.1 7.5 6.22-3.6 3.66-11.11-4.68-20-14.75-6.67z"
    }), r.createElement("path", {
      fill: "#4d2a15",
      d: "M427.38 186.09s3.2-1.21 4.03-3.8c.23-.72-3.24-3.83-3.32-3.83-.08 0 1.76.89 2.61 1.67.85.78 1.5 1.1 1.76.98.26-.12 1.74-3.55 1.17-4.3-.57-.75-1.45-2.5-2.79-3.4-1.33-.89-3.1-.77-3.1-.77s2.45-.78 3.67-.09c1.22.7 1.34 1.5 1.48 1.21.14-.29-.26-3.72-.81-4.87s-1.12-1.7-2.6-1.99c-1.47-.29-3.07-.17-3.07-.17s2.13-1.18 3.75-.78c1.62.4 1.6 1.21 1.73 1.04.15-.17-.8-3.14-1.17-3.9a8.75 8.75 0 0 0-2.86-2.41c-.54-.17-2.3-.23-2.3-.23l-.85.01s1.22-.85 2.79-.7c1.55.14 1.64.66 1.86.57.23-.08-.17-.28-1.11-.95-.96-.66-5.56-2.62-5.56-2.62l-4.2-.06s-.05-1.06 1.18-1.26c1.22-.2 1.57.15 1.49-.16-.09-.32-3.55-1.08-3.55-1.08l-2.84.09c-.85.02-3.95.38-3.95.38s.27-.68.88-1.2c.46-.41 1.17-.67 1.76-.83 1.36-.37-.76-1.44-.76-1.44l1.13-1.73 5.12.43 10.79 6.31 5.05 4.36 3.21 8.18-.97 14.06-7.21 5.96s-3.18.5-3.18.35c0-.15.74-3.03.74-3.03z"
    }), r.createElement("path", {
      d: "M417.97 151.17s-.34-1-.34-2.25.21-1.2.21-1.2-3.45-.48-5.96 1.5c-2.51 2-1.07 5.45-1.07 5.45s1.1-1.08 2.5-1.6 3.94-.43 3.94-.43c.2-.22-.56-1.21-1.5-1.43-.93-.21-2.76-.21-2.76-.21s1.06-.74 2.9-.56c1.83.17 2.08.73 2.08.73z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M428.76 187.3l-2.33.8 1.42 9.8 9.31 15.96 4.89-.86 1.65-2.94 1.3.58c.57.57 2.39 3.68 3.92 4.32 1.53.63 2.33.4 3.7 1.5 1.36 1.1 6.34 8.51 6.6 8.8.25.28-.29-3.19-.29-3.19l-1.52-4.43-1.88-3.1-.29-.83 2.59.02 1.6.99 2.46 2.05 1.27 1.51.67 1.56.28 1.37.66 2.12 1.36 2.94 1.64 2.8.52-1.15-.8-3.28-2.5-7.97-1.53-2.68s2.02 1.45 2.56 1.64c.54.2 2.37 2.93 2.37 2.93l1.16 2.82.84 2.62.58 2.3.84 2.44 1.45-.83-.26-1.77-1.25-5.47-.54-5.92s.7-.01 1.55.92c.85.94 1.62 3.06 1.62 3.06l.63 5.36.85 4.91 1.59 5.01 1.66 3.16 1.08 1.77s.05-2.5.04-2.62l-2.03-20.97.27-.88s.24-.13.94.86c.7 1 1.39 2.55 1.39 2.55l.6 3.27.3 2.26.43 4.26.57 4.63 2.13 4.96 1.15 2.67.64-3.18-1.01-22.43.47-.65s1.2.98 1.59 1.68a7 7 0 0 0 1.14 1.36l.7 4.95.62 14.14.5 3.64 4.16-37.04 2.56-.57.3-.7-1.87-1.44-4.22-6.54-2.84-6.33-4.98-9.18-8.65-10.54s-5.37-4.58-6.73-5.62a26.34 26.34 0 0 0-2.5-1.69l.43-1.31 1.43-2.32-.23-.1-1.11.06-2.9.41-2.92-.86-5.72-4-6.14-2.92-3.6-1.27-8.69-2.2-8.64-1.17-3.88-.06-3.54.66s-1.8.74-2.36 1.85c-.56 1.11-.6 1.89-.43 3.51.17 1.62 1.15 2.46 3.58 3.46s8.14 4.8 8.14 4.8l2.75 2.76 1.02 1.32.14 1.02 1.86 14.58-3.67 7.93-2.62 1.36z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M438.11 210.03s1.56 2.65 3.78.6c2.21-2.04-.97-7.86-.94-8.2.03-.35 1.02-.47 1.02-.47l1.62 3s.97 1.61.6 4.18c-.37 2.56-2.84 4.78-2.84 4.78l-2.81-.64-.43-3.25z"
    }), r.createElement("path", {
      fill: "#4d2a15",
      d: "M492.51 244.21l-2-5.92s-.6-3.8-.6-4.58c0-.78-.38-10.42-.55-12.23-.17-1.82-.08-3.9-.28-4.15l-2.17-2.87-.85-.9.6-.42s.74.8.94.37c.2-.43-.03-2.53-.85-5.82-.83-3.28-5.03-10.97-5.03-10.97l.45.37 1.17 1.18 2.47 1.99 5.34 1.96 2.9.46 1.87 3.75s1.33 6.45 1.25 9.7c-.09 3.26-.29 5.9-1.53 9.16-1.25 3.26-1.56 13.57-1.73 15.21-.18 1.65-.8 3.26-.8 3.26l-.6.45z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M492.53 227.08s1.12-1.33 1.6-3.16c.5-1.83.69-16.2-1.01-17.98-1.7-1.78-5.19-3.18-5.36-3.06-.17.12 1.4 4.68 1.4 4.68s.51.67 1.05 1.86c.3.66.7 1.86.77 2.3.19 1.23 1.2 4.15 1.36 7.9.14 3.76.19 7.46.19 7.46z"
    }), r.createElement("path", {
      fill: "#4d2a15",
      d: "M484.68 236.1s.73-6.8.39-11.78c-.34-4.98-.75-5.6-1.22-6.5-.48-.9-2.19-4.15-3.35-8.3-1.15-4.14-1.9-7.32-2.65-8.15-.75-.83-2.26-2.63-2.6-2.15-.34.49-.34 1.52-.34 1.52l-2.04-.55-.48-1.31.66-2.12-.13-.9-.24-1.5 2.64 2.1 5.43 3.71 2.72 11.25 2.53 7 .35 11.86-.25 10.44-1.42-4.62zM487.87 203.66s1.42 1.34 2.25 1.8c.83.47 2.4 1.43 2.08 1.54-.3.1-1.77-.47-2.69-.99-.92-.51-1.54-1.15-1.54-1.15l-.1-1.2z"
    }), r.createElement("path", {
      fill: "#4d2a15",
      d: "M477.3 233.42s1.08-2.39.91-5.41c-.17-3.03-1.62-10.32-2.07-11.24-.46-.93-2.61-2.3-4.55-6.4-1.93-4.09-1.73-4.92-3-6.42-1.28-1.5-2.62-3.2-2.62-3.2l.4-4.38 4.71 2.4 2.02 1 2.39 11.47 2.13 3.2.9 4.58 1.14 10.68.62 8.5-.34.75-2.64-5.53zM471.86 228.57s.13-3.37-.73-6.4c-.85-3.02-1.44-5.27-2.38-6.22a45.79 45.79 0 0 1-5.45-6.61c-2.13-3.2-5.08-6.57-5.08-6.57l.08-4.29s1.42 1.33 2.62 1.92c1.2.58 3.01 1.6 3.01 1.6l1.26 4.91 1.63 3.54 2.38 3.17 1.53 1.4.97 5.3.52 2.98 1.25 4.25-.41 2.13-1.2-1.11zM467.94 228.61l-1.3-1.25s.7-.85.36-2.53c-.34-1.69-.79-3.3-1.55-4.9-.77-1.6-1-2.58-1.47-3.05-.47-.48-4.45-4.24-5.84-5.38-1.38-1.15-3.5-3.33-4.83-4.17-1.32-.84-2.28-1.06-2.28-1.06l-.75-5.28s1.75 2.34 2.8 2.73c1.04.39 2.74.93 2.74.93l3.7 6.54 1.26 1.67 3.43 2.74 1.4 2.83 1.05 3.27 1.3 4.5.24 2.71-.26-.3zM460.66 227.14s-2.19-2.5-2.53-4.12c-.34-1.61.23-1.61-.45-3.46-.69-1.84-2.96-4.55-4.83-6.05-1.88-1.5-4.54-3.68-4.37-4.9.17-1.2.5-1.26.5-1.26l1.14.97 5.85 6.23 1.8 3.26 1.36 4.06.9 1.9.88 2.42-.25.95zM481.76 196.6s4.03 5 5.05.4c.46-2.04-1.4-5.94-1.4-5.94s-3.74-6.56-5.01-8.14c-1.28-1.59-7.53-9.6-7.53-9.6l-4.57-2.13 1.56 2.68s3.4 3.4 7.76 10.92c4.34 7.52 3.49 11.67 3.49 11.67l.65.14zM458.35 166.47s8 6.83 13.16 14.22c5.16 7.39 7.2 12.32 6.05 13.3-1.15 1-4.39-.55-5.7-2.63-1.33-2.07-2.44-5.7-7.3-11.24-4.85-5.53-7.19-6.35-7.19-6.35l-3.5-5.66 4.48-1.64z"
    }), r.createElement("path", {
      fill: "#4d2a15",
      d: "M454.18 182.84s4.73 3.93 7.7 7.13a49.06 49.06 0 0 1 4.53 5.49l1.91 1.9s-1.15-2.03-.5-2.72c.63-.7 1.4-.35 1.4-.35l-15.04-15.77v4.32zM453.2 183.28s1.53 2.94 4.05 5.4c2.51 2.46 5.28 5.1 5.28 5.1l1.07 3.85s-6.86-5.27-6.9-3.98c-.05 1.3 1.66 3.98 1.66 3.98l-2.1-1.13-2.89-4.19-1.75-3.63-1.96-5.01 3.54-.39z"
    }), r.createElement("path", {
      fill: "#4d2a15",
      d: "M432.46 199.53s3.58 3.2 5.54.09c1.96-3.12.43-6.7.43-6.7s5.05 7.45 6.47.47c.26-1.25-3.07-6.1-3.07-6.1l1.2-1.11 2.55 4.32s2.39-1.08 2.39-4.06c0-2.99-2.47-6.83-2.47-6.83l2.35 2.62s4.67.1 4.76-2.75c.08-2.85-3.92-5.84-3.92-5.84s3.2.22 3.15-1.64c-.04-1.86-4.34-3.15-4.43-4.32-.08-1.17 1.28-3.16 3.24-2.07 1.96 1.08 4.69 1.94 5.8-.18 1.1-2.12-.1-2.55-.1-2.55s-2.5-.51-2.76-.6c-.26-.09-4.48-2.38-4.48-2.38l-3.54-1.34-3.65-.47 1.36 2.72.94 7.47.04 3.46.68 7.52-1.8 6.27-.92 1.13-.66.84-1.56 3.3-2.18 2.38-2.8 3.58-2.56 2.77z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M457.82 213.57s-.9-2.24-2.83-3.74c-1.94-1.5-5-1.62-5-1.62l5.25 5.56 2.58-.2zM465.17 214.84s-1.7-3.4-3.69-5.47c-1.99-2.08-3.3-4.76-3.84-4.76-.53 0-.93.12-.93.12l.51 4.29 3.63 3.52s3.41 2.53 4.32 2.3zM471.22 214.58s-.85-3.95-2.87-7.75c-2-3.8-4.14-5.36-4.14-5.36l.48 4.06 1.65 3.92 2.67 3.86 2.21 1.27zM476.16 212.36s1.42-8.12.14-10.37c-1.27-2.25-3.69-2.68-3.69-2.68l-.77 1.18.77 5.79 1.93 4.43 1.62 1.65zM481.02 198.82s1.2.6 2.64 3.34c1.45 2.74 3.5 10.84 3.46 11.27-.03.42-.76.33-.96.23-.2-.1-5.11-7.78-5.11-7.78l-.78-7.18.75.12z"
    }), r.createElement("path", {
      d: "M446.72 208.26s2.6-.56 2.6-1.47c0-.9-3.1-2.72-2.85-4.2.12-.73 2.64.14 2.81-.38.17-.52-2.6-4.84-1.75-5.83.85-1 3.2 4.66 3.2 4.66s1.4 2.67.9 4.2c-1.59 4.7-4.91 3.02-4.91 3.02zM452.81 202.38c.13-.38 4.1.52 4.13.26.16-.93-3.57-3.8-3.57-3.8s-.86-1.64-.6-1.9c.25-.26 2.64.26 2.77-.09.13-.35-2.73-4.1-2.73-4.8 0-.69.77-.08.77-.08s2.26 2.33 3.45 4.23c1.2 1.9 2.31 3.46 1.92 6.48-.43 3.24-6.48.74-6.14-.3zM470.71 196.42s-.64-2.68-.26-3.03c.39-.34 1.41-.64 1.41-.64s-2.11-1.32-3.11-1.34c-1-.03-1.15-.32-1.4.1-.26.42 1.8 3.03 1.8 3.03l1.56 1.88z"
    }), r.createElement("path", {
      d: "M458.65 198.49s6.1 1.51 6.35 1.08c.25-.43-4.86-5.19-4.86-5.19s-.34-.86-.25-1.16c.08-.3 2.2-.35 2.85.17.64.52 0 1.51.21 1.9.21.4 2.13 3.33 2.48 2.85.34-.47-.4-4.06-.22-4.32.17-.26 2.34 2.03 2.94 2.42.6.4 4 3.07 4.34 1.82.35-1.25.56-1.47.43-2.2-.13-.74 1.14 3.45-.46 3.97-1.59.52-3.42-.56-3.42-.56l-1.4-1.08-.83-.87s.91 3.25-.15 3.59c-1.07.35-2.3.17-2.3.17l-2.56-.26-3.15-2.33zM472.64 194.33s6.5 3.9 7.14 3.21c.65-.69-1.7-9.85-1.32-10.8.3-.76 5.28 10.4 2.86 11.93-1.86 1.16-2.77.34-2.77.34l-3.2-1.68-2.71-3zM490.73 210.76s.59.44 1.42.67c.26.08 1.04.31.83.34-.22.01-1.74.2-1.85.24-.1.04-.4-1.25-.4-1.25zM484.42 189.27s.62.35 1 .46c.39.11.88.35.88.41 0 .07-.48.27-.82.23-.34-.04-.56-.14-.56-.14l-.5-.96zM482.55 186.07s.67.3 1.52-.3.9-1 .84-1.33c-.07-.31-1.4-.31-1.86-.62-.46-.3-.43-.85-.43-.85l-1.46-.02-.54.2 1.93 2.92zM488.29 204.93s1.99 1.17 2.55 1.28c.55.1 1.49.62 1.36.8-.13.17-1.6.3-2.34-.13-.75-.44-1-.17-1-.17l-.57-1.78zM477.58 175.32l.03.01c.11.03.48.13.8.1.38-.05.7-.28.82-.13.27.3.06 1.68-.48 2.07-.54.4-1.2.72-1.29.7-.1-.03-2.1-2.9-2.1-2.9l2.22.15zM468.26 166.98s1.3-.08 1.95-.07c.65 0 1.4.47 2 .84.58.37 1.16 4.3.84 5.03-.31.75-4.7-2.54-4.81-2.83-.13-.3-2.03-3.24-2.03-3.24l2.05.27zM464.15 165.2s3.19.2 2.9-1.83a4.21 4.21 0 0 0-1.76-2.91l-3.82 2.72 2.68 2.02zM455.6 161.47s.85.47 1.8.1c.95-.37 3.46-3.63 5.28-4.03 1.83-.4 2.2-.37 2.54.05.34.42.17 2.28-.25 2.8-.4.51-5.72 2.76-5.72 2.76s-1.1-.07-1.96-.27c-.86-.2-1.74-.57-1.74-.57l.05-.84zM454.61 155.6c-.8-1.88-2.24-2.65-2.78-2.53-.53.13 1.83 2 2.17 4.6.34 2.59.31 4.33.27 4.48-.05.14 1.1.16 1.1.16l.21-.99.14-.7-.01-.64-.16-1.35-.28-1.05-.23-.81s-.02-.2-.43-1.17zM447.06 152.92a20.19 20.19 0 0 0-7.17-4.88c-.3 0 5.15 3.28 6.39 5.4 1.23 2.12 1.27 4.97 1.83 5.36.55.39 1.06-.2 1.1-.26.05-.07.45-.65.39-.82a30.4 30.4 0 0 1-.34-1.36l-.85-1.43-.51-.89-.84-1.12zM439.82 149.94c-3.1-2.72-8.7-4.02-13.23-4.08-4.54-.07-6.86.34-6.2 2.83.66 2.48 2.7 3.56 6.54 3.56s4.75-.4 6.82.24c2.07.65 3.96 1.81 4.7 2.6.75.77-1.42-1.9-3.38-3.38-1.96-1.47-3.25-2.24-3.25-2.24s-.37-.8 2.27-.44c2.64.37 6.17 2.08 7.13 4.28s.81 3.42.8 3.9c-.03.47.9-.27.9-.27l.4-1.08s.14-.86-.37-1.84c-.51-.97-.6-1.3-1.79-2.7-1.2-1.4-1.34-1.38-1.34-1.38zM427.23 187.35c1.93-.06 6.25-3.74 6.88-8.87.62-5.13-2.56-15.56-3.3-16.65-.74-1.1 1.19-.52 2.24.57s3.21 8.53 3.21 13.95c0 5.41-1.08 6.97-3.97 9.73-2.9 2.77-5.23 2.48-5.23 2.48l.17-1.21zM433.94 202.57s.96 1.21 2.04.8c1.99-.74 5.06-2.2 5.06-5.06 0-1.85-2.39-3.46-2.5-4.15-.11-.7 0-1.27 0-1.27l2.1.46.6 2.94s.82.86 1.67.52c.86-.35 3.3-2.13 2.95-3.86-.33-1.73-2.66-3.86-2.89-4.73-.23-.86.06-1.61.06-1.61l1.99.34.6 2.53s.53.87 1.67.64c1.13-.23 3.12-2.3 2.67-3.28-.46-.98-1.93-3.29-2.05-3.52-.11-.23-.05-1.1-.05-1.1l.8.46s.76.3 2.3-.15c1.53-.46 3.02-1.5 3-2.55-.03-1.06-1.16-2.08-1.24-2.66-.09-.58-.02-.82-.02-.82l1 .15 1.23 1.53.3 1.84-.45 1.57-1.87 2.04-1.85.78-.51-.05 1.13 1.97-.37 2.61-1.64 1.51-2.2 1.32-.16 2.44-1.22 2.64-2.8 1.66h-.84l-.32 1.6-1.76 2.51-3.05 2.03-2.22.41-1.27-1.86.11-.63z"
    }), r.createElement("path", {
      d: "M450.74 174.88s5.1 1.44 4.94-1.79c-.09-1.81-5-5.99-5.3-6.68-.32-.7-.23-1.64-.23-1.64l2.54 2.32s3.24.78 4.16-1.1c.92-1.87.18-3.04.02-3.09-.16-.04.74-.16.74-.16l1.5.3-.18 2.9-1.66 7.25s.44 2.85-1.8 3.05c-2.25.2-4.73-1.36-4.73-1.36zM455.57 213.55s.09-1.47-1.05-2.5c-1.14-1.02-3.32-1.98-3.68-2.2-.35-.21 3.65 4.55 3.65 4.55l1.08.15zM462.96 213.79s-2.56-3.15-3.1-4.24c-.56-1.07-1.89-3.45-2.95-3.56-1.06-.11 1 3.93 1 3.93l4.15 3.78.9.09zM469.96 213.72s-2.2-4.15-2.73-5.36c-.53-1.21-1.68-4.52-2.98-5.42-1.3-.91.17 1.5.17 1.5l1.39 4.3 2.43 3.75 1.72 1.23zM475.12 210.71s-.15-3.54-.58-6c-.42-2.47-2.34-4.52-2.47-4.43-.13.08.15 4.38.15 4.38l2.9 6.05zM485.77 213.38s-1.79-4.26-2.51-6.27c-.73-2-2.52-5.38-2.7-5.42-.2-.04.53 3.87.53 3.87l2.17 6.22 2.51 1.6zM495.01 202.23s-1.64-1.69-5.18-3.07c-3.53-1.38-7.07-1.53-7.07-1.53l.43.45 1.6 1.36 3.7 1.9 4.83 1.17 1.69-.28z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M457.05 204.32s.03 3.08 1.62 4.96c1.59 1.87 5.34 5.3 6.08 5.99.74.69 1.36 4.5 2.47 7.66 1.1 3.17 1.36 5.77 1.84 6.66.49.89 1.48 2.33.74 2.19-.74-.15-1.42-1.01-1.87-2.16-.46-1.16-.32-1.16-.26-2.74.06-1.59-2.41-9.71-3.55-10.6-1.14-.9-6.36-5.25-8.38-8.24-2.01-3-1.59-3.7-1.59-3.7l2.9-.02z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M465.48 224.63c-1.1-2.28-1.3-4.3-1.65-5.65-.34-1.35-4.74-5.04-5.8-5.53-.79-.37-2.45.1-3.11-.4-.67-.5-4.83-5.23-4.83-5.23s-.63.6-.43.76c.2.18 4.52 4.84 6.08 6.34 1.56 1.5 2.41 4.84 3.55 7.43 1.14 2.6.68 2.08.8 3.34.1 1.27.9 2 1.7 2 .8 0 1-.38.7-.6-.3-.21-1.93-2.11-2.86-4.58-.86-2.25-1.96-6.4-3.32-7.95l-.31-.35c.32-.04.86-.14 1.7-.18 1.05-.06 5.4 3.94 5.77 5.13.36 1.18-.04 1.64 1.78 5.59 1.82 3.94 2.67 4.86 2.67 4.86h.32s-1.65-2.7-2.76-4.98zM458.65 198.49s3.15 1.99 4.09 2.25c.93.26 1.62.34 1.62.34s.47 5.75 2.77 9c2.3 3.23 4.17 4.4 4.17 4.4s.08 6.26 1.79 10.59c1.7 4.32 2.04 9.55 1.66 10.37-.38.82-1.83-2.55-2.77-5.53-.94-2.99-1.83-6.22-2.47-8.21-.64-2-2.39-4.98-3.36-5.8-.99-.82-.2-.73.38-.21.57.52 2.23 2.57 3.3 5.88 1.06 3.3 1.49 6.65 2.06 6.67.58.02 1.03-.54 1-1.2-.02-.67-.74-2.4-1.27-5.5-.53-3.08-1.07-5.2-1.58-6.07-.51-.86-1.26-1.01-3.23-4.47-1.99-3.46-2.86-5.38-3.2-6.98-.34-1.6.06-1.44-.28-1.68s-.6.02-2.1-.82c-1.52-.85-2.58-3.03-2.58-3.03zM466.82 197.32s1.93 1.5 3 1.96c1.09.46 2.65.54 2.65.54s-.4 5.45 1.74 9c2.12 3.54 4.34 5.61 4.34 5.61s.34 1.33 1.02 8.93c.68 7.61.71 7.75.91 10.8.2 3.06.3 13.88-.14 13.55-1.65-1.27-.29-7.15-1.1-9.57-.83-2.42-2.14-2.82-3.73-9.68-1.59-6.85-.57-8.41-1.7-10.97-1.14-2.57-2.64-2.8-2.64-2.8s2.1.4 2.98 2.57c.88 2.16 1.01 7.9 1.73 10.74 1.62 6.43 3.84 9.68 3.84 9.68s-.49-8.07-1.11-12.65c-.63-4.58-.6-8.4-1.45-10.16-.85-1.77-2.7-3.18-3.8-5.51-1.11-2.33-1.51-6.91-2.05-8.1-.54-1.18-.85-.8-1.62-1.12-2.5-1-2.87-2.82-2.87-2.82z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M472.64 194.33s1.7 1.9 4.09 3.31c2.39 1.41 3.58.98 3.95 1.27.37.29-.49 5.13 2.01 9.6 2.5 4.46 3.41 4.55 3.47 5.15.05.6.5 13.77.82 18.24.31 4.46.65 19.44-1.2 19.44-1.84 0-.16-11.06-1.07-13.65-.91-2.6-.88-1.85-1.76-3.92-.88-2.08-.87-10.28-2.27-15.13-1.05-3.63-2.13-4.2-2.13-4.2s1.76.95 2.58 3.94c.82 3 1.08 13.06 2.05 14.67.96 1.61 2.35 3.6 2.67 5.1.3 1.5-.2-19.1-.63-20.34-.42-1.24-4.57-8.7-4.89-12.82-.3-4.12-.45-4.53-.82-4.84-.37-.32-1.56-.06-3.52-1.9a25.79 25.79 0 0 1-3.35-3.92zM482.01 196.7c.12-.4 1.3 2.21 5 3.69 3.71 1.46 7.25 1.2 7.72 1.6.47.38 2.81 5.96 2.9 13.39.08 7.43-1.29 6.74-2.43 13.14-1.15 6.4-1.2 19.4-1.92 21.39-.34.73-.73 1.03-1.11 2.29-.38 1.25.3 3.63-.85 3.67-1.15.04-1.28-1.81-1.28-2.8 0-1 1.2-4.54 1.2-8.09 0-3.54-.77-3.97-1.29-8.21-.5-4.23-.55-17.72-1.02-19.01-.47-1.3-2.78-4.1-2.78-4.1s2.49 1.59 3.08 3.4c.6 1.82.66 16.8 1.32 19.8.68 3.06.47-.7.73-2.42.25-1.73 1.15-9.08 1.02-13.01-.13-3.93-1.8-12.44-3.16-13.87 0 0 .71.82 1.5 2.7.01.05.5.54 1.05.86.6.34 1.27.52 1.29.58.02.04-.75-.07-1.35-.33-.45-.2-.78-.56-.76-.52.84 2.22 1.68 5.66 1.76 10.58.12 6.7-.97 21.44.1 21.6 1.06.18.85-8.03 1.95-14.68 1.1-6.66 2.6-7.61 2.13-13.06-.47-5.44-1.91-11.32-3.06-12.05-1.15-.74-4.43-.48-7.33-2.34-2.9-1.85-4.53-3.8-4.41-4.2z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M435.05 204.2s1.07.47 2.3-.13c1.24-.6 4.52-3.2 4.52-4.28s.04-2.16.04-2.16.04.48.98.6c.94.14 3.62-1.9 3.83-3.19.22-1.3.22-3.59-.08-4.06-.3-.48.8.47 1.36-.05.56-.51 3.15-2.2 3.11-3.93-.04-1.73-1.45-3.33-1.45-3.33s1.28.18 2.05 0c.77-.17 3.32-1.68 3.24-3.24-.1-1.55-.98-3.93-2.99-4.1 0 0 1.5.34 2.94-.17 1.45-.52 1.96-1.34 1.96-2.99 0-1.64-2.94-5.18-3.45-5.48-.5-.3 3.15 1.03 4.1-.44.92-1.47 1.05-2.5.8-3.32-.26-.83-1.02-1.04-1.02-1.04s1.58.43 3.7-.65c2.14-1.08 4-2.5 4.99-2.46.98.04-3.11 2.2-3.33 3.41-.08.5 1.12 1.36 2.97 2.71.12.09.17.17.36.26.83.46 4.02.59 4.23.75.27.2-3.07.12-2.79.34a44.74 44.74 0 0 1 7.49 7.06c.1.12.62.58 1.23.75.75.21 1.6.15 1.7.29.09.1-2.15-.06-2.07.05 1.6 2.09 3.05 4.2 4.3 6.16.08.14.6.75 1.2 1 .65.29 1.39.22 1.48.37.16.26-1.83 0-1.67.26 2.48 4.09 4.33 7.89 4.33 7.89s-4.01-7.06-8.91-12.55c-4.9-5.49-6.05-6.22-6.3-5.7-.26.52 3.66 5.36 5.75 8.77 2.08 3.42 3.98 7.66 3.98 7.66s-4.92-10.2-11.82-16.48c-6.9-6.26-7.62-7.3-8.4-7.04-.76.26-1.35 4.88-.89 5.83.47.96 5.5 4.76 9.8 9.81 4.3 5.06 9.75 13.75 9.75 13.75s-3.87-6.27-10.43-13.23c-6.56-6.95-9.07-8.55-9.58-8.51-.52.04-.56 1.3-1.32 2.33-.77 1.04-2.35.91-2.4 1.39-.03.47 5.55 5.61 6.65 6.22 1.11.6 1.7.3 2.56.78.85.47 1.77 1.26 1.77 1.26s-1.17-.44-2.03-.7c-.85-.26-1.7-.3-1.7-.04 0 .25 4.52 5.78 5.28 6.13.77.35 1.2.17 2.22.56 1.02.4 2.47 1.43 2.47 1.43s-1.58-.9-2.69-1.12c-1.1-.22-1.57 0-1.53.3.04.3 3.45 4.67 3.28 4.75-.17.09-5.28-6.05-9.63-9.9-4.34-3.84-6.3-4.66-6.52-4.53-.2.13-.08 1.25-1.15 1.64-1.06.39-2.04.52-2.04.9 0 .4 3.92 4.07 6.69 7.14 2.77 3.07 5.15 5.96 5.15 5.96s-2.8-2.8-5.88-5.7c-3.06-2.9-4.64-4.02-4.94-3.85-.3.17-.34 1.64-.04 2.03.3.4 5.97 7.1 5.8 7.26-.18.18-6.7-8.03-7.12-8.03-.43 0-.68 1.03-1.1 1.5-.44.48-2.27.48-2.27 1.13 0 .65 9.2 9.68 8.95 9.9 0 0-7.62-6.57-7.88-6.18-.26.39 3.2 6.7 2.98 6.82-.21.14-4.47-6.6-4.86-6.56-.38.04-.34.77-1.44 1.77-1.11 1-2.52.56-2.56 1-.04.42 6.35 7.51 6.18 7.64-.17.13-6.48-6.74-6.65-6.35-.04.1-.38.4-.2 1 .46 1.65 1.88 4.66 1.7 4.92 0 0-2.05-4.2-2.6-4.02-.56.17-.56 1-1.5 1.6-.93.6-1.7.47-1.79.9-.08.44 1.11 1.17 1.63 2.17.5 1 .93 3.15.93 3.15s-.64-1.81-1.53-2.98c-.9-1.17-1.7-1.95-2.39-1.95-.68 0-1.15.65-1.15.65l-.64-1.51z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M494.74 201.99s2.09-.13 2.34-.56c.26-.43-.77-.13-2.64-2.16-1.87-2.03-6.66-15.89-11.88-22.86-8.56-11.41-16.57-16.64-16.57-16.64s9.53 5.52 16.91 16.3c7.5 10.94 9.31 19.53 11.41 21.77 2.1 2.25 4.15 2.65 4.04 3.29-.12.63-.46 1.1-1.26 1.2-.79.12-2.72.3-2.72.3l.37-.64zM431.77 198.97s.06.17.44.21c.4.05 2.98-2.53 2.84-3.28 0 0-1.15-.43-2.08-1.38-.94-.95-1.16-2.46-1.16-2.46s.86 1.68 1.58 2.16c.72.47 1.87.73 2.3.39.43-.35 4.24-3.17 4-4.28 0 0-1.19.04-2.3-.78-1.1-.82-1.3-2.51-1.3-2.51s.71 1.36 1.85 1.9c1.13.55 2.24.32 2.55-.08.31-.4 2.81-3.84 2.53-4.84 0 0-1.28.14-2.42-.66-1.13-.81-1.73-2.83-1.73-2.83s.82 1.7 2.27 1.99c1.45.29 2.64-.58 2.87-1.61.23-1.04 1.02-4.9-.2-5.88 0 0-1.87.6-3.2-.09-1.34-.69-1.82-2.39-1.82-2.39s1.13 1.56 2.63 1.76c1.51.2 2.17-.6 2.42-1.21.26-.6.31-2.8-.14-4-.45-1.22-1.4-1.13-1.62-2.94 0 0-.48.72-2.41.72-1.93 0-2.96-2.2-2.96-2.2s1.54 1.42 3.07 1.3c1.53-.11 2.1-1.38 2.13-2.36.03-.98-.77-1.84-1.2-2.85-.42-1.01-.45-2.22-.73-2.08-.29.15-.65 1.07-2.64.75-1.99-.31-2.42-1.67-2.42-1.67s1.45 1.01 2.56.92c1.11-.08 1.82-.6 1.82-1.35 0-.75-.43-2.13-2.93-4.27-2.5-2.13-4.54-3.6-4.54-3.6s3.24 1.8 5.34 3.55c2.1 1.76 3.29 3.46 3.29 3.46s2.3.75 2.56-.03c.25-.78.21-1.75-.51-3.14-.71-1.35-2.68-3.37-2.68-3.37s2.06 1.71 3.04 3.48.53 3 .62 3.44c.08.43 4.38 2.1 5.34 1.51.96-.58.51-1.84-.3-3.11l-1.47-2.34s1 1.1 1.73 2.36c.72 1.25 1.32 2.25 1.04 2.83-.27.58-.87.84-.8 1.08.06.24 1.48 1 2.93 1.75 1.45.76 3.13 1.43 3.35 1.02a6 6 0 0 0 .23-2.81c-.13-1.4-.93-3.55-.93-3.55s.95 2.08 1.12 3.55c.17 1.47-.19 2.57.15 3.09.34.52 1.4.65 1.4.65s-.85.6-2.74.04c-1.9-.56-10.03-4.67-10.42-4.28-.38.39 3.8 2.92 5.71 4.73 1.92 1.82 2.86 3.72 2.86 3.72s-1.5-1.26-2.94-2.05c-1.45-.8-5.8-3.03-6.07-2.73-.28.3 1.64.7 1.78 1.04.15.35-1.36 1.7-1.36 2.27 0 .56 6.2 4.86 6 5.34-.18.47-1.57 1.6-1.82 1.53-.26-.07-3.32-2.42-3.32-2.05 0 .37 1.76 1.86 1.74 2.18-.02.32-1.17 1.1-.96 1.84.22.73 3.46 3.39 3.43 4.3-.02.9-1.85 1.68-1.5 2.26.33.59 2 2.64 2 2.64s-1.8-1.19-2.37-1.81c-.58-.63-1.73-2-1.94-1.78-.21.22-1.36 2.75-1.26 3.31.11.56 1.56 1.43 1.84 2.96.27 1.53-.22 3.13-.33 3.13-.1 0-2.14-2.63-2.55-2.68-.4-.04-.91.13-1.26.8-.34.67-1.53 2.77-1.38 3.16.15.39 2.15.84 2.2 2.44a4.46 4.46 0 0 1-1.4 3.09c-.12 0-2.48-3.18-2.72-3.18-.23 0-2.92 2.99-2.98 3.35-.06.37 1.83 1.71 1.5 2.23-.35.52-1.63-.2-2.35.21-.73.42-2 .93-2.26.93-.25 0-.64-.86-.64-.86z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M465.92 159.9s.21-.84.62-1.27c.4-.44 2.05-2.25 1.43-2.62-.62-.36-2.7.3-4.03.2-1.32-.11-2.19.21-6.02-2.97 0 0-12.16-8.5-31-9.59-5.96-.34-8.63 1.79-8.91 2.91-.03.26 1.56-2.42 7.55-2.33 2.64.03 21.6 1.56 31.44 9.27.51.4 3.77 3.53 6.81 3.18 3.05-.35 3.69-.7 3.63-.26-.07.43-1.03 1.56-1.24 2.07a12.1 12.1 0 0 0-.42 1.47l.14-.06zM433.06 162.41l-.05-.15c-.17-.52-1.38-2.21-3.44-4.13-2.47-2.29-10.14-5.49-10.53-5.62-.38-.13 7.88 3.8 10.19 6.01 3.7 3.54 3.83 3.89 3.83 3.89z"
    }), r.createElement("path", {
      d: "M433.04 175.94s-.5-.83-2.12-1.87-3.24-1.47-3.24-1.47l3.75.95a6.28 6.28 0 0 1 1.61 2.39zM432.07 168.89s-.51-.73-2.81-1.47c-2.3-.73-2.85-.7-2.85-.7s2.13-.9 3.74-.08a3.6 3.6 0 0 1 1.92 2.25zM430.71 163.1s-.47-1.04-2.51-1.77c-2.05-.74-3.5-.87-3.5-.87s2.13-.6 4.18.22c2.04.82 1.83 2.42 1.83 2.42zM428.24 159.38s-.6-.82-4.43-1.73c-3.84-.9-5.33-.95-5.33-.95s5.46-.43 6.9.18c1.45.6 2.86 2.5 2.86 2.5zM421.21 155.36s-2.34-.65-4.6-.82c-2.26-.17-5.8.13-5.8.13s6.57-1.04 8.31-.65c1.75.39 2.09 1.34 2.09 1.34z"
    })), r.createElement("g", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: ".35"
    }, r.createElement("path", {
      d: "M399.63 236.56s1.16 2.05 3.46 2.13c2.3.09 4.1 3.37 4.1 3.37l-2.53 2.48-6.08.29-1.96-3.14 3.01-5.13zM399.77 234.46c.2-.4-1.79-4.32-3.21-4.98-1.42-.66.48 1.27.17 2.07-.31.8-.52 1.8-.4 1.95.1.14 1.17 1.8.6 2.55-.57.75 2.84-1.59 2.84-1.59z"
    }), r.createElement("path", {
      d: "M398.68 240.44s1.08.54 1.93.29a4.15 4.15 0 0 0 1.61-1.12M397.58 238.92s3.41-2.48 3.13-3.8c-.29-1.33-.97-1.27-1.43-1.15-.45.11-2.55 1.84-2.66 2.24-.12.4.96 2.71.96 2.71z"
    }), r.createElement("path", {
      d: "M395.17 240.62s.62 1.64 1.73 1.64c1.11 0 2.7-.89 2.73-1.55.03-.67-1.11-1.88-1.85-2.22-.74-.34-2.44.55-2.44.55l-.17 1.58z"
    }), r.createElement("path", {
      d: "M398.27 238.38c-.17.51-2.33 1.52-3.04 1.58-.7.06-2.16-1.75-1.56-2.02.6-.25 1.34-.23 1.87-.51.54-.3.69-1.01 1-1.04.31-.03 1.2.2 1.42.75.23.55.48.72.31 1.24z"
    }), r.createElement("path", {
      d: "M396.05 239.81s-3.35 4.53-4.74 4.3c-1.4-.23.57-6.43.57-6.43s.54.35 1.64.7c1.11.34 2.22.74 2.53 1.43z"
    }), r.createElement("path", {
      d: "M390.09 236.59s4.32.75 4.52 1.44c.2.7-2.08 1.61-3.3 1.61-1.22 0-1.22-3.05-1.22-3.05z"
    }), r.createElement("path", {
      fill: "#202220",
      d: "M379.35 243.13s.57 2.08 2.44 2.2c1.88.1 3.64-1.97 3.64-1.97l-4.43-1.73-1.65 1.5z",
      stroke: "none"
    }), r.createElement("path", {
      fill: "#4b4139",
      d: "M379.35 243.13l-.1.03s.15.53.54 1.08a2.61 2.61 0 0 0 2 1.18l.16.01c1.88-.01 3.55-2 3.56-2l.09-.11-4.62-1.8-1.75 1.58.02.06.1-.03.07.08 1.6-1.46 4.37 1.7.04-.09-.08-.07-.28.3c-.55.55-1.82 1.63-3.12 1.63h-.15a2.4 2.4 0 0 1-1.85-1.1 3.72 3.72 0 0 1-.39-.7l-.08-.23-.03-.09-.1.03.07.08-.07-.08z",
      stroke: "none"
    }), r.createElement("path", {
      fill: "#202220",
      d: "M380.6 242.55s.74 1.56 3.18 1.62c2.44.05 4.37-1.96 4.37-1.96l-3.86-3.06-3.69 3.4z",
      stroke: "none"
    }), r.createElement("path", {
      fill: "#4b4139",
      d: "M380.6 242.55l-.09.05c0 .01.78 1.61 3.27 1.67h.1c2.45 0 4.34-1.99 4.35-1.99l.08-.08-4.02-3.18-3.81 3.5.03.08.09-.05.07.08 3.63-3.34 3.8 3 .05-.08-.07-.08-.08.09c-.39.36-2.07 1.85-4.12 1.84h-.1a3.93 3.93 0 0 1-2.44-.8 2.89 2.89 0 0 1-.62-.7l-.03-.05-.09.04.07.08-.07-.08z",
      stroke: "none"
    }), r.createElement("path", {
      fill: "#4b4139",
      d: "M380.93 242.91s1.08.9 2.36.96c1.28.08 2.87-.33 2.87-.33l-1.47.53-1.05.12-1-.16-.89-.33-.7-.52-.12-.27z",
      stroke: "none"
    }), r.createElement("path", {
      fill: "#202220",
      d: "M383.78 240.76s1.08 2.65 3.35 2.36c2.27-.29 2.33-1.6 2.33-1.6l-2.56-3.7-3.12 2.94z",
      stroke: "none"
    }), r.createElement("path", {
      fill: "#4b4139",
      d: "M383.78 240.76l-.1.04c0 .01.25.61.76 1.22.5.61 1.29 1.23 2.35 1.23.11 0 .23 0 .35-.02 1.16-.15 1.77-.56 2.08-.95.32-.4.34-.75.34-.76v-.04l-2.64-3.81-3.26 3.06.03.07.09-.04.07.08 3.04-2.86 2.49 3.6.08-.07h-.1v.04c-.05.23-.29 1.21-2.24 1.47-.12.02-.23.02-.33.02-.98 0-1.7-.57-2.2-1.15a5.23 5.23 0 0 1-.54-.8l-.13-.27-.04-.1-.1.04.07.08-.07-.08z",
      stroke: "none"
    }), r.createElement("path", {
      fill: "#4b4139",
      d: "M384.1 241.28s1.36 1.66 2.56 1.63c1.19-.03 1.94-.48 1.94-.48l.06.2-.63.3-1.08.23-1.1-.15-.91-.55-.84-1.18zM379.79 243.94s1.05 1.08 2.02 1.12c.96.05 2.44-.78 2.44-.78l.18-.05-.25.23-1 .54-1.2.35-.95-.17-.73-.45-.44-.56-.07-.23z",
      stroke: "none"
    }), r.createElement("path", {
      d: "M389.83 236.36c1.02-.14 3.15 2.77 3.15 4.2 0 1.45-.62 3.6-1.67 3.55-1.06-.06-3.44-2.19-3.98-3.28-.54-1.1-1.08-1.85-.68-2.43.4-.57 3.18-2.04 3.18-2.04zM379.24 236.62s-1.7-1.32-2.39-.63c-.68.69-.45 3 0 3.45.46.47 2.5-1.1 2.5-1.1l-.11-1.72z"
    }), r.createElement("path", {
      d: "M379.01 238.23s-2.27.23-2.27 1.27 1.08 2.13 1.3 2.36c.23.23 2.28-.92 2.28-.92l-1.31-2.71z"
    }), r.createElement("path", {
      d: "M379.92 240.13s-2.33.7-2.33 1.5 1.02 2.3 1.76 2.3 1.3-1.44 1.59-1.73c.29-.29-1.02-2.07-1.02-2.07zM381.06 233.39s-.45-.63-1.42-.23-2.05 1.38-1.87 2.94c.17 1.55.73 2.6.73 2.6l3.53-1.22-.97-4.09z"
    }), r.createElement("path", {
      d: "M381.34 236.1s-3 .98-3.12 2.13c-.12 1.15.68 2.3 1.47 2.53.8.24 3.35-2.24 3.35-2.24l-1.7-2.42z"
    }), r.createElement("path", {
      d: "M383.95 240.89s-2.95 1.95-3.35 1.95c-.4 0-1.48-1.55-1.25-2.59.23-1.03 2.21-1.78 3-2.07.8-.3 1.6 2.71 1.6 2.71zM386.54 230.17s-.94-.78-2.73-.65-3.1 2.46-3.32 3.63c-.21 1.17-.04 3.37.64 3.72.68.34 4.39-2.64 4.39-2.64l1.02-4.06z"
    }), r.createElement("path", {
      d: "M382.92 239.02c-1.24-.13-2.34-1.9-2.13-2.98.21-1.08 2.64-2.94 3.92-2.72 1.28.21 1.02 3.41 1.02 3.41s-1.58 2.42-2.81 2.29z"
    }), r.createElement("path", {
      d: "M386.85 238.75s-.62 1.44-1.87 2.08c-1.25.63-2 .1-2.73-.93-.74-1.03.34-1.5.9-2.02.58-.51 2.22-.92 2.22-.92l1.48 1.79z"
    }), r.createElement("path", {
      d: "M384.86 234.95s-1.4 1.12-.6 2.42c.8 1.3 1.42 1.76 2.42 1.93 1 .17 1.64-.23 2.44-1.18s1.96-1.38 1.85-2.57c-.12-1.18-.57-2.1-1.28-2.45-.71-.34-2.87.03-4.83 1.85z"
    }), r.createElement("path", {
      fill: "#202220",
      d: "M388.82 229.39s-1.44-.55-2.54.1a4.04 4.04 0 0 0-1.92 3.17c-.04 1.22.22 2.91.22 2.91s1.52-.43 2.5-1.25c.97-.82 1.3-1.05 1.16-1.47-.08-.26-.48-.54-.48-1.56 0-1.77 1.06-1.9 1.06-1.9z",
      stroke: "none"
    }), r.createElement("path", {
      fill: "#4b4139",
      d: "M388.82 229.39s-1.66-.28-2.49.26a4.22 4.22 0 0 0-1.83 2.42c-.3 1.08-.09 1.36-.09 1.36s-.15-.94.14-1.84c.34-1.03 1.19-2.06 2.01-2.3 1.01-.3 2.26.1 2.26.1z",
      stroke: "none"
    }), r.createElement("path", {
      d: "M431.58 260.88s1.2-.5 2.03-.96c.83-.46 2.62-1.62 2.62-1.62l.58 2.98-2.3 1.77-2 .02-1.22-.88.29-1.31z"
    }), r.createElement("path", {
      d: "M428.37 261.18s.03.04 1.43.07c1.4.04 1.53-.49 1.78-.37s.64 1.61.64 1.61l-.51.94-2.01 1.14-1.7-.93-.14-2.35.51-.11zM444.32 260.22s-.4-.67-1.2-1.36l-2.84-2.48-.01 6.47 2.98-.07 1.42-2-.35-.56z"
    }), r.createElement("path", {
      d: "M428.37 261.18s-.44-.65-1.7-.52c-1.26.14-2.6 1.17-2.73 2.04-.14.87 0 3.4.68 3.88s1.53.72 2.9.38c1.36-.35 8.31-4.64 8.31-4.64l-1.77.39c-.95.2-1.84-.22-1.84-.22s-.95 1.08-2.04 1.25c-1.1.17-1.4-.52-1.6-1.03-.21-.52-.21-1.53-.21-1.53z"
    }), r.createElement("path", {
      d: "M433.01 263.42s-1.02.4-1.41.67c-.38.28-1.76.77-1.76.77l.53 2.1 2.96.76 1.85-1.53.02-2.12-2.19-.65zM446.77 261.93s-.47-.43-1.02-1.06c-.55-.62-1.24-.75-1.43-.65-.2.11-1.6 1.92-1.6 1.92l-.1 1.37 1.64.89 1.15.2 1.51-.99-.15-1.68z"
    }), r.createElement("path", {
      d: "M436.61 260.89s-1.32.6-1.96 1.14c-.64.55-1.64 1.15-1.64 1.39 0 .23 1.5 1.78 1.5 1.78l1.5.12 3.28-2.3-.21-2.09-2.47-.04zM449.07 263.61s-.25-.52-.76-1c-.52-.47-1.15-.73-1.54-.68-.38.04-1.66 1.94-1.66 1.94l-.16.54 1.18 1.37 2.1.51 1.45-1.46-.61-1.22z"
    }), r.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M443.66 265.9l1.5.26s-.05.39.38.74c.42.34.47.08.47.08s.21 1.43 1.78 2.64c0 0 1.84.6 2.77.08.94-.52.81.16.81.16l2.64-3.27s0-.65-.64-.69c0 0 .47-2.03-1.23-2.46-1.7-.44-3.07.17-3.07.17s-1.3 2.4-2.08 2.07a3.1 3.1 0 0 1-.94-.64c-.72-.78-.94-1.17-.94-1.17s-.55.17-1.2-.26c-.63-.43-1.18-1.47-1.18-1.47s-.98-.17-1.32-.52c-.34-.34-.7-1.03-.7-1.03l-2.44 1.76s-.07.77-1.5 1.8c-1.41 1.05-2.26 1.05-2.26 1.05s-.4 2.13-2 1.78c-1.58-.34-2.66-2.13-2.66-2.13s-1.14-.17-1.88.8c-.74.99-1.08 1.33-1.08 2.31s.63 2.36 1.14 2.82c.51.46 2.1 1.73 3.97.75 1.88-.98 1.26-2.59 1.26-2.59s-.06.12 1.07-.63c1.14-.75 2.39-1.9 3.24-2.25"
    }), r.createElement("path", {
      d: "M440.75 252.87l.01 4.18s.51 3.72-.3 4.88c-.8 1.17-3.75.91-4.17-.08-.43-1-.21-4.24-.21-4.24l4.67-4.74z"
    }), r.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M437.45 265.54s-.63 1.1 1.3 1.27c.56.04.92-.15 1.17-.43.5-.58.39-1.06.39-1.06s-.17 1.54 1.57 1.6c1.93.07 1.76-1.78 1.76-1.78"
    }), r.createElement("path", {
      fill: "#202220",
      d: "M421.55 268.97s-1.08-1.82.2-2.48c1.28-.66 1.96.03 2.72.06.77.03.52-1.97.35-2.37a4.88 4.88 0 0 0-.88-1.49c-.32-.23-4.54.2-4.5 3.03.02 2.72 2.11 3.25 2.11 3.25zM428.17 275.74s-1.36-1.93-.62-3.08c.74-1.16 1.3-.46 1.67-.5.37-.02.54-.86-.08-2.12-.63-1.27-1.4-1.9-1.85-1.97-.46-.05-3 1.82-2.5 4.21a4.56 4.56 0 0 0 3.38 3.46zM452 273.41s4.6 1.93 4.91-2.7c.17-2.49-2.04-4.2-2.75-4.18-.49 0-.85.28-1.68 1.26-.82.98-1.45 1.7-1.1 2.08.33.37 1.7-.4 2.3 1.06 1.02 2.51-1.68 2.48-1.68 2.48z",
      stroke: "none"
    }), r.createElement("path", {
      fill: "#4b4139",
      d: "M428.17 275.74s-3.58-.79-3.55-4.29c.02-2.33 2.62-3.37 2.62-3.37s-2.4 1.28-2.45 3.33c-.07 3.56 3.38 4.33 3.38 4.33zM421.6 268.97s-2.06-.46-2.29-3.43c-.22-2.97 4.68-2.85 4.68-2.85s-4.7.23-4.46 3.07c.26 2.94 2.07 3.21 2.07 3.21zM452 273.41s.92.45 1.98.4c1.05-.04 2.31-.31 2.75-2.07.44-1.76.26-2.59-.9-4.14-.81-1.08-1.56-1.06-1.56-1.06s.8.16 1.42 1.14c.62.98 1.53 2.07.9 4.05-.62 1.97-2.52 2.01-3.21 1.95-.7-.05-1.38-.27-1.38-.27z",
      stroke: "none"
    })), r.createElement("g", {
      fill: "#4d2a15"
    }, r.createElement("path", {
      fill: "#904720",
      d: "M397.2 176.12l-.86-.18.62-1.44 2.42-.89 2.4-.1 2.55-.1 1.17.81 1.3 3.01-4.81 2.87-.78.26-.3-1.19-.74-1.94z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M442.21 245.84l-.3-7.22-19.47 6 7.71 7.22z"
    }), r.createElement("path", {
      fill: "#d2a567",
      d: "M406.16 233.27l-1.64-1.28s-1.17-.83-1.83-1.04c-.65-.2-1.49-.04-1.49-.04l-.27.39.26.66 1.78 2.07 2.96 1.53c.07.03 1.05 1.01 1.05 1.01l.68.3-1.5-3.6zM405.7 236.33l1.11.15 1.11 1.27.69 1.36.9 1.8.3 1.04-2.18-.48-6.3-1.95.54-1.5 1.1-1.01.92-.4 1.28-.2z"
    }), r.createElement("path", {
      fill: "#d2a567",
      d: "M409.8 241.52l1.04-.09.7-.6-.33-2.36.39-7.56-5.12-6.06-1.05 3.5 1.5 6.12 1.11 3.67z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M406.13 227.69s-.34.63.09 2.62c.42 1.98 1.16 6.43 2.92 9.45 1.76 3.02-1.7-2.39-1.7-2.39s-2.73-6.14-2.3-10.78c.42-4.63.99 1.1.99 1.1z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M409.85 231.52s-1.1 1.44-1.28 2.5c-.17 1.07.09 2.89.09 2.89s-.17-1.38.96-1.7c1.14-.32 1 3.11 1.05 3.43.06.31.66-6.14.66-6.14l-1.48-.98zM410.42 244.19l-5.77-1.32c-2.98-1.33-4.55-2.37-4.5-3.09.06-.72 5.3.18 6.06.35.77.17 3.12 1.35 3.12 1.35h1.34l2.45-1.08.34 2.6-3.04 1.19zM400.79 243.1s1.42 1 .74 1.44c-.68.43-2.5.49-3.07.35-.57-.15 5.57 1.35 5.57 1.35s1.19-1.01 1.1-1.07c-.08-.06-4.34-2.07-4.34-2.07z"
    }), r.createElement("path", {
      fill: "#d2a567",
      d: "M399.27 241.58c.21-.35.38.8 2.37 1.07 2 .25 2.9-.35 2.9-.35l.88.58 1.05.23-.97 1.44-3.63-1.07-1.96-1.1-.64-.8z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M412.22 238.97l1.02 1.47.64-3.2-.04-3.33-2.09-1.38z"
    }), r.createElement("path", {
      d: "M406.47 233.58l-1.7-2.85-2.22-4.06 1.36-2.34 1.67 2.42s-.47 1.64-.17 3.2c.3 1.56 1.06 3.63 1.06 3.63z"
    }), r.createElement("path", {
      fill: "#d2a567",
      d: "M394.8 243.95s.74-1.23 2.47-1.37c1.73-.15 3.12.23 3.12.23l3.52 1.84.72 1.16-6.65-.9-3.18-.96z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M412.09 232.2s.13 3.97.25 5.23c.13 1.25.9 2.46.77 2.98s-.38.78-1.24 1.08c-.85.3-2.55 0-2.55 0s1.66-.22 1.75-.56c.08-.35-.51-1.86-.6-3.24-.09-1.39.09-2.9-.38-2.9s-.98.6-1.07.78c-.08.17.47-4.93 1.02-5.49.56-.56 2.05 2.12 2.05 2.12z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M399.94 242.64s-.68-.63-.67-1.07c.02-.43.8 2.09 4.45 1.95 3.65-.14 3.43-.2 3.43-.2h1.7s-.37 1.58-.67 1.72c-.3.15-2.84 1.86-2.89 1.9l-.9.5.07-.25-.17.01-.3-2.8-3.15-1.21-.9-.55z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M406.47 233.58s-4.22-4.37-5.62-7.26c-1.4-2.9-.56-6.87-.56-6.87l3.97 5.18s-.52 1-.35 2.64c.17 1.64 2.56 6.31 2.56 6.31z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M403.77 249.48c-.14-.3-.3-1.26.51-2.28 2.5-3.12 8.85-5.37 8.85-5.37v3.83l-8.13 3.9-1.23-.08z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M404.25 246.59c.35-.25 1.77-1.3 1.82-1.76.06-.52-.96-.6-2.8-.98-1.85-.37-3.36-1.2-3.36-1.2s2.27 1.75 3.15 2.1c.88.34.8.69.69.92-.12.23.45.96.5.92zM415.14 247.48s-1.17-1.75-1.55-2.82c-.37-1.07-.39-2.8-.46-2.82-.07-.02-.78.57-1.3.81-.54.24-2.41.85-2.51.92-.1.07 2.58-.06 2.57.88-.02.93-3.87 1.33-3.89 1.4-.01.07 3.1-.69 2.92.07-.2.76-1.57.83-3.24 1.52-1.67.7-2.4 1.04-3.02 1.4-.62.35-.92.63-.92.63s.75.42 1.93.38c1.18-.05 3.8-.7 3.8-.7l5.03-1.9.64.23z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M415.14 247.48s-1.4-.49-2.4-6.35c-1-5.85-.7-7.43-.7-7.43l2.36 1.66 2.12 3.86-1.38 8.26z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M415.9 237.74s-1.1 3.28-1.1 5.19c0 1.9-.2 3.19.34 4.54.55 1.35 2.4 3.03 2.4 3.03l.86-.9.38-2.65.22-4.4-3.1-4.81z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M419.23 242.2s.54 8.27-1.56 8.5c-1 .1-2.5-3.12-2.53-3.23-.02-.1 1.82 3 2.51 2.72 1.32-.54.92-8.6.92-8.6l.66.61zM415.14 247.48s-.35-.15-.93-1.1c-.57-.93-.07.84-4.48 2.4-4.4 1.55-5.98.69-5.98.69s1.46 1.14 5.91-.16c4.46-1.3 4.05-1.57 4.65-1.7.6-.13.83-.13.83-.13z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M406.94 236.95s.7.6 1.49 2.2l1.36 2.74.2-.2s-.54-1.55-1.28-2.77c-.73-1.2-2.87-4.14-2.87-4.14l1.1 2.17z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M404.26 247.21s.45-1.55 0-1.83c-.46-.3-.88.02-3.89-.35-3.01-.38-5.57-1.08-5.57-1.08s2.05 1.25 4 1.77c1.97.52 4.52 1.1 4.52 1.1l.68.11.26.28z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M404.26 247.21s.06-.36-.28-.74c-.34-.36-.96.18-4.6-.84-3.64-1-4.58-1.68-4.58-1.68s1.3 1.14 4.52 1.97c3.21.82 4.94 1.29 4.94 1.29z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M405.9 236.32s-2.76.15-3.64.86c-.89.71-2.1 2.6-2.1 2.6l1.79.21s-.22-1.66.63-2.5c.85-.83 2.14-.9 3.32-1.17z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M400.68 231.08s1.1 1.47 2.26 1.99c1.15.52 2.3.95 2.85 1.5.55.57 1.15 2.38 1.15 2.38s-3.96-1.76-4.72-2.63c-.77-.87-1.54-3.24-1.54-3.24z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M404.52 231.99s-.36-.6-1.45-1.09c-1.08-.5-1.88-.42-2.2-.2-.3.23-.2.38-.2.38l1.45 2.18.81-.2s-2.15-1.35-1.65-1.78c1.06-.9 3.24.71 3.24.71z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M415.2 227l22.17-11.45 10.5 14.6-19.17 5.14-10.14.87-4.94-3.58z"
    }), r.createElement("path", {
      d: "M444.93 233.26l27.64 23.94-3.06 2.1-6.48-1.84-13.46-13.3-4.98-5.02z"
    }), r.createElement("path", {
      d: "M480.33 252.46s-6.87-5.41-15.79-12.04c-8.92-6.63-19.95-14.98-19.95-14.98l.51 7.14 22.82 20.98 7.53 3.62 3.8-1.15 1.93-2.01-.85-1.56z"
    }), r.createElement("path", {
      fill: "#803f1d",
      d: "M444.85 235.53s7.96 8.99 14.02 13.57c6.04 4.58 11.84 9.59 13.03 8.9 1.19-.7.76-1.47.76-1.47l-27.98-22.82.17 1.82z"
    }), r.createElement("path", {
      d: "M464.4 258.5l-2.81 2.19-3.24-1.32-17-17.38.86-3.2 2.38.35z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M480.33 252.46s-2.08 4.91-6.51 3.76c-4.43-1.15-28.83-24.33-28.83-24.33l-.06 2.42s24.73 22.65 29.5 23.57c4.77.92 8.68-3.22 8.18-3.69-.34-.31-2.28-1.73-2.28-1.73z"
    }), r.createElement("path", {
      fill: "#803f1d",
      d: "M442.12 239.16s7.88 10.11 12.06 13.83c4.17 3.72 7.75 6.65 9.45 6.3 1.7-.34-1.02-2.24-1.02-2.24l-11.93-11.75-6.09-6.14s-2.38-.95-2.47 0z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M444.08 239.16s20.01 20.4 21.6 20.86c3.35.98 8.12-2.48 8.12-2.48l-1.76-1.04-.23.64s-.85 2.07-5.17 1.15c-4.32-.92-21.88-19.82-21.88-19.82l-.68.69z"
    }), r.createElement("path", {
      d: "M451.62 258.68l-7.28-8.38-1.62-2.77-.43-3.55 14.53 14.61-2.05 1.38-1.79-.6z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M464.78 258.97s-1.76 2.6-4.15 2.07a7.04 7.04 0 0 1-3.75-2.24l-13.93-13.64-.34-2.08s15.28 16.17 18.02 16.88c1.99.52 3.47-1.9 3.47-1.9l.68.92z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M457.05 258.51s-.68 2.02-2.72 1.73c-2.05-.29-2.68-1.1-2.68-1.1L443.12 249l-.17-2.7s8.87 12.27 10.92 12.96c2.05.7 2.56-1.38 2.56-1.38l.62.63z"
    }), r.createElement("path", {
      fill: "#b07229",
      d: "M447.93 231.92s8.26 7.09 8.95 7.43c.68.35 3.57.44 3.74.87.17.43-1.87 0-2.04.43-.17.43 4.17 3.98 4.86 4.06.68.09 4.17.09 4.09.52-.09.44-2.39 0-2.47.52-.09.52 3.75 3.54 4.43 3.63.68.09 5.1.09 5.1.52 0 .43-3.57-.09-3.48.69.08.78 6.04 4.5 5.79 5.01-.26.52-7.16-4.67-7.33-4.4-.17.25-.42 1.9-.85 2.15-.43.26 0-2.16-.35-3.2-.34-1.03-4.34-4.06-4.76-3.7-.43.34-.09 2.15-.51 2.15-.43 0 .08-2.25-.35-3.02-.42-.78-4.17-3.9-4.68-3.9-.51 0-.17 1.65-.51 1.9-.35.27-.26-1.9-.77-2.59-.5-.68-9.2-8.55-8.86-9.07z"
    }), r.createElement("path", {
      d: "M433.76 254.86s.07 3.13-1.34 3.59c-1.4.45-4.07-5.75-4.07-5.75l-.62-5.79 4.14 3.84 1.89 4.11zM444.84 253.27s.06-.92-.05-1.67c-.1-.76-.34-1.9-.34-1.9l-.27-3.22-.77-2.16-.62-1.37-.9.07-2.17 1.54-.74 2.1 1.15 3.9 1.06 3.57 1.62.52 2.03-1.38z"
    }), r.createElement("path", {
      d: "M441.99 258.74c.49-.15-.45-4.44-.45-4.44l-2.56-6.34-.68-2.24-2.07-.78-1.37 1.56.32 2.5s1.98 4.18 2.95 5.65c.97 1.47 3.01 4.35 3.86 4.09z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M439.7 245.29c.74.52 1.6 2.22 1.79 3.37 0 0 1.7 4.66 1.48 5.13-.23.46-1.25.52-1.25.52s2.27 2.36 2.95 2.07c.68-.29.4-2.6.17-3.11-.23-.52-.97-.17-1.25-.7a20.2 20.2 0 0 1-1.2-5.47c-.05-1.84-.1-3.1.12-3.57.23-.46 1.93 3.86 1.93 6.17l.74.86s-.45-3.17-.74-4.15c-.28-.98-.9-2.65-.9-3 0-.34.34-1.15.34-1.95s-.06-1.33-.06-1.33.9.63 1.25.58c.34-.06.85-.52 1.08-2.54.22-2.01-.23-7.88-.23-7.88l-8.86 11.69 2.64 3.31z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M439.7 244.28s-.34 3.14.82 6.37c1.17 3.22 1.48 3.34 1.7 3.8.23.46.21 3.86-.22 4.3 0 0-2.27-5.8-3.03-8.65-.77-2.85-.97-3.95-1.37-4.18-.4-.23-1.05-.29-1.05-.29l3.15-1.35z"
    }), r.createElement("path", {
      d: "M438.86 261c.25-.05.1-1.33.1-1.33l-.37-3.03-3.11-6.38-3.41-3.07-1.79-2.77-.25 5.28s2.47 5.27 4.09 6.78c1.61 1.51 4.29 4.63 4.74 4.52z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M426.13 246.61s.53 1.41.53 2.34v1.79s1.25 2.53 2.39 4.55c1.14 2.01 2.21 4.09 3.18 3.63.97-.46 1.3-1.96 1.36-2.14.06-.17-1.08 1.73-1.65 1.44-.56-.28-3.12-8.52-3.06-8.7.06-.17-.68-.51-1.25-1.09-.57-.58-1.5-1.82-1.5-1.82zM435.41 253.79s-1.76-2.88-2.33-4.15c-.57-1.27-1.54-2.25-1.82-2.25s-.65-2.58-.65-2.58.93 1.72 2.13 2.3c1.2.57 1.93 1.03 2.5.8 0 0 .34 1.33.34 2.65s-.17 3.23-.17 3.23z"
    }), r.createElement("path", {
      fill: "#5c3a1d",
      d: "M429.73 249.55s.6 1.81 1.76 3.54c1.16 1.73 3.07 3.8 3.07 3.8s-2.1-2.07-3.21-3.68c-1.1-1.62-1.85-3.72-1.85-3.72l.23.06z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M435.8 247.4s.56-1.57 1.05-1.64c.49-.08 1.51-.38 1.51-.38s-.88-.22-1.58-1.04c-.74-.88-.9-.81-1.71-1.74 0 0 .45 1.74.6 2.56.13.82.13 2.24.13 2.24zM435.24 247.91s2.53 5.41 3.18 7.23c.65 1.82.54 4.53.54 4.53s-.32-1.93-.88-3.52c-.57-1.58-2.87-6-3.07-6.5-.2-.53.23-1.74.23-1.74z"
    }), r.createElement("path", {
      d: "M438.68 244.39l.6-7.96-.6-2.8-3.58-7.95s-.17 1.16-1.07 1.12c-.89-.05-3.27-1.3-4.09-2.38 0 0 .47 1.86.3 3.63-.17 1.77-.46 2.72-.46 2.72l6.9 12.97 2 .65z"
    }), r.createElement("path", {
      fill: "#8b441f",
      d: "M424.96 249.61s1.08 1.3 1.7 1.13c.63-.18.4-2.66-.4-4.04s-9.2-12.62-10.45-13.3c-1.24-.7 9.15 16.21 9.15 16.21z"
    }), r.createElement("path", {
      fill: "#8b441f",
      stroke: "#5c3a1d",
      strokeWidth: ".07",
      d: "M430.7 244.97c.17.52.77 4.1-.68 4.44-2 .46-11.24-12.3-12.67-14.05 0 0-5.8-3.63-5.91-4.55-.12-.92 6.25 1.25 6.25 1.25l12.38 11.84s.46.55.63 1.07z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M424.96 249.61s-1.02-1.81-1.11-3.1c-.08-1.3-.51-2-.6-2.43-.08-.43-6.81-10.2-7.5-10.8-.67-.6-2.97-1.9-2.97-1.9s.26 1.55.26 2.24c0 .7.08.89.08.89s2.13 4.04 5.2 7.59c3.06 3.54 6.64 7.51 6.64 7.51z"
    }), r.createElement("path", {
      d: "M435.24 247.91c.9-.52.5-3.63.17-4.61-.34-.98-5.85-12.44-5.85-12.44l-1.65.63-3.12-2.45-1.76-1.9s.62 2.74.56 4.07c-.05 1.32-.1 2.12-.1 2.12l4.36 7.67 7.39 6.91zM441.43 241l1.31-1.73-.68-5.7-3.64-12.44s-.9.22-1.82-.35c-.9-.58-1.84-1.67-1.84-1.67l.88 7.43 3.75 10.43.23 3.11 1.81.92z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M430.07 243.91s-3.66-3.98-4.86-5.96c-1.2-2-2.21-3.9-2.21-3.9s-1.02.44-2.3-.08c-1.28-.52-2.98-2.33-2.98-2.33s-1.02 1.98 4.26 7.34c6.05 6.14 8.09 4.93 8.09 4.93z"
    }), r.createElement("path", {
      fill: "#8b441f",
      d: "M438.89 245.25c1.54-.62 1.5-7.09.05-11.45-1.46-4.37-3.84-8.13-3.84-8.13s2.98 7 3.62 9.86c.64 2.85 0 4.88-.51 4.7-.51-.17-.51-1.68-1.7-4.45-1.2-2.76-2-3.45-2-3.45s4.21 11.54 3.02 11.32c-1.2-.22-7.07-13-7.33-13.35-.26-.35-.42.47-.42.47s5.23 16.03 9.11 14.48z"
    }), r.createElement("path", {
      d: "M442.31 214.09l2.59 5.5.82 5.8.2 4.9s.17 9.67-1.02 9.9c-1.2.23-1.76-.92-1.82-1.15-.06-.23-2.22-10.9-2.22-10.9l-2.27-11.11.8-.78.28-1.64 1.76-.12.88-.4z"
    }), r.createElement("path", {
      fill: "#8b441f",
      d: "M435.24 247.91c1.03-.14 0-2.76 0-2.76s-.85 1.26-1.54.4c-.68-.86-1.76-4.06-1.76-4.06l-.68-1.93s-.74 2.13-1.7 2.13c-.97 0-5.97-8.47-5.97-8.47l-.6.83s7.05 14.58 12.25 13.86z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M431.94 241.49s.85-2.07.51-3.97c-.34-1.9-2.9-6.66-2.9-6.66s-.76.18-1.78-.17-2.98-1.64-2.98-1.64 1.36 3.54 2.9 6.13c1.53 2.6 4.25 6.31 4.25 6.31zM436.03 238.55s-.64-4.5-2.68-8.65c-2.05-4.14-3.41-5.49-3.41-5.49s.17.91.13 2.6c-.04 1.68 0 2.03 0 2.03s1.87.7 3.28 3.2c1.4 2.5 2.68 6.31 2.68 6.31zM441.6 230.86s-.28-4.84-1.05-7.61c-.77-2.76-1.57-6.44-1.57-6.44s.1-.37.42-.56c.19-.12.47-.17.85-.04 1.02.34 1.45 2.9 1.45 2.9s-.13-3.94-.21-4.11c-.08-.17-.35-.65-.35-.65s-.33.17-.8.13l-1.03-.13s.32 1.2-.19 1.77c-.37.41-.72-.37-.93-.47-.08-.04-.2.56-.2.56s.39 1.38.47 2.6c.09 1.2-.12 2.2-.12 2.2s.75 2.89 1.56 4.66c.8 1.77 1.7 5.19 1.7 5.19zM445.92 230.3s.85-6.96-.72-11.4c-1.58-4.46-2.9-5.63-2.9-5.63l-.72.87s2.37 3.78 3.06 7.3c.73 3.67 1.28 8.86 1.28 8.86zM438.93 233.8s-.77-5.44-1.75-8.94c-.98-3.5-1.26-4.76-1.26-4.76l-1.49-1.38s.88 3.71.8 4.8l-.18 1.81s.73 1.86 1.7 3.41c.98 1.56 2.18 5.06 2.18 5.06z"
    }), r.createElement("path", {
      fill: "#904720",
      d: "M442.57 242.44c1.39.04.17-7.83-.4-9.85-.57-2.01-3.8-11.48-3.8-11.48s3.89 13.46 3.57 14.13c-.46 1-1.98-4.09-2.26-4.03-.29.05 2.89 9.1 1.75 9.22-1.13.11-1.7-1.9-1.7-1.9l.11 1.96s.74 1.9 2.73 1.95z"
    }), r.createElement("path", {
      fill: "#904720",
      d: "M444.27 238.46c.95 0-.27-7.43-.94-10.72-.68-3.28-2.58-9.85-2.58-9.85s1.93 4.55 3 9.8c1.08 5.24 1.82 11.98.8 12.1-1.02.11-1.53-.99-1.53-.99l-.17-1.2s.45.86 1.42.86z"
    }), r.createElement("path", {
      fill: "#312317",
      d: "M431.48 247.19c.15.53.12 3.08-1.23 2.9-1.36-.19-3.83-2.47-4.34-3.97 0 0 2.94 3.25 3.95 3.23 1.01-.02 1-3.35.84-4.22-.17-.86.78 2.06.78 2.06z"
    }), r.createElement("path", {
      fill: "#d2a567",
      d: "M438.55 211.8s1.75 1.12 3.15.3a5.16 5.16 0 0 0 2.3-3.89c-.04-1.08-.08-2.03-.94-3.15-.85-1.13 1.37.95 1.33 3.02-.05 2.08.12 5.66-3.2 6.44-3.32.78-1.87-.17-1.87-.17l-.77-2.55z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M435.92 205.45s2.1 3.44 2.9 6.53c.81 3.09.66 4.27.15 4.34-.5.06-.7-.37-.83-1.14-.12-.79-2.22-9.73-2.22-9.73z"
    }), r.createElement("path", {
      fill: "#1e2121",
      d: "M399.14 209.67l13.88 20.14 17.39-19.62-11-11.32z"
    }), r.createElement("path", {
      d: "M416.69 197.31l-.8 3.16 1.7 5.35 2.9 2.99 3.35 2.24.77-2.5.81-2.94.85-.3 2.13.82 1.41-2.03 2.26-4.07-.47-1.57-.54-1.12-3.52-6.13-1.18 2.32-1.1.67-2.06-1.17-2.47 3.24-3.02-1.4z"
    }), r.createElement("path", {
      fill: "#5c3818",
      d: "M423.85 211.06s.6-.43.86-2.03c.25-1.6.3-6.48-.13-8.43-.43-1.94-1.7-5.79-1.96-5.48-.26.3 2 4.23 1.66 9.03-.34 4.8-.17 6.14-1.2 6.61-1.02.47.77.3.77.3z"
    }), r.createElement("path", {
      fill: "#5c3818",
      d: "M424.66 202.98s2.3 3.28 3.41 2.12c1.1-1.17.55-5.36-.17-7a49.94 49.94 0 0 1-1.5-4.02l.7-.7s.76 2.77 1.18 4.5c.43 1.73 1.7 6.83.17 7.74-1.53.9-3.75-1.86-3.75-1.86l-.04-.78z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M417.23 205.24s.77-1.12 1.82-1.24c1.05-.11 1.25.35 1.25.35l.94 2.7 1.56 2.8 1.39 1.38-.83.78-1.1.2s-3.3-1.73-3.35-1.84c-.06-.12-.91-1.21-.91-1.21l-.77-3.92z"
    }), r.createElement("path", {
      fill: "#d2a567",
      d: "M422.69 233.84c-1.08.56-3.57-.68-4.98-1.92-1.4-1.24-8.82-8.8-8.82-8.8l-1.03-4.2 2.86.79 5.03-2.16.94-1.78 6.05-3.15 3.37-1.81 7.32-.13 1.75-3.6s2.45 4.26 2.86 6c.42 1.74.33 7.1-.3 7.45-.65.34-3.03-1.6-3.37-1.73-.34-.13 1.79 7.52 0 7.82-1.8.3-4.77-2.85-4.77-2.85s1.19 6.82-.22 6.87c-1.4.04-5.04-1.71-6.58-3.39 0 0 1.72 5.64-.11 6.59z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M421.25 224.98l1.55 2.28c.37.54-.07 3.78-.29 4.37-.45 1.25-2.13-1.46-3.04-3.85 0 0-2.66-4.44-2.84-5.02-.17-.57 4.62 2.22 4.62 2.22zM435.52 208.07s2.58 10.66 1.34 11.03c-1.26.38-4.8-3.37-5.2-3.92-.4-.54-5.34-8.4-5.34-8.4l-1.05-1.07.31-.55 2.1.8 7.84 2.1z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M417.23 228.55c-.58.37-1.67-1.38-2.19-1.84-.5-.46-2.24-2.6-3.94-4.33-1.7-1.72-2.96-3-2.96-3.34 0-.34-1.02-1.44-1.02-1.44l.91-1.15 1.2-.17s7.04 5.61 7.52 6.5c.48.9.8 5.57.48 5.77zM427.83 228.64c-.33.26-5-3.11-6.96-5.9-1.96-2.8-4-5.25-4.49-6.55-.48-1.3-.88-2.47-.88-2.47l1.42.31s11.45 14.17 10.91 14.61zM429.5 223.71c-.26.32-2.3-1.2-3.55-2.85-1.25-1.64-.6-3.69-.6-3.69s4.4 6.23 4.15 6.54zM432.11 223.08c-.63.3-3.3-2.93-5.54-6.57-1.64-2.69-2.05-3.1-2.4-3.3-.62-.38-1.77-.56-1.77-.56l-.23-.34 1.2-.3.88-1.03 1.39-1.78 5.54 11.18s1.36 2.5.93 2.7z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M417.72 231.92c.04.4-.02.82-1.53.66-1.51-.15-9.42-4.36-12.97-10.17a2863.2 2863.2 0 0 1-4.03-6.6l1.58-1.79 12.54 14.3 4.41 3.6z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M417.72 231.92c.17.66-.62.84-1.42.63-.8-.2-3.95-1.32-8.97-6.91-5.03-5.59-6.99-9.6-6.99-9.68l-.25-2.4 1.47-.62 8.64 13.16 7.52 5.82z"
    }), r.createElement("path", {
      d: "M426.11 226.27s-2.6-1.86-4.26-3.85c-1.66-1.99-5.03-6.6-4.94-7.52.08-.9 1.49-.9 1.49-.9l-.09-2.33.43-.79 2.43 1 3.06 3.76 1.13 1.53s1.98 4.78 1.6 5.21c-.38.43-3.2-2.68-3.54-2.29-.34.4 3.2 5.83 2.69 6.18zM421.25 224.98s.85 1.3.46 2.2c-.37.91-.72 1.39-2-.51-1.27-1.9-2.82-4.04-2.96-3.88-.14.16.15 2.92-.48 2.92-.65 0-2.65-2.37-3.93-4.27-1.27-1.9-3.23-5.06-3.23-5.06s.17-.65.09-2.8c-.09-2.17-.26-3.3-.26-3.3s.18.68.41 1.19c.23.5.57.86.57.86l4.68 5.52 1.32-.91 2.78 5.4 2.55 2.64zM403.49 216.94s3.62 6.35 6.99 9.9a22.83 22.83 0 0 0 7.24 5.08l-10.95-12.95-3.28-2.03zM431.26 220.7c-.19.13-2.43-2.3-3.83-4.45-1.41-2.16-2.51-5.19-2.43-6.53.09-1.34.47-4.58.47-4.58s3.75 3.9 4.47 5.7c.72 1.82 2.27 4.3 1.93 4.6-.34.3-2.87-1.7-3.17-1.22-.3.47 2.94 6.22 2.56 6.48zM435.52 216.64c-.46.23-2.34-1.99-2.85-3.37-.52-1.39-.69-4.1-.69-4.1l-1.66-3.94.17-4.36 1.66-.26 2.51 3.46s.99 2.02.94 4.96c-.04 2.94.43 7.35-.08 7.61zM406 227.32c-3.37-4.15-5.41-8.04-5.41-8.04l-1.1-3.72.59.48s.98 4.28 6.17 9.38c5.2 5.1 6.35 5.53 6.35 5.53s1.02 2.81.51 3.8c0 0-3.74-3.28-7.11-7.43z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M411.61 233.27s-4.43-3.91-7.95-8.35c-3.52-4.44-5.74-8.7-5.74-8.7l1.54-1.44s2.92 6.82 5.02 9.53c2.1 2.71 7.13 8.96 7.13 8.96zM417.72 231.92s-5.14-5.1-7.75-7.98c-2.61-2.88-4.06-5.79-4.06-5.79l2.16.84s.85 2.24 2.72 4.58c1.88 2.33 6.93 8.35 6.93 8.35zM416.75 222.78s-2.81-3.43-4.15-5.59c-1.33-2.16-2.7-4.92-2.7-4.92s3.78 4.32 4.89 4.6c1.1.3 1.08-.02 1.08-.02s-.46 1.55-.09 2.85.97 3.08.97 3.08zM417.89 208.88s.46 2.42.14 3.83c-.3 1.41-1.06 1.4-1.06 1.4s1.46 2.06 2.31 2.92c.85.87 2.99 2.36 2.99 2.36s-1.71-2.36-2.4-3.57c-.67-1.2-1.67-2.56-1.24-3.74.42-1.19 2.73.8 3.38 1.35.65.55 3.35 3.74 3.35 3.74s-1-3.31-2.33-4.52c-1.33-1.2-5.14-3.77-5.14-3.77z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M429.22 216.13s-1.45-3.48-2.28-5.61c-.82-2.14-2.1-6.76-2.1-6.76s.09 2.12-.03 3.67c-.1 1.56-.66 3.94-1.34 4.28-.68.34-.84.41-2.1.07-1.25-.35.88.58.88.58s1.28-.04 1.84-.67c.55-.63.67-1.97 1.27-1.77.6.2 1.24 2.22 1.73 3.1.49.9 2.13 3.11 2.13 3.11z"
    }), r.createElement("path", {
      fill: "#202020",
      d: "M424.81 203.72s2.7 3.03 3.87 1.66c1.17-1.36.5-5.2.5-5.2s1.63.62 2.14.21c.52-.4.28-1.92.28-1.92s2.91 4.26 4.32 6.98c1.4 2.72 2.13 7.64 2.13 7.64s-2.42-3.92-3.64-7.64c-1.11-3.38-2.74-4.93-3.05-4.6-.3.32-.74 2.7-.38 3.93.37 1.23 1.36 2.83 2.05 4.58.68 1.75 1.44 4.5 1.44 4.5s-1.38-2.1-2.19-3.25c-.8-1.14-1.66-1.6-2.21-2.13-.56-.55-1.39-1.54-2.2-1.86-.8-.33-2.4-1.13-2.4-.5 0 .63-.32-1.23-.32-1.23l-.34-1.17z"
    }), r.createElement("path", {
      fill: "#171717",
      d: "M415.76 216.68s1.5 2.98 2.68 4.54c1.2 1.55 2.82 3.76 2.82 3.76s-2.56-2.33-3.58-3.8c-1.03-1.47-1.92-4.5-1.92-4.5z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M433.35 217.46c-.38.15-1.62-.3-1.75.15-.13.45.7 2.23 1.62 3.16.91.93 1.3.97 1.51.86.22-.1-.1-.93-.24-1.88-.15-.95-.03-1.97-.14-2.27-.1-.3-1-.02-1-.02z"
    }), r.createElement("path", {
      fill: "#d2a567",
      d: "M401.52 198.44l-1.55 1.02-1.87 3.8.5 6.97s1.74 2.45 2.8 4c1.07 1.54 4.59 5.51 5.5 5.28.9-.23 1.87-3 1.99-4.5.11-1.5.22-4.26.22-4.26s.86 1.5 2.33 3.11c1.48 1.62 2.73 3.11 3.41 3 .68-.12 2.72-4.2 2.78-4.72.06-.52-5.11-13.2-5.11-13.2l-2.3-1.2-8.7.7z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M413.12 208.99s.9 3.24 1.45 4.84c.55 1.6-.02 2.98.28 3.02.3.04 3-3.58 3.04-5.22.04-1.64.04-3.33-.68-8.35-.73-5 .23-6.47.23-6.47l-1.55-1.26-2.69 5.4-.08 8.04zM404.04 206.14s.6 4.88.94 6.48c.34 1.6 1.27 4.32 1.79 4.28.5-.04 2.13-4.32 2.17-5.8 0 0-1.1-2.06-1.07-7.3.05-5.22-.5-5.74-.5-5.74l-3.33 8.08z"
    }), r.createElement("path", {
      fill: "#45392d",
      d: "M397.04 196.05s-4.09 5.93-4 9.19c.08 3.25.62 2.53 1.56 5.47.93 2.95 1.45 7.3 1.5 7.67.06.37.66-.2.74-.64.09-.43.2-21.7.2-21.7z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M397.02 196.75s-3.58 5.53-3.32 8.59c.25 3.05.74 2.96 1.76 5.7s1.1 7.2 1.1 7.2 1.14-.34 2.42-1.25c1.28-.91 2.43-2.77 2.43-2.77s-.44-1-1.27-2.78c-.82-1.78-.9-2.48-.9-2.48l-1.06-1.5.32-5.3.93-3.83v-1.44l-2.41-.14z"
    }), r.createElement("path", {
      fill: "#dbad6c",
      d: "M416.35 206.27s-1.79-.39-2.51-.82c-.72-.43-1.02-1.47-1.02-1.47l.42-1.04 3.11 3.33z"
    }), r.createElement("path", {
      fill: "#d2a567",
      d: "M397.75 197.35s-2.58 5.56-2.27 9.4c.31 3.83 2.41 8.72 2.61 8.78.2.06.11-.37.17-1.24.06-.86-.11-11.44-.11-11.44l1.25-3.71.05-1.93-1.7.14z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M404 198.59s.34 1.67.11 2.36c-.22.7-1.59 1.56-2.15 2.65-.57 1.1-1.37 3.63-1.37 3.63s.63-1.44 1.48-2.36c.85-.92 1.2-1.55 1.36-1.04.17.52.46 2.71.29 3.12-.17.4-.86 1.06-1.3 2.59-.5 1.63.05 3.11.05 3.11s.3-1.86.57-2.82c.23-.86.96-1.27.96-1.27l1.42 3.06s0-1.45.23-2.54c.23-1.1 1.42-2.64 1.8-2.64.39 0 .98-.21-.47-.95-.47-.3-.17-5.62.21-5.83.39-.22 2.39-.3 2.18-1.03-.21-.73-1.95-2.71-2.12-2.88-.17-.18-3.25 2.84-3.25 2.84z"
    }), r.createElement("path", {
      fill: "#dbad6c",
      d: "M416.06 209.9l-1.92-.35c-.68-.13-.77-.77-.77-.77l.22-.82 1.57.86.9 1.08z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M399.59 210.53c-.03.57-.46 1.15-.73 1.95-.33.97-.53 2.11-.53 2.11s-.38-2.55-.5-4.34c-.14-1.8-.26-2.96-.47-3.07-.22-.1-.84.84-.84.84s0-2 .39-2.98c.38-.97.7-2.35.36-2.57-.34-.22-1.06.39-1.38.9-.33.53-.92 1.65-.92 1.65s.38-1.7.79-2.4c.4-.7 2.34-2.92 2.7-3.78.36-.86.36-1.8.36-1.8l1.35-.06s1.4 1.1 1.41 2.04c.01.54-1.34 1.14-1.37 1.2-.09.18-1.13-.09-1.39 4.37-.25 4.45.89 4.08.77 5.94zM411.84 199.14s.3 2.42.04 3.15c-.25.74-.98 1.34-1.49 2.3-.51.95-.47 3.24-.47 3.24s.26-1.13.69-1.82c.42-.69.76-1.3.93-1.3.17 0 .68.87 1.02 2.12.35 1.25 1.03 3.37 1.03 3.37s-.3-1.64.12-1.64c.43 0 .6-.13 1.15.3.56.43 1.2 1.04 1.2 1.04s-.05-.6-.85-1.47c-.81-.86-1.28-.82-1.54-1.99a8.16 8.16 0 0 1-.25-2.8c.12-.48.68.3 1.15.86.46.56 1.96 1.86 1.96 1.86s-.64-1-.81-1.3c-.17-.3-.05-2.6 0-3.9.04-1.29-.05-2.5.42-2.84.47-.35.56-2.03.34-2.34-.21-.3-4.64 3.16-4.64 3.16z"
    }), r.createElement("path", {
      fill: "#1e2121",
      d: "M426.09 194.16s.12 2.74.48 4.32c.37 1.59 1.42 5.04 1.42 5.04s-1.42-2.56-2.04-4.78c-.63-2.22-1.2-4.6-1.76-4.78-.57-.17-1.22 1.06-1.22 1.99 0 .92.6 4.38 1.36 5.59.77 1.2-1.22-1.59-1.7-3.09-.48-1.5-.97-2.82-.97-2.82s-.48 1.27-.28 2.68c.2 1.41 1.4 3.43 1.4 3.43s-.78-.67-1.26-1.24c-.48-.58-.91-.92-.91-.92s.08 1.93.6 2.76c.5.84 1.5 2.16 1.5 2.16s-1.19-.89-1.65-1.4c-.45-.53-.59-.9-.59-.9s.25 2.76.85 4.23c.6 1.47 1.9 3.9 1.9 3.9s-1.56-1.25-2.61-3.66c-1.05-2.43-1.56-9.64-1.3-10.74 0 0 .8-1.36 1.53-2.43.74-1.06 1.68-6.15 1.68-6.15s1.16 4.7 1.95 5.6c.8.9 1.62 1.21 1.62 1.21zM414.82 192.74s.6 1.26.98 1.83c.39.56.77 1.28.77 1.28s-1.4 1.51-2.98 2.72c-1.58 1.21-3.67 2.55-4.13 1.86-.47-.7-.45-1.28-.45-1.28s1.73-1.04 3.1-2.42c1.36-1.39 1.83-2.11 2.13-2.84.3-.74.58-1.15.58-1.15zM400.48 197.41s.24 2.94 1.48 2.9c1.24-.05 4.9-3.76 5.15-3.94.26-.17.5-1.08.5-1.38 0-.3-.22-1-.22-1s-3.94 4.05-5.34 4.18c-1.03.1-1.57-.76-1.57-.76zM400.6 193.55s-.47 2.07-.4 2.65c.06.58.24 1.04.24 1.04s-2.82.99-3.29.13c-.47-.87-.16-2.1-.16-2.1s1.31 0 2.03-.16c.73-.18 1.58-1.56 1.58-1.56zM427.27 189.4s1.15 3.03 1.9 4.24a50 50 0 0 1 1.9 3.72s-1.9-2.22-2.5-2.71l-1.57-1.3s.28-.82.28-1.45l-.01-2.5z"
    }), r.createElement("path", {
      fill: "#dbad6c",
      d: "M396.55 195.29s1.05.13 1.7.1c.64-.04 1.07-.3 1.07-.3l1.07-1.6s-.54 1.9-.17 3.24c.38 1.35 1.16 1.56 1.47 1.56.3 0 1.8-.31 2.96-1.52s2.76-2.47 2.76-2.47-.37 1.74.24 3.47c.62 1.73 1.6 1.7 2.93.62 1.33-1.07 2.7-2.9 3.42-3.72.4-.44.91-1.37.91-1.37l1.46-1.16 1.26-7.13-.68-.93-1.84.88-2.21-.88-.65-.9-1.26 2.14-1.33.87-.67.11-1.54.3-.69-1.38-.4-1.07-.76-.35-3.17 3.2-1.8-.08-1.8 2.83-1.3 1.8-1.33 3.14.35.6z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M411.97 188.08s.26 1.77-.64 4.75c-.9 2.99-2.13 5.1-2.13 5.1s3.2-1.94 4.73-5.44c1.53-3.5 1.18-7.52 1.18-7.52l-3.14 3.11zM415.84 184.83s.39.52.04 3.2c-.34 2.68-.97 5.27-.97 5.27s.37.65.8 1.51c.43.87 1.5 2.38 2.26 2.12.77-.26 1.96-1.17 2.77-2.94.8-1.77 1.53-3.5 1.83-3.76.3-.26.43.17.56.3.12.13.37 1.65 1.13 2.3.77.64 1.77 1.66 2.24 1.36.47-.3.93-1.2.84-1.63-.08-.43-1.7-5.27-1.7-5.27l-2.04-5.23-1.31-2.03-3.72.35-2.73 4.45z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M422.29 180.03s1.05 2.25 1.11 4.67c.06 2.42-.48 4.95-.48 4.95s.22-3.02-.12-4.84c-.34-1.81-.88-3-.82-3.51.06-.52.31-1.27.31-1.27z"
    }), r.createElement("path", {
      d: "M427.34 189.49s.21 2.09 0 3.08c-.21 1-1.66-.65-2.55-3.93-.9-3.29-.73-4.02-1.41-5.62-.69-1.6-1.1-2.98-1.1-2.98l1.86-.26 3.2 9.71zM418.23 195.59s3.55-2.01 4-8.08c.22-2.85-1.61-7.48-1.61-7.48s0 4.93-1.32 8.1c-1.33 3.18-2.41 5.3-2.41 5.3s.85-.37 1.28-.89c.42-.52 1.02-1.4 1.02-1.4s.19.9-.13 2.1c-.32 1.18-.83 2.35-.83 2.35zM415.1 184.96s-.11 1.34-1.6 2.55c-1.5 1.21-4.18 2.55-4.18 2.55s1.96-1.81 2.68-3.41c.73-1.6.17-2.64.17-2.64s-.25.86-1.1 1.51c-.85.65-2.09.78-2.09.78s.1-.82.87-1.68c.16-.18.13-.59.24-.92.42-1.3 1.53-3.1 1.53-3.1s.85 1.9 1.7 2.72c.86.82 1.78 1.64 1.78 1.64z"
    }), r.createElement("path", {
      fill: "#1e2121",
      d: "M426.21 177.79s.85 2.2 1.2 5.19c.33 3-.06 6.5-.06 6.5s-1.82-2.82-2.28-3.97c-.45-1.15-.45-2.88-.85-3.74a4.2 4.2 0 0 0-1.37-1.37c-.32-.22-1.33-.18-1.33-.18s1.05-.5 1.14-1.42c.08-.92 0-1.41 0-1.41s.68.34 1.79.49c1.1.14 1.76-.09 1.76-.09zM418.25 190.58s1.94-2.7 2.45-6.05c.5-3.34-.09-4.5-.09-4.5s-.8-.11-1.44-.74c-.66-.64-1.68-2.28-1.68-2.28s.28 1.73-.09 3.83c-.36 2.1-2.3 4.12-2.3 4.12s1.03.35 1.94-.17c1.92-1.13 1.78-3.26 1.78-3.26s.43.26.37 2.91c-.06 2.65-.94 6.14-.94 6.14z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M395.31 195.2c-.41-.06 1.28-2.68 2.43-4.5l2.77-4.36s.3.3.98.26a4.76 4.76 0 0 0 3.15-2.16c.72-1.34 1.28-2.81 1.32-3.24.04-.43-.13 2.33 1.2 3.84 1.31 1.51 1.27 1.39 1.83 1.26 0 0-.05 1.9-.56 3.67s-1.02 4.32-1.02 4.32.21-3.32-.34-4.28c-.55-.95-.85.09-1.32 1.3-.47 1.2-1.5 2.07-1.5 2.07s.77-1.46 1.28-3.02c.52-1.56.26-1.6.13-1.64-.13-.05-.38-.09-.93.56-.56.65-1.11.82-1.11.82s.68-.56.9-1.34c.2-.78.85-1.9 1.23-2.33.38-.44.64-.96.64-1.26 0-.3-.09-.95-.35-.95-.25 0-.6.4-1.82 1.56-1.24 1.16-1.45 1.25-1.67 1.68-.21.43-.38 1-1.15 3.42a20.74 20.74 0 0 1-1.4 3.63c-.13.21-.68.57-.68.57s.42-1.35 1.06-3.12c.64-1.77 1.5-4.1 1.28-4.5-.21-.38-.77-.34-.94 0-.17.35-1.4 1.86-2.64 3.68-1.23 1.81-1.23 4.06-1.53 4.15 0 0-.83-.03-1.24-.09z"
    }), r.createElement("path", {
      fill: "#874f20",
      d: "M427.43 175.83c-.02.2.11 1.5-1.22 1.96a4.55 4.55 0 0 1-3.13-.24c-.16-.15-.16-1.86-.16-1.86l4.51.14z"
    }), r.createElement("path", {
      fill: "#b27129",
      d: "M401.59 180.06s-.24 1.24-.97 2.76c-.73 1.54-1.95 2.81-1.8 3 .15.2.84.91 1.9.9 1.06-.03 1.45-6.39 1.45-6.39l-.19-.22-.39-.05z"
    }), r.createElement("path", {
      fill: "#dbad6c",
      d: "M417.95 176.56s-.48 8.42-2.85 8.4c-2.36 0-3.43-4.25-3.43-4.25s-.2 5.68-3.21 5.68c-1.36 0-2.8-4.39-2.5-5.18 0 0-.56 3.02-1.98 4.14-2.82 2.22-4.63 1.14-4.72.79-.1-.34 2.38-2.71 2.72-6.02 0 0 .44.14 1.12-.84.68-1 1.07-2.08 1.76-1.88.68.2 4.08-1.38 4.08-1.38l1.8-2.27s.2.74 1.51-.15a4.8 4.8 0 0 0 1.76-2.23l3.5 2.97.44 2.22z"
    }), r.createElement("path", {
      fill: "#b27129",
      d: "M408.73 168.56s2.12 3.2 3.54 5c.08.1.77-.68.77-.68.47.64.73 1.2.59 1.54-.55 1.3-1.7 3.07-.77 4.92 0 0-.3-1.03.22-2.37.5-1.34.89-1.82 1.19-1.78.3.05.8 7.7 1.32 7.65.5-.04 1.2-3.45 1.2-5.87 0-2.43.48-.44.7.04.23.47 2.32 3.89 4.1 3.37 1.8-.52 1.54-3.67 1.5-4.36-.04-.7-1.28-4.89-1.28-4.89l-8.01-5.04s-.23.63-.66 2.06c-.43 1.43-4.41.41-4.41.41z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M420.1 167.81s.47.43 1.24 2.42c.76 1.99.85 8.43-.17 8.38-1.03-.04-3.07-1.2-3.41-2.07-.34-.87.12-4.06-.56-4.93-.68-.86-1.49-3.02-1.53-3.63-.04-.6.13-2.55.13-2.55l1.79-.65 2.51 3.03z"
    }), r.createElement("path", {
      d: "M419.53 165.81l3.4 5.07 3.02 4.35s1.52.5 1.48.6a3.24 3.24 0 0 1-4.11.65c-1.18-.66-.58-2.7-2.07-5.99-1.5-3.28-4.17-4.71-4.17-4.71l.93-.9 1.52.93z"
    }), r.createElement("path", {
      fill: "#1e2121",
      d: "M417.65 163.04s3.04 2.01 4.12 4.2c1.08 2.2 1.71 3.52 3.02 5.65 1.3 2.13 2.7 2.8 2.64 2.94-.06.14-.94.34-1.6-.15a6.22 6.22 0 0 1-1.87-2.04c-.54-.98-2.44-4.55-3.15-5.48-.71-.92-2.98-2.65-3.04-2.47-.05.17.71.69 2.02 2.8 1.3 2.1 1.62 4 1.53 4.02-.08.03-.37-.77-1.5-2.67-1.14-1.9-3.61-4.36-3.75-4.01-.15.35 1.22 2.6 1.9 3.89.68 1.3 1.82 4.32 1.7 4.32-.1 0-.9-1.7-2.27-3.8-1.36-2.1-1.62-1.85-2.19-2.54-.56-.69-1.78-2.28-1.78-2.28s1.22.38 2.4-.4c1.2-.77 1.82-1.98 1.82-1.98z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M409.9 168.65s1.96.45 3.02.32c1.07-.13 1.43-.08 1.43-.08s.64.86.64 1.85c0 1-.68 2.86-.98 2.9-.3.04-.25-1.69-.72-2.3-.47-.6-3.39-2.69-3.39-2.69z"
    }), r.createElement("path", {
      fill: "#b27129",
      d: "M410.94 173.79s.63 2.13.15 5.09c-.49 2.96-2.2 6.02-2.63 6.02-.44 0-.3-3.36-.49-5.13l-.06-.55c-.03-.24-.67 2.24-.7 2.03-.02-.23.57-3.15.55-3.34l-.14-1.11 2.2-2.61 1.12-.4z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M407.21 176c-.6.74-1.51.54-2.36.8-.79.25-1.07 1.45-1.07 1.45s.64-.47.94-.34c.3.13.65.1.05 1.57s-2.92 3.96-2.81 3.99c.11.03 2.6-2.1 3.4-3.31.82-1.21.75-1.93.92-2.37.17-.43 1.13-.95 1.34-.99.22-.04.69.04.9.9.21.87.55 3.33.72 3.42.17.09.77-2.25 1.03-3.41.25-1.17.24-3.74.24-3.74s-.16-.07-.76-.2-2.02-1.15-2.02-1.15.28 2.4-.52 3.38z"
    }), r.createElement("path", {
      fill: "#dbad6c",
      d: "M417.72 160.94s.8 2.01-.85 3.42c-.5.4-.97.69-1.85.73-.88.04-2.29-.71-2.29-.71l-5.09-2.12-2.68-.84-1.32-.37.19-1.47 3.98.17 3.94 1.51 1.73.57 1.47.25h1.1l.92-.25s.43-.18.55-.41c.13-.24.2-.48.2-.48z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M417.72 160.94c.17.35-.3 1.47-.68 1.64-.39.18-1.07.48-2.6.13-1.53-.34-3.11-1.34-4.82-1.81-1.7-.48-2.98-.91-4.3-.87-1.32.05-.68-.56-.68-.56s3.03-.34 5.67.65c2.64 1 3.78 1.67 5.11 1.64 2-.04 2.3-.82 2.3-.82z"
    }), r.createElement("path", {
      d: "M403.79 159.34s.6.13 1.1.04c.52-.08.9-.39.9-.39s.09.7-.25.91c-.34.22-1.37.13-1.54.13-.17 0-.21-.69-.21-.69z"
    }), r.createElement("path", {
      fill: "#dbad6c",
      d: "M413.8 165.63s1.78 1.74 1.3 3.25l-3.43-1.57-5.6-2.34-3.04-.9-.37-.48s.58-.54.85-1.06c.28-.52.2-1.01.2-1.01l3.7.5 3.88 1.18 2.51 2.43z"
    }), r.createElement("path", {
      fill: "#dbad6c",
      d: "M409.99 168.13s3.2 4.13 2.45 5.49l-7.46-4.71-2.62 4.33-6.14-3.03s4.95-3.8 5.53-4.52c.57-.72.61-.97.61-.97l2.77.53 4.37 1.39.49 1.49z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M408.26 162.03s2.61.63 4.29 1.5c1.67.86 4.02 1.06 4.02 1.06s-.94.99-2.77 1.04c-.54.02-1.85-1.04-2.7-1.64-.85-.6-3.31-1.33-3.31-1.33l.47-.63z"
    }), r.createElement("path", {
      d: "M403.66 160.63s1.88.39 3.03.9c1.15.53 1.23.4 1.53.27.3-.13.34-.26.34-.26s.24 1.12-.66 1.12-1.26-.3-2.4-.82c-1.16-.52-1.92 0-1.92 0l.08-1.21z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M414.02 167.88s1.34.84 1.08 1c-.25.18-.92.5-2.09.57a4.52 4.52 0 0 1-2.54-.45c-.82-.37-1.33-1.81-3.32-2.59-1.99-.78-2.33-.9-3.7-1.24-1.36-.34-1.67-.32-1.67-.32l1.25-.52 4.29.87 3.66 1.07 2.22 1.06.82.55zM406.82 170.4l.85 3.37-.47 2.03-1.15.74-1.06-.43-.3-.61s.47-.78 0-1.47-2.64-1.55-2.64-1.55.85-1.65 1.83-2.04c.98-.38.51-1.64.51-1.64l2.43 1.6z"
    }), r.createElement("path", {
      d: "M402.64 163.53s.68.58 2.08.72a16 16 0 0 1 2.83.62c.38.12 1.32-.4 1.4-.38l-.81.49c1.23.35 2.79.9 3.33 1.14a7.61 7.61 0 0 1 2.56 1.76c-.05.02-.84-.46-2.56-1.18a22.88 22.88 0 0 0-3.97-1.24c-2.56-.5-5.12-.34-5.65-.52-.55-.17.22-.2.5-.49.29-.29.29-.92.29-.92z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M412.18 172.78s.81.86-.04 1.17c-.85.3-3.18.24-4.28-.92 0 0-.28-1.11-.7-1.63-.43-.52-2.13-1.6-3.12-2.2-.97-.61.34-.7.34-.7s3.5 1.34 4.78 2.03c1.28.7 3.02 2.25 3.02 2.25z"
    }), r.createElement("path", {
      d: "M412.23 172.86s-1.72-2.38-6.5-4.26c-.13-.05 1.62-.3 1.49-.35-.2-.08-2.3.04-2.53-.04l-1.12-.36c-2.51-.77-2.7-.7-2.87-1.04-.17-.34-.48.06-.74.49-.25.43-.96 1.37-.9 1.28.05-.09 1.84-.5 3.26-.16 1.42.35 1.36.87 1.25 1.42-.11.54-1.84 2.65-1.65 2.7.2.06 1.2-1.99 2.5-1.7 1.3.3 1.74 1.01 1.74 1.01s-.03-.75-.29-1.07c-.25-.31-1.7-1.67-1.3-1.67.4 0 2.01.38 4.34 1.56 2.27 1.15 2.64 1.5 3.32 2.19z"
    }), r.createElement("path", {
      fill: "#dbad6c",
      d: "M404.43 169.12s3.67 1.04 3.5 4.93c-.18 3.88-3.02 3.17-3.27 1.75-.26-1.4.34.68 1.36.5 1.12-.21 1.35-1.33 1.28-2.83-.07-1.44-.37-2.16-1.25-3a15.72 15.72 0 0 0-1.62-1.35z"
    }), r.createElement("path", {
      fill: "#6c3f18",
      d: "M388.58 159.75s.38.3-.66 3.04c-1.05 2.74-1.61 3.72-3.2 5.47-2.96 3.26-4.25 3.28-3.94 4.66.32 1.39 1.47 1.02 1.73 1.06.26.05 5.58-7.8 5.58-7.8l1.17-4.7-.28-1.33-.4-.4z"
    }), r.createElement("path", {
      fill: "#dbad6c",
      d: "M401.79 154.14s1.53 2.3 1.05 6.65c-.48 4.35-6.22 8.16-6.22 8.16l-8.37 5.79-3.5-.21s-.55.08-1.06-.06c-.55-.14-1.06-.71-1.18-.71-.23 0-.66-1.47-.66-1.47l1.11-1.35 3.04-3.03 1.9-2.74s.86-1.58.97-3.1c.11-1.54-.28-2.31-.28-2.31l.7 1.1.4 2.3-.3 2.56 2.18-1.47 2.9-1.3s.8-.11 1.36-1.72a20.37 20.37 0 0 0 1.05-5.05c.01-1.06-.12-2.33-.12-2.33s.19-.01.37.1c.18.1.94 1.45.94 2.21 0 .77.5 3.59.5 3.59l1.34-1.36s.99-1.24 1.25-1.9c.27-.64.64-1.66.63-2.35z"
    }), r.createElement("path", {
      fill: "#904720",
      d: "M402.72 175.91s.58.47.36 2.05c-.21 1.58-1.51 2.44-2.15 2.47l.06-2.2-1.85-1.48-1.98-.6s.13-.11.36-.35c.24-.23 2.28-1.08 2.28-1.08l2.92 1.19z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M401.27 175.93s.58.56 1.5.32c.9-.23 1.3-1.7.8-2.29-.49-.58-.28 1.4-.87 1.62-.6.22-1.24-1.49-2.05-1.66-.8-.17-2.08.39-2.4.93-.32.54 1.3.1 1.3.1l.87.24.64.16.21.58z"
    }), r.createElement("path", {
      fill: "#904720",
      d: "M389.17 169.89s1.09.33 2.27.17 4.07-1.37 4.07-1.37 1.34-.75 2.32-1.7c.98-.95 4.07-2.88 4.41-6.74.34-3.86-.45-6.1-.45-6.1s4.58 5 .57 10.74c-2.61 3.74-4.89 4.84-4.89 4.84s4.43-1.3 4.83-.23c.4 1.06-.2 2.72-.32 2.98 0 0 2.51.58 2.88 1.86.21.76-2.86-.89-5.18-.33s-3.34 1.95-3.34 1.95-.43-.67-2.5-.7c-2.06-.02-3 .96-4.17.91-1.17-.04-4.85-.83-5.56-1.83 0 0 .87-1.1 2.43-2.88 1.07-2.05 2.63-1.57 2.63-1.57z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M398.69 159.53s1.79-1.76 2.38-3.05c.6-1.3.72-2.34.72-2.34s.2 1.41-.85 3a16.93 16.93 0 0 1-2.22 2.68l-.03-.29z"
    }), r.createElement("path", {
      fill: "#904720",
      d: "M398.2 155.61s1.46 5.68-.1 8c-1.56 2.34-8.36 5.36-8.36 5.36s5.15-2.79 6.77-6c1.62-3.21 1.5-5.9 1.5-5.9l.2-1.46z"
    }), r.createElement("path", {
      fill: "#1e2121",
      d: "M391.44 170.05s2.17-.04 3.4-.78c1.24-.73 3-2.29 3-2.29s-1.63 1.43-2.1 1.43c-.47 0-.85-.74-.64-1.3 0 0-.38 1.08-1.36 1.82-.98.73-2.3 1.12-2.3 1.12zM396.5 162.97s1.83-1.9 1.79-5.88c-.04-3.97-1.54-3.24-1.54-3.24s1.24.9.98 3.93a17.32 17.32 0 0 1-1.23 5.19zM398.72 163.36s2.06-.5 2.79-1.7c.72-1.22.7-3.53.7-3.53s-.21 2.12-.8 2.9c-.6.77-2.69 2.33-2.69 2.33zM397.52 175.8s1.02-1.99 2.39-1.47c1.36.52 1.36 1.6 1.36 1.6s-.55-.86-1.58-.9c-1.02-.05-2.17.77-2.17.77zM393.65 172.22s3.02-.74 4.81-1.3c1.8-.56 3.84-1.42 3.84-1.42s-1.5 1.85-3.71 3.1c-2.22 1.26-4.05 1.35-4.05 1.35s4.18-1.82 4.52-2.55c0 0-4 1.08-5.41.82z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M388.81 167.55a3.46 3.53 67.76 0 1-3.98 5.72"
    }), r.createElement("path", {
      fill: "#f16e16",
      d: "M388.63 167.94a3.05 3.1 67.77 0 1-3.57 4.97"
    }), r.createElement("path", {
      fill: "#000",
      d: "M387.28 169.62a1.23 1.23 0 1 1-1.2 1.85"
    }), r.createElement("path", {
      fill: "#d5d3ca",
      d: "M387.45 171.18a.4.4 0 1 1-.77-.13.39.39 0 0 1 .45-.33.4.4 0 0 1 .32.46z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M389.58 165.4s2.02-1.99 2.47-4.61c.46-2.62.18-4.11.18-4.11l1.1 1.14.42 2-.7 3.3 2.21-1c.74-1.01 1.9-5.5 1.5-8.27 0 0 .6 1.21-.2 4.98-.79 3.78-1.44 4.22-4.28 5.78-1.46.8-3.3 2.34-4.97 5.54a24.7 24.7 0 0 1-3.06 4c-.06.05 1.42-2.01 2.14-3.56 1.08-2.3 2.25-3.6 2.25-3.6l.94-1.59z"
    }), r.createElement("path", {
      fill: "#904720",
      d: "M388.64 166.99s.88-2.65.88-4.1-.94-3.13-.94-3.13 1.28-.18 1.4 2.96c.1 3.15-.57 3.32-1.34 4.27z"
    }), r.createElement("path", {
      d: "M392.69 163.61s.94-2.33.87-3.89c-.06-1.56-1.34-3.05-1.34-3.05s1.58.3 1.7 3.14c.13 2.83-.36 2.85-1.23 3.8z"
    }), r.createElement("path", {
      fill: "#ab6d29",
      d: "M383.39 174.25s-.73-.94-.64-1.67c.08-.73.02-.9 1.83-2.8s2.82-3.07 3.26-4.09c.45-1.01 1.92-3.78.75-5.93 0 0 .8 3.13-1 5.61-1.81 2.48-2.86 3.78-4.35 4.88-1.49 1.1-1.64 1.62-1.6 2.25.05.63.2 1.25.45 1.4.46.27 1.3.35 1.3.35z"
    }), r.createElement("path", {
      fill: "#6c4119",
      d: "M400.94 180.42s.4.04.66-.43c.25-.48.25-1.28-.38-2.08a4.33 4.33 0 0 0-2.26-1.53c-.9-.26-2.62-.43-2.62-.43s.59 1 1.74 1.66c.57.32 1.54-.09 2.16.52.61.6.7 2.29.7 2.29z"
    }), r.createElement("path", {
      fill: "#6c4119",
      d: "M400.94 180.42s2.01-.65 2.15-2.6c.09-1.2-.17-1.61-.17-1.61s.3.62 1.1.86l.73-.28s-1.2 3.76-3.81 3.63z"
    })), r.createElement("g", {
      fill: "#f9c83a"
    }, r.createElement("path", {
      fill: "#bf802d",
      d: "M386.9 180.05s.4.16 1.14 1.03c.75.86 1.1 1.14 1.1 1.14l4.87-1.25 1.58-1.56-1.32-2.09h-3.5l-3.87 2.73z"
    }), r.createElement("path", {
      stroke: "#8f4620",
      strokeWidth: ".48",
      d: "M398.72 178.39l-.94-1.27s-.2-.49-.9-.86c-.72-.37-3.67-.35-3.67-.35l-2.13.44s-.6.54-1.68.31c-1.08-.23-3.46-1.2-3.46-1.2l-2.39-1.05s-1.79-.74-2.18-.6c-.4.14-1.88 1.76-1.88 1.76s-.25.86.31.89c.57.03-.85.29-.85.29s-3.7 2.03-4.3 5.66c-.6 3.63 6.1 8.99 8.56 6.27 0 0-3.62-2.68-2.9-4.93.73-2.25 2.4-3.63 5.24-3.8 2.86-.17 3.03-.52 4.26-1.39 1.24-.86 3.54-1.38 5.24.4 1.7 1.76-6.47 3.45-6.47 3.45l.9 1.3s10.1-3.46 9.24-5.32z"
    }), r.createElement("path", {
      fill: "#fcf3d8",
      d: "M379.85 187s-4.09-1-3.75-4.75c.34-3.76 3.75-5.14 4.35-5.32.6-.17.47-2.07 1.15-2.29.68-.21 1.99 0 2.58.56.6.57 1.87 1.1 1.87 1.1s-7.24 3.22-7.3 7.37c-.05 2.77 1.1 3.33 1.1 3.33z"
    }), r.createElement("path", {
      fill: "#fdeaaf",
      d: "M398.7 177.99s-.5.3-.63.05c-.76-1.42-2.55-1.8-4-1.78-1.85.03-3.1.72-4.35.72-1.25 0-.9-.2-2.39-.26-1.47-.06-4.62-2.4-5.34-2.16-.7.23-.99 1.1-.9 1.54.08.43-1.29.46-1.48.14-.2-.32 1.08-2.36 2.36-2.36 3.44 0 5.99 2.32 7.64 2.32 1.64 0 2.21-.95 4.43-.95 2.21 0 4.6.98 4.66 2.74z"
    }), r.createElement("path", {
      fill: "#513625",
      d: "M387.45 180.66s1.64-.32 2.87-.86c1.24-.54 2.89-.97 2.89-.97s-1.51 1-2.56 1.5c-1.04.49-2.73.76-2.73.76l-.47-.43z"
    }), r.createElement("path", {
      d: "M381.66 189.16c-.3.12-1.73.06-4.02-1.47-2.28-1.53-2.88-4.12-2.88-4.12s-.52-2.48 1.85-5 2.76-1.8 2.88-1.68c.11.1-.12.23-.12.23l-2.08 1.7-1.04 1.74-.92 1.57.07 1.86 1.06 1.86 3.27 2.04 1.93 1.27z"
    }), r.createElement("path", {
      fill: "#8b5122",
      d: "M380.41 174.93l-.13-.31v.34c.1 0 .12-.03.13-.03l-.13-.31v.34-.35l-.24.25c.09.08.19.1.24.1v-.35l-.24.25.24-.25h-.34c0 .06.02.17.1.25l.24-.25h-.34.34l-.31-.14c0 .03-.03.05-.03.14h.34l-.31-.14.27.12-.24-.17-.03.05.27.12-.24-.17.06.04-.06-.04.06.04-.06-.04-.18.2c-.14.17-.33.4-.48.64-.16.25-.3.5-.31.82v.12c.05.33.27.6.52.7.24.13.5.16.75.16.54 0 1.05-.16 1.07-.16a.35.35 0 0 0 .22-.44.34.34 0 0 0-.42-.23h-.02c-.08.03-.49.14-.85.14-.19 0-.36-.03-.45-.08-.1-.06-.12-.08-.14-.2 0-.04.03-.16.1-.3a3.95 3.95 0 0 1 .64-.84l.07-.08.03-.04.03-.04.02-.05c0-.03.02-.06.02-.13a.34.34 0 0 0-.34-.35c-.1.01-.12.03-.13.03a.35.35 0 0 0-.19.46c.08.17.28.25.45.18z"
    }), r.createElement("path", {
      d: "M387.36 178.44s-4.89 1.37-5.01 1.46c-.36.26 1.56-.04 3.07-.09 1-.03 1.76.22 1.76.22s.59-.01 1.18-.24c1.88-.74 5.83-2.2 6.2-.48.3 1.45-5.46 2.71-5.46 2.71l-.05.57 4.63-1.15 2.38-1.26.77-1.23-2.3-1.64h-3.37l-1.55.43-2.25.7z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M380.21 185.51c.36 1.02 1.18 2.5 2.1 2.97 0 0 .16.01.1.11s-.74.52-2.3.12c-1.56-.4-3.95-1.04-5.4-5.42l.05.97.85 1.71 1.53 1.59 2.4 1.5 1.65.41 1.4-.36.62-.47-1.44-1.3-1.76-3s-.07.42.2 1.17z"
    })), r.createElement("g", {
      fill: "#816c2a"
    }, r.createElement("path", {
      fill: "#fcca3d",
      d: "M396.5 228.99l-.07 1.59-.88-.1.16-1.98zM390.37 183.78l-1.62-1.82-1.05.16 1.6 2.28z"
    }), r.createElement("path", {
      d: "M396.42 232.7s-.98-.64-2.24-1.22c-1.3-.6-3.1-.87-3.12-.87l-.06.4.3.06c.56.1 1.8.37 2.71.78a18.72 18.72 0 0 1 2.02 1.1l.17.1.22-.35zM396.28 228.65s-.9-.06-1.85-.06c-.66 0-1.34.03-1.8.14-1.1.27-1.81.82-1.83.83l.25.33.03-.02a4.99 4.99 0 0 1 3.35-.87 29.74 29.74 0 0 1 1.82.06l.03-.41zM395.81 225.17s-2.26 1.06-3.3 1.76c-1.04.68-2.12 1.57-2.13 1.58l.26.32.67-.53c.39-.3.91-.7 1.42-1.03a48.85 48.85 0 0 1 3.25-1.72l-.17-.38zM393.64 221.59c0 .08-.02.92-.42 1.56-.1.16-.42.54-.83 1-.6.69-1.43 1.57-2.1 2.29l-1.18 1.24.3.3 1.89-2.01 1.4-1.54c.41-.47.73-.84.86-1.06.48-.77.49-1.66.49-1.77v-.01h-.41zM390.81 219.99l.02.07c.03.16.1.53.1 1.03 0 .51-.08 1.16-.31 1.83a27 27 0 0 1-1.29 2.85l-.6 1.17-.26.48.35.2s1.6-2.91 2.18-4.56a5.95 5.95 0 0 0 .2-3.18l-.39.11zM388.07 219.66a11.6 11.6 0 0 0 .07 1.5 7.4 7.4 0 0 1-.29 2.3 144.64 144.64 0 0 1-1.34 3.65l.38.15s.85-2.26 1.35-3.66c.25-.72.3-1.65.31-2.45 0-.85-.07-1.53-.07-1.53l-.41.04zM385.96 219.65s0 .7-.05 1.56c-.04.87-.12 1.9-.27 2.54-.32 1.35-.65 3.3-.65 3.3l.4.07.2-1.14c.13-.65.3-1.47.45-2.13.32-1.39.33-4.19.33-4.2h-.41zM383.68 220.02l.06.65c.02.4.05.92.05 1.45a7.2 7.2 0 0 1-.15 1.66c-.33 1.26-.53 3.25-.53 3.25l.4.05a30.33 30.33 0 0 1 .53-3.2 7.4 7.4 0 0 0 .16-1.76c0-1.1-.11-2.14-.11-2.15l-.41.05zM381.89 220.26v.23c0 .5-.04 1.67-.37 2.89l-.72 2.52c-.2.76-.36 1.3-.36 1.3l.39.12 1.08-3.83c.35-1.27.4-2.49.4-3l-.01-.25-.41.02zM379.89 220.28a10.26 10.26 0 0 0 .05.9c0 .76-.1 1.87-.58 2.74a7.2 7.2 0 0 1-1.81 1.96c-.33.26-.63.47-.85.62l-.26.17-.09.05.2.36c.02-.01 2.27-1.33 3.17-2.97a6.3 6.3 0 0 0 .63-2.93c0-.57-.05-.95-.05-.95l-.41.05zM378.66 219.89l-.09.28a8.78 8.78 0 0 1-1.25 2.46 8.7 8.7 0 0 1-1.68 1.46l-.74.49-.3.18.2.36s1.91-1.09 2.84-2.23a9.53 9.53 0 0 0 1.41-2.88l-.39-.12zM376.71 218.91l-.11.22c-.12.22-.3.54-.5.86a4 4 0 0 1-.62.79c-.27.23-.8.56-1.25.83l-.83.48.2.36s.38-.2.84-.48c.46-.28 1-.61 1.3-.88.34-.29.65-.78.9-1.2.26-.43.43-.8.43-.8l-.36-.18zM375.76 217.69l-.32.37c-.3.34-.77.85-1.23 1.3a8.5 8.5 0 0 1-.67.59c-.2.16-.4.26-.5.3l.11.4c.27-.09.55-.3.86-.56.94-.79 2.06-2.13 2.06-2.13l-.31-.27zM375.29 216.87l-.3.23c-.27.22-.7.53-1.14.8-.42.25-.87.45-1.1.45v.41c.27 0 .56-.11.86-.26.9-.44 1.93-1.3 1.94-1.3l-.26-.33zM374.93 215.99s-.45.26-.98.53l-.78.38c-.25.1-.47.18-.57.19l.04.4c.2-.01.42-.1.69-.2.77-.34 1.8-.94 1.8-.94l-.2-.36zM374.5 214.17l-.04.05c-.1.1-.36.37-.7.6a2.1 2.1 0 0 1-1.14.46v.41a2.74 2.74 0 0 0 1.52-.63c.4-.3.66-.61.66-.62l-.3-.27zM374.65 211.31s-.37.3-.78.68c-.4.38-.84.84-1 1.27 0 0-.06.1-.12.16l-.09.07-.03.02v.02-.02.02-.02.41c.2 0 .32-.12.41-.21.1-.11.17-.2.2-.3.1-.29.53-.75.92-1.12.19-.19.38-.35.52-.47.13-.12.22-.18.22-.18l-.25-.33zM388.69 194.52h2l.03-.01.05-.02.05-.05.04-.13-.04-.12-.07-.06-.06-.02h-.03l-.02.41v-.16.16-.16.16l.01-.2-.04.2h.02l.02-.2-.04.2.04-.2-.07.19h.03l.05-.2-.08.2.08-.2-.13.17.05.03.07-.2-.12.17-.04-.05.16-.12h-.2l.04.12.17-.12h-.2l.03-.12.08-.07.08.2-.02-.21-.06.01.08.19-.02-.2.01.13v-.13h-.01l.01.13v-.13h-1.95v.41zM388.74 193.29h.13c.29 0 .58-.11.88-.27.44-.23.9-.58 1.3-.86.21-.14.4-.26.58-.35.16-.08.31-.13.4-.13v-.42c-.27.01-.52.13-.79.3-.4.23-.84.57-1.27.85-.42.28-.84.48-1.1.47h-.08l-.05.41zM388.57 191.32c.3-.04.63-.19.97-.38.5-.3 1.06-.69 1.57-1 .5-.33.98-.56 1.23-.56v-.42c-.3.01-.6.14-.93.32-.5.27-1.05.66-1.57.99a3.9 3.9 0 0 1-1.32.64l.05.41zM387.84 189.49c.5-.26 1.24-.84 2.01-1.43.77-.6 1.57-1.22 2.1-1.55l-.21-.35c-.57.35-1.37.97-2.14 1.57-.76.6-1.52 1.16-1.95 1.4l.19.36zM386.46 187.4c.98-.7 3.37-2.4 4.27-2.98l-.21-.35c-.92.59-3.31 2.3-4.3 3l.24.33zM384.63 185.39c.65-.55 1.56-1.16 2.4-1.7.85-.55 1.62-1.02 2-1.3l-.23-.34c-.36.27-1.14.74-1.98 1.28a24.4 24.4 0 0 0-2.45 1.74l.26.32zM383.19 184.15a173.4 173.4 0 0 1 3.54-2.5c.46-.31.83-.55.97-.61l-.17-.38c-.2.1-.56.33-1.02.64-1.38.93-3.56 2.51-3.56 2.51l.24.34z"
    }), r.createElement("path", {
      fill: "#78732e",
      d: "M386.48 180.09l.25.2c.56.46 1.96 1.67 3.23 3.25 1.26 1.58 2.36 3.53 2.36 5.43 0 .18-.01.37-.03.55-.29 2.48-1.53 4.66-3.25 6.67-2.59 3.03-6.25 5.66-9.27 8.33a23.72 23.72 0 0 0-3.86 4.1 8 8 0 0 0-1.6 4.56l.01.22c.05 1.5.54 3.14 1.47 4.46a5.74 5.74 0 0 0 5.1 2.55c2.35 0 4.93-.75 7.38-.75 2.07 0 4.03.51 5.77 2.42 1.67 1.82 2.18 4.75 2.18 7.57a31.9 31.9 0 0 1-.87 7.17l-.16.65.4.12c0-.02 1.04-3.84 1.04-7.94 0-2.87-.5-5.9-2.29-7.85a7.68 7.68 0 0 0-6.07-2.55c-2.53 0-5.1.75-7.39.75-.3 0-.6-.02-.88-.05-1.71-.17-3-1.09-3.88-2.33a8 8 0 0 1-1.4-4.23v-.2c0-2.04 1.02-3.89 2.6-5.69 2.37-2.7 5.97-5.26 9.11-8.09 3.14-2.83 5.82-5.96 6.26-9.84.03-.2.04-.4.04-.6 0-2.36-1.52-4.65-3.02-6.36a22.61 22.61 0 0 0-2.98-2.85l-.25.33z"
    }), r.createElement("path", {
      fill: "#a8ac71",
      d: "M383.38 184.11l-.5-.42-.41.15.8.65zM384.7 185.36l-.37-.38-.19.1.3.41z"
    }), r.createElement("path", {
      fill: "#78732e",
      d: "M386.54 187.39l-.31-.4-.2.25.32.37zM387.92 189.45l-.23-.41-.37.06.48.52zM388.7 191.39l-.18-.56-.05.1-.04.42zM388.79 193.34l.02-.54-.24-.15.03.74zM388.71 194.59l.05-.6-.16-.11.01.79zM372.77 213.96s.04-.5.18-.93c.14-.43-.4.2-.4.2l-.06.6.28.13z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M372.64 215.2l-.23.1.08.59.13-.18.02-.51z"
    }), r.createElement("path", {
      fill: "#78732e",
      d: "M372.68 217.51l-.03-.57-.17-.06v.92z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M372.83 218.8l-.05-.51-.18.02-.02.49zM373.18 220.66l-.1-.5-.12.12.1.5zM373.67 222.57l-.2-.67-.15.06.2.65z"
    }), r.createElement("path", {
      fill: "#a8ac71",
      d: "M374.91 225.13l-.28-.42-.26-.04.34.5zM376.8 227s-.26-.15-.63-.45c-.37-.3-.15.28-.15.28l.54.28.24-.11zM389.63 227.96s-.3-.2-.51-.3c-.21-.1.11.02.3.44.18.42.21-.14.21-.14z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M390.73 228.85s-.25-.31-.4-.42c-.17-.1-.11.32-.11.32l.33.14.18-.04z"
    }), r.createElement("path", {
      fill: "#a8ac71",
      d: "M390.95 229.36c-.14-.18-.29.27-.29.27l.4.37s.03-.45-.11-.64zM391.01 231.13s.09-.38.06-.62c-.02-.23-.2.09-.2.09l.01.53h.13z"
    }), r.createElement("path", {
      fill: "#fff",
      d: "M390.39 233l.15-.47-.2.01-.11.48zM370.86 164.65s.73-.15.18.68c-.55.83.37-.74.37-.74l-.3-.1-.25.16z"
    })), r.createElement("g", null, r.createElement("path", {
      fill: "#f9c83a",
      d: "M386.69 179.57l.45.46s-.42-.11-.6-.14c-.18-.02.15-.32.15-.32z"
    }), r.createElement("path", {
      fill: "#8f4620",
      d: "M387.13 180.03l-.85.12c-.23.03.25-.25.25-.25l.6.13z"
    }), r.createElement("path", {
      fill: "#977c2e",
      d: "M394.97 237.46s.53-.06.77-.38c.24-.33-.15.5-.15.5l-.34.14-.28-.26z"
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  t.FlagPH = function (_ref5) {
    var e = _ref5.width,
      t = _ref5.height;
    return r.createElement("svg", {
      preserveAspectRatio: "none",
      height: t,
      width: e,
      viewBox: "0 0 180 90"
    }, r.createElement("title", null, "Flag of the Philippines"), r.createElement("desc", null, 'Coding according to the official "description and specification of the FILIPINO flag" in Executive Order No. 23 from 1936'), r.createElement("rect", {
      width: "180",
      height: "90",
      fill: "#0038a8"
    }), r.createElement("rect", {
      y: "45",
      width: "180",
      height: "45",
      fill: "#ce1126"
    }), r.createElement("path", {
      d: "M 77.942286,45 0,90 0,0",
      fill: "#fff"
    }), r.createElement("g", {
      transform: "translate(28,45)",
      fill: "#fcd116"
    }, r.createElement("circle", {
      r: "9"
    }), r.createElement("g", {
      id: "j"
    }, r.createElement("g", {
      id: "i"
    }, r.createElement("g", {
      id: "h"
    }, r.createElement("path", {
      d: "M -1,0 L -0.93848823,0.06151177 L 0,0 L -0.93848823,-0.06151177 z",
      transform: "scale(19)"
    }), r.createElement("path", {
      id: "g",
      d: "M -0.88366349,0.11633651 L -0.83408932,0.16591068 L 0,0 z",
      transform: "scale(19.238092)"
    }), r.createElement("use", {
      transform: "scale(1,-1)"
    })), r.createElement("use", {
      transform: "rotate(45)"
    })), r.createElement("use", {
      transform: "rotate(90)"
    })), r.createElement("use", {
      transform: "rotate(180)"
    }), r.createElement("g", {
      transform: "translate(-2.019238)"
    }, r.createElement("g", {
      id: "s",
      transform: "translate(37.961524,0)"
    }, r.createElement("path", {
      id: "t",
      d: "M 5,0 L 1.618034,1.175571 1.545085,4.755283 -0.618034,1.902113 -4.045085,2.938926 -2,0 z"
    }), r.createElement("use", {
      transform: "scale(1,-1)"
    })), r.createElement("use", {
      transform: "rotate(120)"
    }), r.createElement("use", {
      transform: "rotate(-120)"
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  t.FlagPT = function (_ref6) {
    var e = _ref6.width,
      t = _ref6.height;
    return r.createElement("svg", {
      width: e,
      height: t,
      viewBox: "0 0 600 400"
    }, r.createElement("rect", {
      width: "600",
      height: "400",
      fill: "#f00"
    }), r.createElement("rect", {
      width: "240",
      height: "400",
      fill: "#060"
    }), r.createElement("g", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "0.573",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, r.createElement("path", {
      d: "m318.24,262.04c-30.21-0.91-168.74-87.38-169.69-101.15l7.6496-12.757c13.741,19.966,155.36,104.06,169.27,101.08l-7.2299,12.823"
    }), r.createElement("path", {
      d: "m154.59,146.4c-2.7101,7.2937,36.149,31.318,82.903,59.754,46.752,28.434,87.065,46.006,90.053,43.486,0.18256-0.32544,1.4701-2.5409,1.352-2.5232-0.56001,0.84402-1.9234,1.1104-4.0506,0.49741-12.631-3.6433-45.575-18.765-86.374-43.506-40.798-24.743-76.294-47.544-81.811-57.232-0.38363-0.67116-0.65702-1.8962-0.60146-2.8487l-0.13405-0.002-1.1747,2.0532-0.16139,0.32191h-0.00088zm164.36,116.04c-0.51238,0.92957-1.4675,0.96044-3.2816,0.76112-11.3-1.2506-45.589-17.925-86.162-42.213-47.21-28.26-86.2-54.01-81.97-60.74l1.1509-2.0346,0.22665,0.0706c-3.8037,11.405,76.948,57.578,81.702,60.522,46.724,28.947,86.115,45.851,89.601,41.458l-1.2682,2.181v-0.002z"
    }), r.createElement("path", {
      d: "m240.17,169.23c30.237-0.23901,67.55-4.1319,89.023-12.69l-4.6265-7.5168c-12.692,7.0247-50.21,11.644-84.652,12.335-40.736-0.37483-69.49-4.1681-83.897-13.835l-4.3672,8.0045c26.484,11.207,53.623,13.587,88.52,13.703"
    }), r.createElement("path", {
      d: "m330.44,156.71c-0.73904,1.1818-14.743,6.0113-35.373,9.5753-13.988,2.1325-32.234,3.9555-55.004,3.9776-21.633,0.0203-39.305-1.5196-52.684-3.3329-21.656-3.3955-32.833-8.1201-36.965-9.7896,0.39509-0.78581,0.64908-1.337,1.0301-2.0708,11.895,4.736,23.124,7.5918,36.279,9.6158,13.291,1.8,30.75,3.362,52.276,3.3417,22.664-0.0229,40.709-1.9844,54.616-4.0534,21.155-3.4122,32.711-7.8034,34.334-9.8425l1.494,2.5788h-0.002zm-4.0603-7.6226c-2.293,1.8415-13.718,5.8932-33.819,9.1034-13.415,1.9226-30.472,3.6433-52.265,3.6645-20.704,0.0203-37.619-1.375-50.485-3.2491-20.414-2.6661-31.279-7.4754-35.196-8.8776,0.3898-0.67381,0.78666-1.3423,1.1941-2.0135,3.0479,1.5346,13.533,5.7909,34.226,8.7224,12.72,1.8036,29.661,3.1477,50.262,3.1265,21.69-0.0221,38.553-1.7762,51.883-3.6883,20.205-2.7799,31.077-7.9472,32.728-9.241l1.4728,2.4509v0.002z"
    }), r.createElement("path", {
      d: "m140.88,205.66c18.598,10.003,59.905,15.044,98.994,15.391,35.591,0.0564,81.958-5.5016,99.297-14.69l-0.47712-10.012c-5.4246,8.4773-55.113,16.609-99.206,16.276-44.093-0.3325-85.038-7.1429-98.687-15.959l0.0794,8.9914"
    }), r.createElement("path", {
      d: "m340.12,204.22,0.00088,2.3874c-2.606,3.1159-18.946,7.8255-39.437,11.142-15.595,2.391-35.927,4.1945-61.262,4.1945-24.069,0-43.263-1.7163-58.148-4.0014-23.529-3.4264-38.579-9.4262-41.6-11.217l0.0132-2.7852c9.0748,6.0334,33.661,10.447,41.917,11.798,14.788,2.2701,33.868,3.9732,57.817,3.9732,25.216,0,45.434-1.7912,60.931-4.1663,14.701-2.1237,35.644-7.6465,39.767-11.324h0.00088zm0.01-8.4922,0.00088,2.3874c-2.606,3.1142-18.946,7.8237-39.437,11.14-15.595,2.391-35.927,4.1945-61.262,4.1945-24.069,0-43.263-1.7145-58.148-4.0014-23.529-3.4246-38.579-9.4245-41.6-11.216l0.0132-2.7852c9.0748,6.0325,33.661,10.447,41.917,11.796,14.788,2.2719,33.868,3.9758,57.817,3.9758,25.216,0,45.434-1.7921,60.931-4.169,14.701-2.1237,35.644-7.6465,39.767-11.324l0.00088,0.002z"
    }), r.createElement("path", {
      d: "m239.79,260.32c-42.772-0.25489-79.421-11.659-87.16-13.544l5.6433,8.8344c13.67,5.7503,49.424,14.32,81.927,13.371,32.504-0.94809,60.91-3.466,80.928-13.211l5.7862-9.1555c-13.642,6.425-60.068,13.639-87.125,13.705"
    }), r.createElement("path", {
      strokeWidth: "0.55",
      d: "m323.3,253.72c-0.85016,1.2991-1.7171,2.5823-2.5963,3.8294-9.4417,3.3293-24.319,6.8245-30.597,7.844-12.824,2.6423-32.665,4.594-50.274,4.6029-37.89-0.55474-68.905-7.9719-83.496-14.299l-1.1773-2.0241,0.19225-0.30427,1.9966,0.77435c25.948,9.2834,55.091,12.987,82.698,13.652,17.538,0.0617,35.095-2.01,49.292-4.5491,21.771-4.3621,30.574-7.65,33.275-9.1405l0.68701-0.38541h-0.00088zm5.0172-8.2753c0.022,0.0256,0.0441,0.0503,0.0653,0.0776-0.63585,1.0733-1.2911,2.1652-1.9622,3.2623-5.0357,1.8-18.702,5.7988-38.659,8.5893-13.149,1.7912-21.322,3.526-47.479,4.034-49.015-1.2471-80.75-10.831-88.289-13.195l-1.1174-2.1431c28.406,7.4154,57.422,12.592,89.408,13.121,23.931-0.50976,34.112-2.2719,47.152-4.0499,23.271-3.6186,34.996-7.4498,38.515-8.5558-0.0441-0.0635-0.0961-0.13053-0.15433-0.19932l2.5231-0.9428-0.002,0.002z"
    }), r.createElement("path", {
      d: "m328.83,197.76c0.13873,28.137-14.26,53.386-25.858,64.525-16.408,15.759-38.163,25.896-63.569,26.363-28.37,0.52117-55.12-17.974-62.295-26.099-14.028-15.885-25.449-36.057-25.815-63.243,1.7376-30.709,13.793-52.1,31.268-66.769s40.743-21.813,60.121-21.302c22.358,0.59003,48.475,11.558,66.521,33.332,11.823,14.266,16.943,29.748,19.627,53.193zm-89.186-96.342c54.485,0,99.296,44.338,99.296,98.703,0,54.364-44.811,98.704-99.296,98.704s-98.924-44.339-98.924-98.704,44.439-98.703,98.924-98.703"
    }), r.createElement("path", {
      d: "m239.91,101.08c54.534,0,99.011,44.483,99.011,99.022,0,54.538-44.478,99.02-99.011,99.02-54.534,0-99.011-44.481-99.011-99.02s44.478-99.022,99.011-99.022zm-96.832,99.0224c0,53.26,43.736,96.842,96.832,96.842,53.097,0,96.833-43.582,96.833-96.842,0-53.262-43.737-96.844-96.833-96.844s-96.832,43.584-96.832,96.844z"
    }), r.createElement("path", {
      d: "m239.99,109.31c49.731,0,90.693,40.821,90.693,90.704,0,49.884-40.963,90.703-90.693,90.703s-90.693-40.819-90.693-90.703c0-49.883,40.964-90.704,90.693-90.704zm-88.515,90.7034c0,48.685,39.979,88.524,88.515,88.524s88.515-39.839,88.515-88.524c0-48.686-39.978-88.525-88.515-88.525-48.536,0-88.515,39.839-88.515,88.525z"
    }), r.createElement("path", {
      d: "m243.98,100.68-8.48545,0,0.01,198.96,8.51455,0z"
    }), r.createElement("path", {
      d: "m243.13,99.546h2.1598l0.0185,201.25h-2.1616l-0.0159-201.25zm-8.4213,0.0018h2.1766l0.003,201.25h-2.1783v-201.25z"
    }), r.createElement("path", {
      d: "m338.99,203.935,0-7.3554-5.99-5.58-34-9-49-5-59,3-42,10-8.48,6.28,0,7.3572l21.48-9.637,51-8h49l36,4,25,6z"
    }), r.createElement("path", {
      d: "m239.95,184.77c23.383-0.0432,46.07,2.2154,64.065,5.7194,18.569,3.7121,31.637,8.3556,36.105,13.571l-0.005,2.5823c-5.3884-6.4902-22.973-11.248-36.518-13.968-17.858-3.474-40.393-5.7168-63.647-5.6736-24.538,0.0459-47.387,2.3698-64.984,5.8032-14.12,2.8019-32.951,8.3679-35.302,13.858v-2.689c1.2911-3.8003,15.313-9.4792,34.984-13.417,17.729-3.4572,40.62-5.7415,65.302-5.7864zm0.01-8.4922c23.383-0.0423,46.07,2.2172,64.065,5.7194,18.569,3.7139,31.637,8.3556,36.105,13.571l-0.005,2.5823c-5.3884-6.4885-22.973-11.247-36.518-13.966-17.858-3.4757-40.393-5.7185-63.647-5.6736-24.538,0.0441-47.276,2.3698-64.875,5.8014-13.626,2.5832-33.226,8.3696-35.412,13.86v-2.6908c1.2911-3.7588,15.597-9.6414,34.985-13.417,17.729-3.4572,40.62-5.7397,65.302-5.7864z"
    }), r.createElement("path", {
      d: "m239.48,132.96c36.849-0.18433,68.99,5.1523,83.695,12.685l5.3638,9.279c-12.781-6.888-47.456-14.05-89.005-12.979-33.854,0.20814-70.027,3.7271-88.176,13.41l6.4035-10.709c14.895-7.7241,50.022-11.643,81.72-11.684"
    }), r.createElement("path", {
      d: "m239.97,140.62c21.017-0.0556,41.325,1.1298,57.476,4.0437,15.041,2.7993,29.385,7.0009,31.436,9.2604l1.5901,2.8099c-4.9881-3.257-17.401-6.8836-33.339-9.906-16.006-3.0083-36.3-4.0049-57.2-3.9502-23.722-0.0811-42.152,1.1712-57.969,3.9291-16.728,3.13-28.334,7.6015-31.197,9.7261l1.5583-2.9704c5.5631-2.8381,14.39-6.2592,29.223-8.9297,16.357-2.988,34.983-3.8841,58.423-4.0128h-0.00088zm-0.009-8.4843c20.113-0.0529,39.972,1.068,55.452,3.8506,12.209,2.3768,24.283,6.0872,28.704,9.3892l2.3256,3.6954c-3.9536-4.3947-18.836-8.5593-31.974-10.892-15.361-2.6494-34.395-3.698-54.508-3.8656-21.108,0.0591-40.615,1.352-55.752,4.1081-14.441,2.7481-23.76,6.0016-27.703,8.5425l2.0451-3.0868c5.4414-2.8646,14.232-5.4954,25.303-7.6465,15.249-2.7764,34.876-4.0358,56.108-4.0949z"
    }), r.createElement("path", {
      d: "m289.15,241.26c-18.218-3.4008-36.469-3.8947-49.217-3.7447-61.407,0.71967-81.244,12.609-83.665,16.209l-4.5894-7.4815c15.634-11.332,49.073-17.687,88.587-17.037,20.518,0.33602,38.224,1.6986,53.119,4.5835l-4.2358,7.4727"
    }), r.createElement("path", {
      strokeWidth: "0.55",
      d: "m239.58,236.46c17.082,0.25488,33.849,0.96044,50.033,3.9784l-1.172,2.069c-15.031-2.7746-31.055-3.8365-48.803-3.75-22.663-0.17727-45.585,1.9394-65.541,7.6668-6.2968,1.7524-16.721,5.8006-17.784,9.1458l-1.1659-1.9226c0.33601-1.9773,6.6363-6.081,18.414-9.3901,22.858-6.5458,44.239-7.6491,66.019-7.799v0.002zm0.77519-8.5963c17.698,0.33073,35.975,1.1492,53.74,4.6681l-1.2206,2.1537c-16.042-3.1847-31.369-4.2466-52.415-4.5702-22.735,0.0414-46.851,1.6625-68.778,8.0372-7.0791,2.062-19.297,6.5202-19.704,10.05l-1.1659-2.0655c0.26545-3.2059,10.842-7.388,20.358-10.156,22.096-6.4241,46.275-8.076,69.186-8.1174z"
    }), r.createElement("path", {
      d: "M327.58,247.38,320.201,258.829,299,240,244,203,182,169,149.81,157.99,156.67,145.27,159,144l20,5,66,34,38,24,32,23,13,15z"
    }), r.createElement("path", {
      d: "m148.65,158.29c5.646-3.8294,47.139,14.655,90.555,40.834,43.301,26.254,84.677,55.921,80.942,61.473l-1.2285,1.9323-0.56354,0.4445c0.12083-0.0864,0.74345-0.84755-0.0609-2.906-1.8449-6.0704-31.195-29.491-79.894-58.895-47.475-28.309-87.041-45.371-90.997-40.494l1.247-2.3892h-0.00089zm180.44,88.927c3.57-7.052-34.916-36.044-82.632-64.272-48.813-27.666-83.994-43.951-90.42-39.095l-1.4278,2.5991c-0.0124,0.14287,0.052-0.17727,0.35364-0.4101,1.1685-1.0195,3.1052-0.95074,3.9792-0.96662,11.065,0.16581,42.667,14.709,87.006,40.128,19.428,11.315,82.071,51.491,81.832,62.789,0.0168,0.97102,0.0803,1.1712-0.28485,1.6519l1.5936-2.4236v-0.002z"
    })), r.createElement("g", null, r.createElement("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "0.67037",
      d: "m180.6,211.01c0,16.271,6.6628,30.987,17.457,41.742,10.815,10.778,25.512,17.579,41.809,17.579,16.381,0,31.247-6.6525,42.016-17.389,10.769-10.735,17.443-25.552,17.446-41.88h-0.002v-79.189l-118.74-0.14111,0.0123,79.278h0.002z"
    }), r.createElement("path", {
      fill: "#f00",
      stroke: "#000",
      strokeWidth: "0.50734",
      d: "m182.82,211.12v0.045c0,15.557,6.4414,29.724,16.775,40.009,10.354,10.305,24.614,16.712,40.214,16.712,15.681,0,29.912-6.3606,40.222-16.626,10.308-10.265,16.697-24.433,16.699-40.044h-0.002v-76.826l-113.84-0.0185-0.0697,76.748m91.022-53.747,0.004,48.891-0.0414,5.1717h0.00088c0,1.3608-0.082,2.9122-0.24076,4.2333-0.92512,7.7294-4.4801,14.467-9.7451,19.708-6.1636,6.1357-14.671,9.9413-24.047,9.9413-9.327,0-17.639-3.9379-23.829-10.1-6.3497-6.32-10.03-14.986-10.03-23.947l-0.0132-54.023,67.94,0.12259,0.002,0.002z"
    }), r.createElement("g", {
      id: "castle3"
    }, r.createElement("g", {
      id: "castle",
      fill: "#ff0",
      stroke: "#000",
      strokeWidth: "0.5"
    }, r.createElement("path", {
      stroke: "none",
      d: "m190.19,154.43c0.13493-5.521,4.0524-6.828,4.0806-6.8474,0.0282-0.0185,4.2314,1.4076,4.2173,6.8986l-8.2978-0.0512"
    }), r.createElement("path", {
      d: "m186.81,147.69-0.68172,6.3447,4.1406,0.009c0.0397-5.2493,3.9739-6.1225,4.0691-6.1031,0.0891-0.005,3.9889,1.1606,4.0929,6.1031h4.1511l-0.74962-6.3932-15.022,0.0379v0.002z"
    }), r.createElement("path", {
      d: "m185.85,154.06h16.946c0.35717,0,0.64908,0.35277,0.64908,0.78404,0,0.43039-0.29191,0.78141-0.64908,0.78141h-16.946c-0.35717,0-0.64908-0.35102-0.64908-0.78141,0-0.43127,0.29191-0.78404,0.64908-0.78404z"
    }), r.createElement("path", {
      d: "m192.01,154.03c0.0185-3.3126,2.2621-4.2501,2.2736-4.2483,0.00088,0,2.3423,0.96661,2.3609,4.2483h-4.6344"
    }), r.createElement("path", {
      d: "m186.21,145.05h16.245c0.34218,0,0.62263,0.31839,0.62263,0.70468,0,0.38717-0.28045,0.70467-0.62263,0.70467h-16.245c-0.34218,0-0.62263-0.31573-0.62263-0.70467,0-0.38629,0.28045-0.70468,0.62263-0.70468z"
    }), r.createElement("path", {
      d: "m186.55,146.47h15.538c0.32719,0,0.59529,0.31662,0.59529,0.70379,0,0.38805-0.2681,0.70467-0.59529,0.70467h-15.538c-0.32719,0-0.59529-0.31662-0.59529-0.70467,0-0.38717,0.2681-0.70379,0.59529-0.70379z"
    }), r.createElement("path", {
      d: "m191.57,135.88,1.2267,0.002v0.87136h0.89513v-0.89076l1.2567,0.004v0.88723h0.89778v-0.89076h1.2576l-0.002,2.0117c0,0.31574-0.25398,0.52035-0.54854,0.52035h-4.4113c-0.29633,0-0.56972-0.23724-0.5706-0.52652l-0.003-1.9879h0.00088z"
    }), r.createElement("path", {
      d: "m196.19,138.57,0.27691,6.4514-4.3028-0.0159,0.28486-6.4523,3.741,0.0168"
    }), r.createElement("path", {
      id: "cp1",
      d: "m190.94,141.56,0.13141,3.4775-4.1256,0.002,0.11641-3.4793h3.8786-0.00089z"
    }), r.createElement("use", {
      xlinkHref: "#cp1",
      x: "10.609"
    }), r.createElement("path", {
      id: "cp2",
      d: "m186.3,139.04,1.1994,0.003v0.87224h0.8775v-0.89253l1.2294,0.004v0.889h0.87926v-0.89253l1.2302,0.002-0.002,2.0117c0,0.31398-0.2487,0.51859-0.5362,0.51859h-4.3169c-0.28926,0-0.55824-0.23548-0.55913-0.52564l-0.003-1.9888h0.00088z"
    }), r.createElement("use", {
      xlinkHref: "#cp2",
      x: "10.609"
    }), r.createElement("path", {
      fill: "#000",
      stroke: "none",
      d: "m193.9,140.61c-0.0265-0.62706,0.87661-0.63411,0.86603,0v1.5364h-0.866v-1.536"
    }), r.createElement("path", {
      id: "cp3",
      fill: "#000",
      stroke: "none",
      d: "m188.57,142.84c-0.003-0.6059,0.83693-0.61824,0.82635,0v1.1871h-0.826v-1.187"
    }), r.createElement("use", {
      xlinkHref: "#cp3",
      x: "10.641"
    })), r.createElement("use", {
      xlinkHref: "#castle",
      y: "46.3198"
    }), r.createElement("use", {
      xlinkHref: "#castle",
      transform: "matrix(0.70460892,-0.70959585,0.70959585,0.70460892,-35.341459,275.10898)"
    })), r.createElement("use", {
      xlinkHref: "#castle",
      x: "45.7138"
    }), r.createElement("use", {
      xlinkHref: "#castle3",
      transform: "matrix(-1,0,0,1,479.79195,0)"
    }), r.createElement("g", {
      id: "quina",
      fill: "#fff"
    }, r.createElement("path", {
      fill: "#039",
      d: "m232.636,202.406v0.005c0,2.2119,0.84927,4.2272,2.2118,5.6894,1.3652,1.4667,3.2454,2.3777,5.302,2.3777,2.0672,0,3.9439-0.90487,5.3029-2.3654,1.3581-1.4587,2.2021-3.47219,2.2021-5.693v-10.768l-14.992-0.0123-0.0273,10.766"
    }), r.createElement("circle", {
      cx: "236.074",
      cy: "195.735",
      r: "1.486"
    }), r.createElement("circle", {
      cx: "244.392",
      cy: "195.742",
      r: "1.486"
    }), r.createElement("circle", {
      cx: "240.225",
      cy: "199.735",
      r: "1.486"
    }), r.createElement("circle", {
      cx: "236.074",
      cy: "203.916",
      r: "1.486"
    }), r.createElement("circle", {
      cx: "244.383",
      cy: "203.905",
      r: "1.486"
    })), r.createElement("use", {
      xlinkHref: "#quina",
      y: "-26.016"
    }), r.createElement("use", {
      xlinkHref: "#quina",
      x: "-20.799"
    }), r.createElement("use", {
      xlinkHref: "#quina",
      x: "20.745"
    }), r.createElement("use", {
      xlinkHref: "#quina",
      y: "25.784"
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0),
    l = n(2),
    c = n(1),
    a = n(32);
  var i = /*#__PURE__*/function (_r$Component11) {
    _inherits(i, _r$Component11);
    function i(e) {
      var _this14;
      _classCallCheck(this, i);
      _this14 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, e)), _this14.getSelectedItems = function (e) {
        var t = l.cloneDeep(e);
        return l.filter(t.items, {
          selected: !0
        });
      }, _this14.setUniqueItemSelected = function (e) {
        return _this14.state.items.map(function (t) {
          return t.selected = t.value === e.value, t;
        });
      }, _this14.onSelectItem = function (e, t) {
        var n = [];
        if (_this14.props.enableMultipleSelection && e) {
          var _e2 = l.filter(_this14.state.items, {
            selected: !0
          });
          n = _e2.length > 0 && _e2[0].chosen !== t.chosen ? _this14.setUniqueItemSelected(t) : _this14.state.items.map(function (e) {
            return e.selected = e.value === t.value || e.selected, e;
          });
        } else n = _this14.setUniqueItemSelected(t);
        _this14.setState(Object.assign(Object.assign({}, _this14.state), {
          items: n
        }));
      }, _this14.onChoseItem = function () {
        var e = _this14.getSelectedItems(_this14.state),
          t = _this14.state.items.map(function (t) {
            return t.chosen = !!e.find(function (e) {
              return e.value == t.value;
            }) || t.chosen, t;
          });
        _this14.setState({
          items: t
        }, _this14.invokeCallback());
      }, _this14.onUnchoseItem = function () {
        var e = _this14.getSelectedItems(_this14.state),
          t = _this14.state.items.map(function (t) {
            return t.chosen = !e.find(function (e) {
              return e.value == t.value;
            }) && t.chosen, t;
          });
        _this14.setState({
          items: t
        }, _this14.invokeCallback());
      }, _this14.invokeCallback = function () {
        return _this14.props.onChange(_this14.state.items.filter(function (e) {
          return e.chosen;
        }).map(function (e) {
          return e.value;
        }));
      };
      var t = [];
      if (void 0 !== e.value && 0 !== e.value.length && (n = e.value, Array.isArray(n) && n.length > 0 && "string" != typeof n[0] && "number" != typeof n[0])) {
        var _n4 = e.value.map(function (e) {
          return {
            value: e.value,
            label: e.label,
            selected: !1,
            chosen: !0
          };
        });
        var _r2 = _n4.map(function (e) {
          return e.value;
        });
        t = e.items.filter(function (e) {
          return !_r2.includes(e.value);
        }).map(function (e) {
          return {
            value: e.value,
            label: e.label,
            selected: !1,
            chosen: !1
          };
        }), t = l.concat(t, _n4);
      } else t = e.items.map(function (t) {
        return {
          value: t.value,
          label: t.label,
          selected: !1,
          chosen: e.value.toString() && e.value.toString().includes(t.value.toString())
        };
      });
      var n;
      _this14.state = {
        items: t
      };
      return _this14;
    }
    _createClass(i, [{
      key: "render",
      value: function render() {
        var _this15 = this;
        var e = this.state.items.filter(function (e) {
            return !e.chosen;
          }),
          t = this.state.items.filter(function (e) {
            return e.chosen;
          });
        return r.createElement("div", {
          className: "two_panel_selector"
        }, r.createElement("div", {
          className: "panel-container"
        }, r.createElement("div", {
          className: "panel-available"
        }, r.createElement("div", {
          className: "panel-label"
        }, "Available"), r.createElement("div", {
          className: "panel"
        }, r.createElement(a.default, {
          items: e,
          onItemSelect: this.onSelectItem
        }))), r.createElement("div", {
          className: "panel-chosen"
        }, r.createElement("div", {
          className: "panel-label"
        }, "Chosen"), r.createElement("div", {
          className: "panel"
        }, r.createElement(a.default, {
          items: t,
          onItemSelect: this.onSelectItem
        })))), r.createElement("div", {
          className: "controls"
        }, r.createElement("div", {
          className: "black-btn control",
          onClick: function onClick() {
            return _this15.onUnchoseItem();
          }
        }, r.createElement("i", {
          className: "material-icons"
        }, "arrow_backwards")), r.createElement("div", {
          className: "black-btn control",
          onClick: function onClick() {
            return _this15.onChoseItem();
          }
        }, r.createElement("i", {
          className: "material-icons"
        }, "arrow_forward"))), this.props.enableMultipleSelection && r.createElement("div", {
          className: "info-note"
        }, "To select multiple items press CTRL while clicking on desired options;"));
      }
    }]);
    return i;
  }(r.Component);
  t.TwoPanelSelector = i, i.propTypes = {
    items: c.array.isRequired,
    onChange: c.func.isRequired
  }, i.defaultProps = {
    items: [],
    value: [],
    onChange: function onChange() {
      return [];
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  var l = /*#__PURE__*/function (_r$Component12) {
    _inherits(l, _r$Component12);
    function l() {
      var _this16;
      _classCallCheck(this, l);
      _this16 = _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments)), _this16.onClick = function (e, t) {
        _this16.props.onItemSelect(e, t);
      };
      return _this16;
    }
    _createClass(l, [{
      key: "render",
      value: function render() {
        var _this17 = this;
        var e = this.props.items.map(function (e) {
          return r.createElement("div", {
            key: e.value,
            onClick: function onClick(t) {
              return _this17.onClick(t.ctrlKey, e);
            },
            className: "panel_item " + (e.selected ? "item-selected" : "")
          }, e.label);
        });
        return r.createElement(r.Fragment, null, e);
      }
    }]);
    return l;
  }(r.Component);
  t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  var l = /*#__PURE__*/function (_r$Component13) {
    _inherits(l, _r$Component13);
    function l() {
      _classCallCheck(this, l);
      return _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments));
    }
    _createClass(l, [{
      key: "render",
      value: function render() {
        var e = this.props.warningAt || 70,
          t = this.props.dangerAt || 90;
        var n = "progress-bar";
        return this.props.progress >= e && this.props.progress < t ? n += " progress-bar-warning" : this.props.progress >= t && (n += " progress-bar-danger"), r.createElement("div", {
          className: "custom-progress-bar"
        }, r.createElement("div", {
          className: "progress",
          style: this.props.height ? {
            height: this.props.height
          } : null
        }, r.createElement("div", {
          className: n,
          style: {
            width: this.props.progress + "%"
          }
        })), this.props.showLabels && r.createElement("div", {
          className: "row"
        }, this.props.minLabel && r.createElement("div", {
          className: "col-6 label"
        }, this.props.minLabel), this.props.maxLabel && r.createElement("div", {
          className: "col-6 text-right label"
        }, this.props.maxLabel)));
      }
    }]);
    return l;
  }(r.Component);
  t.ProgressBar = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  t.IconBadge = function (_ref7) {
    var _ref7$badgeType = _ref7.badgeType,
      e = _ref7$badgeType === void 0 ? "dark" : _ref7$badgeType,
      _ref7$icon = _ref7.icon,
      t = _ref7$icon === void 0 ? null : _ref7$icon,
      _ref7$label = _ref7.label,
      n = _ref7$label === void 0 ? "" : _ref7$label,
      _ref7$small = _ref7.small,
      l = _ref7$small === void 0 ? !1 : _ref7$small;
    var c = "icon-badge  ".concat(l ? "icon-badge-small" : "", " icon-badge-").concat(e);
    return r.createElement("div", {
      className: c
    }, t && r.createElement("i", {
      className: "material-icons icon-badge-icon"
    }, t), r.createElement("span", {
      className: "icon-badge-label"
    }, n));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  t.LoadingRipple = function (e) {
    return r.createElement("div", {
      className: "loading-ripple",
      style: {
        width: e.width,
        height: e.height
      }
    }, r.createElement("div", {
      style: {
        border: "".concat(e.rippleWidth || "5px", " solid ").concat(e.rippleColor || "rgb(234, 34, 72)")
      }
    }), r.createElement("div", {
      style: {
        border: "".concat(e.rippleWidth || "5px", " solid ").concat(e.rippleColor || "rgb(234, 34, 72)")
      }
    }), r.createElement("div", {
      style: {
        border: "".concat(e.rippleWidth || "5px", " solid ").concat(e.rippleColor || "rgb(234, 34, 72)")
      }
    }), r.createElement("div", {
      style: {
        border: "".concat(e.rippleWidth || "5px", " solid ").concat(e.rippleColor || "rgb(234, 34, 72)")
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  var l = /*#__PURE__*/function (_r$Component14) {
    _inherits(l, _r$Component14);
    function l(e) {
      var _this18;
      _classCallCheck(this, l);
      _this18 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, e)), _this18.onDisabledClick = function (e) {}, _this18.handleClick = function () {
        _this18.setState({
          on: !_this18.state.on
        }, _this18.fireOnChange);
      }, _this18.fireOnChange = function () {
        _this18.props.onClick && "function" == typeof _this18.props.onClick && _this18.props.onClick(_this18.state.on);
      }, _this18.state = {
        on: _this18.props.on
      };
      return _this18;
    }
    _createClass(l, [{
      key: "render",
      value: function render() {
        var _this19 = this;
        var e = ["switch", this.props.className, this.state.on ? "on " : "", this.props.enabled ? "" : "disabled "].join(" ");
        return r.createElement("div", {
          className: e,
          onClick: function onClick(e) {
            return _this19.props.enabled ? _this19.handleClick() : _this19.onDisabledClick(e);
          }
        }, r.createElement("div", {
          className: "switch-toggle",
          children: this.props.children
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(e, t) {
        return e.on !== t.on ? {
          on: e.on
        } : null;
      }
    }]);
    return l;
  }(r.Component);
  t.Switch = l, t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(0);
  var l = /*#__PURE__*/function (_r$Component15) {
    _inherits(l, _r$Component15);
    function l(e) {
      var _this20;
      _classCallCheck(this, l);
      _this20 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, e)), _this20.createStyle = function (e, t) {
        return {
          transform: "translateX(".concat(100 * e, "%)"),
          width: 100 / t + "%"
        };
      }, _this20.handleClick = function (e) {
        _this20.setState({
          value: e
        }, _this20.fireOnChange);
      }, _this20.fireOnChange = function () {
        _this20.props.onChange && "function" == typeof _this20.props.onChange && _this20.props.onChange(_this20.state.value);
      }, _this20.state = {
        value: null !== _this20.props.selected ? _this20.props.selected.toString() : null
      };
      return _this20;
    }
    _createClass(l, [{
      key: "render",
      value: function render() {
        var _this21 = this;
        var e = 0;
        return r.createElement("div", {
          className: "checkbox-group"
        }, this.props.items.map(function (t, n) {
          var l = t.value.toString() === _this21.state.value || 0 === n && null === _this21.state.value;
          return e = l ? n : e, r.createElement("div", {
            key: n,
            className: "option ".concat(l ? "selected" : "")
          }, r.createElement("input", {
            onChange: function onChange(e) {
              return _this21.handleClick(e.target.value);
            },
            type: "checkbox",
            name: "server-group",
            value: t.value
          }), t.label);
        }), r.createElement("div", {
          className: "select-indicator",
          style: this.createStyle(e, this.props.items.length)
        }));
      }
    }]);
    return l;
  }(r.Component);
  t.CheckboxGroup = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(39);
  t.Validators = r.Validators;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(40),
    l = n(41),
    c = n(42),
    a = n(43),
    i = n(44),
    s = n(45);
  t.Validators = {
    required: r.required,
    pattern: l.pattern,
    minLength: c.minLength,
    maxLength: a.maxLength,
    min: i.min,
    max: s.max
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(3),
    l = n(2);
  t.required = function (e) {
    if (null == e || "" === e || l.isObjectLike(e) && l.isEmpty(e) || l.isArrayLike(e) && l.isEmpty(e)) return r.ValidatorErrors.REQUIRED;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(3);
  t.pattern = function (e, t) {
    if (!t.test(e)) return r.ValidatorErrors.PATTERN;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(3);
  t.minLength = function (e, t) {
    if (e.length < t) return r.ValidatorErrors.MINLENGTH;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(3);
  t.maxLength = function (e, t) {
    if (e.length > t) return r.ValidatorErrors.MAXLENGTH;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(3);
  t.min = function (e, t) {
    if (e < t) return r.ValidatorErrors.MIN.replace(":minvalue:", t.toString());
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(3);
  t.max = function (e, t) {
    if (e > t) return r.ValidatorErrors.MAX.replace(":maxvalue:", t.toString());
  };
}]);